var lg = Object.defineProperty;
var bu = (e) => {
  throw TypeError(e);
};
var cg = (e, t, n) => t in e ? lg(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Ns = (e, t, n) => cg(e, typeof t != "symbol" ? t + "" : t, n), Iu = (e, t, n) => t.has(e) || bu("Cannot " + n);
var Tu = (e, t, n) => (Iu(e, t, "read from private field"), n ? n.call(e) : t.get(e)), wu = (e, t, n) => t.has(e) ? bu("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), Cu = (e, t, n, o) => (Iu(e, t, "write to private field"), o ? o.call(e, n) : t.set(e, n), n);
/*!
 * @dineug/erd-editor
 * @version 3.3.0 | Thu Oct 15 2026
 * @author SeungHwan-Lee <dineug2@gmail.com>
 * @license MIT
 */
var Cf = typeof global == "object" && global && global.Object === Object && global, ug = typeof self == "object" && self && self.Object === Object && self, ht = Cf || ug || Function("return this")(), Je = ht.Symbol, Sf = Object.prototype, dg = Sf.hasOwnProperty, fg = Sf.toString, rr = Je ? Je.toStringTag : void 0;
function mg(e) {
  var t = dg.call(e, rr), n = e[rr];
  try {
    e[rr] = void 0;
    var o = !0;
  } catch {
  }
  var r = fg.call(e);
  return o && (t ? e[rr] = n : delete e[rr]), r;
}
var hg = Object.prototype, pg = hg.toString;
function yg(e) {
  return pg.call(e);
}
var gg = "[object Null]", vg = "[object Undefined]", Su = Je ? Je.toStringTag : void 0;
function Pn(e) {
  return e == null ? e === void 0 ? vg : gg : Su && Su in Object(e) ? mg(e) : yg(e);
}
function Ct(e) {
  return e != null && typeof e == "object";
}
var bg = "[object Symbol]";
function na(e) {
  return typeof e == "symbol" || Ct(e) && Pn(e) == bg;
}
function Of(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, r = Array(o); ++n < o; )
    r[n] = t(e[n], n, e);
  return r;
}
var Be = Array.isArray, Ou = Je ? Je.prototype : void 0, Eu = Ou ? Ou.toString : void 0;
function Ef(e) {
  if (typeof e == "string")
    return e;
  if (Be(e))
    return Of(e, Ef) + "";
  if (na(e))
    return Eu ? Eu.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var Ig = /\s/;
function Tg(e) {
  for (var t = e.length; t-- && Ig.test(e.charAt(t)); )
    ;
  return t;
}
var wg = /^\s+/;
function Cg(e) {
  return e && e.slice(0, Tg(e) + 1).replace(wg, "");
}
function ut(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var xu = NaN, Sg = /^[-+]0x[0-9a-f]+$/i, Og = /^0b[01]+$/i, Eg = /^0o[0-7]+$/i, xg = parseInt;
function xf(e) {
  if (typeof e == "number")
    return e;
  if (na(e))
    return xu;
  if (ut(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ut(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Cg(e);
  var n = Og.test(e);
  return n || Eg.test(e) ? xg(e.slice(2), n ? 2 : 8) : Sg.test(e) ? xu : +e;
}
var Ag = 1 / 0, Ng = 17976931348623157e292;
function zs(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = xf(e), e === Ag || e === -1 / 0) {
    var t = e < 0 ? -1 : 1;
    return t * Ng;
  }
  return e === e ? e : 0;
}
function Mg(e) {
  var t = zs(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
function Fl(e) {
  return e;
}
var $g = "[object AsyncFunction]", kg = "[object Function]", Dg = "[object GeneratorFunction]", Lg = "[object Proxy]";
function Af(e) {
  if (!ut(e))
    return !1;
  var t = Pn(e);
  return t == kg || t == Dg || t == $g || t == Lg;
}
var Ba = ht["__core-js_shared__"], Au = function() {
  var e = /[^.]+$/.exec(Ba && Ba.keys && Ba.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Rg(e) {
  return !!Au && Au in e;
}
var _g = Function.prototype, Pg = _g.toString;
function Bn(e) {
  if (e != null) {
    try {
      return Pg.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Bg = /[\\^$.*+?()[\]{}|]/g, Wg = /^\[object .+?Constructor\]$/, Ug = Function.prototype, Vg = Object.prototype, Fg = Ug.toString, jg = Vg.hasOwnProperty, qg = RegExp(
  "^" + Fg.call(jg).replace(Bg, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Zg(e) {
  if (!ut(e) || Rg(e))
    return !1;
  var t = Af(e) ? qg : Wg;
  return t.test(Bn(e));
}
function Hg(e, t) {
  return e == null ? void 0 : e[t];
}
function Wn(e, t) {
  var n = Hg(e, t);
  return Zg(n) ? n : void 0;
}
var al = Wn(ht, "WeakMap"), Nu = Object.create, zg = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!ut(t))
      return {};
    if (Nu)
      return Nu(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
function Gg(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
function Br() {
}
function Yg(e, t) {
  var n = -1, o = e.length;
  for (t || (t = Array(o)); ++n < o; )
    t[n] = e[n];
  return t;
}
var Kg = 800, Qg = 16, Jg = Date.now;
function Xg(e) {
  var t = 0, n = 0;
  return function() {
    var o = Jg(), r = Qg - (o - n);
    if (n = o, r > 0) {
      if (++t >= Kg)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function ev(e) {
  return function() {
    return e;
  };
}
var Mi = function() {
  try {
    var e = Wn(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), tv = Mi ? function(e, t) {
  return Mi(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ev(t),
    writable: !0
  });
} : Fl, Nf = Xg(tv);
function nv(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o && t(e[n], n, e) !== !1; )
    ;
  return e;
}
function ov(e, t, n, o) {
  for (var r = e.length, s = n + -1; ++s < r; )
    if (t(e[s], s, e))
      return s;
  return -1;
}
function rv(e) {
  return e !== e;
}
function sv(e, t, n) {
  for (var o = n - 1, r = e.length; ++o < r; )
    if (e[o] === t)
      return o;
  return -1;
}
function iv(e, t, n) {
  return t === t ? sv(e, t, n) : ov(e, rv, n);
}
function Mf(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && iv(e, t, 0) > -1;
}
var av = 9007199254740991, lv = /^(?:0|[1-9]\d*)$/;
function oa(e, t) {
  var n = typeof e;
  return t = t ?? av, !!t && (n == "number" || n != "symbol" && lv.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function jl(e, t, n) {
  t == "__proto__" && Mi ? Mi(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function ra(e, t) {
  return e === t || e !== e && t !== t;
}
var cv = Object.prototype, uv = cv.hasOwnProperty;
function ql(e, t, n) {
  var o = e[t];
  (!(uv.call(e, t) && ra(o, n)) || n === void 0 && !(t in e)) && jl(e, t, n);
}
function rs(e, t, n, o) {
  var r = !n;
  n || (n = {});
  for (var s = -1, i = t.length; ++s < i; ) {
    var a = t[s], l = void 0;
    l === void 0 && (l = e[a]), r ? jl(n, a, l) : ql(n, a, l);
  }
  return n;
}
var Mu = Math.max;
function $f(e, t, n) {
  return t = Mu(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var o = arguments, r = -1, s = Mu(o.length - t, 0), i = Array(s); ++r < s; )
      i[r] = o[t + r];
    r = -1;
    for (var a = Array(t + 1); ++r < t; )
      a[r] = o[r];
    return a[t] = n(i), Gg(e, this, a);
  };
}
function dv(e, t) {
  return Nf($f(e, t, Fl), e + "");
}
var fv = 9007199254740991;
function Zl(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= fv;
}
function Lo(e) {
  return e != null && Zl(e.length) && !Af(e);
}
function mv(e, t, n) {
  if (!ut(n))
    return !1;
  var o = typeof t;
  return (o == "number" ? Lo(n) && oa(t, n.length) : o == "string" && t in n) ? ra(n[t], e) : !1;
}
var hv = Object.prototype;
function sa(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || hv;
  return e === n;
}
function pv(e, t) {
  for (var n = -1, o = Array(e); ++n < e; )
    o[n] = t(n);
  return o;
}
var yv = "[object Arguments]";
function $u(e) {
  return Ct(e) && Pn(e) == yv;
}
var kf = Object.prototype, gv = kf.hasOwnProperty, vv = kf.propertyIsEnumerable, ia = $u(/* @__PURE__ */ function() {
  return arguments;
}()) ? $u : function(e) {
  return Ct(e) && gv.call(e, "callee") && !vv.call(e, "callee");
};
function bv() {
  return !1;
}
var Df = typeof exports == "object" && exports && !exports.nodeType && exports, ku = Df && typeof module == "object" && module && !module.nodeType && module, Iv = ku && ku.exports === Df, Du = Iv ? ht.Buffer : void 0, Tv = Du ? Du.isBuffer : void 0, zr = Tv || bv, wv = "[object Arguments]", Cv = "[object Array]", Sv = "[object Boolean]", Ov = "[object Date]", Ev = "[object Error]", xv = "[object Function]", Av = "[object Map]", Nv = "[object Number]", Mv = "[object Object]", $v = "[object RegExp]", kv = "[object Set]", Dv = "[object String]", Lv = "[object WeakMap]", Rv = "[object ArrayBuffer]", _v = "[object DataView]", Pv = "[object Float32Array]", Bv = "[object Float64Array]", Wv = "[object Int8Array]", Uv = "[object Int16Array]", Vv = "[object Int32Array]", Fv = "[object Uint8Array]", jv = "[object Uint8ClampedArray]", qv = "[object Uint16Array]", Zv = "[object Uint32Array]", ee = {};
ee[Pv] = ee[Bv] = ee[Wv] = ee[Uv] = ee[Vv] = ee[Fv] = ee[jv] = ee[qv] = ee[Zv] = !0;
ee[wv] = ee[Cv] = ee[Rv] = ee[Sv] = ee[_v] = ee[Ov] = ee[Ev] = ee[xv] = ee[Av] = ee[Nv] = ee[Mv] = ee[$v] = ee[kv] = ee[Dv] = ee[Lv] = !1;
function Hv(e) {
  return Ct(e) && Zl(e.length) && !!ee[Pn(e)];
}
function Hl(e) {
  return function(t) {
    return e(t);
  };
}
var Lf = typeof exports == "object" && exports && !exports.nodeType && exports, Wr = Lf && typeof module == "object" && module && !module.nodeType && module, zv = Wr && Wr.exports === Lf, Wa = zv && Cf.process, xo = function() {
  try {
    var e = Wr && Wr.require && Wr.require("util").types;
    return e || Wa && Wa.binding && Wa.binding("util");
  } catch {
  }
}(), Lu = xo && xo.isTypedArray, zl = Lu ? Hl(Lu) : Hv, Gv = Object.prototype, Yv = Gv.hasOwnProperty;
function Rf(e, t) {
  var n = Be(e), o = !n && ia(e), r = !n && !o && zr(e), s = !n && !o && !r && zl(e), i = n || o || r || s, a = i ? pv(e.length, String) : [], l = a.length;
  for (var c in e)
    (t || Yv.call(e, c)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    s && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    oa(c, l))) && a.push(c);
  return a;
}
function _f(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Kv = _f(Object.keys, Object), Qv = Object.prototype, Jv = Qv.hasOwnProperty;
function Pf(e) {
  if (!sa(e))
    return Kv(e);
  var t = [];
  for (var n in Object(e))
    Jv.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function ss(e) {
  return Lo(e) ? Rf(e) : Pf(e);
}
function Xv(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var eb = Object.prototype, tb = eb.hasOwnProperty;
function nb(e) {
  if (!ut(e))
    return Xv(e);
  var t = sa(e), n = [];
  for (var o in e)
    o == "constructor" && (t || !tb.call(e, o)) || n.push(o);
  return n;
}
function Gl(e) {
  return Lo(e) ? Rf(e, !0) : nb(e);
}
var ob = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, rb = /^\w*$/;
function Yl(e, t) {
  if (Be(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || na(e) ? !0 : rb.test(e) || !ob.test(e) || t != null && e in Object(t);
}
var Gr = Wn(Object, "create");
function sb() {
  this.__data__ = Gr ? Gr(null) : {}, this.size = 0;
}
function ib(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ab = "__lodash_hash_undefined__", lb = Object.prototype, cb = lb.hasOwnProperty;
function ub(e) {
  var t = this.__data__;
  if (Gr) {
    var n = t[e];
    return n === ab ? void 0 : n;
  }
  return cb.call(t, e) ? t[e] : void 0;
}
var db = Object.prototype, fb = db.hasOwnProperty;
function mb(e) {
  var t = this.__data__;
  return Gr ? t[e] !== void 0 : fb.call(t, e);
}
var hb = "__lodash_hash_undefined__";
function pb(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Gr && t === void 0 ? hb : t, this;
}
function Dn(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Dn.prototype.clear = sb;
Dn.prototype.delete = ib;
Dn.prototype.get = ub;
Dn.prototype.has = mb;
Dn.prototype.set = pb;
function yb() {
  this.__data__ = [], this.size = 0;
}
function aa(e, t) {
  for (var n = e.length; n--; )
    if (ra(e[n][0], t))
      return n;
  return -1;
}
var gb = Array.prototype, vb = gb.splice;
function bb(e) {
  var t = this.__data__, n = aa(t, e);
  if (n < 0)
    return !1;
  var o = t.length - 1;
  return n == o ? t.pop() : vb.call(t, n, 1), --this.size, !0;
}
function Ib(e) {
  var t = this.__data__, n = aa(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function Tb(e) {
  return aa(this.__data__, e) > -1;
}
function wb(e, t) {
  var n = this.__data__, o = aa(n, e);
  return o < 0 ? (++this.size, n.push([e, t])) : n[o][1] = t, this;
}
function Vt(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Vt.prototype.clear = yb;
Vt.prototype.delete = bb;
Vt.prototype.get = Ib;
Vt.prototype.has = Tb;
Vt.prototype.set = wb;
var Yr = Wn(ht, "Map");
function Cb() {
  this.size = 0, this.__data__ = {
    hash: new Dn(),
    map: new (Yr || Vt)(),
    string: new Dn()
  };
}
function Sb(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function la(e, t) {
  var n = e.__data__;
  return Sb(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Ob(e) {
  var t = la(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Eb(e) {
  return la(this, e).get(e);
}
function xb(e) {
  return la(this, e).has(e);
}
function Ab(e, t) {
  var n = la(this, e), o = n.size;
  return n.set(e, t), this.size += n.size == o ? 0 : 1, this;
}
function Ft(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var o = e[t];
    this.set(o[0], o[1]);
  }
}
Ft.prototype.clear = Cb;
Ft.prototype.delete = Ob;
Ft.prototype.get = Eb;
Ft.prototype.has = xb;
Ft.prototype.set = Ab;
var Nb = "Expected a function";
function Kl(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(Nb);
  var n = function() {
    var o = arguments, r = t ? t.apply(this, o) : o[0], s = n.cache;
    if (s.has(r))
      return s.get(r);
    var i = e.apply(this, o);
    return n.cache = s.set(r, i) || s, i;
  };
  return n.cache = new (Kl.Cache || Ft)(), n;
}
Kl.Cache = Ft;
var Mb = 500;
function $b(e) {
  var t = Kl(e, function(o) {
    return n.size === Mb && n.clear(), o;
  }), n = t.cache;
  return t;
}
var kb = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Db = /\\(\\)?/g, Lb = $b(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(kb, function(n, o, r, s) {
    t.push(r ? s.replace(Db, "$1") : o || n);
  }), t;
});
function Ln(e) {
  return e == null ? "" : Ef(e);
}
function Ro(e, t) {
  return Be(e) ? e : Yl(e, t) ? [e] : Lb(Ln(e));
}
function _o(e) {
  if (typeof e == "string" || na(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function ca(e, t) {
  t = Ro(t, e);
  for (var n = 0, o = t.length; e != null && n < o; )
    e = e[_o(t[n++])];
  return n && n == o ? e : void 0;
}
function Rb(e, t, n) {
  var o = e == null ? void 0 : ca(e, t);
  return o === void 0 ? n : o;
}
function Ql(e, t) {
  for (var n = -1, o = t.length, r = e.length; ++n < o; )
    e[r + n] = t[n];
  return e;
}
var Ru = Je ? Je.isConcatSpreadable : void 0;
function _b(e) {
  return Be(e) || ia(e) || !!(Ru && e && e[Ru]);
}
function Bf(e, t, n, o, r) {
  var s = -1, i = e.length;
  for (n || (n = _b), r || (r = []); ++s < i; ) {
    var a = e[s];
    n(a) ? Ql(r, a) : o || (r[r.length] = a);
  }
  return r;
}
function Pb(e) {
  var t = e == null ? 0 : e.length;
  return t ? Bf(e) : [];
}
function Wf(e) {
  return Nf($f(e, void 0, Pb), e + "");
}
var Jl = _f(Object.getPrototypeOf, Object), Bb = "[object Object]", Wb = Function.prototype, Ub = Object.prototype, Uf = Wb.toString, Vb = Ub.hasOwnProperty, Fb = Uf.call(Object);
function jb(e) {
  if (!Ct(e) || Pn(e) != Bb)
    return !1;
  var t = Jl(e);
  if (t === null)
    return !0;
  var n = Vb.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && Uf.call(n) == Fb;
}
function Vf(e, t, n) {
  var o = -1, r = e.length;
  t < 0 && (t = -t > r ? 0 : r + t), n = n > r ? r : n, n < 0 && (n += r), r = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var s = Array(r); ++o < r; )
    s[o] = e[o + t];
  return s;
}
function qb(e, t, n) {
  var o = e.length;
  return n = n === void 0 ? o : n, Vf(e, t, n);
}
var Zb = "\\ud800-\\udfff", Hb = "\\u0300-\\u036f", zb = "\\ufe20-\\ufe2f", Gb = "\\u20d0-\\u20ff", Yb = Hb + zb + Gb, Kb = "\\ufe0e\\ufe0f", Qb = "\\u200d", Jb = RegExp("[" + Qb + Zb + Yb + Kb + "]");
function Ff(e) {
  return Jb.test(e);
}
function Xb(e) {
  return e.split("");
}
var jf = "\\ud800-\\udfff", eI = "\\u0300-\\u036f", tI = "\\ufe20-\\ufe2f", nI = "\\u20d0-\\u20ff", oI = eI + tI + nI, rI = "\\ufe0e\\ufe0f", sI = "[" + jf + "]", ll = "[" + oI + "]", cl = "\\ud83c[\\udffb-\\udfff]", iI = "(?:" + ll + "|" + cl + ")", qf = "[^" + jf + "]", Zf = "(?:\\ud83c[\\udde6-\\uddff]){2}", Hf = "[\\ud800-\\udbff][\\udc00-\\udfff]", aI = "\\u200d", zf = iI + "?", Gf = "[" + rI + "]?", lI = "(?:" + aI + "(?:" + [qf, Zf, Hf].join("|") + ")" + Gf + zf + ")*", cI = Gf + zf + lI, uI = "(?:" + [qf + ll + "?", ll, Zf, Hf, sI].join("|") + ")", dI = RegExp(cl + "(?=" + cl + ")|" + uI + cI, "g");
function fI(e) {
  return e.match(dI) || [];
}
function mI(e) {
  return Ff(e) ? fI(e) : Xb(e);
}
function hI(e) {
  return function(t) {
    t = Ln(t);
    var n = Ff(t) ? mI(t) : void 0, o = n ? n[0] : t.charAt(0), r = n ? qb(n, 1).join("") : t.slice(1);
    return o[e]() + r;
  };
}
var Yf = hI("toUpperCase");
function pI(e) {
  return Yf(Ln(e).toLowerCase());
}
function yI(e, t, n, o) {
  for (var r = -1, s = e == null ? 0 : e.length; ++r < s; )
    n = t(n, e[r], r, e);
  return n;
}
function gI(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var vI = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, bI = gI(vI), II = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, TI = "\\u0300-\\u036f", wI = "\\ufe20-\\ufe2f", CI = "\\u20d0-\\u20ff", SI = TI + wI + CI, OI = "[" + SI + "]", EI = RegExp(OI, "g");
function xI(e) {
  return e = Ln(e), e && e.replace(II, bI).replace(EI, "");
}
var AI = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function NI(e) {
  return e.match(AI) || [];
}
var MI = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function $I(e) {
  return MI.test(e);
}
var Kf = "\\ud800-\\udfff", kI = "\\u0300-\\u036f", DI = "\\ufe20-\\ufe2f", LI = "\\u20d0-\\u20ff", RI = kI + DI + LI, Qf = "\\u2700-\\u27bf", Jf = "a-z\\xdf-\\xf6\\xf8-\\xff", _I = "\\xac\\xb1\\xd7\\xf7", PI = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", BI = "\\u2000-\\u206f", WI = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Xf = "A-Z\\xc0-\\xd6\\xd8-\\xde", UI = "\\ufe0e\\ufe0f", em = _I + PI + BI + WI, tm = "['’]", _u = "[" + em + "]", VI = "[" + RI + "]", nm = "\\d+", FI = "[" + Qf + "]", om = "[" + Jf + "]", rm = "[^" + Kf + em + nm + Qf + Jf + Xf + "]", jI = "\\ud83c[\\udffb-\\udfff]", qI = "(?:" + VI + "|" + jI + ")", ZI = "[^" + Kf + "]", sm = "(?:\\ud83c[\\udde6-\\uddff]){2}", im = "[\\ud800-\\udbff][\\udc00-\\udfff]", Xn = "[" + Xf + "]", HI = "\\u200d", Pu = "(?:" + om + "|" + rm + ")", zI = "(?:" + Xn + "|" + rm + ")", Bu = "(?:" + tm + "(?:d|ll|m|re|s|t|ve))?", Wu = "(?:" + tm + "(?:D|LL|M|RE|S|T|VE))?", am = qI + "?", lm = "[" + UI + "]?", GI = "(?:" + HI + "(?:" + [ZI, sm, im].join("|") + ")" + lm + am + ")*", YI = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", KI = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", QI = lm + am + GI, JI = "(?:" + [FI, sm, im].join("|") + ")" + QI, XI = RegExp([
  Xn + "?" + om + "+" + Bu + "(?=" + [_u, Xn, "$"].join("|") + ")",
  zI + "+" + Wu + "(?=" + [_u, Xn + Pu, "$"].join("|") + ")",
  Xn + "?" + Pu + "+" + Bu,
  Xn + "+" + Wu,
  KI,
  YI,
  nm,
  JI
].join("|"), "g");
function eT(e) {
  return e.match(XI) || [];
}
function tT(e, t, n) {
  return e = Ln(e), t = t, t === void 0 ? $I(e) ? eT(e) : NI(e) : e.match(t) || [];
}
var nT = "['’]", oT = RegExp(nT, "g");
function rT(e) {
  return function(t) {
    return yI(tT(xI(t).replace(oT, "")), e, "");
  };
}
var sT = rT(function(e, t, n) {
  return t = t.toLowerCase(), e + (n ? pI(t) : t);
}), iT = ht.isFinite, aT = Math.min;
function lT(e) {
  var t = Math[e];
  return function(n, o) {
    if (n = xf(n), o = o == null ? 0 : aT(Mg(o), 292), o && iT(n)) {
      var r = (Ln(n) + "e").split("e"), s = t(r[0] + "e" + (+r[1] + o));
      return r = (Ln(s) + "e").split("e"), +(r[0] + "e" + (+r[1] - o));
    }
    return t(n);
  };
}
function cT() {
  this.__data__ = new Vt(), this.size = 0;
}
function uT(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function dT(e) {
  return this.__data__.get(e);
}
function fT(e) {
  return this.__data__.has(e);
}
var mT = 200;
function hT(e, t) {
  var n = this.__data__;
  if (n instanceof Vt) {
    var o = n.__data__;
    if (!Yr || o.length < mT - 1)
      return o.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Ft(o);
  }
  return n.set(e, t), this.size = n.size, this;
}
function wt(e) {
  var t = this.__data__ = new Vt(e);
  this.size = t.size;
}
wt.prototype.clear = cT;
wt.prototype.delete = uT;
wt.prototype.get = dT;
wt.prototype.has = fT;
wt.prototype.set = hT;
function pT(e, t) {
  return e && rs(t, ss(t), e);
}
function yT(e, t) {
  return e && rs(t, Gl(t), e);
}
var cm = typeof exports == "object" && exports && !exports.nodeType && exports, Uu = cm && typeof module == "object" && module && !module.nodeType && module, gT = Uu && Uu.exports === cm, Vu = gT ? ht.Buffer : void 0, Fu = Vu ? Vu.allocUnsafe : void 0;
function vT(e, t) {
  if (t)
    return e.slice();
  var n = e.length, o = Fu ? Fu(n) : new e.constructor(n);
  return e.copy(o), o;
}
function bT(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length, r = 0, s = []; ++n < o; ) {
    var i = e[n];
    t(i, n, e) && (s[r++] = i);
  }
  return s;
}
function um() {
  return [];
}
var IT = Object.prototype, TT = IT.propertyIsEnumerable, ju = Object.getOwnPropertySymbols, Xl = ju ? function(e) {
  return e == null ? [] : (e = Object(e), bT(ju(e), function(t) {
    return TT.call(e, t);
  }));
} : um;
function wT(e, t) {
  return rs(e, Xl(e), t);
}
var CT = Object.getOwnPropertySymbols, dm = CT ? function(e) {
  for (var t = []; e; )
    Ql(t, Xl(e)), e = Jl(e);
  return t;
} : um;
function ST(e, t) {
  return rs(e, dm(e), t);
}
function fm(e, t, n) {
  var o = t(e);
  return Be(e) ? o : Ql(o, n(e));
}
function ul(e) {
  return fm(e, ss, Xl);
}
function mm(e) {
  return fm(e, Gl, dm);
}
var dl = Wn(ht, "DataView"), fl = Wn(ht, "Promise"), po = Wn(ht, "Set"), qu = "[object Map]", OT = "[object Object]", Zu = "[object Promise]", Hu = "[object Set]", zu = "[object WeakMap]", Gu = "[object DataView]", ET = Bn(dl), xT = Bn(Yr), AT = Bn(fl), NT = Bn(po), MT = Bn(al), Ve = Pn;
(dl && Ve(new dl(new ArrayBuffer(1))) != Gu || Yr && Ve(new Yr()) != qu || fl && Ve(fl.resolve()) != Zu || po && Ve(new po()) != Hu || al && Ve(new al()) != zu) && (Ve = function(e) {
  var t = Pn(e), n = t == OT ? e.constructor : void 0, o = n ? Bn(n) : "";
  if (o)
    switch (o) {
      case ET:
        return Gu;
      case xT:
        return qu;
      case AT:
        return Zu;
      case NT:
        return Hu;
      case MT:
        return zu;
    }
  return t;
});
var $T = Object.prototype, kT = $T.hasOwnProperty;
function DT(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && kT.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var $i = ht.Uint8Array;
function ec(e) {
  var t = new e.constructor(e.byteLength);
  return new $i(t).set(new $i(e)), t;
}
function LT(e, t) {
  var n = t ? ec(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var RT = /\w*$/;
function _T(e) {
  var t = new e.constructor(e.source, RT.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var Yu = Je ? Je.prototype : void 0, Ku = Yu ? Yu.valueOf : void 0;
function PT(e) {
  return Ku ? Object(Ku.call(e)) : {};
}
function BT(e, t) {
  var n = t ? ec(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var WT = "[object Boolean]", UT = "[object Date]", VT = "[object Map]", FT = "[object Number]", jT = "[object RegExp]", qT = "[object Set]", ZT = "[object String]", HT = "[object Symbol]", zT = "[object ArrayBuffer]", GT = "[object DataView]", YT = "[object Float32Array]", KT = "[object Float64Array]", QT = "[object Int8Array]", JT = "[object Int16Array]", XT = "[object Int32Array]", e0 = "[object Uint8Array]", t0 = "[object Uint8ClampedArray]", n0 = "[object Uint16Array]", o0 = "[object Uint32Array]";
function r0(e, t, n) {
  var o = e.constructor;
  switch (t) {
    case zT:
      return ec(e);
    case WT:
    case UT:
      return new o(+e);
    case GT:
      return LT(e, n);
    case YT:
    case KT:
    case QT:
    case JT:
    case XT:
    case e0:
    case t0:
    case n0:
    case o0:
      return BT(e, n);
    case VT:
      return new o();
    case FT:
    case ZT:
      return new o(e);
    case jT:
      return _T(e);
    case qT:
      return new o();
    case HT:
      return PT(e);
  }
}
function s0(e) {
  return typeof e.constructor == "function" && !sa(e) ? zg(Jl(e)) : {};
}
var i0 = "[object Map]";
function a0(e) {
  return Ct(e) && Ve(e) == i0;
}
var Qu = xo && xo.isMap, l0 = Qu ? Hl(Qu) : a0, c0 = "[object Set]";
function u0(e) {
  return Ct(e) && Ve(e) == c0;
}
var Ju = xo && xo.isSet, d0 = Ju ? Hl(Ju) : u0, f0 = 1, m0 = 2, h0 = 4, hm = "[object Arguments]", p0 = "[object Array]", y0 = "[object Boolean]", g0 = "[object Date]", v0 = "[object Error]", pm = "[object Function]", b0 = "[object GeneratorFunction]", I0 = "[object Map]", T0 = "[object Number]", ym = "[object Object]", w0 = "[object RegExp]", C0 = "[object Set]", S0 = "[object String]", O0 = "[object Symbol]", E0 = "[object WeakMap]", x0 = "[object ArrayBuffer]", A0 = "[object DataView]", N0 = "[object Float32Array]", M0 = "[object Float64Array]", $0 = "[object Int8Array]", k0 = "[object Int16Array]", D0 = "[object Int32Array]", L0 = "[object Uint8Array]", R0 = "[object Uint8ClampedArray]", _0 = "[object Uint16Array]", P0 = "[object Uint32Array]", Q = {};
Q[hm] = Q[p0] = Q[x0] = Q[A0] = Q[y0] = Q[g0] = Q[N0] = Q[M0] = Q[$0] = Q[k0] = Q[D0] = Q[I0] = Q[T0] = Q[ym] = Q[w0] = Q[C0] = Q[S0] = Q[O0] = Q[L0] = Q[R0] = Q[_0] = Q[P0] = !0;
Q[v0] = Q[pm] = Q[E0] = !1;
function Ur(e, t, n, o, r, s) {
  var i, a = t & f0, l = t & m0, c = t & h0;
  if (n && (i = r ? n(e, o, r, s) : n(e)), i !== void 0)
    return i;
  if (!ut(e))
    return e;
  var u = Be(e);
  if (u) {
    if (i = DT(e), !a)
      return Yg(e, i);
  } else {
    var d = Ve(e), m = d == pm || d == b0;
    if (zr(e))
      return vT(e, a);
    if (d == ym || d == hm || m && !r) {
      if (i = l || m ? {} : s0(e), !a)
        return l ? ST(e, yT(i, e)) : wT(e, pT(i, e));
    } else {
      if (!Q[d])
        return r ? e : {};
      i = r0(e, d, a);
    }
  }
  s || (s = new wt());
  var f = s.get(e);
  if (f)
    return f;
  s.set(e, i), d0(e) ? e.forEach(function(I) {
    i.add(Ur(I, t, n, I, e, s));
  }) : l0(e) && e.forEach(function(I, g) {
    i.set(g, Ur(I, t, n, g, e, s));
  });
  var p = c ? l ? mm : ul : l ? Gl : ss, v = u ? void 0 : p(e);
  return nv(v || e, function(I, g) {
    v && (g = I, I = e[g]), ql(i, g, Ur(I, t, n, g, e, s));
  }), i;
}
var B0 = 1, W0 = 4;
function ua(e) {
  return Ur(e, B0 | W0);
}
var U0 = "__lodash_hash_undefined__";
function V0(e) {
  return this.__data__.set(e, U0), this;
}
function F0(e) {
  return this.__data__.has(e);
}
function Ao(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Ft(); ++t < n; )
    this.add(e[t]);
}
Ao.prototype.add = Ao.prototype.push = V0;
Ao.prototype.has = F0;
function j0(e, t) {
  for (var n = -1, o = e == null ? 0 : e.length; ++n < o; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function tc(e, t) {
  return e.has(t);
}
var q0 = 1, Z0 = 2;
function gm(e, t, n, o, r, s) {
  var i = n & q0, a = e.length, l = t.length;
  if (a != l && !(i && l > a))
    return !1;
  var c = s.get(e), u = s.get(t);
  if (c && u)
    return c == t && u == e;
  var d = -1, m = !0, f = n & Z0 ? new Ao() : void 0;
  for (s.set(e, t), s.set(t, e); ++d < a; ) {
    var p = e[d], v = t[d];
    if (o)
      var I = i ? o(v, p, d, t, e, s) : o(p, v, d, e, t, s);
    if (I !== void 0) {
      if (I)
        continue;
      m = !1;
      break;
    }
    if (f) {
      if (!j0(t, function(g, b) {
        if (!tc(f, b) && (p === g || r(p, g, n, o, s)))
          return f.push(b);
      })) {
        m = !1;
        break;
      }
    } else if (!(p === v || r(p, v, n, o, s))) {
      m = !1;
      break;
    }
  }
  return s.delete(e), s.delete(t), m;
}
function H0(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o, r) {
    n[++t] = [r, o];
  }), n;
}
function nc(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(o) {
    n[++t] = o;
  }), n;
}
var z0 = 1, G0 = 2, Y0 = "[object Boolean]", K0 = "[object Date]", Q0 = "[object Error]", J0 = "[object Map]", X0 = "[object Number]", ew = "[object RegExp]", tw = "[object Set]", nw = "[object String]", ow = "[object Symbol]", rw = "[object ArrayBuffer]", sw = "[object DataView]", Xu = Je ? Je.prototype : void 0, Ua = Xu ? Xu.valueOf : void 0;
function iw(e, t, n, o, r, s, i) {
  switch (n) {
    case sw:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case rw:
      return !(e.byteLength != t.byteLength || !s(new $i(e), new $i(t)));
    case Y0:
    case K0:
    case X0:
      return ra(+e, +t);
    case Q0:
      return e.name == t.name && e.message == t.message;
    case ew:
    case nw:
      return e == t + "";
    case J0:
      var a = H0;
    case tw:
      var l = o & z0;
      if (a || (a = nc), e.size != t.size && !l)
        return !1;
      var c = i.get(e);
      if (c)
        return c == t;
      o |= G0, i.set(e, t);
      var u = gm(a(e), a(t), o, r, s, i);
      return i.delete(e), u;
    case ow:
      if (Ua)
        return Ua.call(e) == Ua.call(t);
  }
  return !1;
}
var aw = 1, lw = Object.prototype, cw = lw.hasOwnProperty;
function uw(e, t, n, o, r, s) {
  var i = n & aw, a = ul(e), l = a.length, c = ul(t), u = c.length;
  if (l != u && !i)
    return !1;
  for (var d = l; d--; ) {
    var m = a[d];
    if (!(i ? m in t : cw.call(t, m)))
      return !1;
  }
  var f = s.get(e), p = s.get(t);
  if (f && p)
    return f == t && p == e;
  var v = !0;
  s.set(e, t), s.set(t, e);
  for (var I = i; ++d < l; ) {
    m = a[d];
    var g = e[m], b = t[m];
    if (o)
      var S = i ? o(b, g, m, t, e, s) : o(g, b, m, e, t, s);
    if (!(S === void 0 ? g === b || r(g, b, n, o, s) : S)) {
      v = !1;
      break;
    }
    I || (I = m == "constructor");
  }
  if (v && !I) {
    var M = e.constructor, U = t.constructor;
    M != U && "constructor" in e && "constructor" in t && !(typeof M == "function" && M instanceof M && typeof U == "function" && U instanceof U) && (v = !1);
  }
  return s.delete(e), s.delete(t), v;
}
var dw = 1, ed = "[object Arguments]", td = "[object Array]", Ms = "[object Object]", fw = Object.prototype, nd = fw.hasOwnProperty;
function mw(e, t, n, o, r, s) {
  var i = Be(e), a = Be(t), l = i ? td : Ve(e), c = a ? td : Ve(t);
  l = l == ed ? Ms : l, c = c == ed ? Ms : c;
  var u = l == Ms, d = c == Ms, m = l == c;
  if (m && zr(e)) {
    if (!zr(t))
      return !1;
    i = !0, u = !1;
  }
  if (m && !u)
    return s || (s = new wt()), i || zl(e) ? gm(e, t, n, o, r, s) : iw(e, t, l, n, o, r, s);
  if (!(n & dw)) {
    var f = u && nd.call(e, "__wrapped__"), p = d && nd.call(t, "__wrapped__");
    if (f || p) {
      var v = f ? e.value() : e, I = p ? t.value() : t;
      return s || (s = new wt()), r(v, I, n, o, s);
    }
  }
  return m ? (s || (s = new wt()), uw(e, t, n, o, r, s)) : !1;
}
function oc(e, t, n, o, r) {
  return e === t ? !0 : e == null || t == null || !Ct(e) && !Ct(t) ? e !== e && t !== t : mw(e, t, n, o, oc, r);
}
var hw = 1, pw = 2;
function yw(e, t, n, o) {
  var r = n.length, s = r;
  if (e == null)
    return !s;
  for (e = Object(e); r--; ) {
    var i = n[r];
    if (i[2] ? i[1] !== e[i[0]] : !(i[0] in e))
      return !1;
  }
  for (; ++r < s; ) {
    i = n[r];
    var a = i[0], l = e[a], c = i[1];
    if (i[2]) {
      if (l === void 0 && !(a in e))
        return !1;
    } else {
      var u = new wt(), d;
      if (!(d === void 0 ? oc(c, l, hw | pw, o, u) : d))
        return !1;
    }
  }
  return !0;
}
function vm(e) {
  return e === e && !ut(e);
}
function gw(e) {
  for (var t = ss(e), n = t.length; n--; ) {
    var o = t[n], r = e[o];
    t[n] = [o, r, vm(r)];
  }
  return t;
}
function bm(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
function vw(e) {
  var t = gw(e);
  return t.length == 1 && t[0][2] ? bm(t[0][0], t[0][1]) : function(n) {
    return n === e || yw(n, e, t);
  };
}
function bw(e, t) {
  return e != null && t in Object(e);
}
function Iw(e, t, n) {
  t = Ro(t, e);
  for (var o = -1, r = t.length, s = !1; ++o < r; ) {
    var i = _o(t[o]);
    if (!(s = e != null && n(e, i)))
      break;
    e = e[i];
  }
  return s || ++o != r ? s : (r = e == null ? 0 : e.length, !!r && Zl(r) && oa(i, r) && (Be(e) || ia(e)));
}
function Im(e, t) {
  return e != null && Iw(e, t, bw);
}
var Tw = 1, ww = 2;
function Cw(e, t) {
  return Yl(e) && vm(t) ? bm(_o(e), t) : function(n) {
    var o = Rb(n, e);
    return o === void 0 && o === t ? Im(n, e) : oc(t, o, Tw | ww);
  };
}
function Sw(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function Ow(e) {
  return function(t) {
    return ca(t, e);
  };
}
function Ew(e) {
  return Yl(e) ? Sw(_o(e)) : Ow(e);
}
function xw(e) {
  return typeof e == "function" ? e : e == null ? Fl : typeof e == "object" ? Be(e) ? Cw(e[0], e[1]) : vw(e) : Ew(e);
}
function Aw(e, t, n, o) {
  for (var r = -1, s = e == null ? 0 : e.length; ++r < s; ) {
    var i = e[r];
    t(o, i, n(i), e);
  }
  return o;
}
function Nw(e) {
  return function(t, n, o) {
    for (var r = -1, s = Object(t), i = o(t), a = i.length; a--; ) {
      var l = i[++r];
      if (n(s[l], l, s) === !1)
        break;
    }
    return t;
  };
}
var Mw = Nw();
function $w(e, t) {
  return e && Mw(e, t, ss);
}
function kw(e, t) {
  return function(n, o) {
    if (n == null)
      return n;
    if (!Lo(n))
      return e(n, o);
    for (var r = n.length, s = -1, i = Object(n); ++s < r && o(i[s], s, i) !== !1; )
      ;
    return n;
  };
}
var Dw = kw($w);
function Lw(e, t, n, o) {
  return Dw(e, function(r, s, i) {
    t(o, r, n(r), i);
  }), o;
}
function Rw(e, t) {
  return function(n, o) {
    var r = Be(n) ? Aw : Lw, s = t ? t() : {};
    return r(n, e, xw(o), s);
  };
}
function od(e) {
  return Ct(e) && Lo(e);
}
var _w = 200;
function Pw(e, t, n, o) {
  var r = -1, s = Mf, i = !0, a = e.length, l = [], c = t.length;
  if (!a)
    return l;
  t.length >= _w && (s = tc, i = !1, t = new Ao(t));
  e:
    for (; ++r < a; ) {
      var u = e[r], d = u;
      if (u = u !== 0 ? u : 0, i && d === d) {
        for (var m = c; m--; )
          if (t[m] === d)
            continue e;
        l.push(u);
      } else s(t, d, o) || l.push(u);
    }
  return l;
}
var rc = dv(function(e, t) {
  return od(e) ? Pw(e, Bf(t, 1, od, !0)) : [];
});
function Po(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
function is(e) {
  return e && e.length ? e[0] : void 0;
}
var Bw = Object.prototype, Ww = Bw.hasOwnProperty, as = Rw(function(e, t, n) {
  Ww.call(e, n) ? e[n].push(t) : jl(e, n, [t]);
});
function Uw(e, t) {
  return t.length < 2 ? e : ca(e, Vf(t, 0, -1));
}
var Vw = "[object Map]", Fw = "[object Set]", jw = Object.prototype, qw = jw.hasOwnProperty;
function Tm(e) {
  if (e == null)
    return !0;
  if (Lo(e) && (Be(e) || typeof e == "string" || typeof e.splice == "function" || zr(e) || zl(e) || ia(e)))
    return !e.length;
  var t = Ve(e);
  if (t == Vw || t == Fw)
    return !e.size;
  if (sa(e))
    return !Pf(e).length;
  for (var n in e)
    if (qw.call(e, n))
      return !1;
  return !0;
}
function Zw(e, t) {
  return t = Ro(t, e), e = Uw(e, t), e == null || delete e[_o(Po(t))];
}
function Hw(e) {
  return jb(e) ? void 0 : e;
}
var zw = 1, Gw = 2, Yw = 4, Kw = Wf(function(e, t) {
  var n = {};
  if (e == null)
    return n;
  var o = !1;
  t = Of(t, function(s) {
    return s = Ro(s, e), o || (o = s.length > 1), s;
  }), rs(e, mm(e), n), o && (n = Ur(n, zw | Gw | Yw, Hw));
  for (var r = t.length; r--; )
    Zw(n, t[r]);
  return n;
});
function Qw(e, t, n, o) {
  if (!ut(e))
    return e;
  t = Ro(t, e);
  for (var r = -1, s = t.length, i = s - 1, a = e; a != null && ++r < s; ) {
    var l = _o(t[r]), c = n;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return e;
    if (r != i) {
      var u = a[l];
      c = void 0, c === void 0 && (c = ut(u) ? u : oa(t[r + 1]) ? [] : {});
    }
    ql(a, l, c), a = a[l];
  }
  return e;
}
function Jw(e, t, n) {
  for (var o = -1, r = t.length, s = {}; ++o < r; ) {
    var i = t[o], a = ca(e, i);
    n(a, i) && Qw(s, Ro(i, e), a);
  }
  return s;
}
function Xw(e, t) {
  return Jw(e, t, function(n, o) {
    return Im(e, o);
  });
}
var Kr = Wf(function(e, t) {
  return e == null ? {} : Xw(e, t);
}), eC = Math.ceil, tC = Math.max;
function nC(e, t, n, o) {
  for (var r = -1, s = tC(eC((t - e) / (n || 1)), 0), i = Array(s); s--; )
    i[++r] = e, e += n;
  return i;
}
function oC(e) {
  return function(t, n, o) {
    return o && typeof o != "number" && mv(t, n, o) && (n = o = void 0), t = zs(t), n === void 0 ? (n = t, t = 0) : n = zs(n), o = o === void 0 ? t < n ? 1 : -1 : zs(o), nC(t, n, o);
  };
}
var rd = oC(), dt = lT("round"), rC = 1 / 0, sC = po && 1 / nc(new po([, -0]))[1] == rC ? function(e) {
  return new po(e);
} : Br, iC = 200;
function aC(e, t, n) {
  var o = -1, r = Mf, s = e.length, i = !0, a = [], l = a;
  if (s >= iC) {
    var c = sC(e);
    if (c)
      return nc(c);
    i = !1, r = tc, l = new Ao();
  } else
    l = a;
  e:
    for (; ++o < s; ) {
      var u = e[o], d = u;
      if (u = u !== 0 ? u : 0, i && d === d) {
        for (var m = l.length; m--; )
          if (l[m] === d)
            continue e;
        a.push(u);
      } else r(l, d, n) || (l !== a && l.push(d), a.push(u));
    }
  return a;
}
function ki(e) {
  return e && e.length ? aC(e) : [];
}
function B(e) {
  const t = new Set(e);
  return (n) => t.has(n);
}
function lC(e, ...t) {
  try {
    return e == null ? void 0 : e(...t);
  } catch (n) {
    console.error(n);
  }
}
const cC = (e) => {
  Promise.resolve().then(e);
}, zL = queueMicrotask ?? cC, Bo = (e) => (t) => typeof t === e, uC = Bo("object"), qe = Bo("boolean"), GL = Bo("function"), ie = Bo("number"), H = Bo("string"), dC = Bo("undefined"), wm = (e) => e === null, ve = (e) => wm(e) || dC(e), { isArray: Ce } = Array, jt = (e) => uC(e) && !wm(e) && !Ce(e), Cm = (e) => Number.isInteger(e), fC = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let mC = (e, t, n) => {
  let o = (2 << Math.log2(e.length - 1)) - 1, r = -~(1.6 * o * t / e.length);
  return (s = t) => {
    let i = "";
    for (; ; ) {
      let a = n(r), l = r | 0;
      for (; l--; )
        if (i += e[a[l] & o] || "", i.length >= s) return i;
    }
  };
};
const me = mC(fC, 21, (e) => {
  let t = globalThis.crypto;
  return t === void 0 && (t = require("node:crypto").webcrypto), t.getRandomValues(new Uint8Array(e));
}), Xe = (e, t) => (n) => Math.min(Math.max(n, e), t);
/*!
 * @dineug/erd-editor-schema
 * @version 0.1.0 | Thu Oct 15 2026
 * @author SeungHwan-Lee <dineug2@gmail.com>
 * @license MIT
 */
function O(e, t, n) {
  return (o) => {
    if (!n) return;
    const r = n[o];
    e(r) && (t[o] = r);
  };
}
function Ue(e) {
  return (t) => H(t) && e.includes(t);
}
function vt(e) {
  return (t) => ie(t) && e.includes(t);
}
function _e(e, t, n) {
  return Reflect.get(e, t) ?? n;
}
function Wo() {
  const e = Date.now();
  return {
    updateAt: e,
    createAt: e
  };
}
function Uo(e, t) {
  const n = O(ie, e, t);
  n("updateAt"), n("createAt");
}
const hC = () => ({
  tableIds: [],
  relationshipIds: [],
  indexIds: [],
  memoIds: []
});
function pC(e) {
  const t = hC();
  if (!jt(e) || ve(e)) return t;
  const n = O(Ce, t, e);
  return n("tableIds"), n("relationshipIds"), n("indexIds"), n("memoIds"), t;
}
const Sm = () => ({
  id: "",
  name: "",
  tableId: "",
  indexColumnIds: [],
  seqIndexColumnIds: [],
  unique: !1,
  meta: Wo()
});
function yC(e) {
  const t = {};
  if (!jt(e) || ve(e)) return t;
  for (const n of Object.values(e)) {
    if (!n) continue;
    const o = Sm(), r = O(H, o, n), s = O(qe, o, n), i = O(Ce, o, n);
    r("id"), r("name"), r("tableId"), s("unique"), i("indexColumnIds"), i("seqIndexColumnIds"), Uo(o.meta, n.meta), o.id && (t[o.id] = o);
  }
  return t;
}
const sc = {
  ASC: (
    /*  */
    1
  ),
  DESC: (
    /* */
    2
  )
}, gC = Object.values(sc), Om = () => ({
  id: "",
  indexId: "",
  columnId: "",
  orderType: sc.ASC,
  meta: Wo()
});
function vC(e) {
  const t = {};
  if (!jt(e) || ve(e)) return t;
  for (const n of Object.values(e)) {
    if (!n) continue;
    const o = Om(), r = O(H, o, n);
    r("id"), r("indexId"), r("columnId"), O(vt(gC), o, n)("orderType"), Uo(o.meta, n.meta), o.id && (t[o.id] = o);
  }
  return t;
}
const Em = () => ({
  id: "",
  value: "",
  ui: {
    x: 200,
    y: 100,
    zIndex: 2,
    width: 116,
    height: 100,
    color: ""
  },
  meta: Wo()
});
function bC(e) {
  const t = {};
  if (!jt(e) || ve(e)) return t;
  for (const n of Object.values(e)) {
    if (!n) continue;
    const o = Em(), r = O(H, o, n), s = O(ie, o.ui, n.ui), i = O(H, o.ui, n.ui);
    r("id"), r("value"), i("color"), s("x"), s("y"), s("zIndex"), s("width"), s("height"), Uo(o.meta, n.meta), o.id && (t[o.id] = o);
  }
  return t;
}
const ic = {
  // ZeroOneN: /* */ 0b0000000000000000000000000000001,
  ZeroOne: (
    /*  */
    2
  ),
  ZeroN: (
    /*    */
    4
  ),
  OneOnly: (
    /*  */
    8
  ),
  OneN: (
    /*     */
    16
  )
  // One: /*      */ 0b0000000000000000000000000100000,
  // N: /*        */ 0b0000000000000000000000001000000,
}, IC = Object.values(ic), ac = {
  ring: (
    /* */
    1
  ),
  dash: (
    /* */
    2
  )
}, TC = Object.values(
  ac
), Di = {
  left: (
    /*   */
    1
  ),
  right: (
    /*  */
    2
  ),
  top: (
    /*    */
    4
  ),
  bottom: (
    /* */
    8
  )
}, sd = Object.values(Di), xm = () => ({
  id: "",
  identification: !1,
  relationshipType: ic.ZeroN,
  startRelationshipType: ac.dash,
  start: {
    tableId: "",
    columnIds: [],
    x: 0,
    y: 0,
    direction: Di.bottom
  },
  end: {
    tableId: "",
    columnIds: [],
    x: 0,
    y: 0,
    direction: Di.bottom
  },
  meta: Wo()
});
function wC(e) {
  const t = {};
  if (!jt(e) || ve(e)) return t;
  for (const n of Object.values(e)) {
    if (!n) continue;
    const o = xm(), r = O(H, o, n), s = O(qe, o, n), i = O(ie, o.start, n.start), a = O(H, o.start, n.start), l = O(ie, o.end, n.end), c = O(H, o.end, n.end);
    r("id"), s("identification"), O(
      vt(IC),
      o,
      n
    )("relationshipType"), O(
      vt(TC),
      o,
      n
    )("startRelationshipType"), a("tableId"), i("x"), i("y"), O(vt(sd), o.start, n.start)("direction"), O(Ce, o.start, n.start)("columnIds"), c("tableId"), l("x"), l("y"), O(vt(sd), o.end, n.end)("direction"), O(Ce, o.end, n.end)("columnIds"), Uo(o.meta, n.meta), o.id && (t[o.id] = o);
  }
  return t;
}
const lc = {
  ERD: "ERD",
  visualization: "@dineug/erd-editor/builtin-visualization",
  schemaSQL: "@dineug/erd-editor/builtin-schema-sql",
  generatorCode: "@dineug/erd-editor/builtin-generator-code",
  settings: "settings"
}, CC = Object.values(lc), Yt = {
  tableComment: (
    /*        */
    1
  ),
  columnComment: (
    /*       */
    2
  ),
  columnDataType: (
    /*      */
    4
  ),
  columnDefault: (
    /*       */
    8
  ),
  columnAutoIncrement: (
    /* */
    16
  ),
  columnPrimaryKey: (
    /*    */
    32
  ),
  columnUnique: (
    /*        */
    64
  ),
  columnNotNull: (
    /*       */
    128
  ),
  relationship: (
    /*        */
    256
  )
}, Mt = {
  columnName: (
    /*          */
    1
  ),
  columnDataType: (
    /*      */
    2
  ),
  columnNotNull: (
    /*       */
    4
  ),
  columnUnique: (
    /*        */
    8
  ),
  columnAutoIncrement: (
    /* */
    16
  ),
  columnDefault: (
    /*       */
    32
  ),
  columnComment: (
    /*       */
    64
  )
}, ml = Object.values(Mt), cc = {
  MariaDB: (
    /*    */
    1
  ),
  MSSQL: (
    /*      */
    2
  ),
  MySQL: (
    /*      */
    4
  ),
  Oracle: (
    /*     */
    8
  ),
  PostgreSQL: (
    /* */
    16
  ),
  SQLite: (
    /*     */
    32
  )
}, Am = Object.values(cc), uc = {
  GraphQL: (
    /*    */
    1
  ),
  csharp: (
    /*     */
    2
  ),
  Java: (
    /*       */
    4
  ),
  Kotlin: (
    /*     */
    8
  ),
  TypeScript: (
    /* */
    16
  ),
  JPA: (
    /*        */
    32
  ),
  Scala: (
    /*      */
    64
  )
}, Nm = Object.values(uc), Li = {
  none: (
    /*       */
    1
  ),
  camelCase: (
    /*  */
    2
  ),
  pascalCase: (
    /* */
    4
  ),
  snakeCase: (
    /*  */
    8
  )
}, hl = Object.values(Li), dc = {
  none: (
    /*        */
    1
  ),
  doubleQuote: (
    /* */
    2
  ),
  singleQuote: (
    /* */
    4
  ),
  backtick: (
    /*    */
    8
  )
}, Mm = Object.values(dc), SC = {
  scroll: (
    /*    */
    1
  ),
  zoomLevel: (
    /* */
    2
  )
}, $m = 0.1, km = 1, Dm = 2e3, Lm = 2e4, OC = Yt.tableComment | Yt.columnComment | Yt.columnDataType | Yt.columnDefault | Yt.columnPrimaryKey | Yt.columnNotNull | Yt.relationship, EC = () => ({
  width: 2e3,
  height: 2e3,
  scrollTop: 0,
  scrollLeft: 0,
  zoomLevel: 1,
  show: OC,
  database: cc.MySQL,
  databaseName: "",
  canvasType: lc.ERD,
  language: uc.GraphQL,
  tableNameCase: Li.pascalCase,
  columnNameCase: Li.camelCase,
  bracketType: dc.none,
  relationshipDataTypeSync: !0,
  relationshipOptimization: !1,
  columnOrder: [
    Mt.columnName,
    Mt.columnDataType,
    Mt.columnNotNull,
    Mt.columnUnique,
    Mt.columnAutoIncrement,
    Mt.columnDefault,
    Mt.columnComment
  ],
  maxWidthComment: -1,
  ignoreSaveSettings: 0
}), id = Xe(Dm, Lm), xC = Xe($m, km), AC = Xe(60, 200);
function NC(e) {
  const t = EC();
  if (!jt(e) || ve(e)) return t;
  const n = O(ie, t, e), o = O(H, t, e), r = O(qe, t, e);
  return ie(e.width) && (t.width = id(e.width)), ie(e.height) && (t.height = id(e.height)), ie(e.zoomLevel) && (t.zoomLevel = xC(e.zoomLevel)), ie(e.maxWidthComment) && e.maxWidthComment !== -1 && (t.maxWidthComment = AC(e.maxWidthComment)), n("scrollTop"), n("scrollLeft"), n("show"), n("ignoreSaveSettings"), o("databaseName"), o("canvasType"), r("relationshipDataTypeSync"), r("relationshipOptimization"), O(vt(Am), t, e)("database"), O(vt(Nm), t, e)("language"), O(vt(hl), t, e)("tableNameCase"), O(vt(hl), t, e)("columnNameCase"), O(vt(Mm), t, e)("bracketType"), Ce(e.columnOrder) && ml.length === e.columnOrder.length && rc(ml, e.columnOrder).length === 0 && (t.columnOrder = e.columnOrder), t;
}
const Rm = () => ({
  id: "",
  name: "",
  comment: "",
  columnIds: [],
  seqColumnIds: [],
  ui: {
    x: 200,
    y: 100,
    zIndex: 2,
    widthName: 60,
    widthComment: 60,
    color: ""
  },
  meta: Wo()
});
function MC(e) {
  const t = {};
  if (!jt(e) || ve(e)) return t;
  for (const n of Object.values(e)) {
    if (!n) continue;
    const o = Rm(), r = O(H, o, n), s = O(Ce, o, n), i = O(ie, o.ui, n.ui), a = O(H, o.ui, n.ui);
    r("id"), r("name"), r("comment"), s("columnIds"), s("seqColumnIds"), a("color"), i("x"), i("y"), i("zIndex"), i("widthName"), i("widthComment"), Uo(o.meta, n.meta), o.id && (t[o.id] = o);
  }
  return t;
}
const _m = () => ({
  id: "",
  tableId: "",
  name: "",
  comment: "",
  dataType: "",
  default: "",
  options: 0,
  ui: {
    keys: 0,
    widthName: 60,
    widthComment: 60,
    widthDataType: 60,
    widthDefault: 60
  },
  meta: Wo()
});
function $C(e) {
  const t = {};
  if (!jt(e) || ve(e)) return t;
  for (const n of Object.values(e)) {
    if (!n) continue;
    const o = _m(), r = O(H, o, n), s = O(ie, o, n), i = O(ie, o.ui, n.ui);
    r("id"), r("tableId"), r("name"), r("comment"), r("dataType"), r("default"), s("options"), i("keys"), i("widthName"), i("widthComment"), i("widthDataType"), i("widthDefault"), Uo(o.meta, n.meta), o.id && (t[o.id] = o);
  }
  return t;
}
function Un(e) {
  var t, n, o, r, s, i;
  const a = e, l = NC(a.settings), c = pC(a.doc), u = MC(
    (t = a.collections) == null ? void 0 : t.tableEntities
  ), d = $C(
    (n = a.collections) == null ? void 0 : n.tableColumnEntities
  ), m = wC(
    (o = a.collections) == null ? void 0 : o.relationshipEntities
  ), f = yC(
    (r = a.collections) == null ? void 0 : r.indexEntities
  ), p = vC(
    (s = a.collections) == null ? void 0 : s.indexColumnEntities
  ), v = bC(
    (i = a.collections) == null ? void 0 : i.memoEntities
  );
  return {
    $schema: "https://raw.githubusercontent.com/dineug/erd-editor/main/json-schema/schema.json",
    version: "3.0.0",
    settings: l,
    doc: c,
    collections: {
      tableEntities: u,
      tableColumnEntities: d,
      relationshipEntities: m,
      indexEntities: f,
      indexColumnEntities: p,
      memoEntities: v
    }
  };
}
const kC = {
  autoIncrement: (
    /* */
    1
  ),
  primaryKey: (
    /*    */
    2
  ),
  unique: (
    /*        */
    4
  ),
  notNull: (
    /*       */
    8
  )
}, DC = {
  primaryKey: (
    /* */
    1
  ),
  foreignKey: (
    /* */
    2
  )
}, A = {
  CanvasType: lc,
  CanvasTypeList: CC,
  Show: Yt,
  ColumnType: Mt,
  ColumnTypeList: ml,
  Database: cc,
  DatabaseList: Am,
  Language: uc,
  LanguageList: Nm,
  NameCase: Li,
  NameCaseList: hl,
  BracketType: dc,
  BracketTypeList: Mm,
  RelationshipType: ic,
  StartRelationshipType: ac,
  Direction: Di,
  ColumnOption: kC,
  ColumnUIKey: DC,
  OrderType: sc,
  SaveSettingType: SC,
  CANVAS_SIZE_MAX: Lm,
  CANVAS_SIZE_MIN: Dm,
  CANVAS_ZOOM_MAX: km,
  CANVAS_ZOOM_MIN: $m
};
function LC(e) {
  const t = Un({});
  return RC(t.settings, e.canvas), _C(t, e.table), PC(t, e.memo), BC(t, e.relationship), t;
}
function RC(e, t) {
  e.width = t.width, e.height = t.height, e.scrollTop = t.scrollTop, e.scrollLeft = t.scrollLeft, e.zoomLevel = t.zoomLevel, e.databaseName = t.databaseName, e.canvasType = A.CanvasType.ERD, e.show = Object.keys(t.show).reduce((o, r) => {
    if (_e(t.show, r, !1)) {
      const s = _e(A.Show, r, 0);
      return o | s;
    }
    return o;
  }, 0), e.database = Reflect.get(A.Database, t.database) ?? A.Database.MySQL, e.language = t.language === "C#" ? A.Language.csharp : _e(
    A.Language,
    t.language,
    A.Language.GraphQL
  ), e.tableNameCase = _e(
    A.NameCase,
    t.tableCase,
    A.NameCase.pascalCase
  ), e.columnNameCase = _e(
    A.NameCase,
    t.columnCase,
    A.NameCase.camelCase
  ), e.bracketType = _e(
    A.BracketType,
    t.bracketType,
    A.BracketType.none
  ), e.relationshipDataTypeSync = t.setting.relationshipDataTypeSync, e.relationshipOptimization = t.setting.relationshipOptimization;
  const n = t.setting.columnOrder.map(
    (o) => A.ColumnType[o]
  );
  rc(A.ColumnTypeList, n).length === 0 && (e.columnOrder = n);
}
function _C(e, t) {
  const n = t.tables.filter(({ id: r }) => !!r), o = t.indexes.filter(({ id: r }) => !!r);
  e.doc.tableIds = n.map(({ id: r }) => r), e.doc.indexIds = o.map(({ id: r }) => r);
  for (const r of n) {
    const s = Rm();
    s.id = r.id, s.name = r.name, s.comment = r.comment, s.columnIds = r.columns.map(({ id: i }) => i), s.seqColumnIds = [...s.columnIds], s.ui.y = r.ui.top, s.ui.x = r.ui.left, s.ui.zIndex = r.ui.zIndex, s.ui.widthName = r.ui.widthName, s.ui.widthComment = r.ui.widthComment, s.ui.color = r.ui.color ?? "";
    for (const i of r.columns) {
      const a = _m();
      a.id = i.id, a.tableId = r.id, a.name = i.name, a.comment = i.comment, a.dataType = i.dataType, a.default = i.default, a.options = Object.keys(i.option).reduce((l, c) => {
        if (_e(i.option, c, !1)) {
          const u = _e(A.ColumnOption, c, 0);
          return l | u;
        }
        return l;
      }, 0), a.ui.widthName = i.ui.widthName, a.ui.widthComment = i.ui.widthComment, a.ui.widthDataType = i.ui.widthDataType, a.ui.widthDefault = i.ui.widthDefault, i.ui.pfk ? a.ui.keys = A.ColumnUIKey.primaryKey | A.ColumnUIKey.foreignKey : i.ui.pk ? a.ui.keys = A.ColumnUIKey.primaryKey : i.ui.fk && (a.ui.keys = A.ColumnUIKey.foreignKey), e.collections.tableColumnEntities[a.id] = a;
    }
    e.collections.tableEntities[s.id] = s;
  }
  for (const r of o) {
    const s = Sm();
    s.id = r.id, s.name = r.name, s.tableId = r.tableId, s.unique = r.unique;
    for (const i of r.columns) {
      const a = me(), l = Om();
      s.indexColumnIds.push(a), s.seqIndexColumnIds.push(a), l.id = a, l.indexId = r.id, l.columnId = i.id, l.orderType = _e(
        A.OrderType,
        i.orderType,
        A.OrderType.ASC
      ), e.collections.indexColumnEntities[l.id] = l;
    }
    e.collections.indexEntities[s.id] = s;
  }
}
function PC(e, t) {
  const n = t.memos.filter(({ id: o }) => !!o);
  e.doc.memoIds = n.map(({ id: o }) => o);
  for (const o of n) {
    const r = Em();
    r.id = o.id, r.value = o.value, r.ui.y = o.ui.top, r.ui.x = o.ui.left, r.ui.width = o.ui.width, r.ui.height = o.ui.height, r.ui.zIndex = o.ui.zIndex, r.ui.color = o.ui.color ?? "", e.collections.memoEntities[r.id] = r;
  }
}
function BC(e, t) {
  const n = t.relationships.filter(({ id: o }) => !!o);
  e.doc.relationshipIds = n.map(({ id: o }) => o);
  for (const o of n) {
    const r = xm();
    r.id = o.id, r.identification = o.identification, r.relationshipType = _e(
      A.RelationshipType,
      o.relationshipType,
      A.RelationshipType.ZeroN
    ), r.startRelationshipType = _e(
      A.StartRelationshipType,
      o.startRelationshipType === "Ring" ? "ring" : "dash",
      A.StartRelationshipType.dash
    ), r.start.tableId = o.start.tableId, r.start.columnIds = o.start.columnIds, r.start.x = o.start.x, r.start.y = o.start.y, r.start.direction = _e(
      A.Direction,
      o.start.direction,
      A.Direction.bottom
    ), r.end.tableId = o.end.tableId, r.end.columnIds = o.end.columnIds, r.end.x = o.end.x, r.end.y = o.end.y, r.end.direction = _e(
      A.Direction,
      o.end.direction,
      A.Direction.bottom
    ), e.collections.relationshipEntities[r.id] = r;
  }
}
function WC(e) {
  return [e, -1, -1, {}];
}
function fc(e, t, n) {
  return e[t] || (e[t] = WC(n), e[t]);
}
function Pm(e, t, n, o, r) {
  const s = fc(e, n, o), i = s[1], a = s[2];
  i < t && (s[1] = t), a < t && r();
}
function Bm(e, t, n, o, r) {
  const s = fc(e, n, o), i = s[2], a = s[1];
  i < t && (s[2] = t), a <= t && r();
}
function mc(e, t, n, o, r, s) {
  const i = fc(e, n, o);
  (i[3][r] ?? -1) <= t && (i[3][r] = t, s());
}
let UC = class {
  constructor(t) {
    this.collections = t;
  }
  collection(t) {
    return new VC(this.collections[t], t);
  }
}, VC = class {
  constructor(t, n) {
    this.collection = t, this.collectionKey = n;
  }
  selectById(t) {
    return this.collection[t];
  }
  selectByIds(t) {
    return t.length, t.map((n) => this.selectById(n)).filter(Boolean);
  }
  selectEntities() {
    return this.collection;
  }
  selectAll() {
    return Object.values(this.collection);
  }
  setOne(t) {
    return this.collection[t.id] = t, this;
  }
  setMany(t) {
    return t.forEach((n) => this.setOne(n)), this;
  }
  setAll(t) {
    return this.removeAll(), this.setMany(t), this;
  }
  addOne(t) {
    return this.selectById(t.id) ? this : (this.setOne(t), this);
  }
  addMany(t) {
    return t.forEach((n) => this.addOne(n)), this;
  }
  removeOne(t) {
    return this.selectById(t) && Reflect.deleteProperty(this.collection, t), this;
  }
  removeMany(t) {
    return t.forEach((n) => this.removeOne(n)), this;
  }
  removeAll() {
    return this.collection = {}, this;
  }
  updateOne(t, n) {
    const o = this.selectById(t);
    return o && (n(o), o.meta.updateAt = Date.now()), this;
  }
  updateMany(t, n) {
    return t.forEach((o) => this.updateOne(o, n)), this;
  }
  getOrCreate(t, n) {
    const o = this.selectById(t);
    if (o) return o;
    const r = n(t);
    return this.setOne(r), this.selectById(t);
  }
  addOperator(t, n, o, r) {
    return Pm(t, n, o, this.collectionKey, r), this;
  }
  removeOperator(t, n, o, r) {
    return Bm(t, n, o, this.collectionKey, r), this;
  }
  replaceOperator(t, n, o, r, s) {
    return mc(t, n, o, this.collectionKey, r, s), this;
  }
};
const y = (e) => new UC(e);
function ad(e, t) {
  return (e & t) === t;
}
const FC = {
  columnUnique: "columnUnique",
  columnAutoIncrement: "columnAutoIncrement",
  columnName: "columnName",
  columnDataType: "columnDataType",
  columnNotNull: "columnNotNull",
  columnDefault: "columnDefault",
  columnComment: "columnComment"
}, ld = Object.values(FC), jC = {
  ERD: "ERD",
  "@vuerd/builtin-sql-ddl": "@vuerd/builtin-sql-ddl",
  "@vuerd/builtin-grid": "@vuerd/builtin-grid",
  "@vuerd/builtin-generator-code": "@vuerd/builtin-generator-code",
  "@vuerd/builtin-visualization": "@vuerd/builtin-visualization"
}, qC = Object.values(jC), ZC = {
  MariaDB: "MariaDB",
  MSSQL: "MSSQL",
  MySQL: "MySQL",
  Oracle: "Oracle",
  PostgreSQL: "PostgreSQL",
  SQLite: "SQLite"
}, HC = Object.values(ZC), zC = {
  GraphQL: "GraphQL",
  "C#": "C#",
  Java: "Java",
  Kotlin: "Kotlin",
  TypeScript: "TypeScript",
  JPA: "JPA",
  Scala: "Scala"
}, GC = Object.values(zC), YC = {
  none: "none",
  camelCase: "camelCase",
  pascalCase: "pascalCase",
  snakeCase: "snakeCase"
}, cd = Object.values(YC), KC = {
  AtomOneDark: "AtomOneDark",
  AtomOneLight: "AtomOneLight",
  MonokaiSublime: "MonokaiSublime",
  GithubGist: "GithubGist",
  VS2015: "VS2015"
}, QC = Object.values(KC), JC = {
  none: "none",
  doubleQuote: "doubleQuote",
  singleQuote: "singleQuote",
  backtick: "backtick"
}, XC = Object.values(JC), e1 = 0.1, t1 = 1, n1 = 2e3, o1 = 2e4, r1 = () => ({
  version: "2.2.11",
  width: 2e3,
  height: 2e3,
  scrollTop: 0,
  scrollLeft: 0,
  zoomLevel: 1,
  show: {
    tableComment: !0,
    columnComment: !0,
    columnDataType: !0,
    columnDefault: !0,
    columnAutoIncrement: !1,
    columnPrimaryKey: !0,
    columnUnique: !1,
    columnNotNull: !0,
    relationship: !0
  },
  database: "MySQL",
  databaseName: "",
  canvasType: "ERD",
  language: "GraphQL",
  tableCase: "pascalCase",
  columnCase: "camelCase",
  highlightTheme: "VS2015",
  bracketType: "none",
  setting: {
    relationshipDataTypeSync: !0,
    relationshipOptimization: !1,
    columnOrder: [
      "columnName",
      "columnDataType",
      "columnNotNull",
      "columnUnique",
      "columnAutoIncrement",
      "columnDefault",
      "columnComment"
    ]
  },
  pluginSerializationMap: {}
}), ud = Xe(n1, o1), s1 = Xe(e1, t1);
function i1(e) {
  var t;
  const n = r1();
  if (ve(e)) return n;
  const o = O(ie, n, e), r = O(H, n, e), s = O(qe, n.show, e.show), i = O(qe, n.setting, e.setting);
  if (ie(e.width) && (n.width = ud(e.width)), ie(e.height) && (n.height = ud(e.height)), ie(e.zoomLevel) && (n.zoomLevel = s1(e.zoomLevel)), r("version"), r("databaseName"), o("scrollTop"), o("scrollLeft"), O(Ue(HC), n, e)("database"), O(Ue(qC), n, e)("canvasType"), O(Ue(GC), n, e)("language"), O(Ue(cd), n, e)("tableCase"), O(Ue(cd), n, e)("columnCase"), O(Ue(QC), n, e)("highlightTheme"), O(Ue(XC), n, e)("bracketType"), s("tableComment"), s("columnComment"), s("columnDataType"), s("columnDefault"), s("columnAutoIncrement"), s("columnPrimaryKey"), s("columnUnique"), s("columnNotNull"), s("relationship"), i("relationshipDataTypeSync"), i("relationshipOptimization"), (t = e.setting) != null && t.columnOrder && ld.length === e.setting.columnOrder.length && rc(ld, e.setting.columnOrder).length === 0 && (n.setting.columnOrder = e.setting.columnOrder), jt(e.pluginSerializationMap)) {
    const a = e.pluginSerializationMap;
    for (const l of Object.keys(a)) {
      const c = a[l];
      H(c) && (n.pluginSerializationMap[l] = c);
    }
  }
  return n;
}
const a1 = () => ({
  memos: []
}), l1 = () => ({
  id: "",
  value: "",
  ui: {
    active: !1,
    left: 200,
    top: 200,
    zIndex: 2,
    width: 127,
    height: 127
  }
});
function c1(e) {
  const t = a1();
  if (ve(e) || !Ce(e.memos))
    return t;
  for (const n of e.memos) {
    const o = l1(), r = O(H, o, n), s = O(ie, o.ui, n.ui), i = O(qe, o.ui, n.ui), a = O(H, o.ui, n.ui);
    r("id"), r("value"), i("active"), a("color"), s("left"), s("top"), s("zIndex"), s("width"), s("height"), t.memos.push(o);
  }
  return t;
}
const u1 = ["ZeroOneN", "One", "N"], d1 = {
  ZeroOneN: "ZeroN",
  One: "OneOnly",
  N: "OneN"
}, f1 = (e) => u1.includes(e) ? d1[e] : e, pr = {
  ZeroOneN: "ZeroOneN",
  ZeroOne: "ZeroOne",
  ZeroN: "ZeroN",
  OneOnly: "OneOnly",
  OneN: "OneN",
  One: "One",
  N: "N"
}, m1 = Object.values(pr), h1 = {
  Ring: "Ring",
  Dash: "Dash"
}, p1 = Object.values(
  h1
), yr = {
  left: "left",
  right: "right",
  top: "top",
  bottom: "bottom"
}, dd = Object.values(yr), y1 = () => ({
  relationships: []
}), g1 = () => ({
  id: "",
  identification: !1,
  relationshipType: "ZeroN",
  startRelationshipType: "Dash",
  start: {
    tableId: "",
    columnIds: [],
    x: 0,
    y: 0,
    direction: "bottom"
  },
  end: {
    tableId: "",
    columnIds: [],
    x: 0,
    y: 0,
    direction: "bottom"
  },
  constraintName: "",
  visible: !0
});
function v1(e) {
  var t, n, o, r;
  const s = y1();
  if (ve(e) || !Ce(e.relationships))
    return s;
  for (const i of e.relationships) {
    const a = g1(), l = O(H, a, i), c = O(qe, a, i), u = O(
      ie,
      a.start,
      i.start
    ), d = O(
      H,
      a.start,
      i.start
    ), m = O(ie, a.end, i.end), f = O(H, a.end, i.end);
    l("id"), l("constraintName"), c("identification"), c("visible"), O(
      Ue(m1),
      a,
      i
    )("relationshipType"), a.relationshipType = f1(
      a.relationshipType
    ), O(
      Ue(p1),
      a,
      i
    )("startRelationshipType"), d("tableId"), u("x"), u("y"), O(
      Ue(dd),
      a.start,
      i.start
    )("direction"), Ce((t = i.start) == null ? void 0 : t.columnIds) && (a.start.columnIds = (n = i.start) == null ? void 0 : n.columnIds.filter(
      H
    )), f("tableId"), m("x"), m("y"), O(
      Ue(dd),
      a.end,
      i.end
    )("direction"), Ce((o = i.end) == null ? void 0 : o.columnIds) && (a.end.columnIds = (r = i.end) == null ? void 0 : r.columnIds.filter(
      H
    )), s.relationships.push(a);
  }
  return s;
}
const Wm = {
  ASC: "ASC",
  DESC: "DESC"
}, b1 = Object.values(Wm), I1 = () => ({
  tables: [],
  indexes: []
}), T1 = () => ({
  id: "",
  name: "",
  comment: "",
  columns: [],
  ui: {
    active: !1,
    left: 200,
    top: 100,
    zIndex: 2,
    widthName: 60,
    widthComment: 60
  },
  visible: !0
}), w1 = () => ({
  id: "",
  name: "",
  comment: "",
  dataType: "",
  default: "",
  option: {
    autoIncrement: !1,
    primaryKey: !1,
    unique: !1,
    notNull: !1
  },
  ui: {
    active: !1,
    pk: !1,
    fk: !1,
    pfk: !1,
    widthName: 60,
    widthComment: 60,
    widthDataType: 60,
    widthDefault: 60
  }
}), C1 = () => ({
  id: "",
  name: "",
  tableId: "",
  columns: [],
  unique: !1
}), S1 = () => ({
  id: "",
  orderType: Wm.ASC
});
function O1(e) {
  const t = I1();
  if (ve(e)) return t;
  if (Ce(e.tables))
    for (const n of e.tables) {
      const o = T1(), r = O(H, o, n), s = O(qe, o, n), i = O(ie, o.ui, n.ui), a = O(qe, o.ui, n.ui), l = O(H, o.ui, n.ui);
      if (r("id"), r("name"), r("comment"), s("visible"), a("active"), l("color"), i("left"), i("top"), i("zIndex"), i("widthName"), i("widthComment"), Ce(n.columns))
        for (const c of n.columns) {
          const u = w1(), d = O(H, u, c), m = O(ie, u.ui, c.ui), f = O(qe, u.ui, c.ui), p = O(
            qe,
            u.option,
            c.option
          );
          d("id"), d("name"), d("comment"), d("dataType"), d("default"), p("autoIncrement"), p("primaryKey"), p("unique"), p("notNull"), f("active"), f("pk"), f("fk"), f("pfk"), m("widthName"), m("widthComment"), m("widthDataType"), m("widthDefault"), o.columns.push(u);
        }
      t.tables.push(o);
    }
  if (Ce(e.indexes))
    for (const n of e.indexes) {
      const o = C1(), r = O(H, o, n), s = O(qe, o, n);
      if (r("id"), r("name"), r("tableId"), s("unique"), Ce(n.columns))
        for (const i of n.columns) {
          const a = S1();
          O(H, a, i)("id"), O(Ue(b1), a, i)("orderType"), o.columns.push(a);
        }
      t.indexes.push(o);
    }
  return t;
}
function E1(e) {
  const t = e, n = i1(t.canvas), o = O1(t.table), r = v1(t.relationship), s = c1(t.memo);
  return { canvas: n, table: o, relationship: r, memo: s };
}
A.RelationshipType.ZeroOne + "", pr.ZeroOne, A.RelationshipType.ZeroN + "", pr.ZeroN, A.RelationshipType.OneOnly + "", pr.OneOnly, A.RelationshipType.OneN + "", pr.OneN;
A.Direction.left + "", yr.left, A.Direction.right + "", yr.right, A.Direction.top + "", yr.top, A.Direction.bottom + "", yr.bottom;
function Um(e) {
  const t = JSON.parse(e);
  return Reflect.get(t, "version") === "3.0.0" ? Un(t) : LC(E1(t));
}
function hc(e) {
  const t = Kr(e, [
    "$schema",
    "version",
    "settings",
    "doc",
    "collections"
  ]);
  return ad(
    t.settings.ignoreSaveSettings,
    A.SaveSettingType.scroll
  ) && (t.settings.scrollTop = 0, t.settings.scrollLeft = 0), ad(
    t.settings.ignoreSaveSettings,
    A.SaveSettingType.zoomLevel
  ) && (t.settings.zoomLevel = 1), JSON.stringify(t, null, 2);
}
var x1 = Object.defineProperty, Vm = (e) => {
  throw TypeError(e);
}, A1 = (e, t, n) => t in e ? x1(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, W = (e, t, n) => A1(e, typeof t != "symbol" ? t + "" : t, n), Fm = (e, t, n) => t.has(e) || Vm("Cannot " + n), h = (e, t, n) => (Fm(e, t, "read from private field"), n ? n.call(e) : t.get(e)), T = (e, t, n) => t.has(e) ? Vm("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), w = (e, t, n, o) => (Fm(e, t, "write to private field"), t.set(e, n), n);
/*!
 * @dineug/r-html
 * @version 0.1.3 | Thu Oct 15 2026
 * @author SeungHwan-Lee <dineug2@gmail.com>
 * @license MIT
 */
function QL(e, t) {
  return Object.freeze({ key: Symbol(), value: e });
}
const jm = {
  subscribe: "@@r-html/context-subscribe",
  unsubscribe: "@@r-html/context-unsubscribe"
};
function qm(e, t) {
  function n(o, r) {
    return new CustomEvent(e, {
      detail: o,
      ...t,
      ...r
    });
  }
  return n.toString = () => `${e}`, n.type = e, n;
}
const yo = qm(jm.subscribe, { bubbles: !0, composed: !0 }), go = qm(jm.unsubscribe, { bubbles: !0, composed: !0 });
function N1(e, t) {
  const n = (r) => {
    const s = r;
    t.dispatchEvent(yo(s.detail));
  }, o = (r) => {
    const s = r;
    t.dispatchEvent(go(s.detail));
  };
  return e.addEventListener(yo.type, n), e.addEventListener(go.type, o), () => {
    e.removeEventListener(yo.type, n), e.removeEventListener(
      go.type,
      o
    );
  };
}
function da(e, ...t) {
  try {
    return e == null ? void 0 : e(...t);
  } catch (n) {
    console.error(n);
  }
}
const M1 = (e) => {
  Promise.resolve().then(e);
}, Zm = queueMicrotask ?? M1, sn = (e) => (t) => typeof t === e, Hm = sn("object"), $1 = sn("bigint"), zm = sn("boolean"), tn = sn("function"), k1 = sn("number"), Gm = sn("string"), D1 = sn("symbol"), ft = sn("undefined"), Bt = (e) => e === null, { isArray: pe } = Array, Se = (e) => Hm(e) && !Bt(e) && !pe(e), ls = (e) => $1(e) || zm(e) || k1(e) || Gm(e) || D1(e) || ft(e) || Bt(e);
function Qr() {
  const e = /* @__PURE__ */ new Set(), t = (n) => (e.has(n) || e.add(n), () => {
    e.delete(n);
  });
  return {
    subscribe: t,
    next: (n) => {
      e.forEach((o) => o(n));
    },
    asReadonly: () => ({ subscribe: t })
  };
}
const L1 = 1, fa = [], pl = /* @__PURE__ */ new Map(), $s = /* @__PURE__ */ new Map();
let yl = !0, pc = 0;
function R1(e, t, n) {
  const o = Jr.get(n);
  if (!o) return !1;
  const r = o.get(e);
  return r ? r.has(t) : !1;
}
const Ym = (e) => (t) => {
  const n = pl.get(t);
  let o = () => {
  };
  const r = n != null && n.promise ? n.promise : new Promise((s) => {
    o = s;
  });
  if (!n) {
    const s = {
      type: e,
      tickCount: pc,
      promise: r,
      fn: t,
      resolve: () => {
        o();
      }
    };
    fa.push(s), pl.set(t, s);
  }
  return yl && (Zm(U1), yl = !1), r;
}, _1 = Ym("observer"), P1 = Ym("nextTick"), fd = (e, t) => {
  var n;
  return (n = _i.get(e)) == null ? void 0 : n.forEach(
    (o) => R1(e, t, o) && _1(o)
  );
};
function Km() {
  const e = fa.shift();
  if (e) {
    if (pl.delete(e.fn), e.type === "observer")
      Qm(e.fn), bc(e.fn), e.resolve();
    else if (e.type === "nextTick") {
      const t = da(e.fn);
      t instanceof Promise ? t.finally(e.resolve) : e.resolve();
    }
    B1() && Km();
  }
}
function B1() {
  const e = fa[0];
  return e ? L1 <= pc - e.tickCount : !1;
}
function W1() {
  for (; fa.length; )
    Km();
  yl = !0, pc = 0;
}
function U1() {
  W1();
}
function md(e, t) {
  const n = Ys.get(e);
  if (!n) return;
  const o = vl.get(n);
  if (!o) return;
  const r = $s.get(n);
  r ? r.has(t) || r.add(t) : ($s.set(n, /* @__PURE__ */ new Set([t])), P1(() => {
    const s = $s.get(n);
    s && ($s.delete(n), s.forEach((i) => o.next(i)));
  }));
}
const V1 = "on", F1 = "@", j1 = ".", q1 = "?", Z1 = "...", H1 = "@@r-html", z1 = Math.random().toString().substring(2, 8), nn = `${H1}-${z1}`, G1 = `${Z1}${nn}`, gl = new RegExp(`${nn}_(\\d+)_`, "g"), Y1 = new RegExp(`^${nn}_\\d+_$`), K1 = /^\n/;
var te = /* @__PURE__ */ ((e) => (e.attribute = "attribute", e.boolean = "boolean", e.event = "event", e.property = "property", e.spread = "spread", e.directive = "directive", e))(te || {});
const ma = Symbol.for(
  "https://github.com/dineug/r-html#beforeMount"
), ha = Symbol.for("https://github.com/dineug/r-html#mounted"), pa = Symbol.for(
  "https://github.com/dineug/r-html#unmounted"
), yc = Symbol.for(
  "https://github.com/dineug/r-html#beforeFirstUpdate"
), ya = Symbol.for(
  "https://github.com/dineug/r-html#beforeUpdate"
), gc = Symbol.for(
  "https://github.com/dineug/r-html#firstUpdated"
), ga = Symbol.for("https://github.com/dineug/r-html#updated"), Q1 = [
  ma,
  ha,
  pa,
  yc,
  ya,
  gc,
  ga
], vc = Symbol.for(
  "https://github.com/dineug/r-html#Directive"
), xn = Symbol.for(
  "https://github.com/dineug/r-html#TemplateLiterals"
);
let Gs = null;
function Ri(e) {
  Gs = e;
}
const cs = (e) => (t) => {
  Gs && (Gs[e] ?? (Gs[e] = [])).push(t);
}, J1 = cs(ma), JL = cs(ha), X1 = cs(pa), XL = cs(ya), eR = cs(ga);
function Fe(e, t) {
  const n = Reflect.get(e, t, e);
  pe(n) && n.forEach(da);
}
function eS(e) {
  Q1.forEach((t) => Reflect.set(e, t, null, e));
}
const tS = Qr(), nS = (e) => e, oS = (e) => {
  var t, n, o;
  return o = class extends e {
    constructor(r, s, i) {
      super(r, s, i), T(this, t, []), T(this, n, null), this.hmr();
    }
    commit(r) {
      const s = nS(r);
      super.commit(s), w(this, t, r);
    }
    hmr() {
      w(this, n, tS.subscribe(
        (r) => h(this, t).includes(r) && this.commit(h(this, t))
      ));
    }
    destroy() {
      var r, s;
      (r = h(this, n)) == null || r.call(this), (s = super.destroy) == null || s.call(this);
    }
  }, t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), o;
}, Ys = /* @__PURE__ */ new WeakMap(), _i = /* @__PURE__ */ new WeakMap(), hd = /* @__PURE__ */ new WeakMap(), vl = /* @__PURE__ */ new WeakMap(), Jr = /* @__PURE__ */ new WeakMap(), rS = { shallow: !1 };
let $t = null;
function bc(e) {
  return $t = e, da(e), $t = null, () => Qm(e);
}
function Qm(e) {
  const t = Jr.get(e);
  if (t)
    for (const [n] of t.entries()) {
      const o = _i.get(n);
      o == null || o.delete(e);
    }
  t && Jr.delete(e);
}
function sS(e) {
  if (!$t) return;
  const t = _i.get(e);
  t ? t.has($t) || t.add($t) : _i.set(e, /* @__PURE__ */ new Set([$t]));
}
function iS(e, t) {
  if (!$t) return;
  const n = Jr.get($t);
  if (n) {
    const o = n.get(e);
    o ? o.has(t) || o.add(t) : n.set(e, /* @__PURE__ */ new Set([t]));
  } else
    Jr.set($t, /* @__PURE__ */ new Map([[e, /* @__PURE__ */ new Set([t])]]));
}
const aS = (e) => e instanceof Node || e instanceof Map || e instanceof Set || e instanceof WeakMap || e instanceof WeakSet || e instanceof RegExp || e instanceof Date || e instanceof Promise || (pe(e) || Se(e)) && Object.isFrozen(e);
function us(e, t = {}) {
  const { shallow: n } = Object.assign({}, rS, t), o = new Proxy(e, {
    get(r, s, i) {
      const a = Reflect.get(r, s, i);
      return aS(a) ? a : (sS(e), iS(e, s), !n && (Se(a) || pe(a)) && !hd.has(a) ? Ys.has(a) ? Ys.get(a) : us(a, t) : a);
    },
    set(r, s, i, a) {
      const l = Reflect.get(r, s, a), c = Reflect.set(r, s, i, a);
      return (!pe(r) && l !== i || s === "length") && (fd(r, s), md(r, s)), c;
    },
    deleteProperty(r, s) {
      const i = Reflect.deleteProperty(r, s);
      return fd(r, s), md(r, s), i;
    }
  });
  return Ys.set(e, o), hd.set(o, e), o;
}
function tR(e) {
  return (vl.get(e) ?? vl.set(e, Qr()).get(e)).asReadonly();
}
function nR(e, t) {
  const n = us({ value: t.value }, { shallow: !0 }), o = (i) => {
    n.value = i;
  }, r = () => e instanceof HTMLElement ? e : e.parentElement ?? e.host, s = () => {
    r().dispatchEvent(
      yo({
        context: t,
        observer: o
      })
    );
  };
  return s(), J1(s), X1(() => {
    r().dispatchEvent(
      go({
        context: t,
        observer: o
      })
    );
  }), n;
}
function oR(e, t, n) {
  const o = e instanceof HTMLElement ? e : e.parentElement ?? e.host, r = Qr(), s = /* @__PURE__ */ new Map(), i = (l) => {
    var c, u;
    const d = l;
    ((u = (c = d.detail) == null ? void 0 : c.context) == null ? void 0 : u.key) === t.key && (d.stopPropagation(), d.detail.observer(n), s.set(
      d.detail.observer,
      r.subscribe(d.detail.observer)
    ));
  }, a = (l) => {
    var c, u;
    const d = l;
    if (((u = (c = d.detail) == null ? void 0 : c.context) == null ? void 0 : u.key) === t.key) {
      d.stopPropagation();
      const m = s.get(d.detail.observer);
      m == null || m(), s.delete(d.detail.observer);
    }
  };
  return o.addEventListener(yo.type, i), o.addEventListener(
    go.type,
    a
  ), {
    set: (l) => {
      r.next(l);
    },
    destroy: () => {
      o.removeEventListener(
        yo.type,
        i
      ), o.removeEventListener(
        go.type,
        a
      );
      for (const l of s.values())
        l();
      s.clear();
    }
  };
}
const lS = "__REDUX_DEVTOOLS_EXTENSION__";
function rR(e, t) {
  const n = Reflect.get(window, lS), o = n == null ? void 0 : n.connect(t);
  o == null || o.init(e.state);
  const r = e.subscribe((s) => {
    o == null || o.send(
      {
        type: s.map((i) => i.type).join(" |> "),
        actions: s
      },
      e.state
    );
  });
  return () => {
    o == null || o.unsubscribe(), r();
  };
}
var $e = /* @__PURE__ */ ((e) => (e.element = "element", e.text = "text", e.comment = "comment", e))($e || {});
class wn {
  constructor(t = {}) {
    W(this, "type", "comment"), W(this, "value", ""), W(this, "attrs"), W(this, "parent", null), W(this, "children"), Object.assign(this, t);
  }
  *iterParent() {
    yield this, this.parent && (yield* this.parent.iterParent());
  }
  *[Symbol.iterator]() {
    if (yield this, !!this.children)
      for (const t of this.children)
        yield* t;
  }
}
const cS = (e, t = !1) => t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e), uS = ({ type: e, value: t }, n = !1) => e === $e.element ? cS(t, n) : e === $e.text ? document.createTextNode(t) : document.createComment(t), Ic = (e) => !!e && e !== "false";
function dS(e, { type: t, name: n, value: o }) {
  switch (t) {
    case te.attribute:
      e.setAttribute(n, o ?? "");
      break;
    case te.boolean:
      Ic(o) && e.setAttribute(n, "");
      break;
    case te.property:
      Reflect.set(e, n, o, e);
      break;
  }
}
function fS(e, { type: t, name: n, value: o }) {
  switch (t) {
    case te.attribute:
    case te.property:
      Reflect.set(e, n, o);
      break;
    case te.boolean:
      Reflect.set(e, n, Ic(o));
      break;
  }
}
const Rn = (e, t) => e.length === t.length && e.every((n, o) => n === t[o]);
function bl(e, t) {
  if (e === t)
    return !0;
  const n = Se(e) ? e : {}, o = Se(t) ? t : {}, r = Object.keys(n), s = Object.keys(o);
  return r.length === s.length && s.every(
    (i) => Reflect.get(n, i) === Reflect.get(o, i)
  );
}
const mS = (e) => pe(e) && tn(e[0]) && (ft(e[1]) || zm(e[1]) || Se(e[1]));
function et(e, t) {
  const n = t.parentNode;
  n && n.insertBefore(e, t);
}
function tt(e, t) {
  const n = t.parentNode;
  n && (t.nextSibling ? n.insertBefore(e, t.nextSibling) : n.appendChild(e));
}
const ke = (e) => e.parentNode && e.parentNode.removeChild(e), hS = (e) => e instanceof Node;
function De(e, t) {
  const n = [];
  let o = e.nextSibling;
  for (; o && o !== t; )
    n.push(o), o = o.nextSibling;
  return n;
}
const Il = () => {
}, pd = (e) => e instanceof HTMLElement, yd = (e) => e instanceof SVGElement, pS = (e) => e instanceof Promise, yS = (e) => {
  var t;
  return ((t = e.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)) == null ? void 0 : t.join("-").toLowerCase()) ?? "";
}, sr = (e) => e.replace(
  /^([A-Z])|[\s-_](\w)/g,
  (t, n, o) => o ? o.toUpperCase() : n.toLowerCase()
);
var Wt = /* @__PURE__ */ ((e) => (e.html = "html", e.svg = "svg", e.css = "css", e))(Wt || {});
const gS = new Set(
  Object.values(Wt)
), Va = /* @__PURE__ */ new WeakMap(), Fa = /* @__PURE__ */ new WeakMap(), vS = /* @__PURE__ */ new Set([Wt.svg]), Jm = (e) => `${nn}_${e}_`, bS = (e) => pe(e) && pe(e.raw), va = (e) => Se(e) && bS(e.strings) && pe(e.values) && gS.has(Reflect.get(e, xn) ?? ""), ba = (e) => va(e) && e[xn] === Wt.css, Vo = (e, t = !0, n = !1) => (o) => t ? !!(o != null && o.trimStart().startsWith(e)) : n ? !!(o != null && o.trimEnd().endsWith(e)) : new RegExp(e).test(o ?? ""), Xm = Vo(G1), eh = Vo(j1), th = Vo(q1), nh = Vo(F1), oh = Vo(V1), No = Vo(nn, !1), ds = (e) => No(e) && Y1.test((e == null ? void 0 : e.trim()) ?? ""), gd = ({ type: e, value: t }) => e === te.spread || e === te.directive || No(t), IS = (e) => vS.has(e), vd = (e) => ds(e) ? te.directive : Xm(e) ? te.spread : eh(e) ? te.property : nh(e) || oh(e) ? te.event : th(e) ? te.boolean : te.attribute, ks = (e) => Xm(e) ? e.substring(3) : ds(e) ? e : eh(e) || nh(e) || th(e) ? e.substring(1) : oh(e) ? e.substring(2) : e;
function Ie(e) {
  const t = [];
  let n = gl.exec(e);
  for (; n; ) {
    const o = Number(n[1]);
    t.push([n[0], Number.isInteger(o) ? o : -1]), n = gl.exec(e);
  }
  return t;
}
const bd = "0123456789abcdefghijklmnopqrstuvwxyz-_";
function TS(e, t) {
  return e = Math.ceil(e), t = Math.floor(t), Math.floor(Math.random() * (t - e)) + e;
}
function wS(e = 21) {
  let t = "_";
  for (let n = 0; n < e; n++)
    t += bd.charAt(TS(0, bd.length));
  return t;
}
var Ae, eo, Ks, gr, Kt, vr, br;
class CS {
  constructor(t, { name: n, value: o }) {
    T(this, Ae), T(this, eo), T(this, Ks), T(this, gr, []), T(this, Kt, []), T(this, vr, null), T(this, br, null), w(this, Ae, t), w(this, eo, n), w(this, Ks, o), w(this, gr, Ie(o ?? ""));
  }
  commit(t) {
    const n = h(this, gr).map(([r, s]) => t[s]);
    if (Rn(h(this, Kt), n)) return;
    const o = n[n.length - 1];
    if (h(this, eo) === "class")
      this.classCommit(o);
    else if (h(this, eo) === "style")
      this.styleCommit(o);
    else {
      const r = n.reduce(
        (s, i, a) => s.replace(new RegExp(h(this, gr)[a][0]), Qs(i)),
        h(this, Ks) ?? ""
      );
      h(this, Ae).setAttribute(h(this, eo), r.trim());
    }
    w(this, Kt, n);
  }
  classCommit(t) {
    if (!pd(h(this, Ae)) && !yd(h(this, Ae)) || !Se(t) && !pe(t))
      return;
    const n = h(this, Kt)[h(this, Kt).length - 1];
    if (n === t || pe(n) && pe(t) && Rn(n, t) || Se(n) && Se(t) && bl(n, t))
      return;
    const o = [...h(this, Ae).classList], r = rh(t);
    if (Bt(h(this, br)))
      w(this, br, o);
    else {
      const s = h(this, br), i = o.filter(
        (a) => !s.includes(a) && !r.includes(a)
      );
      h(this, Ae).classList.remove(...i);
    }
    h(this, Ae).classList.add(...r);
  }
  styleCommit(t) {
    if (!pd(h(this, Ae)) && !yd(h(this, Ae))) return;
    const n = h(this, Kt)[h(this, Kt).length - 1];
    if (bl(n, t))
      return;
    const o = SS(h(this, Ae)), r = Se(t) ? t : {};
    if (Bt(h(this, vr)))
      w(this, vr, o);
    else {
      const s = h(this, vr);
      Object.keys(o).filter((i) => !s[i] && !r[i]).forEach(
        (i) => h(this, Ae).style.removeProperty(i)
      );
    }
    for (const s of Object.keys(r))
      h(this, Ae).style.setProperty(s, r[s]);
  }
}
Ae = /* @__PURE__ */ new WeakMap(), eo = /* @__PURE__ */ new WeakMap(), Ks = /* @__PURE__ */ new WeakMap(), gr = /* @__PURE__ */ new WeakMap(), Kt = /* @__PURE__ */ new WeakMap(), vr = /* @__PURE__ */ new WeakMap(), br = /* @__PURE__ */ new WeakMap();
function Qs(e) {
  return ls(e) && !Bt(e) && !ft(e) || ba(e) ? String(e) : "";
}
function SS(e) {
  const t = {};
  for (let n = 0; n < e.style.length; n++) {
    const o = e.style.item(n);
    t[o] = e.style.getPropertyValue(o);
  }
  return t;
}
function rh(e, t = []) {
  if (ba(e))
    return t.push(Qs(e)), t;
  if (ls(e))
    t.push(Qs(e));
  else if (Hm(e))
    if (pe(e))
      for (let n = 0; n < e.length; n++)
        e[n] && rh(e[n], t);
    else
      for (const n in e)
        e[n] && t.push(Qs(n));
  return t;
}
var Ir, Tr, Js, Xs;
class OS {
  constructor(t, { name: n, value: o }) {
    T(this, Ir), T(this, Tr), T(this, Js, []), T(this, Xs, []), w(this, Ir, t), w(this, Tr, n), w(this, Js, Ie(o ?? ""));
  }
  commit(t) {
    const n = h(this, Js).map(([r, s]) => t[s]);
    if (Rn(h(this, Xs), n)) return;
    const o = n[n.length - 1];
    Ic(o) ? h(this, Ir).setAttribute(h(this, Tr), "") : h(this, Ir).removeAttribute(h(this, Tr)), w(this, Xs, n);
  }
}
Ir = /* @__PURE__ */ new WeakMap(), Tr = /* @__PURE__ */ new WeakMap(), Js = /* @__PURE__ */ new WeakMap(), Xs = /* @__PURE__ */ new WeakMap();
var fs = /* @__PURE__ */ ((e) => (e.node = "node", e.attribute = "attribute", e))(fs || {});
function sh(e, t) {
  return Reflect.set(t, vc, e), t;
}
const ES = (e) => pe(e) && Reflect.get(e, vc) === fs.attribute;
var Ds, Ls, Rs, ir, qt, Id;
let ih = (Id = class {
  constructor(e, { name: t }) {
    T(this, Ds), T(this, Ls), T(this, Rs, null), T(this, ir, null), T(this, qt, null), w(this, Ds, e), w(this, Ls, Ie(t)[0]);
  }
  commit(e) {
    var t, n, o, r;
    const [, s] = h(this, Ls), i = e[s];
    if (!ES(i)) return;
    const [a, l] = i;
    if (h(this, Rs) !== l)
      (t = h(this, qt)) == null || t.call(this), w(this, ir, l({ node: h(this, Ds) })), w(this, Rs, l), w(this, qt, (n = h(this, ir)) == null ? void 0 : n.call(this, a));
    else {
      const c = (o = h(this, ir)) == null ? void 0 : o.call(this, a);
      h(this, qt) !== c && ((r = h(this, qt)) == null || r.call(this), w(this, qt, c));
    }
  }
  destroy() {
    var e;
    (e = h(this, qt)) == null || e.call(this);
  }
}, Ds = /* @__PURE__ */ new WeakMap(), Ls = /* @__PURE__ */ new WeakMap(), Rs = /* @__PURE__ */ new WeakMap(), ir = /* @__PURE__ */ new WeakMap(), qt = /* @__PURE__ */ new WeakMap(), Id);
var pn, yn, ei, wr;
class ah {
  constructor(t, { name: n, value: o }) {
    T(this, pn), T(this, yn), T(this, ei, []), T(this, wr, []), w(this, pn, t), w(this, yn, n), w(this, ei, Ie(o ?? ""));
  }
  commit(t) {
    const n = h(this, ei).map(([o, r]) => t[r]).filter((o) => tn(o) || mS(o));
    Rn(h(this, wr), n) || (this.clear(), n.forEach(
      (o) => tn(o) ? h(this, pn).addEventListener(h(this, yn), o) : h(this, pn).addEventListener(h(this, yn), o[0], o[1])
    ), w(this, wr, n));
  }
  clear() {
    h(this, wr).forEach(
      (t) => tn(t) ? h(this, pn).removeEventListener(h(this, yn), t) : h(this, pn).removeEventListener(h(this, yn), t[0], t[1])
    );
  }
  destroy() {
    this.clear();
  }
}
pn = /* @__PURE__ */ new WeakMap(), yn = /* @__PURE__ */ new WeakMap(), ei = /* @__PURE__ */ new WeakMap(), wr = /* @__PURE__ */ new WeakMap();
var Cr, ti, ni, oi;
class xS {
  constructor(t, { name: n, value: o }) {
    T(this, Cr), T(this, ti), T(this, ni, []), T(this, oi, []), w(this, Cr, t), w(this, ti, n), w(this, ni, Ie(o ?? ""));
  }
  commit(t) {
    const n = h(this, ni).map(([r, s]) => t[s]);
    if (Rn(h(this, oi), n)) return;
    const o = n[n.length - 1];
    Reflect.set(h(this, Cr), h(this, ti), o, h(this, Cr)), w(this, oi, n);
  }
}
Cr = /* @__PURE__ */ new WeakMap(), ti = /* @__PURE__ */ new WeakMap(), ni = /* @__PURE__ */ new WeakMap(), oi = /* @__PURE__ */ new WeakMap();
var Sr, ri, si;
class lh {
  constructor(t, { name: n }) {
    T(this, Sr), T(this, ri), T(this, si, null), w(this, Sr, t), w(this, ri, Ie(n)[0]);
  }
  commit(t) {
    const [, n] = h(this, ri), o = t[n];
    !Se(o) || bl(h(this, si), o) || (Object.keys(o).forEach(
      (r) => Reflect.set(h(this, Sr), r, o[r], h(this, Sr))
    ), w(this, si, o));
  }
}
Sr = /* @__PURE__ */ new WeakMap(), ri = /* @__PURE__ */ new WeakMap(), si = /* @__PURE__ */ new WeakMap();
const AS = (e, t) => t.type === te.attribute ? new CS(e, t) : t.type === te.boolean ? new OS(e, t) : t.type === te.event ? new ah(e, t) : t.type === te.property ? new xS(e, t) : t.type === te.spread ? new lh(e, t) : new ih(e, t);
var ii, ai, Or, Er;
class NS {
  constructor(t, { value: n }) {
    T(this, ii), T(this, ai), T(this, Or, []), T(this, Er, []), w(this, ii, t), w(this, ai, n), Gm(n) && w(this, Or, Ie(n));
  }
  commit(t) {
    const n = h(this, Or).map(([r, s]) => t[s]);
    if (Rn(h(this, Er), n)) return;
    w(this, Er, n);
    const o = h(this, Er).reduce(
      (r, s, i) => r.replace(
        new RegExp(h(this, Or)[i][0]),
        ls(s) && !Bt(s) && !ft(s) ? String(s) : ""
      ),
      h(this, ai) ?? ""
    );
    h(this, ii).data = o;
  }
}
ii = /* @__PURE__ */ new WeakMap(), ai = /* @__PURE__ */ new WeakMap(), Or = /* @__PURE__ */ new WeakMap(), Er = /* @__PURE__ */ new WeakMap();
const Tl = Symbol("https://github.com/dineug/r-html.git#hostBridge");
function MS(e, t) {
  if (t instanceof ShadowRoot) {
    const n = t.host;
    Reflect.set(e, Tl, n);
  }
  return () => {
    Reflect.deleteProperty(e, Tl);
  };
}
function $S(e) {
  return Reflect.get(e, Tl) ?? null;
}
var li, ci, ui, di;
class kS {
  constructor(t, { name: n, value: o }) {
    T(this, li), T(this, ci), T(this, ui, []), T(this, di, []), w(this, li, t), w(this, ci, n), w(this, ui, Ie(o ?? ""));
  }
  commit(t) {
    const n = h(this, ui).map(([r, s]) => t[s]);
    if (Rn(h(this, di), n)) return;
    const o = n[n.length - 1];
    Reflect.set(h(this, li), h(this, ci), o), w(this, di, n);
  }
}
li = /* @__PURE__ */ new WeakMap(), ci = /* @__PURE__ */ new WeakMap(), ui = /* @__PURE__ */ new WeakMap(), di = /* @__PURE__ */ new WeakMap();
var Xr = /* @__PURE__ */ ((e) => (e.create = "create", e.move = "move", e))(Xr || {});
function DS(e) {
  const t = [], n = /* @__PURE__ */ new Map();
  return e.forEach(({ type: o, value: r }, s) => {
    const i = {
      type: o,
      key: o === Tc.templateLiterals ? r.strings : r
    };
    t.push(i), n.set(i, s);
  }), {
    items: t,
    itemToIndex: n
  };
}
function LS(e) {
  const t = [], n = /* @__PURE__ */ new Map();
  return e.forEach((o, r) => {
    const s = an(o), i = {
      type: s,
      key: s === Tc.templateLiterals ? o.strings : o
    };
    t.push(i), n.set(i, r);
  }), {
    items: t,
    itemToIndex: n
  };
}
function ch(e, t, n) {
  const o = !!(n != null && n.strict), r = {
    update: [],
    delete: []
  }, s = /* @__PURE__ */ new Set(), i = [], a = e.items, l = t.items;
  return a.forEach((c, u) => {
    const d = l.findIndex(
      (m, f) => c.type === m.type && c.key === m.key && !s.has(f)
    );
    d === -1 ? o ? r.delete.push({ from: u }) : i.push(c) : (s.add(d), r.update.push({ action: "move", from: u, to: d }));
  }), i.forEach((c) => {
    const u = e.itemToIndex.get(c), d = l.find(
      (m, f) => c.type === m.type && !s.has(f)
    );
    if (d) {
      const m = t.itemToIndex.get(d);
      s.add(m), r.update.push({ action: "move", from: u, to: m });
    } else
      r.delete.push({ from: u });
  }), l.forEach((c, u) => {
    s.has(u) || r.update.push({
      action: "create",
      from: -1,
      to: t.itemToIndex.get(c)
    });
  }), r.update.sort((c, u) => c.to - u.to), r;
}
var xr, fi, Re;
class uh {
  constructor(t, n) {
    T(this, xr), T(this, fi), T(this, Re, []), w(this, xr, t), w(this, fi, n);
  }
  commit(t) {
    const n = ch(
      DS(h(this, Re)),
      LS(t)
    ), o = { length: t.length };
    n.update.forEach(({ action: r, from: s, to: i }) => {
      switch (r) {
        case Xr.create:
          const a = document.createComment("");
          i === 0 ? tt(a, h(this, xr)) : h(this, Re).length ? tt(
            a,
            o[i - 1] ? o[i - 1].endNode : h(this, Re)[i - 1].endNode
          ) : et(a, h(this, fi)), o[i] = new RS(a, t[i]);
          break;
        case Xr.move:
          if (o[i] = h(this, Re)[s], i === s) return;
          i === 0 ? h(this, Re)[s].insert("after", h(this, xr)) : h(this, Re)[s].insert(
            "after",
            o[i - 1] ? o[i - 1].endNode : h(this, Re)[i - 1].endNode
          );
          break;
      }
    }), n.delete.forEach(({ from: r }) => h(this, Re)[r].destroy()), w(this, Re, Array.from(o)), h(this, Re).forEach((r, s) => r.commit(t[s]));
  }
  destroy() {
    h(this, Re).forEach((t) => t.destroy());
  }
}
xr = /* @__PURE__ */ new WeakMap(), fi = /* @__PURE__ */ new WeakMap(), Re = /* @__PURE__ */ new WeakMap();
var ar, Td;
let RS = (Td = class {
  constructor(e, t) {
    T(this, ar), W(this, "startNode", document.createComment("")), W(this, "endNode", document.createComment("")), W(this, "type"), W(this, "value"), et(this.startNode, e), tt(this.endNode, e), ke(e), this.value = t, this.type = an(t), w(this, ar, Fo(this.type, this.startNode, this.endNode));
  }
  commit(e) {
    h(this, ar).commit(e), this.value = e;
  }
  insert(e, t) {
    const n = [
      this.startNode,
      ...De(this.startNode, this.endNode),
      this.endNode
    ];
    e === "before" ? n.forEach((o) => et(o, t)) : n.reverse().forEach((o) => tt(o, t));
  }
  destroy() {
    var e, t;
    (t = (e = h(this, ar)).destroy) == null || t.call(e), De(this.startNode, this.endNode).forEach(ke), this.startNode.remove(), this.endNode.remove();
  }
}, ar = /* @__PURE__ */ new WeakMap(), Td);
var Ar, Nr, mi, Mr, to;
class dh {
  constructor(t, n) {
    T(this, Ar), T(this, Nr), T(this, mi, null), T(this, Mr, null), T(this, to), w(this, Ar, t), w(this, Nr, n);
  }
  commit(t) {
    var n, o;
    if (!gh(t)) return;
    const [r, s] = t;
    if (h(this, mi) !== s)
      this.clear(), w(this, Mr, s({
        startNode: h(this, Ar),
        endNode: h(this, Nr)
      })), w(this, mi, s), w(this, to, (n = h(this, Mr)) == null ? void 0 : n.call(this, r));
    else {
      const i = (o = h(this, Mr)) == null ? void 0 : o.call(this, r);
      h(this, to) !== i && (this.clear(), w(this, to, i));
    }
  }
  clear() {
    var t;
    (t = h(this, to)) == null || t.call(this), De(h(this, Ar), h(this, Nr)).forEach(ke);
  }
  destroy() {
    this.clear();
  }
}
Ar = /* @__PURE__ */ new WeakMap(), Nr = /* @__PURE__ */ new WeakMap(), mi = /* @__PURE__ */ new WeakMap(), Mr = /* @__PURE__ */ new WeakMap(), to = /* @__PURE__ */ new WeakMap();
class fh {
  constructor(t, n) {
  }
  commit(t) {
  }
}
var hi, no;
class mh {
  constructor(t, n) {
    T(this, hi), T(this, no, null), w(this, hi, n);
  }
  commit(t) {
    h(this, no) !== t && (h(this, no) && ke(h(this, no)), et(t, h(this, hi)), w(this, no, t));
  }
}
hi = /* @__PURE__ */ new WeakMap(), no = /* @__PURE__ */ new WeakMap();
var oo, ro, pi, so, $r;
class hh {
  constructor(t, n) {
    T(this, oo), T(this, ro), T(this, pi, null), T(this, so, null), T(this, $r, Il), w(this, oo, t), w(this, ro, n);
  }
  commit(t) {
    h(this, pi) !== t && (this.clear(), pS(t) && this.promiseCommit(t));
  }
  promiseCommit(t) {
    const [n, o] = _S(t);
    w(this, $r, o), n.then((r) => {
      var s;
      const i = an(r);
      w(this, so, Fo(i, h(this, oo), h(this, ro))), (s = h(this, so)) == null || s.commit(r);
    }), w(this, pi, t);
  }
  partClear() {
    var t, n;
    (n = (t = h(this, so)) == null ? void 0 : t.destroy) == null || n.call(t), De(h(this, oo), h(this, ro)).forEach(ke);
  }
  clear() {
    var t, n;
    h(this, $r).call(this), (n = (t = h(this, so)) == null ? void 0 : t.destroy) == null || n.call(t), De(h(this, oo), h(this, ro)).forEach(ke), w(this, $r, Il);
  }
  destroy() {
    this.clear();
  }
}
oo = /* @__PURE__ */ new WeakMap(), ro = /* @__PURE__ */ new WeakMap(), pi = /* @__PURE__ */ new WeakMap(), so = /* @__PURE__ */ new WeakMap(), $r = /* @__PURE__ */ new WeakMap();
function _S(e) {
  let t = Il;
  const n = new Promise((r, s) => t = s), o = () => t();
  return [Promise.race([n, e]), o];
}
var yi, gi;
class ph {
  constructor(t, n) {
    T(this, yi, document.createTextNode("")), T(this, gi, null), tt(h(this, yi), t);
  }
  commit(t) {
    h(this, gi) !== t && (h(this, yi).data = Bt(t) || ft(t) ? "" : String(t), w(this, gi, t));
  }
}
yi = /* @__PURE__ */ new WeakMap(), gi = /* @__PURE__ */ new WeakMap();
var vi, kr, at;
class yh {
  constructor(t, n) {
    T(this, vi), T(this, kr), T(this, at, null), w(this, vi, t), w(this, kr, n);
  }
  commit(t) {
    const { strings: n, values: o } = t;
    h(this, at) && !h(this, at).equalStrings(n) && (h(this, at).destroy(), w(this, at, null)), h(this, at) || (w(this, at, new Ih(
      t,
      h(this, vi),
      h(this, kr)
    )), h(this, at).insert("before", h(this, kr))), h(this, at).commit(o);
  }
  destroy() {
    var t;
    (t = h(this, at)) == null || t.destroy();
  }
}
vi = /* @__PURE__ */ new WeakMap(), kr = /* @__PURE__ */ new WeakMap(), at = /* @__PURE__ */ new WeakMap();
var Tc = /* @__PURE__ */ ((e) => (e.primitive = "primitive", e.templateLiterals = "templateLiterals", e.array = "array", e.node = "node", e.object = "object", e.function = "function", e.directive = "directive", e))(Tc || {});
const gh = (e) => pe(e) && Reflect.get(e, vc) === fs.node, Vn = (e) => (t) => t instanceof e, PS = Vn(ph), BS = Vn(yh), WS = Vn(uh), US = Vn(mh), VS = Vn(hh), FS = Vn(fh), jS = Vn(dh), an = (e) => ls(e) ? "primitive" : va(e) ? "templateLiterals" : gh(e) ? "directive" : pe(e) ? "array" : hS(e) ? "node" : tn(e) ? "function" : "object", qS = {
  primitive: PS,
  templateLiterals: BS,
  array: WS,
  node: US,
  function: FS,
  object: VS,
  directive: jS
}, ZS = {
  primitive: ph,
  templateLiterals: yh,
  array: uh,
  node: mh,
  function: fh,
  object: hh,
  directive: dh
}, vh = (e, t) => qS[e](t), Fo = (e, t, n) => new ZS[e](t, n);
var Qt, io, bi, wl, Dr, gn, ao, lo, Ii, Lr, Ti;
class HS {
  constructor(t, n, o, r) {
    T(this, Qt, document.createComment("")), T(this, io, document.createComment("")), T(this, bi), T(this, wl), T(this, Dr, []), T(this, gn, []), T(this, ao, null), T(this, lo, us({}, { shallow: !0 })), T(this, Ii, null), T(this, Lr, null), T(this, Ti, document.createElement("div"));
    var s;
    w(this, Qt, t), w(this, io, n), w(this, wl, o), w(this, bi, Ie(o.value)[0]), o.staticAttrs && o.staticAttrs.forEach((i) => fS(h(this, lo), i)), (s = o.attrs) == null || s.forEach((i) => {
      i.type === te.directive ? h(this, Dr).push(i) : i.type === te.spread ? r.push(new lh(h(this, lo), i)) : i.type === te.event ? r.push(new ah(h(this, Ti), i)) : r.push(new kS(h(this, lo), i));
    });
  }
  createContext() {
    const t = h(this, Qt), n = {
      host: document.body,
      get parentElement() {
        return t.parentElement;
      },
      dispatchEvent: (r) => h(this, Ti).dispatchEvent(r)
    }, o = h(this, Qt).getRootNode();
    if (o instanceof ShadowRoot) {
      const r = o.host;
      n.host = r;
    } else if (o instanceof DocumentFragment) {
      const r = $S(o);
      r && (n.host = r);
    }
    return n;
  }
  commit(t) {
    const [, n] = h(this, bi), o = t[n];
    if (!tn(o) || h(this, Ii) === o) {
      h(this, gn).forEach((a) => a.commit(t));
      return;
    }
    const r = this.createContext();
    this.clear(), Ri(this);
    const s = o.call(r, h(this, lo), r);
    Ri(null), h(this, Dr).length && h(this, gn).push(
      ...h(this, Dr).map((a) => new ih(r, a))
    ), Fe(this, ma);
    let i = !1;
    w(this, Lr, bc(() => {
      var a;
      const l = s(), c = an(l);
      vh(c, h(this, ao)) || (this.partClear(), w(this, ao, Fo(c, h(this, Qt), h(this, io)))), Fe(this, i ? ya : yc), (a = h(this, ao)) == null || a.commit(l), i ? Fe(this, ga) : (Fe(this, gc), i = !0);
    })), h(this, gn).forEach((a) => a.commit(t)), Fe(this, ha), w(this, Ii, o);
  }
  partClear() {
    var t, n;
    (n = (t = h(this, ao)) == null ? void 0 : t.destroy) == null || n.call(t), De(h(this, Qt), h(this, io)).forEach(ke);
  }
  clear() {
    var t;
    De(h(this, Qt), h(this, io)).forEach(ke), Fe(this, pa), h(this, gn).forEach((n) => {
      var o;
      return (o = n.destroy) == null ? void 0 : o.call(n);
    }), (t = h(this, Lr)) == null || t.call(this), w(this, gn, []), w(this, Lr, null), eS(this);
  }
  destroy() {
    this.clear(), this.partClear();
  }
}
Qt = /* @__PURE__ */ new WeakMap(), io = /* @__PURE__ */ new WeakMap(), bi = /* @__PURE__ */ new WeakMap(), wl = /* @__PURE__ */ new WeakMap(), Dr = /* @__PURE__ */ new WeakMap(), gn = /* @__PURE__ */ new WeakMap(), ao = /* @__PURE__ */ new WeakMap(), lo = /* @__PURE__ */ new WeakMap(), Ii = /* @__PURE__ */ new WeakMap(), Lr = /* @__PURE__ */ new WeakMap(), Ti = /* @__PURE__ */ new WeakMap();
var lr, cr, ur, wd;
const zS = (wd = class {
  constructor(e, t, n) {
    T(this, lr, document.createComment("")), T(this, cr, document.createComment("")), T(this, ur), w(this, ur, new HS(
      h(this, lr),
      h(this, cr),
      t,
      n
    )), et(h(this, lr), e), tt(h(this, cr), e), e.remove();
  }
  commit(e) {
    h(this, ur).commit(e);
  }
  destroy() {
    var e, t;
    (t = (e = h(this, ur)).destroy) == null || t.call(e), h(this, lr).remove(), h(this, cr).remove();
  }
}, lr = /* @__PURE__ */ new WeakMap(), cr = /* @__PURE__ */ new WeakMap(), ur = /* @__PURE__ */ new WeakMap(), wd), GS = oS(zS);
var co, uo, wi, Ci, vn;
class YS {
  constructor(t, { value: n }) {
    T(this, co, document.createComment("")), T(this, uo, document.createComment("")), T(this, wi), T(this, Ci, null), T(this, vn, null), w(this, wi, Ie(n)[0]), et(h(this, co), t), tt(h(this, uo), t), t.remove();
  }
  commit(t) {
    var n;
    const [, o] = h(this, wi), r = t[o];
    if (h(this, Ci) === r) return;
    const s = an(r);
    vh(s, h(this, vn)) || (Bt(h(this, vn)) || this.clear(), w(this, vn, Fo(s, h(this, co), h(this, uo)))), (n = h(this, vn)) == null || n.commit(r), w(this, Ci, r);
  }
  clear() {
    var t, n;
    (n = (t = h(this, vn)) == null ? void 0 : t.destroy) == null || n.call(t), De(h(this, co), h(this, uo)).forEach(ke);
  }
  destroy() {
    this.clear(), h(this, co).remove(), h(this, uo).remove();
  }
}
co = /* @__PURE__ */ new WeakMap(), uo = /* @__PURE__ */ new WeakMap(), wi = /* @__PURE__ */ new WeakMap(), Ci = /* @__PURE__ */ new WeakMap(), vn = /* @__PURE__ */ new WeakMap();
function bh(e = [], t, n = !1, o = []) {
  return e.forEach((r) => {
    if (r.isComponent) {
      const i = document.createComment("");
      t.appendChild(i), o.push(new GS(i, r, o));
      return;
    }
    const s = uS(r, r.isSvg || n);
    t.appendChild(s), s instanceof Comment && r.isMarker && o.push(new NS(s, r)), s instanceof Text && r.isMarkerOnly && o.push(new YS(s, r)), s instanceof Element && (r.staticAttrs && r.staticAttrs.forEach((i) => dS(s, i)), r.attrs && o.push(...r.attrs.map((i) => AS(s, i))), r.children && bh(r.children, s, r.isSvg || n, o));
  }), o;
}
function KS(e, t = !1) {
  const n = document.createDocumentFragment(), o = bh(e.children, n, t);
  return [n, o];
}
var fo, mo, Jt, Rr, Si, Oi;
class Ih {
  constructor(t, n, o) {
    if (T(this, fo, document.createComment("")), T(this, mo, document.createComment("")), T(this, Jt, null), T(this, Rr, []), T(this, Si), T(this, Oi, !1), w(this, Si, t.strings), t[xn] !== Wt.html && t[xn] !== Wt.svg)
      return;
    const [r, s] = KS(
      t.template.node,
      IS(t[xn])
    );
    w(this, Jt, r), w(this, Rr, s), n && o ? (w(this, fo, n), w(this, mo, o), w(this, Oi, !0)) : (r.prepend(h(this, fo)), r.append(h(this, mo)));
  }
  equalStrings(t) {
    return h(this, Si) === t;
  }
  commit(t) {
    h(this, Rr).forEach((n) => n.commit(t));
  }
  insert(t, n) {
    h(this, Jt) && (t === "before" ? et(h(this, Jt), n) : t === "after" ? tt(h(this, Jt), n) : n.appendChild(h(this, Jt)), w(this, Jt, null));
  }
  destroy() {
    h(this, Rr).forEach((t) => {
      var n;
      return (n = t.destroy) == null ? void 0 : n.call(t);
    }), De(h(this, fo), h(this, mo)).forEach(ke), h(this, Oi) || (h(this, fo).remove(), h(this, mo).remove());
  }
}
fo = /* @__PURE__ */ new WeakMap(), mo = /* @__PURE__ */ new WeakMap(), Jt = /* @__PURE__ */ new WeakMap(), Rr = /* @__PURE__ */ new WeakMap(), Si = /* @__PURE__ */ new WeakMap(), Oi = /* @__PURE__ */ new WeakMap();
const dr = /* @__PURE__ */ new WeakMap();
function QS(e, t) {
  var n;
  if (!va(t)) {
    dr.has(e) && ((n = dr.get(e)) == null || n.destroy(), dr.delete(e));
    return;
  }
  const { strings: o, values: r } = t, s = dr.get(e);
  if (s != null && s.equalStrings(o))
    s == null || s.commit(r);
  else {
    const i = new Ih(t);
    s == null || s.destroy(), dr.set(e, i), i.insert("children", e), i.commit(r);
  }
}
function JS(e, t) {
  return (...n) => sh(
    fs.attribute,
    [e(...n), t]
  );
}
const sR = (e) => ({ value: e }), iR = JS(
  (e) => e,
  ({ node: e }) => {
    let t = null;
    const n = () => {
      t && (t.value = null);
    };
    return (o) => (t === o || (o.value = e, t = o), n);
  }
);
function wc(e, t) {
  return (...n) => sh(fs.node, [
    e(...n),
    t
  ]);
}
const aR = wc(
  (e) => e,
  ({ startNode: e, endNode: t }) => {
    const n = e.getRootNode();
    let o = /* @__PURE__ */ new Map(), r = null;
    const s = (u) => va(u) ? u.strings : u, i = (u) => {
      const d = s(u);
      return o.has(d) ? o.get(d) : null;
    }, a = (u, d) => {
      o.set(s(u), d);
    }, l = (u) => {
      const d = an(u), m = Fo(d, e, t), f = document.createDocumentFragment(), p = N1(f, n), v = MS(f, n);
      return {
        part: m,
        fragment: f,
        destroy: () => {
          var I;
          p(), v(), (I = m.destroy) == null || I.call(m);
        }
      };
    }, c = () => {
      o.forEach(({ destroy: u }) => u()), o = /* @__PURE__ */ new Map(), De(e, t).forEach(ke);
    };
    return (u) => {
      const d = i(r), m = i(u);
      if (d && s(r) !== s(u) && De(e, t).forEach(
        (f) => d.fragment.appendChild(f)
      ), m)
        s(r) !== s(u) && et(m.fragment, t), m.part.commit(u);
      else {
        const f = l(u);
        a(u, f), f.part.commit(u);
      }
      return r = u, c;
    };
  }
), lR = wc(
  (e) => e,
  ({ startNode: e, endNode: t }) => {
    let n = null;
    const o = () => {
      De(e, t).forEach(ke);
    };
    return (r) => {
      if (n === r) return o;
      o();
      const s = document.createElement("template");
      return s.innerHTML = r, et(s.content, t), n = r, o;
    };
  }
), cR = wc(
  (e, t, n) => (e.length, [e, t, n]),
  ({ startNode: e, endNode: t }) => {
    let n = [];
    const o = () => {
      n.forEach((r) => r.destroy());
    };
    return ([r, s, i]) => {
      const a = tO(r, s, i), l = a.values, c = ch(eO(n), a, {
        strict: !0
      }), u = { length: l.length };
      return c.update.forEach(({ action: d, from: m, to: f }) => {
        switch (d) {
          case Xr.create:
            const p = document.createComment("");
            f === 0 ? tt(p, e) : n.length ? tt(
              p,
              u[f - 1] ? u[f - 1].endNode : n[f - 1].endNode
            ) : et(p, t), u[f] = new XS(
              p,
              l[f].value,
              l[f].key
            );
            break;
          case Xr.move:
            if (u[f] = n[m], f === m) return;
            f === 0 ? n[m].insert("after", e) : n[m].insert(
              "after",
              u[f - 1] ? u[f - 1].endNode : n[f - 1].endNode
            );
            break;
        }
      }), c.delete.forEach(({ from: d }) => n[d].destroy()), n = Array.from(u), n.forEach((d, m) => d.commit(l[m].value)), o;
    };
  }
);
var _r;
class XS {
  constructor(t, n, o) {
    T(this, _r), W(this, "startNode", document.createComment("")), W(this, "endNode", document.createComment("")), W(this, "type"), W(this, "key"), et(this.startNode, t), tt(this.endNode, t), ke(t), this.key = o, this.type = an(n), w(this, _r, Fo(this.type, this.startNode, this.endNode));
  }
  commit(t) {
    h(this, _r).commit(t);
  }
  insert(t, n) {
    const o = [
      this.startNode,
      ...De(this.startNode, this.endNode),
      this.endNode
    ];
    t === "before" ? o.forEach((r) => et(r, n)) : o.reverse().forEach((r) => tt(r, n));
  }
  destroy() {
    var t, n;
    (n = (t = h(this, _r)).destroy) == null || n.call(t), De(this.startNode, this.endNode).forEach(ke), this.startNode.remove(), this.endNode.remove();
  }
}
_r = /* @__PURE__ */ new WeakMap();
function eO(e) {
  const t = [], n = /* @__PURE__ */ new Map();
  return e.forEach(({ type: o, key: r }, s) => {
    const i = { type: o, key: r };
    t.push(i), n.set(i, s);
  }), {
    items: t,
    itemToIndex: n
  };
}
function tO(e, t, n) {
  const o = [], r = /* @__PURE__ */ new Map(), s = [];
  return e.forEach((i, a, l) => {
    const c = {
      key: t(i),
      value: n(i, a, l)
    }, u = { type: an(c.value), key: c.key };
    s.push(c), o.push(u), r.set(u, a);
  }), {
    items: o,
    itemToIndex: r,
    values: s
  };
}
const nO = (e) => pe(e) ? e : ft(e) ? [] : Object.keys(e), oO = (e) => ft(e) || pe(e) ? [] : Object.keys(e).filter((t) => {
  const n = e[t];
  return n === Number || n === String || n === Boolean || Se(n) && !ft(n.default);
}).map((t) => {
  const n = e[t];
  return Se(n) ? [t, Reflect.get(n, "default")] : n === Number ? [t, 0] : n === Boolean ? [t, !1] : [t, ""];
}), rO = (e) => ft(e) || pe(e) ? [] : Object.keys(e).filter((t) => {
  const n = e[t];
  return tn(n) || Se(n) && !ft(n.type);
}).map((t) => {
  const n = e[t];
  return Se(n) ? [t, Reflect.get(n, "type")] : [t, n];
});
var ae = /* @__PURE__ */ ((e) => (e.string = "string", e.whiteSpace = "whiteSpace", e.nextLine = "nextLine", e.equal = "equal", e.tilde = "tilde", e.plus = "plus", e.sharp = "sharp", e.asterisk = "asterisk", e.commercialAt = "commercialAt", e.ampersand = "ampersand", e.period = "period", e.comma = "comma", e.colon = "colon", e.semicolon = "semicolon", e.gt = "gt", e.leftBrace = "leftBrace", e.rightBrace = "rightBrace", e.leftBracket = "leftBracket", e.rightBracket = "rightBracket", e.leftParent = "leftParent", e.rightParent = "rightParent", e))(ae || {});
const X = {
  doubleQuote: '"',
  singleQuote: "'",
  whiteSpace: /\s/,
  string: /\S/,
  breakString: /:|;|{|&|#|@|,|>|~|\(|\)|\[|\.|\+/,
  nextLine: `
`,
  slash: "/",
  equal: "=",
  tilde: "~",
  plus: "+",
  sharp: "#",
  asterisk: "*",
  commercialAt: "@",
  ampersand: "&",
  period: ".",
  comma: ",",
  colon: ":",
  semicolon: ";",
  gt: ">",
  leftBrace: "{",
  rightBrace: "}",
  leftBracket: "[",
  rightBracket: "]",
  leftParent: "(",
  rightParent: ")"
}, re = (e) => (t) => e === t, ja = (e) => (t) => e.test(t), _ = {
  doubleQuote: re(X.doubleQuote),
  singleQuote: re(X.singleQuote),
  whiteSpace: ja(X.whiteSpace),
  string: ja(X.string),
  breakString: ja(X.breakString),
  nextLine: re(X.nextLine),
  slash: re(X.slash),
  equal: re(X.equal),
  tilde: re(X.tilde),
  plus: re(X.plus),
  sharp: re(X.sharp),
  asterisk: re(X.asterisk),
  commercialAt: re(X.commercialAt),
  ampersand: re(X.ampersand),
  period: re(X.period),
  comma: re(X.comma),
  colon: re(X.colon),
  semicolon: re(X.semicolon),
  gt: re(X.gt),
  leftBrace: re(X.leftBrace),
  rightBrace: re(X.rightBrace),
  leftBracket: re(X.leftBracket),
  rightBracket: re(X.rightBracket),
  leftParent: re(X.leftParent),
  rightParent: re(X.rightParent)
}, sO = (e) => (t) => _.slash(e[t]) && _.asterisk(e[t + 1]), iO = (e) => (t) => _.asterisk(e[t]) && _.slash(e[t + 1]), aO = (e) => (t) => _.slash(e[t]) && _.slash(e[t + 1]);
function lO(e) {
  const t = [];
  let n = 0;
  const o = () => n < e.length, r = sO(e), s = iO(e), i = aO(e), a = (l = "style") => {
    for (; o(); ) {
      let c = e[n];
      if (_.nextLine(c)) {
        if (t.push({ type: "nextLine", value: c }), n++, l === "singleComment")
          break;
        continue;
      }
      if (_.whiteSpace(c)) {
        let u = "";
        for (; o() && _.whiteSpace(c) && !_.nextLine(c); )
          u += c, c = e[++n];
        t.push({ type: "whiteSpace", value: u });
        continue;
      }
      if (l === "style") {
        if (r(n)) {
          a(
            "multiComment"
            /* multiComment */
          );
          continue;
        }
        if (i(n)) {
          a(
            "singleComment"
            /* singleComment */
          );
          continue;
        }
        if (_.colon(c)) {
          t.push({ type: "colon", value: c });
          let u = "";
          if (c = e[++n], _.whiteSpace(c)) {
            for (u = ""; o() && _.whiteSpace(c); )
              u += c, c = e[++n];
            t.push({ type: "whiteSpace", value: u }), u = "";
          } else
            continue;
          for (; o() && !_.semicolon(c); )
            u += c, c = e[++n];
          t.push({ type: "string", value: u });
          continue;
        }
        if (_.leftBracket(c)) {
          t.push({ type: "leftBracket", value: c });
          let u = "";
          for (c = e[++n]; o() && !_.equal(c) && !_.rightBracket(c); )
            u += c, c = e[++n];
          if (t.push({ type: "string", value: u }), _.equal(c) && (t.push({ type: "equal", value: c }), c = e[++n]), _.doubleQuote(c)) {
            let d = "";
            for (c = e[++n]; o() && !_.doubleQuote(c); )
              d += c, c = e[++n];
            t.push({ type: "string", value: d }), c = e[++n];
          }
          if (_.singleQuote(c)) {
            let d = "";
            for (c = e[++n]; o() && !_.singleQuote(c); )
              d += c, c = e[++n];
            t.push({ type: "string", value: d }), c = e[++n];
          }
          _.rightBracket(c) && (t.push({ type: "rightBracket", value: c }), n++);
          continue;
        }
        if (_.commercialAt(c)) {
          t.push({ type: "commercialAt", value: c }), n++;
          continue;
        }
        if (_.gt(c)) {
          t.push({ type: "gt", value: c }), n++;
          continue;
        }
        if (_.tilde(c)) {
          t.push({ type: "tilde", value: c }), n++;
          continue;
        }
        if (_.plus(c)) {
          t.push({ type: "plus", value: c }), n++;
          continue;
        }
        if (_.sharp(c)) {
          t.push({ type: "sharp", value: c }), n++;
          continue;
        }
        if (_.asterisk(c)) {
          t.push({ type: "asterisk", value: c }), n++;
          continue;
        }
        if (_.ampersand(c)) {
          t.push({ type: "ampersand", value: c }), n++;
          continue;
        }
        if (_.period(c)) {
          t.push({ type: "period", value: c }), n++;
          continue;
        }
        if (_.comma(c)) {
          t.push({ type: "comma", value: c }), n++;
          continue;
        }
        if (_.semicolon(c)) {
          t.push({ type: "semicolon", value: c }), n++;
          continue;
        }
        if (_.leftBrace(c)) {
          t.push({ type: "leftBrace", value: c }), n++;
          continue;
        }
        if (_.rightBrace(c)) {
          t.push({ type: "rightBrace", value: c }), n++;
          continue;
        }
        if (_.leftParent(c)) {
          let u = "";
          for (; o() && !_.rightParent(c); )
            u += c, c = e[++n];
          u += c, t.push({ type: "string", value: u }), n++;
          continue;
        }
      } else if (l === "multiComment") {
        if (s(n)) {
          t.push({ type: "string", value: "*/" }), n += 2;
          break;
        }
      } else if (l === "singleComment" && _.nextLine(c)) {
        t.push({ type: "nextLine", value: c }), n++;
        break;
      }
      if (_.string(c)) {
        let u = "";
        for (; o() && _.string(c) && !_.breakString(c); )
          u += c, c = e[++n];
        t.push({ type: "string", value: u });
        continue;
      }
      n++;
    }
  };
  return a(), t;
}
const Th = new RegExp(`^${nn.replace("@@", "")}_\\d+_$`), wh = (e) => (t) => (n) => (o) => n[o] ? n[o][e] === t : !1, ue = wh("type"), Cc = wh("value"), ln = ue(ae.string), cO = ue(ae.whiteSpace), Ch = ue(ae.nextLine);
ue(ae.equal);
ue(ae.tilde);
ue(ae.plus);
const uO = ue(ae.sharp), dO = ue(ae.asterisk), Sc = ue(ae.commercialAt), fO = ue(ae.ampersand), mO = ue(ae.period);
ue(ae.comma);
const Sh = ue(ae.colon), Oc = ue(ae.semicolon);
ue(ae.gt);
const hO = ue(ae.leftBrace), pO = ue(ae.rightBrace);
ue(ae.leftBracket);
ue(ae.rightBracket);
ue(ae.leftParent);
ue(ae.rightParent);
const yO = Cc("/*"), gO = Cc("*/"), vO = Cc("//"), bO = Ch, IO = (e) => {
  const t = ln(e), n = Sh(e), o = cO(e), r = Oc(e);
  return (s) => t(s) && n(s + 1) && o(s + 2) && t(s + 3) && r(s + 4);
}, TO = (e) => {
  const t = Sc(e), n = ln(e), o = Oc(e), r = Ch(e);
  return (s) => t(s) && t(s + 1) && n(s + 2) && Th.test(e[s + 2].value) && (r(s + 3) || o(s + 3));
}, Oh = (e) => {
  const t = Sc(e), n = ln(e);
  return (o) => t(o) && n(o + 1);
}, wO = (e) => {
  const t = Sh(e), n = ln(e);
  return (o) => t(o) && n(o + 1);
}, CO = ln, SO = dO, OO = (e) => {
  const t = Sc(e), n = ln(e);
  return (o) => t(o) && t(o + 1) && n(o + 2) && Th.test(e[o + 2].value);
}, EO = (e) => {
  const t = CO(e), n = SO(e), o = fO(e), r = OO(e);
  return (s) => t(s) || n(s) || o(s) || r(s);
}, xO = (e) => {
  const t = mO(e), n = ln(e);
  return (o) => t(o) && n(o + 1);
}, AO = (e) => {
  const t = uO(e), n = ln(e);
  return (o) => t(o) && n(o + 1);
}, NO = (e) => {
  const t = EO(e), n = xO(e), o = AO(e), r = Oh(e), s = wO(e);
  return (i) => t(i) || n(i) || o(i) || r(i) || s(i);
}, Eh = (e) => (t) => (n) => {
  var o;
  n && (t[e] ? (o = t[e]) == null || o.push(n) : t[e] = [n]);
}, Cd = Eh("properties"), fr = Eh("children");
var Ze = /* @__PURE__ */ ((e) => (e.style = "style", e.comment = "comment", e.atRule = "atRule", e))(Ze || {});
class _s {
  constructor(t = {}) {
    W(this, "type", "comment"), W(this, "value"), W(this, "properties"), W(this, "parent", null), W(this, "children"), Object.assign(this, t);
  }
  *iterParent() {
    yield this, this.parent && (yield* this.parent.iterParent());
  }
  *[Symbol.iterator]() {
    if (yield this, !!this.children)
      for (const t of this.children)
        yield* t;
  }
}
function MO(e) {
  let t = 0;
  const n = () => t < e.length, o = IO(e), r = TO(e), s = NO(e), i = hO(e), a = pO(e), l = yO(e), c = gO(e), u = vO(e), d = bO(e), m = Oh(e), f = Oc(e), p = (v, I, g = Ze.style) => {
    const b = new _s({
      type: g,
      parent: v,
      value: I
    });
    for (; n(); ) {
      let S = e[t];
      if (a(t)) {
        t++;
        break;
      }
      if (o(t)) {
        const M = e[t + 3];
        Cd(b)({
          name: S.value,
          value: M.value
        }), t += 5;
        continue;
      } else if (r(t)) {
        const M = `@@${e[t + 2].value}`;
        Cd(b)({
          name: M,
          value: M
        }), t += 4;
        continue;
      } else if (l(t)) {
        let M = S.value;
        for (S = e[++t]; n() && !c(t); )
          M += S.value, S = e[++t];
        M += S.value, fr(b)(
          new _s({
            type: Ze.comment,
            parent: b,
            value: M
          })
        ), t++;
        continue;
      } else if (u(t)) {
        let M = S.value;
        for (S = e[++t]; n() && !d(t); )
          M += S.value, S = e[++t];
        fr(b)(
          new _s({
            type: Ze.comment,
            parent: b,
            value: M
          })
        ), t++;
        continue;
      } else if (m(t)) {
        let M = S.value;
        for (S = e[++t]; n() && !i(t) && !f(t); )
          M += S.value, S = e[++t];
        if (f(t)) {
          M += ";", fr(b)(
            new _s({
              type: Ze.atRule,
              parent: b,
              value: M
            })
          ), t++;
          continue;
        }
        fr(b)(p(b, M.trim(), Ze.atRule));
        continue;
      } else if (s(t)) {
        let M = S.value;
        for (S = e[++t]; n() && !i(t); )
          M += S.value, S = e[++t];
        fr(b)(p(b, M.trim()));
        continue;
      }
      t++;
    }
    return b;
  };
  return p(null);
}
const $O = (e) => MO(lO(e));
var Fn = /* @__PURE__ */ ((e) => (e.string = "string", e.whiteSpace = "whiteSpace", e.lt = "lt", e.gt = "gt", e.slash = "slash", e.equal = "equal", e))(Fn || {});
const ot = {
  doubleQuote: '"',
  singleQuote: "'",
  whiteSpace: /\s/,
  string: /\S/,
  breakString: /<|>|=/,
  lt: "<",
  gt: ">",
  slash: "/",
  equal: "=",
  hyphen: "-",
  exclamationPoint: "!"
}, Zt = (e) => (t) => e === t, qa = (e) => (t) => e.test(t), de = {
  doubleQuote: Zt(ot.doubleQuote),
  singleQuote: Zt(ot.singleQuote),
  whiteSpace: qa(ot.whiteSpace),
  string: qa(ot.string),
  breakString: qa(ot.breakString),
  lt: Zt(ot.lt),
  gt: Zt(ot.gt),
  slash: Zt(ot.slash),
  equal: Zt(ot.equal),
  hyphen: Zt(ot.hyphen),
  exclamationPoint: Zt(ot.exclamationPoint)
}, kO = (e) => (t) => de.lt(e[t]) && de.exclamationPoint(e[t + 1]) && de.hyphen(e[t + 2]) && de.hyphen(e[t + 3]);
function DO(e) {
  const t = [];
  let n = 0;
  const o = () => n < e.length, r = kO(e), s = (i = "text") => {
    for (; o(); ) {
      let a = e[n];
      if (de.whiteSpace(a)) {
        let l = "";
        for (; o() && de.whiteSpace(a); )
          l += a, a = e[++n];
        i !== "element" && t.push({ type: "whiteSpace", value: l });
        continue;
      }
      if (i === "element") {
        if (de.lt(a)) {
          t.push({ type: "lt", value: a }), n++;
          continue;
        }
        if (de.gt(a)) {
          t.push({ type: "gt", value: a }), n++;
          break;
        }
        if (de.slash(a)) {
          t.push({ type: "slash", value: a }), n++;
          continue;
        }
        if (de.equal(a)) {
          t.push({ type: "equal", value: a }), n++;
          continue;
        }
        if (de.doubleQuote(a)) {
          let l = "";
          for (a = e[++n]; o() && !de.doubleQuote(a); )
            l += a, a = e[++n];
          t.push({ type: "string", value: l }), n++;
          continue;
        }
        if (de.singleQuote(a)) {
          let l = "";
          for (a = e[++n]; o() && !de.singleQuote(a); )
            l += a, a = e[++n];
          t.push({ type: "string", value: l }), n++;
          continue;
        }
      } else if (i === "comment") {
        if (de.lt(a)) {
          t.push({ type: "lt", value: a }), n++;
          continue;
        }
        if (de.gt(a)) {
          t.push({ type: "gt", value: a }), n++;
          break;
        }
      } else if (de.lt(a)) {
        s(
          r(n) ? "comment" : "element"
          /* element */
        );
        continue;
      }
      if (de.string(a)) {
        let l = "";
        for (; o() && de.string(a) && !de.breakString(a); )
          l += a, a = e[++n];
        t.push({ type: "string", value: l });
        continue;
      }
      n++;
    }
  };
  return s(), t;
}
const LO = /^(area|base|br|col|embed|hr|img|input|keygen|link|meta|param|source|track|wbr)$/i, xh = (e) => (t) => (n) => (o) => n[o] ? n[o][e] === t : !1, jo = xh("type"), Ah = xh("value"), ms = jo(Fn.lt), hs = jo(Fn.gt), Ec = jo(Fn.slash), RO = jo(Fn.equal), ps = jo(Fn.string), _O = jo(Fn.whiteSpace), PO = Ah("!--"), BO = Ah("--"), WO = (e) => {
  const t = ms(e), n = ps(e);
  return (o) => t(o) && n(o + 1);
}, UO = (e) => {
  const t = ms(e), n = Ec(e), o = ps(e), r = hs(e);
  return (s) => t(s) && n(s + 1) && o(s + 2) && r(s + 3);
}, VO = (e) => {
  const t = ms(e), n = Ec(e), o = hs(e);
  return (r) => t(r) && n(r + 1) && n(r + 2) && o(r + 3);
}, FO = (e) => {
  const t = Ec(e), n = hs(e);
  return (o) => t(o) && n(o + 1);
}, jO = (e) => LO.test(e), qO = (e) => {
  const t = ms(e), n = ps(e), o = PO(e);
  return (r) => t(r) && n(r + 1) && o(r + 1);
}, ZO = (e) => {
  const t = ps(e), n = BO(e), o = hs(e);
  return (r) => t(r) && n(r) && o(r + 1);
}, Nh = (e) => (t) => (n) => {
  var o;
  n && (t[e] ? (o = t[e]) == null || o.push(n) : t[e] = [n]);
}, HO = Nh("attrs"), Sd = Nh("children");
function zO(e) {
  const t = new wn({
    type: $e.element,
    value: "template",
    children: []
  });
  let n = 0;
  const o = () => n < e.length, r = WO(e), s = UO(e), i = VO(e), a = FO(e), l = qO(e), c = ZO(e), u = ms(e), d = hs(e), m = RO(e), f = _O(e), p = ps(e), v = () => {
    let g = e[n];
    const b = { name: g.value };
    return g = e[++n], m(n) && (g = e[++n], p(n) && (b.value = g.value, n++)), b;
  }, I = (g) => {
    let b = e[n];
    if (f(n) || p(n)) {
      let S = b.value;
      for (b = e[++n]; o() && !u(n); )
        S += b.value, b = e[++n];
      return S = S.trim(), S.length ? new wn({ parent: g, type: $e.text, value: S }) : null;
    }
    if (l(n)) {
      let S = "";
      for (n += 2, b = e[n]; o() && !c(n); )
        S += b.value, b = e[++n];
      return c(n) && (n += 2), new wn({ parent: g, type: $e.comment, value: S });
    }
    if (r(n)) {
      b = e[++n];
      const S = jO(b.value), M = new wn({
        parent: g,
        type: $e.element,
        value: b.value.toLowerCase()
      });
      for (n++; o() && !d(n) && !a(n); ) {
        if (p(n)) {
          HO(M)(v());
          continue;
        }
        n++;
      }
      if (a(n))
        return n += 2, M;
      for (b = e[++n]; o() && !s(n) && !i(n) && !S; )
        Sd(M)(I(M));
      return (s(n) || i(n)) && (n += 4), M;
    }
    return n++, null;
  };
  for (; o(); )
    Sd(t)(I(t));
  return t;
}
const GO = (e) => zO(DO(e)), YO = (e, t) => e.reduce((n, o) => {
  const r = n[t(o)];
  return r ? r.push(o) : n[t(o)] = [o], n;
}, {});
class vo {
  constructor(t, n = null) {
    if (W(this, "type", $e.comment), W(this, "value", ""), W(this, "staticAttrs"), W(this, "attrs"), W(this, "parent", null), W(this, "children"), this.type = t.type, this.value = t.value, this.parent = n, t.attrs) {
      const [o, r] = JO(t.attrs);
      o.length && (this.staticAttrs = o), r.length && (this.attrs = r);
    }
    t.children && (this.children = t.children.map((o) => new vo(o, this)));
  }
  get isMarker() {
    return No(this.value);
  }
  get isMarkerOnly() {
    return ds(this.value);
  }
  get isSvg() {
    return this.type === $e.element && /^svg$/i.test(this.value);
  }
  get isComponent() {
    return this.type === $e.element && this.isMarkerOnly;
  }
  insert(t, n, o) {
    if (this.children) {
      const r = t === "before" ? 0 : 1;
      this.children.includes(o) && this.children.splice(
        this.children.indexOf(o) + r,
        0,
        n
      );
    } else
      this.children = [n];
  }
  *iterParent() {
    yield this, this.parent && (yield* this.parent.iterParent());
  }
  *[Symbol.iterator]() {
    if (yield this, !!this.children)
      for (const t of this.children)
        yield* t;
  }
}
function KO(e) {
  const t = new vo(e);
  for (const n of t)
    n.type === $e.text && !ds(n.value) && QO(n);
  return t;
}
function QO(e) {
  const t = Ie(e.value);
  e.value.replace(gl, nn).split(nn).reduce((n, o, r) => (r < t.length ? n.push(
    new vo(new wn({ type: $e.text, value: o }), e.parent),
    new vo(
      new wn({ type: $e.text, value: t[r][0] }),
      e.parent
    )
  ) : n.push(
    new vo(new wn({ type: $e.text, value: o }), e.parent)
  ), n), []).filter(
    (n) => n.value !== "" && !(!n.value.trim() && K1.test(n.value))
  ).reverse().forEach(
    (n, o, { length: r }) => o === r - 1 ? e.value = n.value : e.parent && e.parent.insert("after", n, e)
  );
}
function JO(e = []) {
  const t = YO(e, (n) => ks(n.name));
  return Object.keys(t).map((n) => t[n]).reduce(
    (n, o) => {
      const [r, s] = n, i = o[o.length - 1], a = vd(i.name);
      if (a === te.event)
        s.push(
          ...o.filter((l) => !!l.value).map((l) => ({
            type: vd(l.name),
            name: ks(l.name),
            value: l.value
          }))
        );
      else if (a === te.attribute) {
        const l = o.filter((u) => !!u.value).map((u) => u.value).join(" "), c = { type: a, name: ks(i.name) };
        l && (c.value = l), gd(c) ? s.push(c) : r.push(c);
      } else {
        const l = { type: a, name: ks(i.name) };
        i.value && (l.value = i.value), gd(l) ? s.push(l) : r.push(l);
      }
      return n;
    },
    [[], []]
  );
}
const Mh = (e) => (t, ...n) => {
  const o = {
    strings: t,
    values: n,
    [xn]: e
  };
  if (Va.has(t)) {
    const i = Va.get(t);
    return o.template = i, o;
  }
  const r = t.reduce((i, a, l) => (l < n.length ? i.push(a, Jm(l)) : i.push(a), i), []).join(""), s = KO(GO(r));
  return o.template = Object.freeze({ node: s }), Va.set(t, o.template), o;
}, XO = Mh(Wt.html), uR = Mh(Wt.svg), $h = (e) => ls(e) && !Bt(e) && !ft(e) ? String(e) : ba(e) ? `.${String(e)}` : "", kh = (e) => (t, [n, o]) => t.replace(new RegExp(n), $h(e[o]));
class xc {
  constructor(t, n = null, o) {
    W(this, "type", Ze.comment), W(this, "value"), W(this, "style", ""), W(this, "parent", null), W(this, "children"), W(this, "skipParent", !1);
    var r;
    if (this.type = t.type, this.value = t.value, this.parent = n, t.value && t.isMarker) {
      const a = kh(o), l = Ie(t.value).reduce(a, t.value);
      this.value = l;
    }
    this.value && t.isThis && this.parent && (this.value = this.value.replace(/\&/, (r = this.parent) == null ? void 0 : r.toString(!0)), this.skipParent = !0), this.value && t.isAtRule && this.parent && (this.skipParent = !0);
    const [s, i] = Dh(t, o);
    if (t.children && i.push(
      ...t.children.map((a) => [a, o])
    ), this.style = s, this.children = i.filter(
      ([a]) => a.type === Ze.style || a.type === Ze.atRule
    ).map(([a, l]) => new xc(a, this, l)), this.value && t.isAtRule && this.parent && t.children) {
      let a = "";
      for (const l of this.children)
        l.value && (a += `${l.value} {
${l.style}}
`);
      this.style = a;
    }
  }
  get selector() {
    return [...this.iterParent()].reverse().map((t) => t.toString(!0)).join(" ");
  }
  get isAtRule() {
    return this.type === Ze.atRule;
  }
  toString(t = !1) {
    return this.value ? this.value : t ? `.${Od(this.style)}` : Od(this.style);
  }
  *iterParent() {
    if (yield this, !!this.parent)
      if (this.skipParent) {
        if (!this.parent.parent) return;
        yield* this.parent.parent.iterParent();
      } else
        yield* this.parent.iterParent();
  }
  *[Symbol.iterator]() {
    if (yield this, !!this.children)
      for (const t of this.children)
        t.isAtRule ? yield t : yield* t;
  }
}
const Za = /* @__PURE__ */ new Map();
function Od(e) {
  if (Za.has(e))
    return Za.get(e);
  const t = wS();
  return Za.set(e, t), t;
}
const Ps = (e, t) => `${e}: ${t};
`;
function Dh(e, t, n = ["", []]) {
  var o;
  const r = kh(t);
  return (o = e.properties) == null || o.forEach((s) => {
    if (s.isDynamic) {
      const i = Ie(s.name), a = t[i[0][1]];
      ba(a) ? (a.template.node.children && n[1].push(
        ...a.template.node.children.map((l) => [
          l,
          a.values
        ])
      ), Dh(a.template.node, a.values, n)) : n[0] += $h(a);
    } else if (s.isMarkerName && s.isMarkerValue) {
      const i = Ie(s.name), a = Ie(s.value), l = i.reduce(r, s.name), c = a.reduce(r, s.value);
      n[0] += Ps(l, c);
    } else if (s.isMarkerName) {
      const i = Ie(s.name).reduce(r, s.name);
      n[0] += Ps(i, s.value);
    } else if (s.isMarkerValue) {
      const i = Ie(s.value).reduce(r, s.value);
      n[0] += Ps(s.name, i);
    } else
      n[0] += Ps(s.name, s.value);
  }), n;
}
const eE = {
  vCSSStyleSheetMap: /* @__PURE__ */ new Map(),
  hostContextMap: /* @__PURE__ */ new Map()
};
let Pi = globalThis.ShadowRoot && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
function ys() {
  return eE;
}
function Ed(e, t) {
  const n = ys(), o = new xc(e, null, t);
  return [...o].forEach((r) => {
    const s = r.selector;
    if (n.vCSSStyleSheetMap.has(s))
      return;
    const i = Pi ? new CSSStyleSheet() : null, a = Pi ? null : document.createElement("style"), l = r.isAtRule && !r.style ? `${s}` : `${s} {
${r.style}}`;
    i ? i.replaceSync(l) : a && (a.textContent = l), n.vCSSStyleSheetMap.set(s, {
      selector: s,
      cssText: l,
      style: r.style,
      sheet: i,
      styleElement: a
    }), Lh();
  }), String(o);
}
function Lh() {
  Pi ? tE() : nE();
}
function tE() {
  const e = ys(), t = Array.from(e.vCSSStyleSheetMap).map(([, { sheet: n }]) => n).filter(Boolean);
  Array.from(e.hostContextMap).forEach(([n]) => {
    n.adoptedStyleSheets = t;
  });
}
function nE() {
  const e = ys();
  Array.from(e.hostContextMap).forEach(
    ([t, { vSheets: n, styleElements: o }]) => {
      Array.from(e.vCSSStyleSheetMap).filter(([, r]) => !n.has(r)).map(([, r]) => (n.add(r), r.styleElement ? document.importNode(r.styleElement, !0) : null)).filter(Boolean).forEach((r) => {
        t.appendChild(r), o.add(r);
      });
    }
  );
}
function oE(e) {
  const t = ys();
  t.hostContextMap.has(e) || (t.hostContextMap.set(e, {
    vSheets: /* @__PURE__ */ new Set(),
    styleElements: /* @__PURE__ */ new Set()
  }), Lh());
}
function rE(e) {
  const t = ys(), n = t.hostContextMap.get(e);
  n && (Pi ? e.adoptedStyleSheets = [] : n.styleElements.forEach(
    (o) => e.removeChild(o)
  ), t.hostContextMap.delete(e));
}
const fn = Symbol.for("https://github.com/dineug/r-html#props");
function dR(e, t) {
  var n, o, r, s, i, a;
  t.shadow ?? (t.shadow = "open");
  const l = nO(t.observedProps), c = rO(t.observedProps), u = oO(t.observedProps), d = (a = class extends (o = HTMLElement, n = fn, o) {
    constructor() {
      super(), W(this, n, us({}, { shallow: !0 })), T(this, r, null), T(this, s, this), T(this, i), W(this, "host", this), u.forEach(
        ([m, f]) => Reflect.set(this[fn], sr(m), f)
      ), t.shadow && w(this, s, this.attachShadow({ mode: t.shadow })), Ri(this), w(this, i, t.render.call(
        this,
        this[fn],
        this
      )), Ri(null);
    }
    static get observedAttributes() {
      return Array.from(
        /* @__PURE__ */ new Set([
          ...l,
          ...l.map((m) => yS(m))
        ])
      );
    }
    connectedCallback() {
      const m = this.getRootNode();
      m instanceof ShadowRoot && (this.host = m.host), h(this, s) instanceof ShadowRoot && oE(h(this, s)), Fe(this, ma);
      let f = !1;
      w(this, r, bc(() => {
        Fe(this, f ? ya : yc), QS(h(this, s), XO`${h(this, i).call(this)}`), f ? Fe(this, ga) : (Fe(this, gc), f = !0);
      })), Fe(this, ha);
    }
    disconnectedCallback() {
      var m;
      (m = h(this, r)) == null || m.call(this), w(this, r, null), Fe(this, pa), h(this, s) instanceof ShadowRoot && rE(h(this, s));
    }
    attributeChangedCallback(m, f, p) {
      const v = c.find(
        ([I]) => sr(I) === sr(m)
      );
      v ? Reflect.set(
        this[fn],
        sr(m),
        v[1] === Boolean ? p === "true" || p === "" : v[1](p)
      ) : Reflect.set(this[fn], sr(m), p);
    }
  }, r = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap(), a);
  l.forEach((m) => {
    Object.defineProperty(d.prototype, m, {
      get() {
        return Reflect.get(this[fn], m);
      },
      set(f) {
        Reflect.set(this[fn], m, f);
      }
    });
  }), customElements.define(e, d);
}
function C(e) {
  function t(n) {
    return {
      type: e,
      payload: n
    };
  }
  return t.toString = () => `${e}`, t.type = e, t;
}
function* Cl(e, t, n) {
  for (const o of n)
    o != null && o[Symbol.iterator] ? yield* Cl(e, t, o) : tn(o) ? yield* Cl(e, t, o(e, t)) : yield o;
}
const Rh = (e, t, n) => [...Cl(e, t, n)], Ha = (...e) => (t) => e.reduce((n, o) => o(n), t);
function* sE(e) {
  yield e;
}
const za = function* (e) {
  for (const t of e)
    t.length && (yield t);
};
function iE({
  context: e,
  state: t,
  reducers: n,
  enableObservable: o = !0
}) {
  const r = o ? us(t) : t, s = Qr(), i = Qr();
  let a = Ha(za);
  const l = (v) => {
    const I = Reflect.get(n, v.type, n);
    da(I, r, v, e);
  }, c = (...v) => {
    const I = Rh(r, e, v);
    s.next(I);
  }, u = (...v) => {
    Zm(() => c(...v));
  }, d = s.subscribe((v) => {
    const I = a(sE(v));
    for (const g of I)
      i.next(g);
  }), m = i.subscribe((v) => v.forEach(l)), f = (...v) => (a = Ha(...v, za), () => {
    a = Ha(za);
  }), p = () => {
    d(), m();
  };
  return {
    context: e,
    state: r,
    dispatch: u,
    dispatchSync: c,
    subscribe: i.subscribe,
    pipe: f,
    destroy: p
  };
}
class aE {
  constructor(t) {
    W(this, "name"), W(this, "value"), this.name = t.name, this.value = t.value;
  }
  get isMarkerName() {
    return No(this.name);
  }
  get isMarkerValue() {
    return No(this.value);
  }
  get isDynamic() {
    return ds(this.name) && this.name === this.value;
  }
}
class Ac {
  constructor(t, n = null) {
    W(this, "type", Ze.comment), W(this, "value"), W(this, "properties"), W(this, "parent", null), W(this, "children"), this.type = t.type, this.value = t.value, this.parent = n, t.properties && (this.properties = t.properties.map(
      (o) => new aE(o)
    )), t.children && (this.children = t.children.map((o) => new Ac(o, this)));
  }
  get isMarker() {
    return No(this.value);
  }
  get isThis() {
    var t;
    return !!((t = this.value) != null && t.startsWith("&"));
  }
  get isAtRule() {
    return this.type === Ze.atRule;
  }
  *iterParent() {
    yield this, this.parent && (yield* this.parent.iterParent());
  }
  *[Symbol.iterator]() {
    if (yield this, !!this.children)
      for (const t of this.children)
        yield* t;
  }
}
function lE(e) {
  return new Ac(e);
}
const fR = (e, ...t) => {
  const n = {
    strings: e,
    values: t,
    [xn]: Wt.css
  };
  if (Fa.has(e)) {
    const i = Fa.get(e), a = Ed(i.node, t);
    return n.template = i, n.toString = () => a, n;
  }
  const o = e.raw.reduce((i, a, l) => (l < t.length ? i.push(a, Jm(l)) : i.push(a), i), []).join(""), r = lE($O(o)), s = Ed(r, t);
  return n.template = Object.freeze({ node: r }), n.toString = () => s, Fa.set(e, n.template), n;
};
var Sl = function(e, t) {
  return Sl = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, o) {
    n.__proto__ = o;
  } || function(n, o) {
    for (var r in o) Object.prototype.hasOwnProperty.call(o, r) && (n[r] = o[r]);
  }, Sl(e, t);
};
function cn(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Sl(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
function cE(e, t, n, o) {
  function r(s) {
    return s instanceof n ? s : new n(function(i) {
      i(s);
    });
  }
  return new (n || (n = Promise))(function(s, i) {
    function a(u) {
      try {
        c(o.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(o.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? s(u.value) : r(u.value).then(a, l);
    }
    c((o = o.apply(e, t || [])).next());
  });
}
function _h(e, t) {
  var n = { label: 0, sent: function() {
    if (s[0] & 1) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, o, r, s, i = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return i.next = a(0), i.throw = a(1), i.return = a(2), typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function a(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (o) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, c[0] && (n = 0)), n; ) try {
      if (o = 1, r && (s = c[0] & 2 ? r.return : c[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, c[1])).done) return s;
      switch (r = 0, s && (c = [c[0] & 2, s.value]), c[0]) {
        case 0:
        case 1:
          s = c;
          break;
        case 4:
          return n.label++, { value: c[1], done: !1 };
        case 5:
          n.label++, r = c[1], c = [0];
          continue;
        case 7:
          c = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (s = n.trys, !(s = s.length > 0 && s[s.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            n = 0;
            continue;
          }
          if (c[0] === 3 && (!s || c[1] > s[0] && c[1] < s[3])) {
            n.label = c[1];
            break;
          }
          if (c[0] === 6 && n.label < s[1]) {
            n.label = s[1], s = c;
            break;
          }
          if (s && n.label < s[2]) {
            n.label = s[2], n.ops.push(c);
            break;
          }
          s[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      c = t.call(e, n);
    } catch (u) {
      c = [6, u], r = 0;
    } finally {
      o = s = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Mo(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], o = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && o >= e.length && (e = void 0), { value: e && e[o++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Bi(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var o = n.call(e), r, s = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = o.next()).done; ) s.push(r.value);
  } catch (a) {
    i = { error: a };
  } finally {
    try {
      r && !r.done && (n = o.return) && n.call(o);
    } finally {
      if (i) throw i.error;
    }
  }
  return s;
}
function Wi(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, r = t.length, s; o < r; o++)
    (s || !(o in t)) && (s || (s = Array.prototype.slice.call(t, 0, o)), s[o] = t[o]);
  return e.concat(s || Array.prototype.slice.call(t));
}
function bo(e) {
  return this instanceof bo ? (this.v = e, this) : new bo(e);
}
function uE(e, t, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var o = n.apply(e, t || []), r, s = [];
  return r = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), a("next"), a("throw"), a("return", i), r[Symbol.asyncIterator] = function() {
    return this;
  }, r;
  function i(f) {
    return function(p) {
      return Promise.resolve(p).then(f, d);
    };
  }
  function a(f, p) {
    o[f] && (r[f] = function(v) {
      return new Promise(function(I, g) {
        s.push([f, v, I, g]) > 1 || l(f, v);
      });
    }, p && (r[f] = p(r[f])));
  }
  function l(f, p) {
    try {
      c(o[f](p));
    } catch (v) {
      m(s[0][3], v);
    }
  }
  function c(f) {
    f.value instanceof bo ? Promise.resolve(f.value.v).then(u, d) : m(s[0][2], f);
  }
  function u(f) {
    l("next", f);
  }
  function d(f) {
    l("throw", f);
  }
  function m(f, p) {
    f(p), s.shift(), s.length && l(s[0][0], s[0][1]);
  }
}
function dE(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof Mo == "function" ? Mo(e) : e[Symbol.iterator](), n = {}, o("next"), o("throw"), o("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function o(s) {
    n[s] = e[s] && function(i) {
      return new Promise(function(a, l) {
        i = e[s](i), r(a, l, i.done, i.value);
      });
    };
  }
  function r(s, i, a, l) {
    Promise.resolve(l).then(function(c) {
      s({ value: c, done: a });
    }, i);
  }
}
function ge(e) {
  return typeof e == "function";
}
function Ph(e) {
  var t = function(o) {
    Error.call(o), o.stack = new Error().stack;
  }, n = e(t);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var Ga = Ph(function(e) {
  return function(n) {
    e(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(o, r) {
      return r + 1 + ") " + o.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function Ui(e, t) {
  if (e) {
    var n = e.indexOf(t);
    0 <= n && e.splice(n, 1);
  }
}
var gs = function() {
  function e(t) {
    this.initialTeardown = t, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var t, n, o, r, s;
    if (!this.closed) {
      this.closed = !0;
      var i = this._parentage;
      if (i)
        if (this._parentage = null, Array.isArray(i))
          try {
            for (var a = Mo(i), l = a.next(); !l.done; l = a.next()) {
              var c = l.value;
              c.remove(this);
            }
          } catch (v) {
            t = { error: v };
          } finally {
            try {
              l && !l.done && (n = a.return) && n.call(a);
            } finally {
              if (t) throw t.error;
            }
          }
        else
          i.remove(this);
      var u = this.initialTeardown;
      if (ge(u))
        try {
          u();
        } catch (v) {
          s = v instanceof Ga ? v.errors : [v];
        }
      var d = this._finalizers;
      if (d) {
        this._finalizers = null;
        try {
          for (var m = Mo(d), f = m.next(); !f.done; f = m.next()) {
            var p = f.value;
            try {
              xd(p);
            } catch (v) {
              s = s ?? [], v instanceof Ga ? s = Wi(Wi([], Bi(s)), Bi(v.errors)) : s.push(v);
            }
          }
        } catch (v) {
          o = { error: v };
        } finally {
          try {
            f && !f.done && (r = m.return) && r.call(m);
          } finally {
            if (o) throw o.error;
          }
        }
      }
      if (s)
        throw new Ga(s);
    }
  }, e.prototype.add = function(t) {
    var n;
    if (t && t !== this)
      if (this.closed)
        xd(t);
      else {
        if (t instanceof e) {
          if (t.closed || t._hasParent(this))
            return;
          t._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(t);
      }
  }, e.prototype._hasParent = function(t) {
    var n = this._parentage;
    return n === t || Array.isArray(n) && n.includes(t);
  }, e.prototype._addParent = function(t) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(t), n) : n ? [n, t] : t;
  }, e.prototype._removeParent = function(t) {
    var n = this._parentage;
    n === t ? this._parentage = null : Array.isArray(n) && Ui(n, t);
  }, e.prototype.remove = function(t) {
    var n = this._finalizers;
    n && Ui(n, t), t instanceof e && t._removeParent(this);
  }, e.EMPTY = function() {
    var t = new e();
    return t.closed = !0, t;
  }(), e;
}(), Bh = gs.EMPTY;
function Wh(e) {
  return e instanceof gs || e && "closed" in e && ge(e.remove) && ge(e.add) && ge(e.unsubscribe);
}
function xd(e) {
  ge(e) ? e() : e.unsubscribe();
}
var fE = {
  Promise: void 0
}, mE = {
  setTimeout: function(e, t) {
    for (var n = [], o = 2; o < arguments.length; o++)
      n[o - 2] = arguments[o];
    return setTimeout.apply(void 0, Wi([e, t], Bi(n)));
  },
  clearTimeout: function(e) {
    return clearTimeout(e);
  },
  delegate: void 0
};
function Uh(e) {
  mE.setTimeout(function() {
    throw e;
  });
}
function Ol() {
}
function Ei(e) {
  e();
}
var Nc = function(e) {
  cn(t, e);
  function t(n) {
    var o = e.call(this) || this;
    return o.isStopped = !1, n ? (o.destination = n, Wh(n) && n.add(o)) : o.destination = yE, o;
  }
  return t.create = function(n, o, r) {
    return new El(n, o, r);
  }, t.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, t.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, t.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, t.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, t.prototype._next = function(n) {
    this.destination.next(n);
  }, t.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, t.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, t;
}(gs), hE = function() {
  function e(t) {
    this.partialObserver = t;
  }
  return e.prototype.next = function(t) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(t);
      } catch (o) {
        Bs(o);
      }
  }, e.prototype.error = function(t) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(t);
      } catch (o) {
        Bs(o);
      }
    else
      Bs(t);
  }, e.prototype.complete = function() {
    var t = this.partialObserver;
    if (t.complete)
      try {
        t.complete();
      } catch (n) {
        Bs(n);
      }
  }, e;
}(), El = function(e) {
  cn(t, e);
  function t(n, o, r) {
    var s = e.call(this) || this, i;
    return ge(n) || !n ? i = {
      next: n ?? void 0,
      error: o ?? void 0,
      complete: r ?? void 0
    } : i = n, s.destination = new hE(i), s;
  }
  return t;
}(Nc);
function Bs(e) {
  Uh(e);
}
function pE(e) {
  throw e;
}
var yE = {
  closed: !0,
  next: Ol,
  error: pE,
  complete: Ol
}, Mc = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function gE(e) {
  return e;
}
function vE(e) {
  return e.length === 0 ? gE : e.length === 1 ? e[0] : function(n) {
    return e.reduce(function(o, r) {
      return r(o);
    }, n);
  };
}
var nt = function() {
  function e(t) {
    t && (this._subscribe = t);
  }
  return e.prototype.lift = function(t) {
    var n = new e();
    return n.source = this, n.operator = t, n;
  }, e.prototype.subscribe = function(t, n, o) {
    var r = this, s = IE(t) ? t : new El(t, n, o);
    return Ei(function() {
      var i = r, a = i.operator, l = i.source;
      s.add(a ? a.call(s, l) : l ? r._subscribe(s) : r._trySubscribe(s));
    }), s;
  }, e.prototype._trySubscribe = function(t) {
    try {
      return this._subscribe(t);
    } catch (n) {
      t.error(n);
    }
  }, e.prototype.forEach = function(t, n) {
    var o = this;
    return n = Ad(n), new n(function(r, s) {
      var i = new El({
        next: function(a) {
          try {
            t(a);
          } catch (l) {
            s(l), i.unsubscribe();
          }
        },
        error: s,
        complete: r
      });
      o.subscribe(i);
    });
  }, e.prototype._subscribe = function(t) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(t);
  }, e.prototype[Mc] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    return vE(t)(this);
  }, e.prototype.toPromise = function(t) {
    var n = this;
    return t = Ad(t), new t(function(o, r) {
      var s;
      n.subscribe(function(i) {
        return s = i;
      }, function(i) {
        return r(i);
      }, function() {
        return o(s);
      });
    });
  }, e.create = function(t) {
    return new e(t);
  }, e;
}();
function Ad(e) {
  var t;
  return (t = e ?? fE.Promise) !== null && t !== void 0 ? t : Promise;
}
function bE(e) {
  return e && ge(e.next) && ge(e.error) && ge(e.complete);
}
function IE(e) {
  return e && e instanceof Nc || bE(e) && Wh(e);
}
function TE(e) {
  return ge(e == null ? void 0 : e.lift);
}
function jn(e) {
  return function(t) {
    if (TE(t))
      return t.lift(function(n) {
        try {
          return e(n, this);
        } catch (o) {
          this.error(o);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function St(e, t, n, o, r) {
  return new Vh(e, t, n, o, r);
}
var Vh = function(e) {
  cn(t, e);
  function t(n, o, r, s, i, a) {
    var l = e.call(this, n) || this;
    return l.onFinalize = i, l.shouldUnsubscribe = a, l._next = o ? function(c) {
      try {
        o(c);
      } catch (u) {
        n.error(u);
      }
    } : e.prototype._next, l._error = s ? function(c) {
      try {
        s(c);
      } catch (u) {
        n.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, l._complete = r ? function() {
      try {
        r();
      } catch (c) {
        n.error(c);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, l;
  }
  return t.prototype.unsubscribe = function() {
    var n;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var o = this.closed;
      e.prototype.unsubscribe.call(this), !o && ((n = this.onFinalize) === null || n === void 0 || n.call(this));
    }
  }, t;
}(Nc), wE = Ph(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), Fh = function(e) {
  cn(t, e);
  function t() {
    var n = e.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return t.prototype.lift = function(n) {
    var o = new Nd(this, this);
    return o.operator = n, o;
  }, t.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new wE();
  }, t.prototype.next = function(n) {
    var o = this;
    Ei(function() {
      var r, s;
      if (o._throwIfClosed(), !o.isStopped) {
        o.currentObservers || (o.currentObservers = Array.from(o.observers));
        try {
          for (var i = Mo(o.currentObservers), a = i.next(); !a.done; a = i.next()) {
            var l = a.value;
            l.next(n);
          }
        } catch (c) {
          r = { error: c };
        } finally {
          try {
            a && !a.done && (s = i.return) && s.call(i);
          } finally {
            if (r) throw r.error;
          }
        }
      }
    });
  }, t.prototype.error = function(n) {
    var o = this;
    Ei(function() {
      if (o._throwIfClosed(), !o.isStopped) {
        o.hasError = o.isStopped = !0, o.thrownError = n;
        for (var r = o.observers; r.length; )
          r.shift().error(n);
      }
    });
  }, t.prototype.complete = function() {
    var n = this;
    Ei(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var o = n.observers; o.length; )
          o.shift().complete();
      }
    });
  }, t.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(t.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, n);
  }, t.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, t.prototype._innerSubscribe = function(n) {
    var o = this, r = this, s = r.hasError, i = r.isStopped, a = r.observers;
    return s || i ? Bh : (this.currentObservers = null, a.push(n), new gs(function() {
      o.currentObservers = null, Ui(a, n);
    }));
  }, t.prototype._checkFinalizedStatuses = function(n) {
    var o = this, r = o.hasError, s = o.thrownError, i = o.isStopped;
    r ? n.error(s) : i && n.complete();
  }, t.prototype.asObservable = function() {
    var n = new nt();
    return n.source = this, n;
  }, t.create = function(n, o) {
    return new Nd(n, o);
  }, t;
}(nt), Nd = function(e) {
  cn(t, e);
  function t(n, o) {
    var r = e.call(this) || this;
    return r.destination = n, r.source = o, r;
  }
  return t.prototype.next = function(n) {
    var o, r;
    (r = (o = this.destination) === null || o === void 0 ? void 0 : o.next) === null || r === void 0 || r.call(o, n);
  }, t.prototype.error = function(n) {
    var o, r;
    (r = (o = this.destination) === null || o === void 0 ? void 0 : o.error) === null || r === void 0 || r.call(o, n);
  }, t.prototype.complete = function() {
    var n, o;
    (o = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || o === void 0 || o.call(n);
  }, t.prototype._subscribe = function(n) {
    var o, r;
    return (r = (o = this.source) === null || o === void 0 ? void 0 : o.subscribe(n)) !== null && r !== void 0 ? r : Bh;
  }, t;
}(Fh), CE = {
  now: function() {
    return Date.now();
  }
}, SE = function(e) {
  cn(t, e);
  function t(n, o) {
    return e.call(this) || this;
  }
  return t.prototype.schedule = function(n, o) {
    return this;
  }, t;
}(gs), Md = {
  setInterval: function(e, t) {
    for (var n = [], o = 2; o < arguments.length; o++)
      n[o - 2] = arguments[o];
    return setInterval.apply(void 0, Wi([e, t], Bi(n)));
  },
  clearInterval: function(e) {
    return clearInterval(e);
  },
  delegate: void 0
}, OE = function(e) {
  cn(t, e);
  function t(n, o) {
    var r = e.call(this, n, o) || this;
    return r.scheduler = n, r.work = o, r.pending = !1, r;
  }
  return t.prototype.schedule = function(n, o) {
    var r;
    if (o === void 0 && (o = 0), this.closed)
      return this;
    this.state = n;
    var s = this.id, i = this.scheduler;
    return s != null && (this.id = this.recycleAsyncId(i, s, o)), this.pending = !0, this.delay = o, this.id = (r = this.id) !== null && r !== void 0 ? r : this.requestAsyncId(i, this.id, o), this;
  }, t.prototype.requestAsyncId = function(n, o, r) {
    return r === void 0 && (r = 0), Md.setInterval(n.flush.bind(n, this), r);
  }, t.prototype.recycleAsyncId = function(n, o, r) {
    if (r === void 0 && (r = 0), r != null && this.delay === r && this.pending === !1)
      return o;
    o != null && Md.clearInterval(o);
  }, t.prototype.execute = function(n, o) {
    if (this.closed)
      return new Error("executing a cancelled action");
    this.pending = !1;
    var r = this._execute(n, o);
    if (r)
      return r;
    this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
  }, t.prototype._execute = function(n, o) {
    var r = !1, s;
    try {
      this.work(n);
    } catch (i) {
      r = !0, s = i || new Error("Scheduled action threw falsy error");
    }
    if (r)
      return this.unsubscribe(), s;
  }, t.prototype.unsubscribe = function() {
    if (!this.closed) {
      var n = this, o = n.id, r = n.scheduler, s = r.actions;
      this.work = this.state = this.scheduler = null, this.pending = !1, Ui(s, this), o != null && (this.id = this.recycleAsyncId(r, o, null)), this.delay = null, e.prototype.unsubscribe.call(this);
    }
  }, t;
}(SE), $d = function() {
  function e(t, n) {
    n === void 0 && (n = e.now), this.schedulerActionCtor = t, this.now = n;
  }
  return e.prototype.schedule = function(t, n, o) {
    return n === void 0 && (n = 0), new this.schedulerActionCtor(this, t).schedule(o, n);
  }, e.now = CE.now, e;
}(), EE = function(e) {
  cn(t, e);
  function t(n, o) {
    o === void 0 && (o = $d.now);
    var r = e.call(this, n, o) || this;
    return r.actions = [], r._active = !1, r;
  }
  return t.prototype.flush = function(n) {
    var o = this.actions;
    if (this._active) {
      o.push(n);
      return;
    }
    var r;
    this._active = !0;
    do
      if (r = n.execute(n.state, n.delay))
        break;
    while (n = o.shift());
    if (this._active = !1, r) {
      for (; n = o.shift(); )
        n.unsubscribe();
      throw r;
    }
  }, t;
}($d), $c = new EE(OE), xE = $c;
function AE(e) {
  return e && ge(e.schedule);
}
var NE = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function ME(e) {
  return ge(e == null ? void 0 : e.then);
}
function $E(e) {
  return ge(e[Mc]);
}
function kE(e) {
  return Symbol.asyncIterator && ge(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function DE(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function LE() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var RE = LE();
function _E(e) {
  return ge(e == null ? void 0 : e[RE]);
}
function PE(e) {
  return uE(this, arguments, function() {
    var n, o, r, s;
    return _h(this, function(i) {
      switch (i.label) {
        case 0:
          n = e.getReader(), i.label = 1;
        case 1:
          i.trys.push([1, , 9, 10]), i.label = 2;
        case 2:
          return [4, bo(n.read())];
        case 3:
          return o = i.sent(), r = o.value, s = o.done, s ? [4, bo(void 0)] : [3, 5];
        case 4:
          return [2, i.sent()];
        case 5:
          return [4, bo(r)];
        case 6:
          return [4, i.sent()];
        case 7:
          return i.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return n.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function BE(e) {
  return ge(e == null ? void 0 : e.getReader);
}
function vs(e) {
  if (e instanceof nt)
    return e;
  if (e != null) {
    if ($E(e))
      return WE(e);
    if (NE(e))
      return UE(e);
    if (ME(e))
      return VE(e);
    if (kE(e))
      return jh(e);
    if (_E(e))
      return FE(e);
    if (BE(e))
      return jE(e);
  }
  throw DE(e);
}
function WE(e) {
  return new nt(function(t) {
    var n = e[Mc]();
    if (ge(n.subscribe))
      return n.subscribe(t);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function UE(e) {
  return new nt(function(t) {
    for (var n = 0; n < e.length && !t.closed; n++)
      t.next(e[n]);
    t.complete();
  });
}
function VE(e) {
  return new nt(function(t) {
    e.then(function(n) {
      t.closed || (t.next(n), t.complete());
    }, function(n) {
      return t.error(n);
    }).then(null, Uh);
  });
}
function FE(e) {
  return new nt(function(t) {
    var n, o;
    try {
      for (var r = Mo(e), s = r.next(); !s.done; s = r.next()) {
        var i = s.value;
        if (t.next(i), t.closed)
          return;
      }
    } catch (a) {
      n = { error: a };
    } finally {
      try {
        s && !s.done && (o = r.return) && o.call(r);
      } finally {
        if (n) throw n.error;
      }
    }
    t.complete();
  });
}
function jh(e) {
  return new nt(function(t) {
    qE(e, t).catch(function(n) {
      return t.error(n);
    });
  });
}
function jE(e) {
  return jh(PE(e));
}
function qE(e, t) {
  var n, o, r, s;
  return cE(this, void 0, void 0, function() {
    var i, a;
    return _h(this, function(l) {
      switch (l.label) {
        case 0:
          l.trys.push([0, 5, 6, 11]), n = dE(e), l.label = 1;
        case 1:
          return [4, n.next()];
        case 2:
          if (o = l.sent(), !!o.done) return [3, 4];
          if (i = o.value, t.next(i), t.closed)
            return [2];
          l.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return a = l.sent(), r = { error: a }, [3, 11];
        case 6:
          return l.trys.push([6, , 9, 10]), o && !o.done && (s = n.return) ? [4, s.call(n)] : [3, 8];
        case 7:
          l.sent(), l.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (r) throw r.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return t.complete(), [2];
      }
    });
  });
}
function mR(e, t, n, o, r) {
  o === void 0 && (o = 0), r === void 0 && (r = !1);
  var s = t.schedule(function() {
    n(), r ? e.add(this.schedule(null, o)) : this.unsubscribe();
  }, o);
  if (e.add(s), !r)
    return s;
}
function ZE(e) {
  return e instanceof Date && !isNaN(e);
}
function Vi(e, t) {
  return jn(function(n, o) {
    var r = 0;
    n.subscribe(St(o, function(s) {
      o.next(e.call(t, s, r++));
    }));
  });
}
function HE(e, t, n, o, r, s, i, a) {
  var l = [], c = 0, u = 0, d = !1, m = function() {
    d && !l.length && !c && t.complete();
  }, f = function(v) {
    return c < o ? p(v) : l.push(v);
  }, p = function(v) {
    c++;
    var I = !1;
    vs(n(v, u++)).subscribe(St(t, function(g) {
      t.next(g);
    }, function() {
      I = !0;
    }, void 0, function() {
      if (I)
        try {
          c--;
          for (var g = function() {
            var b = l.shift();
            i || p(b);
          }; l.length && c < o; )
            g();
          m();
        } catch (b) {
          t.error(b);
        }
    }));
  };
  return e.subscribe(St(t, f, function() {
    d = !0, m();
  })), function() {
  };
}
function qh(e, t, n) {
  return n === void 0 && (n = 1 / 0), ge(t) ? qh(function(o, r) {
    return Vi(function(s, i) {
      return t(o, s, r, i);
    })(vs(e(o, r)));
  }, n) : (typeof t == "number" && (n = t), jn(function(o, r) {
    return HE(o, r, e, n);
  }));
}
function zE(e, t, n) {
  e === void 0 && (e = 0), n === void 0 && (n = xE);
  var o = -1;
  return t != null && (AE(t) ? n = t : o = t), new nt(function(r) {
    var s = ZE(e) ? +e - n.now() : e;
    s < 0 && (s = 0);
    var i = 0;
    return n.schedule(function() {
      r.closed || (r.next(i++), 0 <= o ? this.schedule(void 0, o) : r.complete());
    }, s);
  });
}
function GE(e, t) {
  return jn(function(n, o) {
    var r = 0;
    n.subscribe(St(o, function(s) {
      return e.call(t, s, r++) && o.next(s);
    }));
  });
}
function YE(e) {
  return jn(function(t, n) {
    var o = [];
    return t.subscribe(St(n, function(r) {
      return o.push(r);
    }, function() {
      n.next(o), n.complete();
    })), vs(e).subscribe(St(n, function() {
      var r = o;
      o = [], n.next(r);
    }, Ol)), function() {
      o = null;
    };
  });
}
function KE(e, t) {
  return t === void 0 && (t = $c), jn(function(n, o) {
    var r = null, s = null, i = null, a = function() {
      if (r) {
        r.unsubscribe(), r = null;
        var c = s;
        s = null, o.next(c);
      }
    };
    function l() {
      var c = i + e, u = t.now();
      if (u < c) {
        r = this.schedule(void 0, c - u), o.add(r);
        return;
      }
      a();
    }
    n.subscribe(St(o, function(c) {
      s = c, i = t.now(), r || (r = t.schedule(l, e), o.add(r));
    }, function() {
      a(), o.complete();
    }, void 0, function() {
      s = r = null;
    }));
  });
}
function QE(e, t, n, o) {
  return jn(function(r, s) {
    var i;
    (!t || typeof t == "function") && (i = t);
    var a = /* @__PURE__ */ new Map(), l = function(p) {
      a.forEach(p), p(s);
    }, c = function(p) {
      return l(function(v) {
        return v.error(p);
      });
    }, u = 0, d = !1, m = new Vh(s, function(p) {
      try {
        var v = e(p), I = a.get(v);
        if (!I) {
          a.set(v, I = o ? o() : new Fh());
          var g = f(v, I);
          if (s.next(g), n) {
            var b = St(I, function() {
              I.complete(), b == null || b.unsubscribe();
            }, void 0, void 0, function() {
              return a.delete(v);
            });
            m.add(vs(n(g)).subscribe(b));
          }
        }
        I.next(i ? i(p) : p);
      } catch (S) {
        c(S);
      }
    }, function() {
      return l(function(p) {
        return p.complete();
      });
    }, c, function() {
      return a.clear();
    }, function() {
      return d = !0, u === 0;
    });
    r.subscribe(m);
    function f(p, v) {
      var I = new nt(function(g) {
        u++;
        var b = v.subscribe(g);
        return function() {
          b.unsubscribe(), --u === 0 && d && m.unsubscribe();
        };
      });
      return I.key = p, I;
    }
  });
}
function JE(e, t) {
  return jn(function(n, o) {
    var r = t ?? {}, s = r.leading, i = s === void 0 ? !0 : s, a = r.trailing, l = a === void 0 ? !1 : a, c = !1, u = null, d = null, m = !1, f = function() {
      d == null || d.unsubscribe(), d = null, l && (I(), m && o.complete());
    }, p = function() {
      d = null, m && o.complete();
    }, v = function(g) {
      return d = vs(e(g)).subscribe(St(o, f, p));
    }, I = function() {
      if (c) {
        c = !1;
        var g = u;
        u = null, o.next(g), !m && v(g);
      }
    };
    n.subscribe(St(o, function(g) {
      c = !0, u = g, !(d && !d.closed) && (i ? I() : v(g));
    }, function() {
      m = !0, !(l && c && d && !d.closed) && o.complete();
    }));
  });
}
function XE(e, t, n) {
  t === void 0 && (t = $c);
  var o = zE(e, t);
  return JE(function() {
    return o;
  }, n);
}
const N = {
  changeHasHistory: "editor.changeHasHistory",
  selectAll: "editor.selectAll",
  unselectAll: "editor.unselectAll",
  select: "editor.select",
  changeViewport: "editor.changeViewport",
  clear: "editor.clear",
  loadJson: "editor.loadJson",
  initialClear: "editor.initialClear",
  initialLoadJson: "editor.initialLoadJson",
  focusTable: "editor.focusTable",
  focusColumn: "editor.focusColumn",
  focusTableEnd: "editor.focusTableEnd",
  focusMoveTable: "editor.focusMoveTable",
  editTable: "editor.editTable",
  editTableEnd: "editor.editTableEnd",
  selectAllColumn: "editor.selectAllColumn",
  drawStartRelationship: "editor.drawStartRelationship",
  drawStartAddRelationship: "editor.drawStartAddRelationship",
  drawEndRelationship: "editor.drawEndRelationship",
  drawRelationship: "editor.drawRelationship",
  hoverColumnMap: "editor.hoverColumnMap",
  hoverRelationshipMap: "editor.hoverRelationshipMap",
  changeOpenMap: "editor.changeOpenMap",
  dragstartColumn: "editor.dragstartColumn",
  dragendColumn: "editor.dragendColumn",
  sharedMouseTracker: "editor.sharedMouseTracker",
  validationIds: "editor.validationIds",
  getLWW: "editor.getLWW",
  mergeLWW: "editor.mergeLWW"
}, Zh = A.CanvasType, ex = A.CanvasTypeList, K = A.Show, R = A.ColumnType, tx = A.ColumnTypeList, Kn = A.Database, nx = A.DatabaseList, hR = A.Language, ox = A.LanguageList, pR = A.NameCase, rx = A.NameCaseList, Ws = A.BracketType, sx = A.BracketTypeList, Hh = A.RelationshipType, xl = A.StartRelationshipType, Tt = A.Direction, V = A.ColumnOption, bt = A.ColumnUIKey, Io = A.OrderType, yR = A.SaveSettingType, ix = A.CANVAS_SIZE_MAX, ax = A.CANVAS_SIZE_MIN, lx = A.CANVAS_ZOOM_MAX, cx = A.CANVAS_ZOOM_MIN, gR = {
  [Ws.none]: "",
  [Ws.backtick]: "`",
  [Ws.doubleQuote]: '"',
  [Ws.singleQuote]: "'"
}, vR = {
  [R.columnName]: "Name",
  [R.columnDataType]: "DataType",
  [R.columnDefault]: "Default",
  [R.columnComment]: "Comment",
  [R.columnAutoIncrement]: "Auto Increment",
  [R.columnUnique]: "Unique",
  [R.columnNotNull]: "Not Null"
}, qn = {
  shared: (
    /*     */
    1
  ),
  changeOnly: (
    /* */
    2
  ),
  following: (
    /*  */
    4
  )
};
function ux(e, t) {
  return {
    ...ua(t),
    tags: Cm(t.tags) ? t.tags | e : e
  };
}
function dx(e, t) {
  return t.map((n) => ux(e, n));
}
const fx = (e) => (...t) => function* (n, o) {
  const r = Rh(n, o, t);
  yield dx(e, r);
}, bR = fx(qn.changeOnly);
function $(e, t) {
  return (e & t) === t;
}
function kd(e, t) {
  return !(e.x > t.x + t.w || e.x + e.w < t.x || e.y > t.y + t.h || e.y + e.h < t.y);
}
function Al(e, t, n) {
  const o = { x: 0, y: 0, w: 0, h: 0 };
  return o.w = e * n, o.h = t * n, o.x = (e - o.w) / 2, o.y = (t - o.h) / 2, o;
}
function mx({ x: e, y: t }, n, o, r) {
  const s = Al(n, o, r), i = e * r, a = t * r, l = s.x + i, c = s.y + a;
  return { x: l, y: c };
}
function zh(e, t, n, o) {
  const { x: r, y: s } = e, { x: i, y: a } = mx(
    e,
    t,
    n,
    o
  ), l = (r - i) / o, c = (s - a) / o, u = r + l, d = s + c;
  return { x: u, y: d };
}
const hx = 200, px = 100, Dd = 50, yx = 16, gx = 9, Gh = 1200, vx = Gh / yx * gx, Yh = 20, An = 8, Kh = 12, bx = 4, Fi = 1, ji = 8, Ix = 2, Tx = 2, wx = Yh + Ix * 2, Cx = Kh + Tx + wx, IR = 4, Qh = 12, Jh = 12, He = 60, Xh = 35, ep = 22, tp = 15, Sx = 2, Ox = Yh + Sx * 2, qi = 1, Zi = 8, np = Kh + bx, Ex = 100 + np, xx = 100, TR = 150, wR = 20, CR = 30, SR = 200, bn = {
  MariaDB: "MariaDB",
  MSSQL: "MSSQL",
  MySQL: "MySQL",
  Oracle: "Oracle",
  PostgreSQL: "PostgreSQL",
  SQLite: "SQLite"
}, Ax = Object.values(bn), OR = {
  [bn.MariaDB]: Kn.MariaDB,
  [bn.MSSQL]: Kn.MSSQL,
  [bn.MySQL]: Kn.MySQL,
  [bn.Oracle]: Kn.Oracle,
  [bn.PostgreSQL]: Kn.PostgreSQL,
  [bn.SQLite]: Kn.SQLite
}, Nx = /[^0-9]/g, op = (e) => e.replace(Nx, ""), Mx = Xe(ax, ix), $x = Xe(cx, lx), rp = Xe(He, 200);
function Nl(e) {
  const t = H(e) ? Number(op(e)) : e;
  return Mx(t);
}
function Ia(e) {
  return dt($x(e), 2);
}
function ER(e) {
  const t = H(e) ? Number(op(e)) : e;
  return `${rp(t)}px`;
}
function xR(e) {
  return `${(e * 100).toFixed()}%`;
}
const kx = B(nx), sp = B(rx), Dx = B(sx), Lx = B(ox), Ld = B(tx), AR = B(Ax), ip = B(ex);
function ye(e) {
  return Math.max(e, He);
}
function NR(e) {
  return H(e) ? e.trim() : "";
}
function MR(e) {
  return e <= 0.7;
}
const Le = {
  table: "table",
  memo: "memo"
}, P = {
  tableName: "tableName",
  tableComment: "tableComment",
  columnName: "columnName",
  columnDataType: "columnDataType",
  columnNotNull: "columnNotNull",
  columnUnique: "columnUnique",
  columnAutoIncrement: "columnAutoIncrement",
  columnDefault: "columnDefault",
  columnComment: "columnComment"
}, lt = {
  ArrowUp: "ArrowUp",
  ArrowRight: "ArrowRight",
  ArrowDown: "ArrowDown",
  ArrowLeft: "ArrowLeft",
  Tab: "Tab"
}, $R = B(Object.values(lt)), Rx = () => ({
  id: me(),
  selectedMap: {},
  hasUndo: !1,
  hasRedo: !1,
  viewport: {
    width: Gh,
    height: vx
  },
  focusTable: null,
  drawRelationship: null,
  hoverColumnMap: {},
  hoverRelationshipMap: {},
  openMap: {},
  draggableColumn: null,
  draggingColumnMap: {},
  sharedMouseTrackerMap: {}
}), Rd = (e) => e.ui.zIndex, Ta = (e, t) => Math.max(1, ...e.map(Rd), ...t.map(Rd)) + 1, _x = (e) => (t) => e.y === t.y && e.x === t.x;
function ap({ width: e, height: t, zoomLevel: n, scrollLeft: o, scrollTop: r }, s, i) {
  const a = zh(
    {
      x: hx - o,
      y: px - r
    },
    e,
    t,
    n
  ), l = [...s, ...i].map(({ ui: c }) => c);
  for (; l.some(_x(a)); )
    a.x += Dd, a.y += Dd;
  return a;
}
function qo() {
  const e = Date.now();
  return {
    updateAt: e,
    createAt: e
  };
}
function Px(e, t) {
  return e < t ? rd(e, t + 1) : rd(t, e + 1);
}
function kR(e) {
  return Yf(sT(e));
}
function bs(e, t) {
  return ki([...e, t]);
}
function lp(e, t, n) {
  if (!t || t === n) return [n];
  const o = e.indexOf(t), r = e.indexOf(n);
  return o === -1 ? [n] : Px(o, r).map((s) => e[s]);
}
function Bx(e, t, n, o) {
  return ki([
    ...t,
    ...lp(e, n, o)
  ]);
}
const Wx = {
  [R.columnName]: !0,
  [R.columnDataType]: K.columnDataType,
  [R.columnNotNull]: K.columnNotNull,
  [R.columnUnique]: K.columnUnique,
  [R.columnAutoIncrement]: K.columnAutoIncrement,
  [R.columnDefault]: K.columnDefault,
  [R.columnComment]: K.columnComment
}, Ux = {
  [R.columnName]: P.columnName,
  [R.columnDataType]: P.columnDataType,
  [R.columnNotNull]: P.columnNotNull,
  [R.columnUnique]: P.columnUnique,
  [R.columnAutoIncrement]: P.columnAutoIncrement,
  [R.columnDefault]: P.columnDefault,
  [R.columnComment]: P.columnComment
}, cp = [
  P.tableName,
  P.tableComment
];
function Zo({
  settings: { show: e, columnOrder: t }
}) {
  return t.filter((n) => {
    const o = Wx[n];
    return o === !0 ? !0 : $(e, o);
  }).map((n) => Ux[n]);
}
function Is({ collections: e, editor: { focusTable: t } }) {
  if (!t) return !1;
  const n = y(e).collection("tableEntities").selectById(t.tableId);
  return !!(n != null && n.columnIds.length);
}
function kc(e) {
  const {
    editor: { focusTable: t }
  } = e;
  if (!t) return !0;
  const n = Zo(e);
  return n.indexOf(t.focusType) === n.length - 1;
}
function up(e) {
  const {
    editor: { focusTable: t }
  } = e;
  return t ? Zo(e).indexOf(t.focusType) === 0 : !0;
}
function Dc({
  collections: e,
  editor: { focusTable: t }
}) {
  if (!(t != null && t.columnId))
    return !0;
  const n = y(e).collection("tableEntities").selectById(t.tableId);
  return n ? n.columnIds.indexOf(t.columnId) === n.columnIds.length - 1 : !0;
}
function dp({ collections: e, editor: { focusTable: t } }) {
  if (!(t != null && t.columnId))
    return !0;
  const n = y(e).collection("tableEntities").selectById(t.tableId);
  return n ? n.columnIds.indexOf(t.columnId) === 0 : !0;
}
function Ml(e) {
  const t = Zo(e);
  return t[t.length - 1];
}
function $l(e) {
  return Zo(e)[0];
}
function Vx(e) {
  const {
    editor: { focusTable: t }
  } = e;
  if (!t) return P.columnName;
  const n = Zo(e), o = n.indexOf(t.focusType);
  return kc(e) ? n[0] : n[o + 1];
}
function Fx(e) {
  const {
    editor: { focusTable: t }
  } = e;
  if (!t) return P.columnName;
  const n = Zo(e), o = n.indexOf(t.focusType);
  return up(e) ? n[n.length - 1] : n[o - 1];
}
function jx(e, t) {
  const {
    collections: n,
    editor: { focusTable: o }
  } = e;
  if (!(o != null && o.columnId)) return null;
  const r = y(n).collection("tableEntities").selectById(o.tableId);
  if (!r) return null;
  const s = r.columnIds.indexOf(o.columnId);
  if (s <= 0) return null;
  let i = null;
  for (let a = s; a >= 0; a--) {
    const l = r.columnIds[a];
    if (!t.includes(l)) {
      i = l;
      break;
    }
  }
  return i;
}
function wa({ settings: { show: e } }) {
  return $(e, K.tableComment) ? cp : [P.tableName];
}
function Lc(e) {
  const {
    editor: { focusTable: t }
  } = e;
  if (!t) return !0;
  const n = wa(e);
  return n.indexOf(t.focusType) === n.length - 1;
}
function fp(e) {
  const {
    editor: { focusTable: t }
  } = e;
  return t ? wa(e).indexOf(t.focusType) === 0 : !0;
}
const _n = B(cp);
function _d(e) {
  const {
    editor: { focusTable: t }
  } = e;
  if (!t) return P.tableName;
  const n = wa(e), o = n.indexOf(t.focusType);
  return Lc(e) ? n[0] : n[o + 1];
}
function Pd(e) {
  const {
    editor: { focusTable: t }
  } = e;
  if (!t) return P.tableName;
  const n = wa(e), o = n.indexOf(t.focusType);
  return fp(e) ? n[n.length - 1] : n[o - 1];
}
function qx(e, t) {
  const {
    collections: n,
    editor: { focusTable: o }
  } = e;
  if (!o) return;
  const r = y(n).collection("tableEntities").selectById(o.tableId);
  if (r) {
    if (_n(o.focusType)) {
      if (Is(e)) {
        const s = r.columnIds[r.columnIds.length - 1];
        o.focusType = Ml(e), o.columnId = s, o.prevSelectColumnId = s, o.selectColumnIds = [s];
      }
    } else if (dp(e))
      o.focusType = P.tableName, o.columnId = null, o.prevSelectColumnId = null, o.selectColumnIds = [];
    else if (o.columnId) {
      const s = r.columnIds.indexOf(o.columnId), i = r.columnIds[s - 1];
      o.columnId = i, o.prevSelectColumnId = i, t.shiftKey && t.moveKey !== lt.Tab ? o.selectColumnIds = bs(
        o.selectColumnIds,
        i
      ) : o.selectColumnIds = [i];
    }
  }
}
function Zx(e, t) {
  const {
    collections: n,
    editor: { focusTable: o }
  } = e;
  if (!o) return;
  const r = y(n).collection("tableEntities").selectById(o.tableId);
  if (r) {
    if (_n(o.focusType)) {
      if (Is(e)) {
        const s = r.columnIds[0];
        o.focusType = $l(e), o.columnId = s, o.prevSelectColumnId = s, o.selectColumnIds = [s];
      }
    } else if (Dc(e))
      o.focusType = P.tableName, o.columnId = null, o.prevSelectColumnId = null, o.selectColumnIds = [];
    else if (o.columnId) {
      const s = r.columnIds.indexOf(o.columnId), i = r.columnIds[s + 1];
      o.columnId = i, o.prevSelectColumnId = i, t.shiftKey && t.moveKey !== lt.Tab ? o.selectColumnIds = bs(
        o.selectColumnIds,
        i
      ) : o.selectColumnIds = [i];
    }
  }
}
function Bd(e, t) {
  const {
    collections: n,
    editor: { focusTable: o }
  } = e;
  if (!o) return;
  const r = y(n).collection("tableEntities").selectById(o.tableId);
  if (r)
    if (_n(o.focusType))
      if (fp(e))
        if (Is(e)) {
          const s = r.columnIds[r.columnIds.length - 1];
          o.focusType = Ml(e), o.columnId = s, o.prevSelectColumnId = s, o.selectColumnIds = [s];
        } else
          o.focusType = Pd(e);
      else
        o.focusType = Pd(e);
    else if (up(e)) {
      if (dp(e))
        o.focusType = $(e.settings.show, K.tableComment) ? P.tableComment : P.tableName, o.columnId = null, o.prevSelectColumnId = null, o.selectColumnIds = [];
      else if (o.columnId) {
        const s = r.columnIds.indexOf(o.columnId), i = r.columnIds[s - 1];
        o.focusType = Ml(e), o.columnId = i, o.prevSelectColumnId = i, t.shiftKey && t.moveKey !== lt.Tab ? o.selectColumnIds = bs(
          o.selectColumnIds,
          i
        ) : o.selectColumnIds = [i];
      }
    } else
      o.focusType = Fx(e), !t.shiftKey && o.columnId && (o.prevSelectColumnId = o.columnId, o.selectColumnIds = [o.columnId]);
}
function Wd(e, t) {
  const {
    collections: n,
    editor: { focusTable: o }
  } = e;
  if (!o) return;
  const r = y(n).collection("tableEntities").selectById(o.tableId);
  if (r)
    if (_n(o.focusType))
      if (Lc(e))
        if (Is(e)) {
          const s = r.columnIds[0];
          o.focusType = $l(e), o.columnId = s, o.prevSelectColumnId = s, o.selectColumnIds = [s];
        } else
          o.focusType = _d(e);
      else
        o.focusType = _d(e);
    else if (kc(e)) {
      if (Dc(e))
        o.focusType = P.tableName, o.columnId = null, o.prevSelectColumnId = null, o.selectColumnIds = [];
      else if (o.columnId) {
        const s = r.columnIds.indexOf(o.columnId), i = r.columnIds[s + 1];
        o.focusType = $l(e), o.columnId = i, o.prevSelectColumnId = i, t.shiftKey && t.moveKey !== lt.Tab ? o.selectColumnIds = bs(
          o.selectColumnIds,
          i
        ) : o.selectColumnIds = [i];
      }
    } else
      o.focusType = Vx(e), !t.shiftKey && o.columnId && (o.prevSelectColumnId = o.columnId, o.selectColumnIds = [o.columnId]);
}
const Ud = 1e3 * 30, Hx = C(N.changeHasHistory), zx = ({ editor: e }, { payload: { hasRedo: t, hasUndo: n } }) => {
  e.hasRedo = t, e.hasUndo = n;
}, Gx = C(N.selectAll), Yx = ({
  editor: e,
  doc: t
}) => {
  const n = t.tableIds.reduce(
    (r, s) => (r[s] = Le.table, r),
    {}
  ), o = t.memoIds.reduce(
    (r, s) => (r[s] = Le.memo, r),
    {}
  );
  e.selectedMap = {
    ...o,
    ...n
  };
}, Ca = C(N.unselectAll), Kx = ({
  editor: e
}) => {
  Object.keys(e.selectedMap).forEach((t) => {
    Reflect.deleteProperty(e.selectedMap, t);
  });
}, Ho = C(
  N.select
), Qx = ({ editor: e }, { payload: t }) => {
  Object.assign(e.selectedMap, t);
}, Jx = C(N.changeViewport), Xx = ({ editor: e }, { payload: { width: t, height: n } }) => {
  e.viewport.width = t, e.viewport.height = n;
}, Rc = C(
  N.clear
), eA = (e) => {
  const { doc: t, collections: n } = Un({});
  e.doc = t, e.collections = n;
}, on = C(N.loadJson), tA = (e, { payload: { value: t } }) => {
  const { version: n, settings: o, doc: r, collections: s } = Um(t);
  ip(o.canvasType) || (o.canvasType = Zh.ERD), Object.assign(e.settings, o), e.version = n, e.doc = r, e.collections = s;
}, mp = C(N.initialClear), nA = (e) => {
  const { doc: t, collections: n } = Un({});
  e.doc = t, e.collections = n;
}, $o = C(N.initialLoadJson), oA = (e, { payload: { value: t } }) => {
  const { version: n, settings: o, doc: r, collections: s } = Um(t);
  ip(o.canvasType) || (o.canvasType = Zh.ERD), Object.assign(e.settings, o), e.version = n, e.doc = r, e.collections = s;
}, Sa = C(N.focusTable), rA = ({ editor: e, collections: t }, { payload: n }) => {
  var r, s;
  const o = y(t).collection("tableEntities");
  if (((r = e.focusTable) == null ? void 0 : r.tableId) === n.tableId && n.focusType)
    e.focusTable.focusType = n.focusType, e.focusTable.columnId = null, e.focusTable.prevSelectColumnId = null, e.focusTable.selectColumnIds = [];
  else if (n.focusType) {
    const i = o.selectById(n.tableId);
    if (!i) return;
    e.focusTable = {
      tableId: i.id,
      focusType: n.focusType,
      columnId: null,
      prevSelectColumnId: null,
      selectColumnIds: [],
      edit: !1
    };
  } else if (((s = e.focusTable) == null ? void 0 : s.tableId) !== n.tableId) {
    const i = o.selectById(n.tableId);
    if (!i) return;
    e.focusTable = {
      tableId: i.id,
      focusType: P.tableName,
      columnId: null,
      prevSelectColumnId: null,
      selectColumnIds: [],
      edit: !1
    };
  }
}, rn = C(N.focusColumn), sA = ({ editor: e, collections: t }, { payload: n }) => {
  var r;
  const o = y(t).collection("tableEntities");
  if (((r = e.focusTable) == null ? void 0 : r.tableId) === n.tableId) {
    const s = o.selectById(n.tableId);
    if (!s) return;
    const i = e.focusTable;
    i.columnId = n.columnId, i.focusType = n.focusType, n.$mod && n.shiftKey ? i.selectColumnIds = Bx(
      s.columnIds,
      i.selectColumnIds,
      i.prevSelectColumnId,
      i.columnId
    ) : n.shiftKey ? i.selectColumnIds = lp(
      s.columnIds,
      i.prevSelectColumnId,
      i.columnId
    ) : n.$mod ? i.selectColumnIds = bs(
      i.selectColumnIds,
      n.columnId
    ) : i.selectColumnIds = [n.columnId], i.prevSelectColumnId = n.columnId;
  } else {
    const s = o.selectById(n.tableId);
    if (!s) return;
    e.focusTable = {
      tableId: s.id,
      focusType: n.focusType,
      columnId: n.columnId,
      prevSelectColumnId: n.columnId,
      selectColumnIds: [n.columnId],
      edit: !1
    };
  }
}, _c = C(N.focusTableEnd), iA = ({
  editor: e
}) => {
  e.focusTable = null;
}, hp = C(N.focusMoveTable), aA = (e, { payload: t }) => {
  const {
    editor: { focusTable: n }
  } = e;
  if (n)
    switch (n.edit = !1, t.moveKey) {
      case lt.ArrowUp:
        qx(e, t);
        break;
      case lt.ArrowDown:
        Zx(e, t);
        break;
      case lt.ArrowLeft:
        Bd(e, t);
        break;
      case lt.ArrowRight:
        Wd(e, t);
        break;
      case lt.Tab:
        t.shiftKey ? Bd(e, t) : Wd(e, t);
        break;
    }
}, lA = C(N.editTable), cA = ({
  editor: { focusTable: e }
}) => {
  e && (e.edit = !0);
}, uA = C(N.editTableEnd), dA = ({
  editor: { focusTable: e }
}) => {
  e && (e.edit = !1);
}, fA = C(N.selectAllColumn), mA = ({
  collections: e,
  editor: { focusTable: t }
}) => {
  if (!t) return;
  const n = y(e).collection("tableEntities").selectById(t.tableId);
  n && (t.selectColumnIds = [...n.columnIds]);
}, pp = C(N.drawStartRelationship), hA = ({ editor: e }, { payload: { relationshipType: t } }) => {
  e.drawRelationship = {
    relationshipType: t,
    start: null,
    end: { x: 0, y: 0 }
  };
}, yp = C(N.drawStartAddRelationship), pA = ({ editor: { drawRelationship: e }, collections: t }, { payload: { tableId: n } }) => {
  if (!e) return;
  const o = y(t).collection("tableEntities").selectById(n);
  o && (e.start = {
    tableId: n,
    x: o.ui.x,
    y: o.ui.y
  });
}, Pc = C(N.drawEndRelationship), yA = ({ editor: e }) => {
  e.drawRelationship = null;
}, gA = C(N.drawRelationship), vA = ({
  editor: { drawRelationship: e },
  settings: { scrollLeft: t, scrollTop: n, zoomLevel: o, width: r, height: s }
}, { payload: { x: i, y: a } }) => {
  if (!(e != null && e.start)) return;
  const l = zh(
    { x: i - t, y: a - n },
    r,
    s,
    o
  );
  e.end.x = l.x, e.end.y = l.y;
}, Bc = C(N.hoverColumnMap), bA = ({ editor: e }, { payload: { columnIds: t } }) => {
  Object.keys(e.hoverColumnMap).forEach((n) => {
    Reflect.deleteProperty(e.hoverColumnMap, n);
  });
  for (const n of t)
    e.hoverColumnMap[n] = !0;
}, Wc = C(N.hoverRelationshipMap), IA = ({ editor: e }, { payload: { relationshipIds: t } }) => {
  Object.keys(e.hoverRelationshipMap).forEach((n) => {
    Reflect.deleteProperty(e.hoverRelationshipMap, n);
  });
  for (const n of t)
    e.hoverRelationshipMap[n] = !0;
}, TA = C(N.changeOpenMap), wA = ({ editor: e }, { payload: t }) => {
  Object.assign(e.openMap, t);
}, Uc = C(N.dragstartColumn), CA = ({ editor: e }, { payload: t }) => {
  e.draggableColumn = t, t.columnIds.forEach((n) => {
    e.draggingColumnMap[n] = !0;
  });
}, SA = C(N.dragendColumn), OA = ({
  editor: e
}) => {
  e.draggableColumn = null, Object.keys(e.draggingColumnMap).forEach((t) => {
    Reflect.deleteProperty(e.draggingColumnMap, t);
  });
}, EA = C(N.sharedMouseTracker), xA = ({ editor: e }, { payload: t, tags: n, meta: o }) => {
  if (ve(n) || !$(n, qn.shared) || !H(o == null ? void 0 : o.editorId) || e.id === o.editorId)
    return;
  const r = e.sharedMouseTrackerMap[o.editorId], s = !H(o.nickname) || Tm(o.nickname.trim()) ? "user" : o.nickname.trim();
  r ? (r.x = t.x, r.y = t.y, r.nickname = s, clearTimeout(r.timeoutId), r.timeoutId = setTimeout(() => {
    Reflect.deleteProperty(e.sharedMouseTrackerMap, o.editorId);
  }, Ud)) : e.sharedMouseTrackerMap[o.editorId] = {
    ...t,
    id: o.editorId,
    nickname: s,
    timeoutId: setTimeout(() => {
      Reflect.deleteProperty(e.sharedMouseTrackerMap, o.editorId);
    }, Ud)
  };
}, AA = C(N.validationIds), NA = ({
  doc: e,
  collections: t
}) => {
  const n = y(t).collection("tableEntities"), o = y(t).collection(
    "tableColumnEntities"
  ), r = y(t).collection("indexEntities"), s = y(t).collection(
    "indexColumnEntities"
  ), i = y(t).collection(
    "relationshipEntities"
  ), a = y(t).collection("memoEntities"), l = e.tableIds.filter(
    (m) => !n.selectById(m)
  ), c = e.relationshipIds.filter(
    (m) => !i.selectById(m)
  ), u = e.indexIds.filter(
    (m) => !r.selectById(m)
  ), d = e.memoIds.filter(
    (m) => !a.selectById(m)
  );
  e.tableIds = e.tableIds.filter((m) => !l.includes(m)), e.relationshipIds = e.relationshipIds.filter(
    (m) => !c.includes(m)
  ), e.indexIds = e.indexIds.filter((m) => !u.includes(m)), e.memoIds = e.memoIds.filter((m) => !d.includes(m)), n.selectAll().forEach((m) => {
    const f = m.columnIds.filter(
      (v) => !o.selectById(v)
    ), p = m.seqColumnIds.filter(
      (v) => !o.selectById(v)
    );
    m.columnIds = m.columnIds.filter(
      (v) => !f.includes(v)
    ), m.seqColumnIds = m.seqColumnIds.filter(
      (v) => !p.includes(v)
    );
  }), r.selectAll().forEach((m) => {
    const f = m.indexColumnIds.filter(
      (v) => !s.selectById(v)
    ), p = m.seqIndexColumnIds.filter(
      (v) => !s.selectById(v)
    );
    m.indexColumnIds = m.indexColumnIds.filter(
      (v) => !f.includes(v)
    ), m.seqIndexColumnIds = m.seqIndexColumnIds.filter(
      (v) => !p.includes(v)
    );
  });
}, MA = C(
  N.getLWW
), $A = Br, kA = C(N.mergeLWW), DA = ({ lww: e }, { payload: { lww: t } }) => {
  Object.entries(t).forEach(
    ([n, [o, r, s, i]]) => {
      Pm(e, r, n, o, Br), Bm(e, s, n, o, Br), Object.entries(i).forEach(([a, l]) => {
        mc(e, l, n, o, a, Br);
      });
    }
  );
}, LA = {
  [N.changeHasHistory]: zx,
  [N.selectAll]: Yx,
  [N.unselectAll]: Kx,
  [N.select]: Qx,
  [N.changeViewport]: Xx,
  [N.clear]: eA,
  [N.loadJson]: tA,
  [N.initialClear]: nA,
  [N.initialLoadJson]: oA,
  [N.focusTable]: rA,
  [N.focusColumn]: sA,
  [N.focusTableEnd]: iA,
  [N.focusMoveTable]: aA,
  [N.editTable]: cA,
  [N.editTableEnd]: dA,
  [N.selectAllColumn]: mA,
  [N.drawStartRelationship]: hA,
  [N.drawStartAddRelationship]: pA,
  [N.drawEndRelationship]: yA,
  [N.drawRelationship]: vA,
  [N.hoverColumnMap]: bA,
  [N.hoverRelationshipMap]: IA,
  [N.changeOpenMap]: wA,
  [N.dragstartColumn]: CA,
  [N.dragendColumn]: OA,
  [N.sharedMouseTracker]: xA,
  [N.validationIds]: NA,
  [N.getLWW]: $A,
  [N.mergeLWW]: DA
}, RA = {
  changeHasHistoryAction: Hx,
  selectAllAction: Gx,
  unselectAllAction: Ca,
  selectAction: Ho,
  changeViewportAction: Jx,
  clearAction: Rc,
  loadJsonAction: on,
  initialClearAction: mp,
  initialLoadJsonAction: $o,
  focusTableAction: Sa,
  focusColumnAction: rn,
  focusTableEndAction: _c,
  focusMoveTableAction: hp,
  editTableAction: lA,
  editTableEndAction: uA,
  selectAllColumnAction: fA,
  drawStartRelationshipAction: pp,
  drawStartAddRelationshipAction: yp,
  drawEndRelationshipAction: Pc,
  drawRelationshipAction: gA,
  hoverColumnMapAction: Bc,
  hoverRelationshipMapAction: Wc,
  changeOpenMapAction: TA,
  dragstartColumnAction: Uc,
  dragendColumnAction: SA,
  sharedMouseTrackerAction: EA,
  validationIdsAction: AA,
  getLWWAction: MA,
  mergeLWWAction: kA
}, _A = (e, t, n) => {
  e.push(Rc(), on({ value: hc(n) }));
}, PA = (e, t, n) => {
  e.push(on({ value: hc(n) }));
}, BA = {
  [N.loadJson]: _A,
  [N.clear]: PA
}, ze = {
  addIndex: "index.add",
  removeIndex: "index.remove",
  changeIndexName: "index.changeName",
  changeIndexUnique: "index.changeUnique"
};
function WA(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ya, Vd;
function UA() {
  if (Vd) return Ya;
  Vd = 1;
  var e = function(b) {
    return t(b) && !n(b);
  };
  function t(g) {
    return !!g && typeof g == "object";
  }
  function n(g) {
    var b = Object.prototype.toString.call(g);
    return b === "[object RegExp]" || b === "[object Date]" || s(g);
  }
  var o = typeof Symbol == "function" && Symbol.for, r = o ? Symbol.for("react.element") : 60103;
  function s(g) {
    return g.$$typeof === r;
  }
  function i(g) {
    return Array.isArray(g) ? [] : {};
  }
  function a(g, b) {
    return b.clone !== !1 && b.isMergeableObject(g) ? v(i(g), g, b) : g;
  }
  function l(g, b, S) {
    return g.concat(b).map(function(M) {
      return a(M, S);
    });
  }
  function c(g, b) {
    if (!b.customMerge)
      return v;
    var S = b.customMerge(g);
    return typeof S == "function" ? S : v;
  }
  function u(g) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(g).filter(function(b) {
      return Object.propertyIsEnumerable.call(g, b);
    }) : [];
  }
  function d(g) {
    return Object.keys(g).concat(u(g));
  }
  function m(g, b) {
    try {
      return b in g;
    } catch {
      return !1;
    }
  }
  function f(g, b) {
    return m(g, b) && !(Object.hasOwnProperty.call(g, b) && Object.propertyIsEnumerable.call(g, b));
  }
  function p(g, b, S) {
    var M = {};
    return S.isMergeableObject(g) && d(g).forEach(function(U) {
      M[U] = a(g[U], S);
    }), d(b).forEach(function(U) {
      f(g, U) || (m(g, U) && S.isMergeableObject(b[U]) ? M[U] = c(U, S)(g[U], b[U], S) : M[U] = a(b[U], S));
    }), M;
  }
  function v(g, b, S) {
    S = S || {}, S.arrayMerge = S.arrayMerge || l, S.isMergeableObject = S.isMergeableObject || e, S.cloneUnlessOtherwiseSpecified = a;
    var M = Array.isArray(b), U = Array.isArray(g), Ee = M === U;
    return Ee ? M ? S.arrayMerge(g, b, S) : p(g, b, S) : a(b, S);
  }
  v.all = function(b, S) {
    if (!Array.isArray(b))
      throw new Error("first argument should be an array");
    return b.reduce(function(M, U) {
      return v(M, U, S);
    }, {});
  };
  var I = v;
  return Ya = I, Ya;
}
var VA = UA();
const zo = /* @__PURE__ */ WA(VA), Zn = (e) => zo(
  {
    id: me(),
    name: "",
    tableId: "",
    indexColumnIds: [],
    seqIndexColumnIds: [],
    unique: !1,
    meta: qo()
  },
  e ?? {}
), Vc = C(ze.addIndex), FA = ({ doc: e, collections: t, lww: n }, { payload: { id: o, tableId: r }, version: s }, { clock: i }) => {
  const a = s ?? i.getVersion();
  y(t).collection("indexEntities").addOne(Zn({ id: o, tableId: r })).addOperator(n, a, o, () => {
    B(e.indexIds)(o) || e.indexIds.push(o);
  });
}, es = C(ze.removeIndex), jA = ({ doc: e, collections: t, lww: n }, { payload: { id: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion();
  y(t).collection("indexEntities").removeOperator(n, i, o, () => {
    const a = e.indexIds.indexOf(o);
    a !== -1 && e.indexIds.splice(a, 1);
  });
}, gp = C(ze.changeIndexName), qA = ({ collections: e, lww: t }, { payload: { id: n, tableId: o, value: r }, version: s }, { clock: i }) => {
  const a = s ?? i.getVersion(), l = y(e).collection("indexEntities");
  l.getOrCreate(n, (c) => Zn({ id: c, tableId: o })), l.replaceOperator(t, a, n, "name", () => {
    l.updateOne(n, (c) => {
      c.name = r;
    });
  });
}, Fc = C(ze.changeIndexUnique), ZA = ({ collections: e, lww: t }, { payload: { id: n, tableId: o, value: r }, version: s }, { clock: i }) => {
  const a = s ?? i.getVersion(), l = y(e).collection("indexEntities");
  l.getOrCreate(n, (c) => Zn({ id: c, tableId: o })), l.replaceOperator(t, a, n, "unique", () => {
    l.updateOne(n, (c) => {
      c.unique = r;
    });
  });
}, HA = {
  [ze.addIndex]: FA,
  [ze.removeIndex]: jA,
  [ze.changeIndexName]: qA,
  [ze.changeIndexUnique]: ZA
}, zA = {
  addIndexAction: Vc,
  removeIndexAction: es,
  changeIndexNameAction: gp,
  changeIndexUniqueAction: Fc
}, GA = (e, { payload: { id: t } }) => {
  e.push(es({ id: t }));
}, YA = (e, { payload: { id: t } }, { collections: n }) => {
  const o = y(n).collection("indexEntities").selectById(t);
  o && e.push(
    Vc({
      id: t,
      tableId: o.tableId
    })
  );
}, KA = (e, { payload: { id: t, tableId: n } }, { collections: o }) => {
  const r = y(o).collection("indexEntities").selectById(t);
  r && e.push(
    gp({
      id: t,
      tableId: n,
      value: r.name
    })
  );
}, QA = (e, {
  payload: { id: t, tableId: n, value: o }
}, { collections: r }) => {
  y(r).collection("indexEntities").selectById(t) && e.push(
    Fc({
      id: t,
      tableId: n,
      value: !o
    })
  );
}, JA = {
  [ze.addIndex]: GA,
  [ze.removeIndex]: YA,
  [ze.changeIndexName]: KA,
  [ze.changeIndexUnique]: QA
}, Ge = {
  addIndexColumn: "indexColumn.add",
  removeIndexColumn: "indexColumn.remove",
  moveIndexColumn: "indexColumn.move",
  changeIndexColumnOrderType: "indexColumn.changeOrderType"
}, jc = (e) => zo(
  {
    id: me(),
    indexId: "",
    columnId: "",
    orderType: Io.ASC,
    meta: qo()
  },
  e ?? {}
);
function vp(e, t, n) {
  if (B(t)(n)) {
    const r = t.reduce(
      (s, i, a) => (s[i] = a, s),
      {}
    );
    e.push(n), e.sort((s, i) => {
      const a = r[s], l = r[i];
      return a === void 0 ? 1 : l === void 0 ? -1 : a - l;
    });
  } else
    e.push(n), t.push(n);
}
const Hi = C(Ge.addIndexColumn), XA = ({ collections: e, lww: t }, { payload: { id: n, indexId: o, tableId: r, columnId: s }, version: i }, { clock: a }) => {
  const l = i ?? a.getVersion(), c = y(e).collection("indexEntities"), u = c.getOrCreate(
    o,
    (d) => Zn({ id: d, tableId: r })
  );
  y(e).collection("indexColumnEntities").addOne(jc({ id: n, indexId: o, columnId: s })).addOperator(t, l, n, () => {
    B(u.indexColumnIds)(n) || c.updateOne(o, (d) => {
      vp(d.indexColumnIds, d.seqIndexColumnIds, n);
    });
  });
}, qc = C(Ge.removeIndexColumn), eN = ({ collections: e, lww: t }, { payload: { id: n, indexId: o, tableId: r }, version: s }, { clock: i }) => {
  const a = s ?? i.getVersion(), l = y(e).collection("indexEntities"), c = l.getOrCreate(
    o,
    (u) => Zn({ id: u, tableId: r })
  );
  y(e).collection("indexColumnEntities").removeOperator(t, a, n, () => {
    const u = c.indexColumnIds.indexOf(n);
    u !== -1 && l.updateOne(o, (d) => {
      d.indexColumnIds.splice(u, 1);
    });
  });
}, Zc = C(Ge.moveIndexColumn), tN = ({ collections: e }, { payload: { id: t, indexId: n, tableId: o, targetId: r } }) => {
  if (t === r)
    return;
  const s = y(e).collection("indexEntities"), i = s.getOrCreate(
    n,
    (c) => Zn({ id: c, tableId: o })
  ), a = i.indexColumnIds.indexOf(t);
  if (a === -1) return;
  const l = i.indexColumnIds.indexOf(r);
  l !== -1 && s.updateOne(n, (c) => {
    c.indexColumnIds.splice(a, 1), c.indexColumnIds.splice(l, 0, t);
    const u = c.seqIndexColumnIds.indexOf(t), d = c.seqIndexColumnIds.indexOf(r);
    u !== -1 && d !== -1 && (c.seqIndexColumnIds.splice(u, 1), c.seqIndexColumnIds.splice(d, 0, t));
  });
}, Hc = C(Ge.changeIndexColumnOrderType), nN = ({ collections: e, lww: t }, { payload: { id: n, indexId: o, columnId: r, value: s }, version: i }, { clock: a }) => {
  const l = i ?? a.getVersion(), c = y(e).collection("indexColumnEntities");
  c.getOrCreate(
    n,
    (u) => jc({ id: u, indexId: o, columnId: r })
  ), c.replaceOperator(t, l, n, "orderType", () => {
    c.updateOne(n, (u) => {
      u.orderType = s;
    });
  });
}, oN = {
  [Ge.addIndexColumn]: XA,
  [Ge.removeIndexColumn]: eN,
  [Ge.moveIndexColumn]: tN,
  [Ge.changeIndexColumnOrderType]: nN
}, rN = {
  addIndexColumnAction: Hi,
  removeIndexColumnAction: qc,
  moveIndexColumnAction: Zc,
  changeIndexColumnOrderTypeAction: Hc
}, sN = (e, { payload: { id: t, indexId: n, tableId: o } }) => {
  e.push(qc({ id: t, indexId: n, tableId: o }));
}, iN = (e, {
  payload: { id: t, indexId: n, tableId: o }
}, { collections: r }) => {
  const s = y(r).collection("indexColumnEntities").selectById(t);
  s && e.push(
    Hi({
      id: t,
      indexId: n,
      tableId: o,
      columnId: s.columnId
    })
  );
}, aN = (e, {
  payload: { id: t, indexId: n, tableId: o, targetId: r }
}, { collections: s }) => {
  const i = y(s).collection("indexEntities").selectById(n);
  if (!i) return;
  const a = i.indexColumnIds.indexOf(t);
  if (a === -1) return;
  const l = i.indexColumnIds.indexOf(r);
  if (l === -1) return;
  const c = a < l ? a + 1 : a - 1, u = i.indexColumnIds[c];
  e.push(
    Zc({
      indexId: n,
      tableId: o,
      id: t,
      targetId: u
    })
  );
}, lN = (e, {
  payload: { id: t, indexId: n, columnId: o }
}, { collections: r }) => {
  const s = y(r).collection("indexColumnEntities").selectById(t);
  s && e.push(
    Hc({
      id: t,
      indexId: n,
      columnId: o,
      value: s.orderType
    })
  );
}, cN = {
  [Ge.addIndexColumn]: sN,
  [Ge.removeIndexColumn]: iN,
  [Ge.moveIndexColumn]: aN,
  [Ge.changeIndexColumnOrderType]: lN
}, ne = {
  addMemo: "memo.add",
  moveMemo: "memo.move",
  moveToMemo: "memo.moveTo",
  removeMemo: "memo.remove",
  changeMemoValue: "memo.changeValue",
  changeMemoColor: "memo.changeColor",
  resizeMemo: "memo.resize",
  changeZIndex: "memo.changeZIndex"
}, Hn = (e) => zo(
  {
    id: me(),
    value: "",
    ui: {
      x: 200,
      y: 100,
      zIndex: 2,
      width: Ex,
      height: xx,
      color: ""
    },
    meta: qo()
  },
  e ?? {}
), zc = C(
  ne.addMemo
), uN = ({ doc: e, collections: t, lww: n }, { payload: { id: o, ui: r }, version: s }, { clock: i }) => {
  const a = s ?? i.getVersion();
  y(t).collection("memoEntities").addOne(Hn({ id: o, ui: r })).addOperator(n, a, o, () => {
    B(e.memoIds)(o) || e.memoIds.push(o);
  });
}, To = C(ne.moveMemo), dN = ({ collections: e }, { payload: { ids: t, movementX: n, movementY: o } }) => {
  const r = y(e).collection("memoEntities");
  for (const s of t)
    r.getOrCreate(s, (i) => Hn({ id: i }));
  r.updateMany(t, (s) => {
    s.ui.x = dt(s.ui.x + n, 4), s.ui.y = dt(s.ui.y + o, 4);
  });
}, bp = C(ne.moveToMemo), fN = ({ collections: e }, { payload: { id: t, x: n, y: o } }) => {
  const r = y(e).collection("memoEntities");
  r.getOrCreate(t, (s) => Hn({ id: s })), r.updateOne(t, (s) => {
    s.ui.x = n, s.ui.y = o;
  });
}, zi = C(ne.removeMemo), mN = ({ doc: e, collections: t, lww: n }, { payload: { id: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion();
  y(t).collection("memoEntities").removeOperator(n, i, o, () => {
    const a = e.memoIds.indexOf(o);
    a !== -1 && e.memoIds.splice(a, 1);
  });
}, Ip = C(ne.changeMemoValue), hN = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion(), a = y(e).collection("memoEntities");
  a.getOrCreate(n, (l) => Hn({ id: l })), a.replaceOperator(t, i, n, "value", () => {
    a.updateOne(n, (l) => {
      l.value = o;
    });
  });
}, Vr = C(ne.changeMemoColor), pN = ({ collections: e, lww: t }, { payload: { id: n, color: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion(), a = y(e).collection("memoEntities");
  a.getOrCreate(n, (l) => Hn({ id: l })), a.replaceOperator(t, i, n, "ui.color", () => {
    a.updateOne(n, (l) => {
      l.ui.color = o;
    });
  });
}, Tp = C(ne.resizeMemo), yN = ({ collections: e }, { payload: { id: t, x: n, y: o, width: r, height: s } }) => {
  const i = y(e).collection("memoEntities");
  i.getOrCreate(t, (a) => Hn({ id: a })), i.updateOne(t, (a) => {
    a.ui.x = n, a.ui.y = o, a.ui.width = r, a.ui.height = s;
  });
}, wp = C(ne.changeZIndex), gN = ({ collections: e }, { payload: { id: t, zIndex: n } }) => {
  const o = y(e).collection("memoEntities");
  o.getOrCreate(t, (r) => Hn({ id: r })), o.updateOne(t, (r) => {
    r.ui.zIndex = n;
  });
}, vN = {
  [ne.addMemo]: uN,
  [ne.moveMemo]: dN,
  [ne.moveToMemo]: fN,
  [ne.removeMemo]: mN,
  [ne.changeMemoValue]: hN,
  [ne.changeMemoColor]: pN,
  [ne.resizeMemo]: yN,
  [ne.changeZIndex]: gN
}, bN = {
  addMemoAction: zc,
  moveMemoAction: To,
  moveToMemoAction: bp,
  removeMemoAction: zi,
  changeMemoValueAction: Ip,
  changeMemoColorAction: Vr,
  resizeMemoAction: Tp,
  changeZIndexAction: wp
}, IN = 20, TN = (e, { payload: { id: t } }) => {
  e.push(zi({ id: t }));
}, wN = (e, { payload: { id: t } }, { collections: n }) => {
  const o = y(n).collection("memoEntities").selectById(t);
  o && e.push(
    zc({ id: o.id, ui: Kr(o.ui, ["x", "y", "zIndex"]) })
  );
}, CN = (e, { payload: { id: t } }, { collections: n }) => {
  const o = y(n).collection("memoEntities").selectById(t);
  o && e.push(Ip({ id: t, value: o.value }));
}, SN = (e, { payload: { id: t } }, { collections: n }) => {
  const o = y(n).collection("memoEntities").selectById(t);
  o && e.push(
    bp({
      id: t,
      x: o.ui.x,
      y: o.ui.y
    })
  );
}, ON = {
  [ne.addMemo]: TN,
  [ne.removeMemo]: wN,
  [ne.changeMemoValue]: CN,
  [ne.moveToMemo]: SN
}, EN = (e, t, n) => {
  const o = n.filter((s) => s.type === To.type);
  if (!o.length) return;
  const r = as(
    o,
    (s) => s.payload.ids.join(",")
  );
  for (const [, s] of Object.entries(r)) {
    const {
      payload: { ids: i }
    } = is(s), { x: a, y: l } = s.reduce(
      (c, { payload: { movementX: u, movementY: d } }) => (c.x += u, c.y += d, c),
      { x: 0, y: 0 }
    );
    Math.abs(a) + Math.abs(l) < IN || (e.push(
      To({
        ids: i,
        movementX: -1 * a,
        movementY: -1 * l
      })
    ), t.push(
      To({
        ids: i,
        movementX: a,
        movementY: l
      })
    ));
  }
}, xN = (e, t, n) => {
  const o = n.filter(({ type: s }) => s === Vr.type);
  if (!o.length) return;
  const r = as(o, (s) => s.payload.id);
  for (const [s, i] of Object.entries(r)) {
    const a = is(i), l = Po(i);
    e.push(
      Vr({
        id: s,
        color: a.payload.prevColor,
        prevColor: l.payload.color
      })
    ), t.push(
      Vr({
        id: s,
        color: l.payload.color,
        prevColor: a.payload.prevColor
      })
    );
  }
}, AN = (e, t, n) => {
  const o = n.filter((s) => s.type === Tp.type);
  if (!o.length) return;
  const r = as(o, (s) => s.payload.id);
  for (const [, s] of Object.entries(r)) {
    if (s.length < 2) continue;
    const i = is(s), a = Po(s);
    e.push(i), t.push(a);
  }
}, NN = {
  [ne.moveMemo]: EN,
  [ne.changeMemoColor]: xN,
  [ne.resizeMemo]: AN
}, kt = {
  addRelationship: "relationship.add",
  removeRelationship: "relationship.remove",
  changeRelationshipType: "relationship.changeType"
}, Cp = (e) => zo(
  {
    id: me(),
    identification: !1,
    relationshipType: Hh.ZeroN,
    startRelationshipType: xl.dash,
    start: {
      tableId: "",
      columnIds: [],
      x: 0,
      y: 0,
      direction: Tt.bottom
    },
    end: {
      tableId: "",
      columnIds: [],
      x: 0,
      y: 0,
      direction: Tt.bottom
    },
    meta: qo()
  },
  e ?? {}
), Ts = C(kt.addRelationship), MN = ({ doc: e, collections: t, lww: n }, { payload: { id: o, relationshipType: r, start: s, end: i }, version: a }, { clock: l }) => {
  const c = a ?? l.getVersion();
  y(t).collection("relationshipEntities").addOne(
    Cp({
      id: o,
      relationshipType: r,
      start: {
        tableId: s.tableId,
        columnIds: s.columnIds
      },
      end: {
        tableId: i.tableId,
        columnIds: i.columnIds
      }
    })
  ).addOperator(n, c, o, () => {
    B(e.relationshipIds)(o) || e.relationshipIds.push(o);
  });
}, ko = C(kt.removeRelationship), $N = ({ doc: e, collections: t, lww: n }, { payload: { id: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion();
  y(t).collection("relationshipEntities").removeOperator(n, i, o, () => {
    const a = e.relationshipIds.indexOf(o);
    a !== -1 && e.relationshipIds.splice(a, 1);
  });
}, Sp = C(kt.changeRelationshipType), kN = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion(), a = y(e).collection("relationshipEntities");
  a.replaceOperator(t, i, n, "relationshipType", () => {
    a.updateOne(n, (l) => {
      l.relationshipType = o;
    });
  });
}, DN = {
  [kt.addRelationship]: MN,
  [kt.removeRelationship]: $N,
  [kt.changeRelationshipType]: kN
}, LN = {
  addRelationshipAction: Ts,
  removeRelationshipAction: ko,
  changeRelationshipTypeAction: Sp
}, RN = (e, { payload: { id: t } }) => {
  e.push(ko({ id: t }));
}, _N = (e, { payload: { id: t } }, { collections: n }) => {
  const o = y(n).collection("relationshipEntities").selectById(t);
  o && e.push(
    Ts({
      id: o.id,
      relationshipType: o.relationshipType,
      start: Kr(o.start, ["tableId", "columnIds"]),
      end: Kr(o.end, ["tableId", "columnIds"])
    })
  );
}, PN = (e, { payload: { id: t } }, { collections: n }) => {
  const o = y(n).collection("relationshipEntities").selectById(t);
  o && e.push(
    Sp({
      id: t,
      value: o.relationshipType
    })
  );
}, BN = {
  [kt.addRelationship]: RN,
  [kt.removeRelationship]: _N,
  [kt.changeRelationshipType]: PN
}, L = {
  changeDatabaseName: "settings.changeDatabaseName",
  resize: "settings.resize",
  changeZoomLevel: "settings.changeZoomLevel",
  streamZoomLevel: "settings.streamZoomLevel",
  scrollTo: "settings.scrollTo",
  streamScrollTo: "settings.streamScrollTo",
  changeShow: "settings.changeShow",
  changeDatabase: "settings.changeDatabase",
  changeCanvasType: "settings.changeCanvasType",
  changeLanguage: "settings.changeLanguage",
  changeTableNameCase: "settings.changeTableNameCase",
  changeColumnNameCase: "settings.changeColumnNameCase",
  changeBracketType: "settings.changeBracketType",
  changeRelationshipDataTypeSync: "settings.changeRelationshipDataTypeSync",
  changeRelationshipOptimization: "settings.changeRelationshipOptimization",
  changeColumnOrder: "settings.changeColumnOrder",
  changeMaxWidthComment: "settings.changeMaxWidthComment",
  changeIgnoreSaveSettings: "settings.changeIgnoreSaveSettings"
}, WN = C(L.changeDatabaseName), UN = ({ settings: e, lww: t }, { payload: { value: n }, version: o }, { clock: r }) => {
  const s = o ?? r.getVersion();
  mc(
    t,
    s,
    "settings.databaseName",
    "settings",
    "databaseName",
    () => {
      e.databaseName = n;
    }
  );
}, Op = C(
  L.resize
), VN = ({ settings: e }, { payload: { width: t, height: n } }) => {
  e.width = Nl(t), e.height = Nl(n);
}, Gc = C(L.changeZoomLevel), FN = ({ settings: e }, { payload: { value: t }, tags: n }) => {
  !ve(n) && $(n, qn.following) || (e.zoomLevel = Ia(t));
}, Fr = C(L.streamZoomLevel), jN = ({ settings: e }, { payload: { value: t }, tags: n }) => {
  !ve(n) && $(n, qn.following) || (e.zoomLevel = Ia(e.zoomLevel + t));
}, Yc = C(L.scrollTo), qN = ({ settings: e, editor: { viewport: t } }, { payload: { scrollTop: n, scrollLeft: o }, tags: r }) => {
  if (!ve(r) && $(r, qn.following))
    return;
  const s = Xe(t.height - e.height, 0), i = Xe(t.width - e.width, 0);
  e.scrollTop = dt(s(n), 4), e.scrollLeft = dt(i(o), 4);
}, jr = C(L.streamScrollTo), ZN = ({ settings: e, editor: { viewport: t } }, { payload: { movementX: n, movementY: o }, tags: r }) => {
  if (!ve(r) && $(r, qn.following))
    return;
  const s = Xe(t.height - e.height, 0), i = Xe(t.width - e.width, 0);
  e.scrollTop = dt(
    s(e.scrollTop + o),
    4
  ), e.scrollLeft = dt(
    i(e.scrollLeft + n),
    4
  );
}, Kc = C(L.changeShow), HN = ({ settings: e }, { payload: { show: t, value: n } }) => {
  e.show = n ? e.show | t : e.show & ~t;
}, zN = C(L.changeDatabase), GN = ({ settings: e }, { payload: { value: t } }) => {
  kx(t) && (e.database = t);
}, YN = C(L.changeCanvasType), KN = ({ settings: e }, { payload: { value: t }, tags: n }) => {
  !ve(n) && $(n, qn.following) || (e.canvasType = t);
}, QN = C(L.changeLanguage), JN = ({ settings: e }, { payload: { value: t } }) => {
  Lx(t) && (e.language = t);
}, XN = C(L.changeTableNameCase), eM = ({ settings: e }, { payload: { value: t } }) => {
  sp(t) && (e.tableNameCase = t);
}, tM = C(L.changeColumnNameCase), nM = ({ settings: e }, { payload: { value: t } }) => {
  sp(t) && (e.columnNameCase = t);
}, oM = C(L.changeBracketType), rM = ({ settings: e }, { payload: { value: t } }) => {
  Dx(t) && (e.bracketType = t);
}, sM = C(L.changeRelationshipDataTypeSync), iM = ({ settings: e }, { payload: { value: t } }) => {
  e.relationshipDataTypeSync = t;
}, aM = C(L.changeRelationshipOptimization), lM = ({ settings: e }, { payload: { value: t } }) => {
  e.relationshipOptimization = t;
}, cM = C(L.changeColumnOrder), uM = ({ settings: e }, { payload: { value: t, target: n } }) => {
  if (t === n || !Ld(t) || !Ld(n))
    return;
  const o = e.columnOrder.indexOf(t), r = e.columnOrder.indexOf(n);
  o === -1 || r === -1 || (e.columnOrder.splice(o, 1), e.columnOrder.splice(r, 0, t));
}, Ep = C(L.changeMaxWidthComment), dM = ({ settings: e }, { payload: { value: t } }) => {
  e.maxWidthComment = t === -1 ? t : rp(t);
}, fM = C(L.changeIgnoreSaveSettings), mM = ({ settings: e }, { payload: { saveSettingType: t, value: n } }) => {
  e.ignoreSaveSettings = n ? e.ignoreSaveSettings | t : e.ignoreSaveSettings & ~t;
}, hM = {
  [L.changeDatabaseName]: UN,
  [L.resize]: VN,
  [L.changeZoomLevel]: FN,
  [L.streamZoomLevel]: jN,
  [L.scrollTo]: qN,
  [L.streamScrollTo]: ZN,
  [L.changeShow]: HN,
  [L.changeDatabase]: GN,
  [L.changeCanvasType]: KN,
  [L.changeLanguage]: JN,
  [L.changeTableNameCase]: eM,
  [L.changeColumnNameCase]: nM,
  [L.changeBracketType]: rM,
  [L.changeRelationshipDataTypeSync]: iM,
  [L.changeRelationshipOptimization]: lM,
  [L.changeColumnOrder]: uM,
  [L.changeMaxWidthComment]: dM,
  [L.changeIgnoreSaveSettings]: mM
}, pM = {
  changeDatabaseNameAction: WN,
  resizeAction: Op,
  changeZoomLevelAction: Gc,
  streamZoomLevelAction: Fr,
  scrollToAction: Yc,
  streamScrollToAction: jr,
  changeShowAction: Kc,
  changeDatabaseAction: zN,
  changeCanvasTypeAction: YN,
  changeLanguageAction: QN,
  changeTableNameCaseAction: XN,
  changeColumnNameCaseAction: tM,
  changeBracketTypeAction: oM,
  changeRelationshipDataTypeSyncAction: sM,
  changeRelationshipOptimizationAction: aM,
  changeColumnOrderAction: cM,
  changeMaxWidthCommentAction: Ep,
  changeIgnoreSaveSettingsAction: fM
}, yM = 20, gM = (e, t, { settings: n }) => {
  e.push(
    Op({ width: n.width, height: n.height })
  );
}, vM = (e, t, { settings: n }) => {
  e.push(
    Yc({
      scrollLeft: n.scrollLeft,
      scrollTop: n.scrollTop
    })
  );
}, bM = (e, { payload: { show: t, value: n } }) => {
  e.push(Kc({ show: t, value: !n }));
}, IM = (e, t, { settings: n }) => {
  e.push(Gc({ value: n.zoomLevel }));
}, TM = {
  [L.resize]: gM,
  [L.scrollTo]: vM,
  [L.changeShow]: bM,
  [L.changeZoomLevel]: IM
}, wM = (e, t, n) => {
  const o = n.filter((i) => i.type === jr.type);
  if (!o.length) return;
  const { x: r, y: s } = o.reduce(
    (i, { payload: { movementX: a, movementY: l } }) => (i.x += a, i.y += l, i),
    { x: 0, y: 0 }
  );
  Math.abs(r) + Math.abs(s) < yM || (e.push(
    jr({
      movementX: -1 * r,
      movementY: -1 * s
    })
  ), t.push(
    jr({
      movementX: r,
      movementY: s
    })
  ));
}, CM = (e, t, n) => {
  const o = n.filter((s) => s.type === Fr.type);
  if (!o.length) return;
  const r = o.reduce(
    (s, { payload: { value: i } }) => s + i,
    0
  );
  e.push(Fr({ value: -1 * r })), t.push(Fr({ value: r }));
}, SM = {
  [L.streamScrollTo]: wM,
  [L.streamZoomLevel]: CM
}, J = {
  addTable: "table.add",
  moveTable: "table.move",
  moveToTable: "table.moveTo",
  removeTable: "table.remove",
  changeTableName: "table.changeName",
  changeTableComment: "table.changeComment",
  changeTableColor: "table.changeColor",
  changeZIndex: "table.changeZIndex",
  sortTable: "table.sort"
};
function Qc(e, { settings: { show: t, maxWidthComment: n }, collections: o }) {
  let r = e.ui.widthName + An;
  if ($(t, K.tableComment)) {
    const l = n === -1 ? e.ui.widthComment : n < e.ui.widthComment ? n : e.ui.widthComment;
    r += l + An;
  }
  const s = EM(t);
  r < s && (r = s);
  const i = y(o).collection("tableColumnEntities").selectByIds(e.columnIds), a = xM(i, t, n);
  return r < a.width && (r = a.width), {
    ...a,
    width: Fi + ji + r + ji + Fi
  };
}
const OM = [
  {
    key: K.columnComment,
    width: He
  },
  {
    key: K.columnDataType,
    width: He
  },
  {
    key: K.columnDefault,
    width: He
  },
  {
    key: K.columnNotNull,
    width: Xh
  },
  {
    key: K.columnAutoIncrement,
    width: tp
  },
  {
    key: K.columnUnique,
    width: ep
  }
];
function EM(e) {
  return OM.reduce(
    (t, { key: n, width: o }) => $(e, n) ? t + o + An : t,
    Jh + An + He + An + Qh
  );
}
function xM(e, t, n) {
  const o = {
    width: 0,
    name: 0,
    comment: 0,
    dataType: 0,
    default: 0,
    notNull: 0,
    autoIncrement: 0,
    unique: 0
  };
  for (const r of e) {
    if (o.name < r.ui.widthName && (o.name = r.ui.widthName), $(t, K.columnComment) && o.comment < r.ui.widthComment) {
      const s = n === -1 ? r.ui.widthComment : n < r.ui.widthComment ? n : r.ui.widthComment;
      o.comment = s;
    }
    $(t, K.columnDataType) && o.dataType < r.ui.widthDataType && (o.dataType = r.ui.widthDataType), $(t, K.columnDefault) && o.default < r.ui.widthDefault && (o.default = r.ui.widthDefault);
  }
  return $(t, K.columnNotNull) && (o.notNull = Xh), $(t, K.columnAutoIncrement) && (o.autoIncrement = tp), $(t, K.columnUnique) && (o.unique = ep), o.width = Object.entries(o).reduce(
    (r, [s, i]) => s === "width" || i === 0 ? r : r + i + An,
    Jh + An + Qh
  ), o;
}
function Gi(e) {
  return Fi + ji + Cx + e.columnIds.length * Ox + ji + Fi;
}
function AM({ doc: { tableIds: e }, collections: t }, { toWidth: n }) {
  const o = y(t).collection("tableEntities").selectByIds(e), r = y(t).collection("tableColumnEntities");
  for (const s of o) {
    s.ui.widthName = ye(n(s.name)), s.ui.widthComment = ye(n(s.comment));
    const i = r.selectByIds(s.columnIds);
    for (const a of i)
      a.ui.widthName = ye(n(a.name)), a.ui.widthDataType = ye(n(a.dataType)), a.ui.widthDefault = ye(n(a.default)), a.ui.widthComment = ye(n(a.comment));
  }
}
const pt = (e) => zo(
  {
    id: me(),
    name: "",
    comment: "",
    columnIds: [],
    seqColumnIds: [],
    ui: {
      x: 200,
      y: 100,
      zIndex: 2,
      widthName: He,
      widthComment: He,
      color: ""
    },
    meta: qo()
  },
  e ?? {}
), Jc = C(J.addTable), NM = ({ doc: e, collections: t, lww: n }, { payload: { id: o, ui: r }, version: s }, { clock: i }) => {
  const a = s ?? i.getVersion();
  y(t).collection("tableEntities").addOne(pt({ id: o, ui: r })).addOperator(n, a, o, () => {
    B(e.tableIds)(o) || e.tableIds.push(o);
  });
}, wo = C(J.moveTable), MM = ({ collections: e }, { payload: { ids: t, movementX: n, movementY: o } }) => {
  const r = y(e).collection("tableEntities");
  for (const s of t)
    r.getOrCreate(s, (i) => pt({ id: i }));
  r.updateMany(t, (s) => {
    s.ui.x = dt(s.ui.x + n, 4), s.ui.y = dt(s.ui.y + o, 4);
  });
}, Xc = C(J.moveToTable), $M = ({ collections: e }, { payload: { id: t, x: n, y: o } }) => {
  const r = y(e).collection("tableEntities");
  r.getOrCreate(t, (s) => pt({ id: s })), r.updateOne(t, (s) => {
    s.ui.x = n, s.ui.y = o;
  });
}, Yi = C(J.removeTable), kM = ({ doc: e, collections: t, lww: n }, { payload: { id: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion();
  y(t).collection("tableEntities").removeOperator(n, i, o, () => {
    const a = e.tableIds.indexOf(o);
    a !== -1 && e.tableIds.splice(a, 1);
  });
}, eu = C(J.changeTableName), DM = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { toWidth: s, clock: i }) => {
  const a = r ?? i.getVersion(), l = y(e).collection("tableEntities");
  l.getOrCreate(n, (c) => pt({ id: c })), l.replaceOperator(t, a, n, "name", () => {
    l.updateOne(n, (c) => {
      c.name = o, c.ui.widthName = ye(s(o));
    });
  });
}, tu = C(J.changeTableComment), LM = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { toWidth: s, clock: i }) => {
  const a = r ?? i.getVersion(), l = y(e).collection("tableEntities");
  l.getOrCreate(n, (c) => pt({ id: c })), l.replaceOperator(t, a, n, "comment", () => {
    l.updateOne(n, (c) => {
      c.comment = o, c.ui.widthComment = ye(s(o));
    });
  });
}, qr = C(J.changeTableColor), RM = ({ collections: e, lww: t }, { payload: { id: n, color: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion(), a = y(e).collection("tableEntities");
  a.getOrCreate(n, (l) => pt({ id: l })), a.replaceOperator(t, i, n, "ui.color", () => {
    a.updateOne(n, (l) => {
      l.ui.color = o;
    });
  });
}, xp = C(J.changeZIndex), _M = ({ collections: e }, { payload: { id: t, zIndex: n } }) => {
  const o = y(e).collection("tableEntities");
  o.getOrCreate(t, (r) => pt({ id: r })), o.updateOne(t, (r) => {
    r.ui.zIndex = n;
  });
}, nu = C(J.sortTable), PM = (e) => {
  const { doc: t, settings: n, collections: o } = e, r = n.width, s = y(o).collection("tableEntities").selectByIds(t.tableIds), i = 80, a = s.filter((f) => f.ui.x === 0 && f.ui.y === 0);
  if (a.length === 0) return;
  const l = s.filter((f) => f.ui.x !== 0 || f.ui.y !== 0);
  let c = 50;
  l.length > 0 && (c = Math.max(
    ...l.map((p) => p.ui.y + Gi(p) + i)
  )), a.sort((f, p) => f.columnIds.length - p.columnIds.length);
  let u = 50, d = c, m = 50;
  a.forEach((f) => {
    const p = Qc(f, e).width + i, v = Gi(f) + i;
    u + p > r && (d += m, m = 0, u = 50), m < v && (m = v), f.ui.y = d, f.ui.x = u, u += p;
  });
}, BM = {
  [J.addTable]: NM,
  [J.moveTable]: MM,
  [J.moveToTable]: $M,
  [J.removeTable]: kM,
  [J.changeTableName]: DM,
  [J.changeTableComment]: LM,
  [J.changeTableColor]: RM,
  [J.changeZIndex]: _M,
  [J.sortTable]: PM
}, WM = {
  addTableAction: Jc,
  moveTableAction: wo,
  moveToTableAction: Xc,
  removeTableAction: Yi,
  changeTableNameAction: eu,
  changeTableCommentAction: tu,
  changeTableColorAction: qr,
  changeZIndexAction: xp,
  sortTableAction: nu
}, UM = 20, VM = (e, { payload: { id: t } }) => {
  e.push(Yi({ id: t }));
}, FM = (e, { payload: { id: t } }, { collections: n }) => {
  const o = y(n).collection("tableEntities").selectById(t);
  o && e.push(
    Jc({ id: o.id, ui: Kr(o.ui, ["x", "y", "zIndex"]) })
  );
}, jM = (e, { payload: { id: t } }, { collections: n }) => {
  const o = y(n).collection("tableEntities").selectById(t);
  o && e.push(eu({ id: t, value: o.name }));
}, qM = (e, { payload: { id: t } }, { collections: n }) => {
  const o = y(n).collection("tableEntities").selectById(t);
  o && e.push(tu({ id: t, value: o.comment }));
}, ZM = (e, { payload: { id: t } }, { collections: n }) => {
  const o = y(n).collection("tableEntities").selectById(t);
  o && e.push(
    Xc({
      id: t,
      x: o.ui.x,
      y: o.ui.y
    })
  );
}, HM = () => {
}, zM = {
  [J.addTable]: VM,
  [J.removeTable]: FM,
  [J.changeTableName]: jM,
  [J.changeTableComment]: qM,
  [J.moveToTable]: ZM,
  [J.sortTable]: HM
}, GM = (e, t, n) => {
  const o = n.filter((s) => s.type === wo.type);
  if (!o.length) return;
  const r = as(
    o,
    (s) => s.payload.ids.join(",")
  );
  for (const [, s] of Object.entries(r)) {
    const {
      payload: { ids: i }
    } = is(s), { x: a, y: l } = s.reduce(
      (c, { payload: { movementX: u, movementY: d } }) => (c.x += u, c.y += d, c),
      { x: 0, y: 0 }
    );
    Math.abs(a) + Math.abs(l) < UM || (e.push(
      wo({
        ids: i,
        movementX: -1 * a,
        movementY: -1 * l
      })
    ), t.push(
      wo({
        ids: i,
        movementX: a,
        movementY: l
      })
    ));
  }
}, YM = (e, t, n) => {
  const o = n.filter(({ type: s }) => s === qr.type);
  if (!o.length) return;
  const r = as(o, (s) => s.payload.id);
  for (const [s, i] of Object.entries(r)) {
    const a = is(i), l = Po(i);
    e.push(
      qr({
        id: s,
        color: a.payload.prevColor,
        prevColor: l.payload.color
      })
    ), t.push(
      qr({
        id: s,
        color: l.payload.color,
        prevColor: a.payload.prevColor
      })
    );
  }
}, KM = {
  [J.moveTable]: GM,
  [J.changeTableColor]: YM
}, j = {
  addColumn: "column.add",
  removeColumn: "column.remove",
  changeColumnName: "column.changeName",
  changeColumnComment: "column.changeComment",
  changeColumnDataType: "column.changeDataType",
  changeColumnDefault: "column.changeDefault",
  changeColumnAutoIncrement: "column.changeAutoIncrement",
  changeColumnPrimaryKey: "column.changePrimaryKey",
  changeColumnUnique: "column.changeUnique",
  changeColumnNotNull: "column.changeNotNull",
  moveColumn: "column.move"
}, Et = (e) => zo(
  {
    id: me(),
    tableId: "",
    name: "",
    comment: "",
    dataType: "",
    default: "",
    options: 0,
    ui: {
      keys: 0,
      widthName: He,
      widthComment: He,
      widthDataType: He,
      widthDefault: He
    },
    meta: qo()
  },
  e ?? {}
), Ot = C(j.addColumn), QM = ({ collections: e, lww: t }, { payload: { id: n, tableId: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion(), a = y(e).collection("tableEntities"), l = a.getOrCreate(o, (c) => pt({ id: c }));
  y(e).collection("tableColumnEntities").addOne(Et({ id: n, tableId: o })).addOperator(t, i, n, () => {
    B(l.columnIds)(n) || a.updateOne(o, (c) => {
      vp(c.columnIds, c.seqColumnIds, n);
    });
  });
}, Co = C(j.removeColumn), JM = ({ collections: e, lww: t }, { payload: { id: n, tableId: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion(), a = y(e).collection("tableEntities"), l = a.getOrCreate(o, (c) => pt({ id: c }));
  y(e).collection("tableColumnEntities").removeOperator(t, i, n, () => {
    const c = l.columnIds.indexOf(n);
    c !== -1 && a.updateOne(o, (u) => {
      u.columnIds.splice(c, 1);
    });
  });
}, Dt = C(j.changeColumnName), XM = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { toWidth: s, clock: i }) => {
  const a = r ?? i.getVersion(), l = y(e).collection("tableColumnEntities");
  l.getOrCreate(n, (c) => Et({ id: c })), l.replaceOperator(t, a, n, "name", () => {
    l.updateOne(n, (c) => {
      c.name = o, c.ui.widthName = ye(s(o));
    });
  });
}, Lt = C(j.changeColumnComment), e$ = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { toWidth: s, clock: i }) => {
  const a = r ?? i.getVersion(), l = y(e).collection("tableColumnEntities");
  l.getOrCreate(n, (c) => Et({ id: c })), l.replaceOperator(t, a, n, "comment", () => {
    l.updateOne(n, (c) => {
      c.comment = o, c.ui.widthComment = ye(s(o));
    });
  });
}, Rt = C(j.changeColumnDataType), t$ = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { toWidth: s, clock: i }) => {
  const a = r ?? i.getVersion(), l = y(e).collection("tableColumnEntities");
  l.getOrCreate(n, (c) => Et({ id: c })), l.replaceOperator(t, a, n, "dataType", () => {
    l.updateOne(n, (c) => {
      c.dataType = o, c.ui.widthDataType = ye(s(o));
    });
  });
}, _t = C(j.changeColumnDefault), n$ = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { toWidth: s, clock: i }) => {
  const a = r ?? i.getVersion(), l = y(e).collection("tableColumnEntities");
  l.getOrCreate(n, (c) => Et({ id: c })), l.replaceOperator(t, a, n, "default", () => {
    l.updateOne(n, (c) => {
      c.default = o, c.ui.widthDefault = ye(s(o));
    });
  });
}, Nn = C(j.changeColumnAutoIncrement), o$ = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion(), a = y(e).collection("tableColumnEntities");
  a.getOrCreate(n, (l) => Et({ id: l })), a.replaceOperator(
    t,
    i,
    n,
    "options(autoIncrement)",
    () => {
      a.updateOne(n, (l) => {
        l.options = o ? l.options | V.autoIncrement : l.options & ~V.autoIncrement;
      });
    }
  );
}, zn = C(j.changeColumnPrimaryKey), r$ = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion(), a = y(e).collection("tableColumnEntities");
  a.getOrCreate(n, (l) => Et({ id: l })), a.replaceOperator(
    t,
    i,
    n,
    "options(primaryKey)",
    () => {
      a.updateOne(n, (l) => {
        l.options = o ? l.options | V.primaryKey : l.options & ~V.primaryKey, l.ui.keys = o ? l.ui.keys | bt.primaryKey : l.ui.keys & -2;
      });
    }
  );
}, Mn = C(j.changeColumnUnique), s$ = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion(), a = y(e).collection("tableColumnEntities");
  a.getOrCreate(n, (l) => Et({ id: l })), a.replaceOperator(t, i, n, "options(unique)", () => {
    a.updateOne(n, (l) => {
      l.options = o ? l.options | V.unique : l.options & ~V.unique;
    });
  });
}, Pt = C(j.changeColumnNotNull), i$ = ({ collections: e, lww: t }, { payload: { id: n, value: o }, version: r }, { clock: s }) => {
  const i = r ?? s.getVersion(), a = y(e).collection("tableColumnEntities");
  a.getOrCreate(n, (l) => Et({ id: l })), a.replaceOperator(t, i, n, "options(notNull)", () => {
    a.updateOne(n, (l) => {
      l.options = o ? l.options | V.notNull : l.options & ~V.notNull;
    });
  });
}, Ki = C(j.moveColumn), a$ = ({ collections: e }, { payload: { id: t, tableId: n, targetId: o } }) => {
  if (t === o)
    return;
  const r = y(e).collection("tableEntities"), s = r.getOrCreate(n, (l) => pt({ id: l })), i = s.columnIds.indexOf(t);
  if (i === -1) return;
  const a = s.columnIds.indexOf(o);
  a !== -1 && r.updateOne(n, (l) => {
    l.columnIds.splice(i, 1), l.columnIds.splice(a, 0, t);
    const c = l.seqColumnIds.indexOf(t), u = l.seqColumnIds.indexOf(o);
    c !== -1 && u !== -1 && (l.seqColumnIds.splice(c, 1), l.seqColumnIds.splice(u, 0, t));
  });
}, l$ = {
  [j.addColumn]: QM,
  [j.removeColumn]: JM,
  [j.changeColumnName]: XM,
  [j.changeColumnComment]: e$,
  [j.changeColumnDataType]: t$,
  [j.changeColumnDefault]: n$,
  [j.changeColumnAutoIncrement]: o$,
  [j.changeColumnPrimaryKey]: r$,
  [j.changeColumnUnique]: s$,
  [j.changeColumnNotNull]: i$,
  [j.moveColumn]: a$
}, c$ = {
  addColumnAction: Ot,
  removeColumnAction: Co,
  changeColumnNameAction: Dt,
  changeColumnCommentAction: Lt,
  changeColumnDataTypeAction: Rt,
  changeColumnDefaultAction: _t,
  changeColumnAutoIncrementAction: Nn,
  changeColumnPrimaryKeyAction: zn,
  changeColumnUniqueAction: Mn,
  changeColumnNotNullAction: Pt,
  moveColumnAction: Ki
}, u$ = (e, { payload: { id: t, tableId: n } }) => {
  e.push(Co({ id: t, tableId: n }));
}, d$ = (e, { payload: { id: t, tableId: n } }) => {
  e.push(Ot({ id: t, tableId: n }));
}, f$ = (e, { payload: { id: t, tableId: n } }, { collections: o }) => {
  const r = y(o).collection("tableColumnEntities").selectById(t);
  r && e.push(Dt({ id: t, tableId: n, value: r.name }));
}, m$ = (e, { payload: { id: t, tableId: n } }, { collections: o }) => {
  const r = y(o).collection("tableColumnEntities").selectById(t);
  r && e.push(
    Rt({ id: t, tableId: n, value: r.dataType })
  );
}, h$ = (e, { payload: { id: t, tableId: n } }, { collections: o }) => {
  const r = y(o).collection("tableColumnEntities").selectById(t);
  r && e.push(
    _t({ id: t, tableId: n, value: r.default })
  );
}, p$ = (e, { payload: { id: t, tableId: n } }, { collections: o }) => {
  const r = y(o).collection("tableColumnEntities").selectById(t);
  r && e.push(
    Lt({ id: t, tableId: n, value: r.comment })
  );
}, y$ = (e, {
  payload: { id: t, tableId: n, value: o }
}, { collections: r }) => {
  y(r).collection("tableColumnEntities").selectById(t) && e.push(
    Nn({
      id: t,
      tableId: n,
      value: !o
    })
  );
}, g$ = (e, {
  payload: { id: t, tableId: n, value: o }
}, { collections: r }) => {
  y(r).collection("tableColumnEntities").selectById(t) && e.push(
    Pt({
      id: t,
      tableId: n,
      value: !o
    })
  );
}, v$ = (e, {
  payload: { id: t, tableId: n, value: o }
}, { collections: r }) => {
  y(r).collection("tableColumnEntities").selectById(t) && e.push(
    zn({
      id: t,
      tableId: n,
      value: !o
    })
  );
}, b$ = (e, {
  payload: { id: t, tableId: n, value: o }
}, { collections: r }) => {
  y(r).collection("tableColumnEntities").selectById(t) && e.push(
    Mn({
      id: t,
      tableId: n,
      value: !o
    })
  );
}, I$ = (e, { payload: { id: t, tableId: n, targetId: o } }, { collections: r }) => {
  const s = y(r).collection("tableEntities").selectById(n);
  if (!s) return;
  const i = s.columnIds.indexOf(t);
  if (i === -1) return;
  const a = s.columnIds.indexOf(o);
  if (a === -1) return;
  const l = i < a ? i + 1 : i - 1, c = s.columnIds[l];
  e.push(
    Ki({
      id: t,
      tableId: n,
      targetId: c
    })
  );
}, T$ = {
  [j.addColumn]: u$,
  [j.removeColumn]: d$,
  [j.changeColumnName]: f$,
  [j.changeColumnDataType]: m$,
  [j.changeColumnDefault]: h$,
  [j.changeColumnComment]: p$,
  [j.changeColumnAutoIncrement]: y$,
  [j.changeColumnNotNull]: g$,
  [j.changeColumnPrimaryKey]: v$,
  [j.changeColumnUnique]: b$,
  [j.moveColumn]: I$
}, Ap = {
  ...zM,
  ...T$,
  ...BN,
  ...ON,
  ...TM,
  ...BA,
  ...JA,
  ...cN
}, ts = {
  ...KM,
  ...NN,
  ...SM
};
function w$(e, t, n) {
  const o = [], r = [];
  for (const s of n) {
    const i = Ap[s.type];
    i && (i(o, s, e.state), r.push(ua(s)));
  }
  for (const s of Object.keys(ts))
    ts[s](o, r, n);
  !o.length || !r.length || t.push({
    undo: (s) => {
      const i = e.context.clock.getNextVersion();
      s(o.map(Fd(i)));
    },
    redo: (s) => {
      const i = e.context.clock.getNextVersion();
      s(r.map(Fd(i)));
    }
  });
}
function Fd(e) {
  return (t) => ({
    ...ua(t),
    version: e
  });
}
const DR = (e, t) => (n) => {
  lC(w$, e, t, n);
}, C$ = () => function* ({ settings: e, doc: { tableIds: t, memoIds: n }, collections: o }) {
  const r = y(o).collection("tableEntities").selectByIds(t), s = y(o).collection("memoEntities").selectByIds(n), i = ap(e, r, s), a = me();
  yield Na(), yield Ho({ [a]: Le.memo }), yield zc({
    id: a,
    ui: {
      ...i,
      zIndex: Ta(r, s)
    }
  });
}, Np = (e) => function* ({ editor: { selectedMap: t } }) {
  if (e) {
    yield zi({ id: e });
    return;
  }
  const n = Object.entries(t).filter(
    ([, o]) => o === Le.memo
  );
  for (const [o] of n)
    yield zi({ id: o });
}, S$ = (e, t) => function* ({ doc: { tableIds: n, memoIds: o }, collections: r }) {
  const s = y(r).collection("tableEntities").selectByIds(n), i = y(r).collection("memoEntities").selectByIds(o);
  t || (yield Na()), yield Ho({ [e]: Le.memo }), yield wp({ id: e, zIndex: Ta(s, i) });
}, O$ = {
  addMemoAction$: C$,
  removeMemoAction$: Np,
  selectMemoAction$: S$
}, E$ = {
  columnName: "columnName",
  columnDataType: "columnDataType",
  columnNotNull: "columnNotNull",
  columnUnique: "columnUnique",
  columnAutoIncrement: "columnAutoIncrement",
  columnDefault: "columnDefault",
  columnComment: "columnComment"
}, LR = B(Object.values(E$));
function x$(e, t) {
  return t.filter((n) => {
    switch (n) {
      case R.columnName:
        return !0;
      case R.columnDataType:
        return $(e, K.columnDataType);
      case R.columnDefault:
        return $(e, K.columnDefault);
      case R.columnComment:
        return $(e, K.columnComment);
      case R.columnAutoIncrement:
        return $(e, K.columnAutoIncrement);
      case R.columnUnique:
        return $(e, K.columnUnique);
      case R.columnNotNull:
        return $(e, K.columnNotNull);
      default:
        return !1;
    }
  });
}
const A$ = () => function* ({ settings: e, doc: { tableIds: t, memoIds: n }, collections: o }) {
  const r = y(o).collection("tableEntities").selectByIds(t), s = y(o).collection("memoEntities").selectByIds(n), i = ap(e, r, s), a = me();
  yield Ca(), yield Ho({ [a]: Le.table }), yield Jc({
    id: a,
    ui: {
      ...i,
      zIndex: Ta(r, s)
    }
  }), yield Sa({ tableId: a });
}, Mp = (e) => function* ({
  doc: { relationshipIds: t, indexIds: n },
  editor: { selectedMap: o },
  collections: r
}) {
  const s = y(r).collection("relationshipEntities").selectByIds(t), i = y(r).collection("indexEntities").selectByIds(n);
  if (e) {
    const d = s.filter(
      ({ start: f, end: p }) => f.tableId === e || p.tableId === e
    ), m = i.filter(({ tableId: f }) => f === e);
    for (const { id: f } of m)
      yield es({ id: f });
    for (const { id: f } of d)
      yield ko({ id: f });
    yield Yi({ id: e });
    return;
  }
  const a = Object.entries(o).filter(([, d]) => d === Le.table).map(([d]) => d), l = B(a), c = s.filter(
    ({ start: d, end: m }) => l(d.tableId) || l(m.tableId)
  ), u = i.filter(({ tableId: d }) => l(d));
  for (const { id: d } of u)
    yield es({ id: d });
  for (const { id: d } of c)
    yield ko({ id: d });
  for (const d of a)
    yield Yi({ id: d });
}, N$ = (e, t) => function* ({
  doc: { tableIds: n, memoIds: o },
  collections: r,
  editor: { drawRelationship: s }
}) {
  const i = y(r).collection("tableEntities"), a = i.selectByIds(n), l = y(r).collection("memoEntities").selectByIds(o);
  if (t || (yield Ca()), yield Ho({ [e]: Le.table }), yield xp({ id: e, zIndex: Ta(a, l) }), yield Sa({ tableId: e }), !!s)
    if (s.start) {
      const c = i.selectById(
        s.start.tableId
      ), u = i.selectById(e);
      if (!c || !u) return;
      const d = y(r).collection("tableColumnEntities").selectByIds(c.columnIds).filter(({ options: f }) => $(f, V.primaryKey));
      if (!d.length) return;
      const m = d.map(() => me());
      for (let f = 0; f < d.length; f++) {
        const p = d[f], I = {
          id: m[f],
          tableId: u.id
        };
        yield [
          Ot(I),
          Pt({
            ...I,
            value: !0
          }),
          Dt({
            ...I,
            value: p.name
          }),
          Rt({
            ...I,
            value: p.dataType
          }),
          _t({
            ...I,
            value: p.default
          }),
          Lt({
            ...I,
            value: p.comment
          })
        ];
      }
      yield Ts({
        id: me(),
        relationshipType: s.relationshipType,
        start: {
          tableId: c.id,
          columnIds: d.map(({ id: f }) => f)
        },
        end: {
          tableId: u.id,
          columnIds: m
        }
      }), yield Pc();
    } else
      yield Gp(e);
}, M$ = (e) => function* ({
  editor: { selectedMap: t, focusTable: n },
  settings: { show: o, columnOrder: r },
  collections: s
}) {
  const i = n && !_n(n.focusType), a = Object.entries(t).filter(([, p]) => p === Le.table).map(([p]) => p).filter((p) => i ? p !== (n == null ? void 0 : n.tableId) : !0);
  for (const p of a)
    for (const v of e) {
      const g = {
        id: me(),
        tableId: p
      };
      yield [
        Ot(g),
        Dt({
          ...g,
          value: v.name
        }),
        Rt({
          ...g,
          value: v.dataType
        }),
        _t({
          ...g,
          value: v.default
        }),
        Lt({
          ...g,
          value: v.comment
        }),
        Pt({
          ...g,
          value: $(v.options, V.notNull)
        }),
        Mn({
          ...g,
          value: $(v.options, V.unique)
        }),
        Nn({
          ...g,
          value: $(v.options, V.autoIncrement)
        })
      ];
    }
  if (!n || !i) return;
  const l = y(s).collection("tableEntities").selectById(n.tableId);
  if (!l) return;
  const c = l.columnIds.filter(
    B(n.selectColumnIds)
  );
  if (c.length === 0) return;
  const u = l.columnIds.slice(
    l.columnIds.indexOf(c[c.length - 1]) + 1
  ), d = [...c, ...u], m = x$(o, r);
  yield _c();
  for (let p = 0; p < d.length; p++) {
    const v = d[p], I = e[p];
    if (!I) break;
    const g = {
      id: v,
      tableId: l.id
    };
    yield [
      ...m.map((b) => {
        switch (b) {
          case R.columnName:
            return Dt({
              ...g,
              value: I.name
            });
          case R.columnDataType:
            return Rt({
              ...g,
              value: I.dataType
            });
          case R.columnDefault:
            return _t({
              ...g,
              value: I.default
            });
          case R.columnComment:
            return Lt({
              ...g,
              value: I.comment
            });
          case R.columnAutoIncrement:
            return Nn({
              ...g,
              value: $(I.options, V.autoIncrement)
            });
          case R.columnUnique:
            return Mn({
              ...g,
              value: $(I.options, V.unique)
            });
          case R.columnNotNull:
            return Pt({
              ...g,
              value: $(I.options, V.notNull)
            });
          default:
            return null;
        }
      }).filter(Boolean),
      rn({
        tableId: l.id,
        columnId: v,
        focusType: n.focusType,
        $mod: !0,
        shiftKey: !1
      })
    ];
  }
  const f = e.slice(d.length);
  for (const p of f) {
    const v = me(), I = {
      id: v,
      tableId: l.id
    };
    yield [
      Ot(I),
      ...m.map((g) => {
        switch (g) {
          case R.columnName:
            return Dt({
              ...I,
              value: p.name
            });
          case R.columnDataType:
            return Rt({
              ...I,
              value: p.dataType
            });
          case R.columnDefault:
            return _t({
              ...I,
              value: p.default
            });
          case R.columnComment:
            return Lt({
              ...I,
              value: p.comment
            });
          case R.columnAutoIncrement:
            return Nn({
              ...I,
              value: $(p.options, V.autoIncrement)
            });
          case R.columnUnique:
            return Mn({
              ...I,
              value: $(p.options, V.unique)
            });
          case R.columnNotNull:
            return Pt({
              ...I,
              value: $(p.options, V.notNull)
            });
          default:
            return null;
        }
      }).filter(Boolean),
      rn({
        tableId: l.id,
        columnId: v,
        focusType: n.focusType,
        $mod: !0,
        shiftKey: !1
      })
    ];
  }
}, $$ = {
  addTableAction$: A$,
  removeTableAction$: Mp,
  selectTableAction$: N$,
  pasteTableAction$: M$
};
function $p(e, t, n, o = []) {
  const {
    doc: { relationshipIds: r },
    collections: s
  } = t, i = e.pop();
  return i && (o.some(({ id: a }) => a === i.id) || (o.push(i), y(s).collection("relationshipEntities").selectByIds(r).forEach(({ start: a, end: l }) => {
    const c = a.columnIds.indexOf(i.id);
    if (c !== -1) {
      const u = l.columnIds[c];
      e.push({
        id: u,
        tableId: l.tableId,
        value: n.value
      });
    } else {
      const u = l.columnIds.indexOf(i.id);
      if (u !== -1) {
        const d = a.columnIds[u];
        e.push({
          id: d,
          tableId: a.tableId,
          value: n.value
        });
      }
    }
  })), $p(e, t, n, o)), o;
}
const k$ = B([
  P.columnNotNull,
  P.columnUnique,
  P.columnAutoIncrement
]), D$ = B([
  P.columnName,
  P.columnDataType,
  P.columnDefault,
  P.columnComment
]), kp = (e) => function* ({ editor: { selectedMap: t } }) {
  if (e) {
    const r = me();
    yield Ot({
      id: r,
      tableId: e
    }), yield rn({
      tableId: e,
      columnId: r,
      focusType: P.columnName,
      $mod: !1,
      shiftKey: !1
    });
    return;
  }
  const n = Object.entries(t).filter(([, r]) => r === Le.table).map(([r]) => ({ tableId: r, id: me() }));
  for (const r of n)
    yield Ot(r);
  const o = Po(n);
  o && (yield rn({
    tableId: o.tableId,
    columnId: o.id,
    focusType: P.columnName,
    $mod: !1,
    shiftKey: !1
  }));
}, Dp = (e, t) => function* (n) {
  const {
    doc: { relationshipIds: o, indexIds: r },
    editor: { focusTable: s },
    collections: i
  } = n;
  if (s != null && s.columnId) {
    const u = jx(n, t);
    u ? yield rn({
      tableId: s.tableId,
      columnId: u,
      focusType: s.focusType,
      $mod: !1,
      shiftKey: !1
    }) : yield Sa({
      tableId: s.tableId,
      focusType: P.tableName
    });
  }
  const a = B(t), l = y(i).collection("relationshipEntities").selectByIds(o).filter(
    ({ start: u, end: d }) => u.tableId === e && u.columnIds.some(a) || d.tableId === e && d.columnIds.some(a)
  ), c = y(i).collection("indexEntities").selectByIds(r).filter(
    (u) => u.tableId === e && y(i).collection("indexColumnEntities").selectByIds(u.indexColumnIds).map(({ columnId: d }) => d).some(a)
  );
  for (const { id: u } of c)
    yield es({ id: u });
  for (const { id: u } of l)
    yield ko({ id: u });
  for (const u of t)
    yield Co({
      id: u,
      tableId: e
    });
}, L$ = (e, t, n) => function* ({ collections: o }) {
  if (!k$(e))
    return;
  const r = y(o).collection("tableColumnEntities").selectById(n);
  if (r)
    switch (e) {
      case P.columnNotNull:
        yield Pt({
          id: n,
          tableId: t,
          value: !$(r.options, V.notNull)
        });
        break;
      case P.columnUnique:
        yield Mn({
          id: n,
          tableId: t,
          value: !$(r.options, V.unique)
        });
        break;
      case P.columnAutoIncrement:
        yield Nn({
          id: n,
          tableId: t,
          value: !$(r.options, V.autoIncrement)
        });
        break;
    }
}, Lp = (e) => function* (t) {
  const {
    settings: { relationshipDataTypeSync: n }
  } = t;
  let o = [e];
  n && (o = $p([e], t, e)), yield o.map(Rt);
}, R$ = (e, t, n, o) => function* ({ collections: r }) {
  if (!D$(e) || !y(r).collection("tableColumnEntities").selectById(n)) return;
  const i = {
    id: n,
    tableId: t,
    value: o
  };
  switch (e) {
    case P.columnName:
      yield Dt(i);
      break;
    case P.columnDataType:
      yield Lp(i);
      break;
    case P.columnDefault:
      yield _t(i);
      break;
    case P.columnComment:
      yield Lt(i);
      break;
  }
}, _$ = (e, t) => function* ({ collections: n }) {
  const o = y(n).collection("tableColumnEntities").selectById(t);
  if (!o) return;
  const r = $(o.options, V.primaryKey);
  yield zn({
    tableId: e,
    id: t,
    value: !r
  });
}, P$ = {
  addColumnAction$: kp,
  removeColumnAction$: Dp,
  toggleColumnValueAction$: L$,
  changeColumnDataTypeAction$: Lp,
  changeColumnValueAction$: R$,
  changeColumnPrimaryKeyAction$: _$
};
function B$(e) {
  return qi + Zi + e.ui.width + Zi + qi;
}
function W$(e) {
  return qi + Zi + np + e.ui.height + Zi + qi;
}
/*!
 * @dineug/schema-sql-parser
 * @version 0.1.0 | Thu Oct 15 2026
 * @author SeungHwan-Lee <dineug2@gmail.com>
 * @license MIT
 */
const U$ = [
  "BIGINT",
  "BINARY",
  "BIT",
  "BLOB",
  "BOOL",
  "BOOLEAN",
  "CHAR",
  "DATE",
  "DATETIME",
  "DEC",
  "DECIMAL",
  "DOUBLE PRECISION",
  "DOUBLE",
  "ENUM",
  "FIXED",
  "FLOAT",
  "GEOMETRY",
  "GEOMETRYCOLLECTION",
  "INT",
  "INTEGER",
  "JSON",
  "LINESTRING",
  "LONGBLOB",
  "LONGTEXT",
  "MEDIUMBLOB",
  "MEDIUMINT",
  "MEDIUMTEXT",
  "MULTILINESTRING",
  "MULTIPOINT",
  "MULTIPOLYGON",
  "NUMERIC",
  "POINT",
  "POLYGON",
  "REAL",
  "SET",
  "SMALLINT",
  "TEXT",
  "TIME",
  "TIMESTAMP",
  "TINYBLOB",
  "TINYINT",
  "TINYTEXT",
  "VARBINARY",
  "VARCHAR",
  "YEAR"
], V$ = [
  "BIGINT",
  "BINARY",
  "BIT",
  "CHAR",
  "DATE",
  "DATETIME",
  "DATETIME2",
  "DATETIMEOFFSET",
  "DECIMAL",
  "FLOAT",
  "GEOGRAPHY",
  "GEOMETRY",
  "IMAGE",
  "INT",
  "MONEY",
  "NCHAR",
  "NTEXT",
  "NUMERIC",
  "NVARCHAR",
  "REAL",
  "SMALLDATETIME",
  "SMALLINT",
  "SMALLMONEY",
  "SQL_VARIANT",
  "TEXT",
  "TIME",
  "TINYINT",
  "UNIQUEIDENTIFIER",
  "VARBINARY",
  "VARCHAR",
  "XML"
], F$ = [
  "BIGINT",
  "BINARY",
  "BIT",
  "BLOB",
  "BOOL",
  "BOOLEAN",
  "CHAR",
  "DATE",
  "DATETIME",
  "DEC",
  "DECIMAL",
  "DOUBLE PRECISION",
  "DOUBLE",
  "ENUM",
  "FLOAT",
  "GEOMETRY",
  "GEOMETRYCOLLECTION",
  "INT",
  "INTEGER",
  "JSON",
  "LINESTRING",
  "LONGBLOB",
  "LONGTEXT",
  "MEDIUMBLOB",
  "MEDIUMINT",
  "MEDIUMTEXT",
  "MULTILINESTRING",
  "MULTIPOINT",
  "MULTIPOLYGON",
  "NUMERIC",
  "POINT",
  "POLYGON",
  "SET",
  "SMALLINT",
  "TEXT",
  "TIME",
  "TIMESTAMP",
  "TINYBLOB",
  "TINYINT",
  "TINYTEXT",
  "VARBINARY",
  "VARCHAR",
  "YEAR"
], j$ = [
  "BFILE",
  "BINARY_DOUBLE",
  "BINARY_FLOAT",
  "BLOB",
  "CHAR",
  "CLOB",
  "DATE",
  "DATETIME",
  "LONG RAW",
  "LONG",
  "NCHAR",
  "NCLOB",
  "NUMBER",
  "NVARCHAR2",
  "RAW",
  "TIMESTAMP WITH LOCAL TIME ZONE",
  "TIMESTAMP WITH TIME ZONE",
  "TIMESTAMP",
  "UriType",
  "VARCHAR",
  "VARCHAR2",
  "XMLType"
], q$ = [
  "BIGINT",
  "BIGSERIAL",
  "BIT VARYING",
  "BIT",
  "BOOL",
  "BOOLEAN",
  "BOX",
  "BYTEA",
  "CHAR",
  "CHARACTER VARYING",
  "CHARACTER",
  "CIDR",
  "CIRCLE",
  "DATE",
  "DECIMAL",
  "DOUBLE PRECISION",
  "FLOAT4",
  "FLOAT8",
  "INET",
  "INT",
  "INT2",
  "INT4",
  "INT8",
  "INTEGER",
  "INTERVAL",
  "JSON",
  "JSONB",
  "LINE",
  "LSEG",
  "MACADDR",
  "MACADDR8",
  "MONEY",
  "NUMERIC",
  "PATH",
  "PG_LSN",
  "POINT",
  "POLYGON",
  "REAL",
  "SERIAL",
  "SERIAL2",
  "SERIAL4",
  "SERIAL8",
  "SMALLINT",
  "SMALLSERIAL",
  "TEXT",
  "TIME WITH",
  "TIME",
  "TIMESTAMP WITH",
  "TIMESTAMP",
  "TIMESTAMPTZ",
  "TIMETZ",
  "TSQUERY",
  "TSVECTOR",
  "TXID_SNAPSHOT",
  "UUID",
  "VARBIT",
  "VARCHAR",
  "XML"
], Z$ = [
  "BLOB",
  "INTEGER",
  "NUMERIC",
  "REAL",
  "TEXT"
], be = {
  string: "string",
  leftParent: "leftParent",
  rightParent: "rightParent",
  comma: "comma",
  period: "period",
  equal: "equal",
  semicolon: "semicolon"
}, xe = {
  doubleQuote: '"',
  singleQuote: "'",
  backtick: "`",
  whiteSpace: /\s/,
  string: /\S/,
  breakString: /;|,|\(|\)|\[|\]|\./,
  equal: "=",
  period: ".",
  comma: ",",
  semicolon: ";",
  leftParent: "(",
  rightParent: ")",
  leftBracket: "[",
  rightBracket: "]"
}, rt = (e) => (t) => e === t, Ka = (e) => (t) => e.test(t), he = {
  doubleQuote: rt(xe.doubleQuote),
  singleQuote: rt(xe.singleQuote),
  backtick: rt(xe.backtick),
  whiteSpace: Ka(xe.whiteSpace),
  string: Ka(xe.string),
  breakString: Ka(xe.breakString),
  equal: rt(xe.equal),
  period: rt(xe.period),
  comma: rt(xe.comma),
  semicolon: rt(xe.semicolon),
  leftParent: rt(xe.leftParent),
  rightParent: rt(xe.rightParent),
  leftBracket: rt(xe.leftBracket),
  rightBracket: rt(xe.rightBracket)
};
function H$(e) {
  const t = [];
  let n = 0;
  const o = () => n < e.length;
  for (; o(); ) {
    let r = e[n];
    if (he.whiteSpace(r)) {
      for (; o() && he.whiteSpace(r); )
        r = e[++n];
      continue;
    }
    if (he.leftParent(r)) {
      t.push({ type: be.leftParent, value: r }), n++;
      continue;
    }
    if (he.rightParent(r)) {
      t.push({ type: be.rightParent, value: r }), n++;
      continue;
    }
    if (he.comma(r)) {
      t.push({ type: be.comma, value: r }), n++;
      continue;
    }
    if (he.period(r)) {
      t.push({ type: be.period, value: r }), n++;
      continue;
    }
    if (he.equal(r)) {
      t.push({ type: be.equal, value: r }), n++;
      continue;
    }
    if (he.semicolon(r)) {
      t.push({ type: be.semicolon, value: r }), n++;
      continue;
    }
    if (he.leftBracket(r)) {
      let s = "";
      for (r = e[++n]; o() && !he.rightBracket(r); )
        s += r, r = e[++n];
      t.push({ type: be.string, value: s }), n++;
      continue;
    }
    if (he.doubleQuote(r)) {
      let s = "";
      for (r = e[++n]; o() && !he.doubleQuote(r); )
        s += r, r = e[++n];
      t.push({ type: be.string, value: s }), n++;
      continue;
    }
    if (he.singleQuote(r)) {
      let s = "";
      for (r = e[++n]; o() && !he.singleQuote(r); )
        s += r, r = e[++n];
      t.push({ type: be.string, value: s }), n++;
      continue;
    }
    if (he.backtick(r)) {
      let s = "";
      for (r = e[++n]; o() && !he.backtick(r); )
        s += r, r = e[++n];
      t.push({ type: be.string, value: s }), n++;
      continue;
    }
    if (he.string(r)) {
      let s = "";
      for (; o() && he.string(r) && !he.breakString(r); )
        s += r, r = e[++n];
      t.push({ type: be.string, value: s });
      continue;
    }
    n++;
  }
  return t;
}
const Go = (e) => (t) => (n) => t[n] ? t[n].type === e : !1, z = (e) => {
  const t = e.toUpperCase();
  return (n) => (o) => n[o] ? n[o].value.toUpperCase() === t : !1;
}, un = Go(be.string), ws = Go(be.period), ou = Go(be.comma), z$ = Go(be.semicolon), Yo = Go(be.leftParent), Cs = Go(be.rightParent), Ko = z("CREATE"), ru = z("ALTER"), G$ = z("DROP"), Y$ = z("USE"), K$ = z("RENAME"), Q$ = z("DELETE"), J$ = z("SELECT"), Qo = z("TABLE"), Oa = z("INDEX"), Jo = z("UNIQUE"), Xo = z("ADD"), Ea = z("PRIMARY"), Gn = z("KEY"), xt = z("CONSTRAINT"), xa = z("FOREIGN"), su = z("NOT"), X$ = z("NULL"), ek = z("DEFAULT"), Rp = z("COMMENT"), tk = z("REFERENCES"), _p = z("ASC"), Pp = z("DESC"), nk = z("ON"), ok = z("AUTO_INCREMENT"), rk = z("AUTOINCREMENT"), Bp = z("IF"), Wp = z("EXISTS"), sk = z("ONLY"), ik = z("CHECK"), ak = (e) => {
  const t = ok(e), n = rk(e);
  return (o) => t(o) || n(o);
}, Ss = (e) => {
  const t = Ko(e), n = ru(e), o = G$(e), r = Y$(e), s = K$(e), i = Q$(e), a = J$(e);
  return (l) => t(l) || n(l) || o(l) || r(l) || s(l) || i(l) || a(l);
}, lk = (e) => {
  const t = Ko(e), n = Qo(e), o = Bp(e), r = su(e), s = Wp(e);
  return (i) => t(i) && n(i + 1) && o(i + 2) && r(i + 3) && s(i + 4);
}, ck = (e) => {
  const t = Ko(e), n = Qo(e);
  return (o) => t(o) && n(o + 1);
}, Up = (e) => {
  const t = Ko(e), n = Oa(e), o = Jo(e);
  return (r) => t(r) && o(r + 1) && n(r + 2);
}, uk = (e) => {
  const t = Ko(e), n = Oa(e), o = Up(e);
  return (r) => t(r) && n(r + 1) || o(r);
}, dk = (e) => {
  const t = Bp(e), n = su(e), o = Wp(e);
  return (r) => t(r) && n(r + 1) && o(r + 2);
}, Aa = (e) => {
  const t = ru(e), n = Qo(e);
  return (o) => t(o) && n(o + 1);
}, iu = (e) => {
  const t = Aa(e), n = sk(e);
  return (o) => t(o) && n(o + 2);
}, Vp = (e) => {
  const t = iu(e), n = Xo(e), o = Ea(e), r = Gn(e), s = xt(e), i = (u) => t(u) && n(u + 4) && o(u + 5) && r(u + 6), a = (u) => t(u) && n(u + 4) && s(u + 5) && o(u + 7) && r(u + 8), l = (u) => t(u) && n(u + 6) && o(u + 7) && r(u + 8), c = (u) => t(u) && n(u + 6) && s(u + 7) && o(u + 9) && r(u + 10);
  return (u) => i(u) || a(u) || l(u) || c(u);
}, fk = (e) => {
  const t = Vp(e), n = Aa(e), o = Xo(e), r = Ea(e), s = Gn(e), i = xt(e), a = (d) => n(d) && o(d + 3) && r(d + 4) && s(d + 5), l = (d) => n(d) && o(d + 3) && i(d + 4) && r(d + 6) && s(d + 7), c = (d) => n(d) && o(d + 5) && r(d + 6) && s(d + 7), u = (d) => n(d) && o(d + 5) && i(d + 6) && r(d + 8) && s(d + 9);
  return (d) => a(d) || l(d) || c(d) || u(d) || t(d);
}, Fp = (e) => {
  const t = iu(e), n = Xo(e), o = xa(e), r = Gn(e), s = xt(e), i = (u) => t(u) && n(u + 4) && o(u + 5) && r(u + 6), a = (u) => t(u) && n(u + 4) && s(u + 5) && o(u + 7) && r(u + 8), l = (u) => t(u) && n(u + 6) && o(u + 7) && r(u + 8), c = (u) => t(u) && n(u + 6) && s(u + 7) && o(u + 9) && r(u + 10);
  return (u) => i(u) || a(u) || l(u) || c(u);
}, mk = (e) => {
  const t = Fp(e), n = Aa(e), o = Xo(e), r = xa(e), s = Gn(e), i = xt(e), a = (d) => n(d) && o(d + 3) && r(d + 4) && s(d + 5), l = (d) => n(d) && o(d + 3) && i(d + 4) && r(d + 6) && s(d + 7), c = (d) => n(d) && o(d + 5) && r(d + 6) && s(d + 7), u = (d) => n(d) && o(d + 5) && i(d + 6) && r(d + 8) && s(d + 9);
  return (d) => a(d) || l(d) || c(d) || u(d) || t(d);
}, jp = (e) => {
  const t = iu(e), n = Xo(e), o = Jo(e), r = xt(e), s = (c) => t(c) && n(c + 4) && o(c + 5), i = (c) => t(c) && n(c + 4) && r(c + 5) && o(c + 7), a = (c) => t(c) && n(c + 6) && o(c + 7), l = (c) => t(c) && n(c + 6) && r(c + 7) && o(c + 9);
  return (c) => s(c) || i(c) || a(c) || l(c);
}, hk = (e) => {
  const t = jp(e), n = Aa(e), o = Xo(e), r = Jo(e), s = xt(e), i = (u) => n(u) && o(u + 3) && r(u + 4), a = (u) => n(u) && o(u + 3) && s(u + 4) && r(u + 6), l = (u) => n(u) && o(u + 5) && r(u + 6), c = (u) => n(u) && o(u + 5) && s(u + 6) && r(u + 8);
  return (u) => i(u) || a(u) || l(u) || c(u) || t(u);
}, pk = Array.from(
  new Set(
    [
      ...U$,
      ...V$,
      ...F$,
      ...j$,
      ...q$,
      ...Z$
    ].map((e) => e.toUpperCase())
  )
), yk = (e) => {
  const t = un(e);
  return (n) => {
    const o = e[n];
    return o ? t(n) && pk.includes(o.value.toUpperCase()) : !1;
  };
}, It = {
  createTable: "create.table",
  createIndex: "create.index",
  alterTableAddUnique: "alter.table.add.unique",
  alterTableAddPrimaryKey: "alter.table.add.primaryKey",
  alterTableAddForeignKey: "alter.table.add.foreignKey"
}, $n = {
  asc: "ASC",
  desc: "DESC"
};
function gk(e, t) {
  const n = Ss(e), o = un(e), r = Yo(e), s = ws(e), i = Rp(e), a = lk(e), l = () => t.value < e.length, c = {
    type: It.createTable,
    name: "",
    comment: "",
    columns: [],
    indexes: [],
    foreignKeys: []
  };
  for (t.value += a(t.value) ? 5 : 2; l() && !n(t.value); ) {
    let u = e[t.value];
    if (r(t.value)) {
      if (c.columns.length === 0) {
        t.value++;
        const { columns: d, indexes: m, foreignKeys: f } = vk(
          e,
          t
        );
        c.columns = d, c.indexes = m, c.foreignKeys = f;
      } else
        t.value++;
      continue;
    }
    if (o(t.value) && !c.name) {
      c.name = u.value, u = e[++t.value], s(t.value) && (u = e[++t.value], o(t.value) && (c.name = u.value, t.value++));
      continue;
    }
    if (i(t.value)) {
      u = e[++t.value], o(t.value) && (c.comment = u.value, t.value++);
      continue;
    }
    t.value++;
  }
  return c;
}
function vk(e, t) {
  const n = un(e), o = Yo(e), r = Cs(e), s = ou(e), i = xt(e), a = ik(e), l = Oa(e), c = Ea(e), u = xa(e), d = ak(e), m = Jo(e), f = X$(e), p = su(e), v = ek(e), I = Rp(e), g = Pp(e), b = _p(e), S = Gn(e), M = yk(e), U = () => t.value < e.length, Ee = [], yt = [], At = [], Nt = [], gt = [];
  let le = {
    name: "",
    dataType: "",
    default: "",
    comment: "",
    primaryKey: !1,
    autoIncrement: !1,
    unique: !1,
    nullable: !0
  };
  for (; U(); ) {
    let x = e[t.value];
    if (n(t.value) && !le.name && !i(t.value) && !a(t.value) && !c(t.value) && !u(t.value) && !m(t.value) && !l(t.value) && !S(t.value)) {
      le.name = x.value, t.value++;
      continue;
    }
    if (a(t.value)) {
      if (t.value++, o(t.value)) {
        let q = 1;
        for (t.value++; U() && q > 0; )
          o(t.value) ? q++ : r(t.value) && q--, q > 0 && t.value++;
        r(t.value) && t.value++;
      }
      continue;
    }
    if (o(t.value)) {
      let q = 1;
      for (t.value++; U() && q > 0; )
        o(t.value) ? q++ : r(t.value) && q--, q > 0 && t.value++;
      r(t.value) && t.value++;
      continue;
    }
    if (i(t.value)) {
      x = e[++t.value], n(t.value) && t.value++;
      continue;
    }
    if (c(t.value)) {
      if (x = e[++t.value], S(t.value))
        if (x = e[++t.value], o(t.value)) {
          for (x = e[++t.value]; U() && !r(t.value); )
            n(t.value) && Nt.push(x.value.toUpperCase()), x = e[++t.value];
          t.value++;
        } else
          le.primaryKey = !0;
      continue;
    }
    if (u(t.value)) {
      const q = qp(e, t);
      q && At.push(q);
      continue;
    }
    if (l(t.value) || S(t.value)) {
      if (x = e[++t.value], n(t.value)) {
        const q = x.value, Te = [];
        if (x = e[++t.value], o(t.value)) {
          x = e[++t.value];
          let dn = {
            name: "",
            sort: $n.asc
          };
          for (; U() && !r(t.value); )
            n(t.value) && !g(t.value) && !b(t.value) && (dn.name = x.value), g(t.value) && (dn.sort = $n.desc), s(t.value) && (Te.push(dn), dn = {
              name: "",
              sort: $n.asc
            }), x = e[++t.value];
          !Te.includes(dn) && dn.name !== "" && Te.push(dn), Te.length && yt.push({
            name: q,
            unique: !1,
            columns: Te
          }), t.value++;
        }
      }
      continue;
    }
    if (m(t.value)) {
      if (x = e[++t.value], S(t.value) && (x = e[++t.value]), n(t.value) && (x = e[++t.value]), o(t.value)) {
        for (x = e[++t.value]; U() && !r(t.value); )
          n(t.value) && gt.push(x.value.toUpperCase()), x = e[++t.value];
        t.value++;
      } else
        le.unique = !0;
      continue;
    }
    if (p(t.value)) {
      x = e[++t.value], f(t.value) && (le.nullable = !1, t.value++);
      continue;
    }
    if (v(t.value)) {
      if (x = e[++t.value], n(t.value)) {
        let q = x.value;
        if (t.value++, o(t.value)) {
          q += "(";
          let Te = 1;
          for (t.value++; U() && Te > 0; )
            o(t.value) ? Te++ : r(t.value) && Te--, Te > 0 && (q += e[t.value].value, t.value++);
          q += ")", r(t.value) && t.value++;
        }
        le.default = q;
      }
      continue;
    }
    if (I(t.value)) {
      x = e[++t.value], n(t.value) && (le.comment = x.value, t.value++);
      continue;
    }
    if (d(t.value)) {
      le.autoIncrement = !0, t.value++;
      continue;
    }
    if (M(t.value)) {
      let q = x.value;
      if (x = e[++t.value], o(t.value)) {
        for (q += "(", x = e[++t.value]; U() && !r(t.value); )
          q += x.value, x = e[++t.value];
        q += ")", t.value++;
      }
      le.dataType = q;
      continue;
    }
    if (s(t.value)) {
      (le.name || le.dataType) && Ee.push(le), le = {
        name: "",
        dataType: "",
        default: "",
        comment: "",
        primaryKey: !1,
        autoIncrement: !1,
        unique: !1,
        nullable: !0
      }, t.value++;
      continue;
    }
    if (r(t.value)) {
      t.value++;
      break;
    }
    t.value++;
  }
  return !Ee.includes(le) && (le.name || le.dataType) && Ee.push(le), Ee.forEach((x) => {
    Nt.includes(x.name.toUpperCase()) && (x.primaryKey = !0), gt.includes(x.name.toUpperCase()) && (x.unique = !0);
  }), {
    columns: Ee,
    indexes: yt,
    foreignKeys: At
  };
}
function qp(e, t) {
  const n = un(e), o = Yo(e), r = Cs(e), s = ou(e), i = z$(e), a = Ko(e), l = ru(e), c = tk(e), u = ws(e), d = Gn(e), m = () => t.value < e.length, f = {
    columnNames: [],
    refTableName: "",
    refColumnNames: []
  };
  let p = e[++t.value];
  if (d(t.value)) {
    if (p = e[++t.value], o(t.value)) {
      for (p = e[++t.value]; m() && !r(t.value); )
        n(t.value) && f.columnNames.push(p.value), p = e[++t.value];
      p = e[++t.value];
    }
    if (c(t.value) && (p = e[++t.value], n(t.value) && (f.refTableName = p.value, p = e[++t.value], u(t.value) && (p = e[++t.value], n(t.value) && (f.refTableName = p.value, p = e[++t.value])), o(t.value)))) {
      for (p = e[++t.value]; m() && !r(t.value); )
        n(t.value) && f.refColumnNames.push(p.value), p = e[++t.value];
      p = e[++t.value];
    }
    for (; m() && !s(t.value) && !r(t.value) && !i(t.value) && !a(t.value) && !l(t.value); )
      t.value++;
    if (f.columnNames.length && f.columnNames.length === f.refColumnNames.length)
      return f;
  }
  return null;
}
function bk(e, t) {
  const n = Ss(e), o = un(e), r = xt(e), s = ws(e), i = Qo(e), a = xa(e), l = Fp(e)(t.value), c = () => t.value < e.length, u = {
    type: It.alterTableAddForeignKey,
    name: "",
    columnNames: [],
    refTableName: "",
    refColumnNames: []
  };
  for (t.value++; c() && !n(t.value); ) {
    let d = e[t.value];
    if (i(t.value)) {
      d = e[++t.value], l && (d = e[++t.value]), o(t.value) && (u.name = d.value, d = e[++t.value], s(t.value) && (d = e[++t.value], o(t.value) && (u.name = d.value, t.value++)));
      continue;
    }
    if (r(t.value)) {
      d = e[++t.value], o(t.value) && t.value++;
      continue;
    }
    if (a(t.value)) {
      const m = qp(e, t);
      m && (u.columnNames = m.columnNames, u.refTableName = m.refTableName, u.refColumnNames = m.refColumnNames);
      continue;
    }
    t.value++;
  }
  return u;
}
function Ik(e, t) {
  const n = Ss(e), o = un(e), r = Yo(e), s = Cs(e), i = xt(e), a = Ea(e), l = ws(e), c = Gn(e), u = Qo(e), d = Vp(e)(t.value), m = () => t.value < e.length, f = {
    type: It.alterTableAddPrimaryKey,
    name: "",
    columnNames: []
  };
  for (t.value++; m() && !n(t.value); ) {
    let p = e[t.value];
    if (u(t.value)) {
      p = e[++t.value], d && (p = e[++t.value]), o(t.value) && (f.name = p.value, p = e[++t.value], l(t.value) && (p = e[++t.value], o(t.value) && (f.name = p.value, t.value++)));
      continue;
    }
    if (i(t.value)) {
      p = e[++t.value], o(t.value) && t.value++;
      continue;
    }
    if (a(t.value)) {
      if (p = e[++t.value], c(t.value) && (p = e[++t.value], r(t.value))) {
        for (p = e[++t.value]; m() && !s(t.value); )
          o(t.value) && f.columnNames.push(p.value), p = e[++t.value];
        p = e[++t.value];
      }
      continue;
    }
    t.value++;
  }
  return f;
}
function Tk(e, t) {
  const n = Ss(e), o = un(e), r = xt(e), s = ws(e), i = Qo(e), a = Jo(e), l = Yo(e), c = Cs(e), u = jp(e)(t.value), d = () => t.value < e.length, m = {
    type: It.alterTableAddUnique,
    name: "",
    columnNames: []
  };
  for (t.value++; d() && !n(t.value); ) {
    let f = e[t.value];
    if (i(t.value)) {
      f = e[++t.value], u && (f = e[++t.value]), o(t.value) && (m.name = f.value, f = e[++t.value], s(t.value) && (f = e[++t.value], o(t.value) && (m.name = f.value, t.value++)));
      continue;
    }
    if (r(t.value)) {
      f = e[++t.value], o(t.value) && t.value++;
      continue;
    }
    if (a(t.value)) {
      if (f = e[++t.value], l(t.value)) {
        for (f = e[++t.value]; d() && !c(t.value); )
          o(t.value) && m.columnNames.push(f.value), f = e[++t.value];
        t.value++;
      }
      continue;
    }
    t.value++;
  }
  return m;
}
function wk(e, t) {
  const n = Ss(e), o = Jo(e), r = un(e), s = Yo(e), i = Cs(e), a = ou(e), l = Oa(e), c = nk(e), u = Pp(e), d = _p(e), m = Up(e), f = dk(e), p = () => t.value < e.length, v = {
    type: It.createIndex,
    name: "",
    unique: o(t.value + 1),
    tableName: "",
    columns: []
  };
  for (t.value += m(t.value) ? 2 : 1; p() && !n(t.value); ) {
    let I = e[t.value];
    if (l(t.value)) {
      t.value++, f(t.value) && (t.value += 3), p() && r(t.value) && (v.name = e[t.value].value, t.value++);
      continue;
    }
    if (c(t.value)) {
      if (I = e[++t.value], r(t.value) && (v.tableName = I.value, I = e[++t.value], s(t.value))) {
        I = e[++t.value];
        let g = {
          name: "",
          sort: $n.asc
        };
        for (; p() && !i(t.value); )
          r(t.value) && !u(t.value) && !d(t.value) && (g.name = I.value), u(t.value) && (g.sort = $n.desc), a(t.value) && (v.columns.push(g), g = {
            name: "",
            sort: $n.asc
          }), I = e[++t.value];
        !v.columns.includes(g) && g.name !== "" && v.columns.push(g), t.value++;
      }
      continue;
    }
    t.value++;
  }
  return v;
}
function Ck(e) {
  const t = [], n = { value: 0 }, o = () => n.value < e.length, r = ck(e), s = uk(e), i = fk(e), a = mk(e), l = hk(e);
  for (; o(); ) {
    if (r(n.value)) {
      t.push(gk(e, n));
      continue;
    }
    if (s(n.value)) {
      t.push(wk(e, n));
      continue;
    }
    if (i(n.value)) {
      t.push(Ik(e, n));
      continue;
    }
    if (a(n.value)) {
      t.push(bk(e, n));
      continue;
    }
    if (l(n.value)) {
      t.push(Tk(e, n));
      continue;
    }
    n.value++;
  }
  return t;
}
const Sk = (e) => Ck(H$(e));
function je(e, t) {
  for (const n of e)
    if (n.name.toUpperCase() === t.toUpperCase())
      return n;
  return null;
}
function Ok(e, t, n) {
  const o = Un({}), r = Sk(e), s = Ek(r), i = xk(s), a = Nl(i.length * 100);
  return o.settings.width = a, o.settings.height = a, i.forEach((l) => Ak(o, l, t)), Nk(o, i), Mk(o, i), hc(n ? n(o) : o);
}
function Ek(e) {
  const t = {
    tables: [],
    indexes: [],
    primaryKeys: [],
    foreignKeys: [],
    uniques: []
  };
  for (const n of e)
    switch (n.type) {
      case It.createTable:
        n.name && t.tables.push(n);
        break;
      case It.createIndex:
        n.tableName && n.columns.length && t.indexes.push(n);
        break;
      case It.alterTableAddPrimaryKey:
        n.name && n.columnNames.length && t.primaryKeys.push(n);
        break;
      case It.alterTableAddForeignKey:
        n.name && n.columnNames.length && n.refTableName && n.refColumnNames.length && n.columnNames.length === n.refColumnNames.length && t.foreignKeys.push(n);
        break;
      case It.alterTableAddUnique:
        n.name && n.columnNames.length && t.uniques.push(n);
        break;
    }
  return t;
}
function xk({
  tables: e,
  indexes: t,
  primaryKeys: n,
  foreignKeys: o,
  uniques: r
}) {
  return t.forEach((s) => {
    const i = je(e, s.tableName);
    i && i.indexes.push({
      name: s.name,
      unique: s.unique,
      columns: s.columns
    });
  }), n.forEach((s) => {
    const i = je(e, s.name);
    i && s.columnNames.forEach((a) => {
      const l = je(i.columns, a);
      l && (l.primaryKey = !0);
    });
  }), r.forEach((s) => {
    const i = je(e, s.name);
    i && s.columnNames.forEach((a) => {
      const l = je(i.columns, a);
      l && (l.unique = !0);
    });
  }), o.forEach((s) => {
    const i = je(e, s.name);
    if (!i) return;
    i.foreignKeys.some(
      (l) => l.refTableName.toLowerCase() === s.refTableName.toLowerCase() && l.columnNames.length === s.columnNames.length && l.columnNames.every(
        (c, u) => c.toLowerCase() === s.columnNames[u].toLowerCase()
      ) && l.refColumnNames.length === s.refColumnNames.length && l.refColumnNames.every(
        (c, u) => c.toLowerCase() === s.refColumnNames[u].toLowerCase()
      )
    ) || i.foreignKeys.push({
      columnNames: s.columnNames,
      refTableName: s.refTableName,
      refColumnNames: s.refColumnNames
    });
  }), e;
}
function Ak({ doc: e, collections: t }, n, { toWidth: o }) {
  const r = pt({
    name: n.name,
    comment: n.comment,
    ui: {
      widthName: ye(o(n.name)),
      widthComment: ye(o(n.comment))
    }
  });
  n.columns.forEach((s) => {
    const i = Et({
      tableId: r.id,
      name: s.name,
      comment: s.comment,
      dataType: s.dataType,
      default: s.default,
      options: (s.autoIncrement ? V.autoIncrement : 0) | (s.primaryKey ? V.primaryKey : 0) | (s.unique ? V.unique : 0) | (s.nullable ? 0 : V.notNull),
      ui: {
        widthName: ye(o(s.name)),
        widthComment: ye(o(s.comment)),
        widthDataType: ye(o(s.dataType)),
        widthDefault: ye(o(s.default)),
        keys: s.primaryKey ? bt.primaryKey : 0
      }
    });
    r.columnIds.push(i.id), r.seqColumnIds.push(i.id), y(t).collection("tableColumnEntities").setOne(i);
  }), e.tableIds.push(r.id), y(t).collection("tableEntities").setOne(r);
}
function Nk({ doc: e, collections: t }, n) {
  const o = y(t).collection("tableEntities").selectByIds(e.tableIds), r = y(t).collection("tableColumnEntities");
  n.forEach((s) => {
    if (!s.foreignKeys.length) return;
    const i = je(o, s.name);
    if (!i) return;
    const a = r.selectByIds(i.columnIds);
    s.foreignKeys.forEach((l) => {
      const c = je(o, l.refTableName);
      if (!c) return;
      const u = r.selectByIds(c.columnIds), d = [], m = [];
      l.refColumnNames.forEach((g) => {
        const b = je(u, g);
        b && d.push(b);
      }), l.columnNames.forEach((g) => {
        const b = je(a, g);
        b && (m.push(b), $(b.ui.keys, bt.primaryKey) ? b.ui.keys |= bt.foreignKey : b.ui.keys = bt.foreignKey);
      });
      const f = d.map((g) => g.id), p = m.map((g) => g.id);
      if (y(t).collection("relationshipEntities").selectAll().some(
        (g) => g.start.tableId === c.id && g.end.tableId === i.id && g.start.columnIds.length === f.length && g.start.columnIds.every((b, S) => b === f[S]) && g.end.columnIds.length === p.length && g.end.columnIds.every((b, S) => b === p[S])
      )) return;
      const I = Cp({
        identification: !m.some(
          (g) => !($(g.ui.keys, bt.primaryKey) && $(g.ui.keys, bt.foreignKey))
        ),
        relationshipType: Hh.ZeroN,
        start: {
          tableId: c.id,
          columnIds: f
        },
        end: {
          tableId: i.id,
          columnIds: p
        }
      });
      e.relationshipIds.push(I.id), y(t).collection("relationshipEntities").setOne(I);
    });
  });
}
function Mk({ doc: e, collections: t }, n) {
  const o = y(t).collection("tableEntities").selectByIds(e.tableIds);
  n.forEach((r) => {
    r.indexes.forEach((s) => {
      const i = je(o, r.name);
      if (!i) return;
      const a = y(t).collection("tableColumnEntities").selectByIds(i.columnIds), l = [], c = Zn({
        name: s.name,
        tableId: i.id,
        unique: s.unique
      });
      s.columns.forEach((u) => {
        const d = je(a, u.name);
        if (!d) return;
        const m = jc({
          indexId: c.id,
          columnId: d.id,
          orderType: u.sort === $n.asc ? Io.ASC : Io.DESC
        });
        l.push(m);
      }), l.length !== 0 && (l.forEach((u) => {
        c.indexColumnIds.push(u.id), c.seqIndexColumnIds.push(u.id), y(t).collection("indexColumnEntities").setOne(u);
      }), e.indexIds.push(c.id), y(t).collection("indexEntities").setOne(c));
    });
  });
}
function Zp(e, t, n = []) {
  const {
    doc: { relationshipIds: o },
    collections: r
  } = t, s = e.pop();
  return s && (n.some(({ columnId: i }) => i === s.columnId) || (n.push(s), y(r).collection("relationshipEntities").selectByIds(o).forEach(({ id: i, start: a, end: l }) => {
    const c = a.columnIds.indexOf(s.columnId);
    if (c !== -1) {
      const u = l.columnIds[c];
      e.push({
        columnId: u,
        relationshipIds: [i]
      });
    } else {
      const u = l.columnIds.indexOf(s.columnId);
      if (u !== -1) {
        const d = a.columnIds[u];
        e.push({
          columnId: d,
          relationshipIds: [i]
        });
      }
    }
  })), Zp(e, t, n)), n;
}
const Ht = 15;
function Hp(e) {
  return Object.entries(e).reduce(
    (t, [n, o]) => (o === Le.table ? t.tableIds.push(n) : o === Le.memo && t.memoIds.push(n), t),
    { tableIds: [], memoIds: [] }
  );
}
const zp = (e) => function* () {
  yield Rc(), yield on({ value: e });
}, $k = (e) => function* () {
  yield mp(), yield $o({ value: e });
}, kk = (e, t) => function* ({ editor: { selectedMap: n }, settings: { zoomLevel: o } }) {
  const { tableIds: r, memoIds: s } = Hp(n), i = e / o, a = t / o;
  r.length && (yield wo({
    ids: r,
    movementX: i,
    movementY: a
  })), s.length && (yield To({
    ids: s,
    movementX: i,
    movementY: a
  }));
}, Dk = () => function* () {
  yield Mp(), yield Np();
}, Lk = (e) => function* (t) {
  const {
    doc: { tableIds: n, memoIds: o },
    collections: r
  } = t, s = {
    ...y(r).collection("tableEntities").selectByIds(n).reduce((i, a) => {
      const l = Qc(a, t).width, c = Gi(a), u = a.ui.x + l / 2 - Ht, d = a.ui.y + c / 2 - Ht;
      return kd(e, {
        x: u,
        y: d,
        w: Ht,
        h: Ht
      }) && (i[a.id] = Le.table), i;
    }, {}),
    ...y(r).collection("memoEntities").selectByIds(o).reduce((i, a) => {
      const l = B$(a), c = W$(a), u = a.ui.x + l / 2 - Ht, d = a.ui.y + c / 2 - Ht;
      return kd(e, {
        x: u,
        y: d,
        w: Ht,
        h: Ht
      }) && (i[a.id] = Le.memo), i;
    }, {})
  };
  yield Na(), Tm(s) || (yield Ho(s));
}, Na = () => function* () {
  yield Ca(), yield _c();
}, Rk = (e, t) => function* (n) {
  const {
    editor: { focusTable: o }
  } = n;
  o && (e === lt.Tab && !t && (_n(o.focusType) && Lc(n) && !Is(n) || !_n(o.focusType) && kc(n) && Dc(n)) ? yield kp(o.tableId) : yield hp({ moveKey: e, shiftKey: t }));
}, _k = (e) => function* ({ editor: t }) {
  var n;
  ((n = t.drawRelationship) == null ? void 0 : n.relationshipType) === e ? yield Pc() : yield pp({ relationshipType: e });
}, Gp = (e) => function* ({ collections: t }) {
  const n = y(t).collection("tableEntities").selectById(e);
  if (!n) return;
  if (!y(t).collection("tableColumnEntities").selectByIds(n.columnIds).some((r) => $(r.options, V.primaryKey))) {
    const r = me();
    yield Ot({
      tableId: e,
      id: r
    }), yield zn({
      tableId: e,
      id: r,
      value: !0
    }), yield rn({
      tableId: e,
      columnId: r,
      focusType: P.columnName,
      $mod: !1,
      shiftKey: !1
    });
  }
  yield yp({ tableId: e });
}, Pk = (e) => function* ({ editor: { selectedMap: t }, collections: n }) {
  const { tableIds: o, memoIds: r } = Hp(t), s = y(n).collection("tableEntities").selectByIds(o), i = y(n).collection("memoEntities").selectByIds(r);
  yield s.map(
    (a) => qr({ id: a.id, color: e, prevColor: a.ui.color })
  ), yield i.map(
    (a) => Vr({ id: a.id, color: e, prevColor: a.ui.color })
  );
}, Bk = (e) => function* ({ collections: t, settings: n }, o) {
  const r = y(t).collection("tableEntities").selectAll(), s = /* @__PURE__ */ new Map();
  r.forEach((i) => {
    s.set(i.name.toLowerCase(), { ...i.ui });
  }), yield zp(
    Ok(e, o, (i) => (i.settings = {
      ...i.settings,
      ...Kw(ua(n), [
        "width",
        "height",
        "scrollTop",
        "scrollLeft",
        "zoomLevel"
      ])
    }, Object.values(i.collections.tableEntities).forEach((l) => {
      const c = s.get(l.name.toLowerCase());
      c && (l.ui.x = c.x, l.ui.y = c.y, l.ui.zIndex = c.zIndex, c.color && (l.ui.color = c.color));
    }), i))
  ), yield nu();
}, Wk = (e) => function* ({ editor: { focusTable: t } }) {
  !t || !t.columnId || (yield Uc({
    tableId: t.tableId,
    columnIds: e ? [...t.selectColumnIds] : [t.columnId]
  }));
}, Uk = (e, t) => function* ({ editor: { draggableColumn: n }, collections: o }) {
  if (!n || n.columnIds.length === 0)
    return;
  const { tableId: r, columnIds: s } = n, i = y(o).collection("tableEntities"), a = i.selectById(r);
  if (!a) return;
  if (t === r) {
    const d = a.columnIds.indexOf(s[0]);
    if (d === -1) return;
    const m = a.columnIds.indexOf(e);
    if (m === -1) return;
    const f = s.map(
      (p) => Ki({ tableId: r, id: p, targetId: e })
    );
    d < m && f.reverse(), yield f;
    return;
  }
  if (!i.selectById(t)) return;
  const c = y(o).collection("tableColumnEntities").selectByIds(s);
  if (c.length === 0) return;
  yield Dp(r, s);
  const u = c.map(() => me());
  for (let d = 0; d < c.length; d++) {
    const m = c[d], f = u[d], p = {
      id: f,
      tableId: t
    };
    yield [
      Ot(p),
      Dt({
        ...p,
        value: m.name
      }),
      Rt({
        ...p,
        value: m.dataType
      }),
      _t({
        ...p,
        value: m.default
      }),
      Lt({
        ...p,
        value: m.comment
      }),
      zn({
        ...p,
        value: $(m.options, V.primaryKey)
      }),
      Pt({
        ...p,
        value: $(m.options, V.notNull)
      }),
      Mn({
        ...p,
        value: $(m.options, V.unique)
      }),
      Nn({
        ...p,
        value: $(m.options, V.autoIncrement)
      }),
      Ki({
        ...p,
        targetId: e
      }),
      rn({
        tableId: t,
        columnId: f,
        focusType: P.columnName,
        $mod: !0,
        shiftKey: !1
      })
    ];
  }
  yield Uc({
    tableId: t,
    columnIds: u
  });
}, Vk = (e) => function* (t) {
  const { columnIds: n, relationshipIds: o } = Zp(
    [{ columnId: e, relationshipIds: [] }],
    t
  ).reduce(
    (r, { columnId: s, relationshipIds: i }) => (r.columnIds.push(s), r.relationshipIds.push(...i), r),
    { columnIds: [], relationshipIds: [] }
  );
  yield Bc({ columnIds: ki(n) }), yield Wc({
    relationshipIds: ki(o)
  });
}, Fk = () => function* () {
  yield Bc({ columnIds: [] }), yield Wc({ relationshipIds: [] });
}, jk = {
  loadJsonAction$: zp,
  initialLoadJsonAction$: $k,
  moveAllAction$: kk,
  removeSelectedAction$: Dk,
  dragSelectAction$: Lk,
  unselectAllAction$: Na,
  focusMoveTableAction$: Rk,
  drawStartRelationshipAction$: _k,
  drawStartAddRelationshipAction$: Gp,
  changeColorAllAction$: Pk,
  loadSchemaSQLAction$: Bk,
  dragstartColumnAction$: Wk,
  dragoverColumnAction$: Uk,
  columnKeyHoverStartAction$: Vk,
  columnKeyHoverEndAction$: Fk
}, qk = (e) => function* () {
  yield Vc({
    id: me(),
    tableId: e
  });
}, Zk = (e) => function* ({ collections: t }) {
  const n = y(t).collection("indexEntities").selectById(e);
  n && (yield Fc({
    id: e,
    tableId: n.tableId,
    value: !n.unique
  }));
}, Hk = {
  addIndexAction$: qk,
  changeIndexUniqueAction$: Zk
}, zk = (e, t) => function* ({ collections: n }) {
  const o = y(n).collection("indexEntities").selectById(e);
  if (!o) return;
  const r = y(n).collection("indexColumnEntities").selectByIds(o.seqIndexColumnIds).find((s) => s.columnId === t);
  r ? yield Hi({
    id: r.id,
    indexId: e,
    tableId: o.tableId,
    columnId: t
  }) : yield Hi({
    id: me(),
    indexId: e,
    tableId: o.tableId,
    columnId: t
  });
}, Gk = (e, t) => function* ({ collections: n }) {
  const o = y(n).collection("indexEntities").selectById(e);
  if (!o) return;
  const r = y(n).collection("indexColumnEntities").selectByIds(o.indexColumnIds).filter((s) => s.columnId === t);
  for (const s of r)
    yield qc({
      id: s.id,
      indexId: e,
      tableId: o.tableId
    });
}, Yk = (e) => function* ({ collections: t }) {
  const n = y(t).collection("indexColumnEntities").selectById(e);
  n && (yield Hc({
    id: e,
    indexId: n.indexId,
    columnId: n.columnId,
    value: n.orderType === Io.ASC ? Io.DESC : Io.ASC
  }));
}, Kk = (e, t) => function* ({ collections: n }) {
  if (e === t) return;
  const o = y(n).collection("indexColumnEntities").selectById(e);
  if (!o) return;
  const r = y(n).collection("indexEntities").selectById(o.indexId);
  r && (yield Zc({
    id: e,
    indexId: o.indexId,
    tableId: r.tableId,
    targetId: t
  }));
}, Qk = {
  addIndexColumnAction$: zk,
  removeIndexColumnAction$: Gk,
  changeIndexColumnOrderTypeAction$: Yk,
  moveIndexColumnAction$: Kk
}, Jk = {};
function Yp({
  editor: { viewport: e },
  settings: { scrollLeft: t, scrollTop: n, zoomLevel: o, width: r, height: s }
}, i) {
  const a = Al(r, s, o), l = Al(r, s, i), c = (a.w - l.w) / 2, u = (a.h - l.h) / 2, d = r / 2, m = s / 2, f = t * -1 + e.width / 2, p = n * -1 + e.height / 2, v = (d - f) / d, I = (m - p) / m, g = dt(-1 * c * v, 4), b = dt(-1 * u * I, 4);
  return { movementX: g, movementY: b };
}
const Xk = (e) => function* (t) {
  const {
    settings: { scrollLeft: n, scrollTop: o }
  } = t, r = Ia(e), { movementX: s, movementY: i } = Yp(t, r);
  yield Gc({ value: e }), yield Yc({
    scrollLeft: n + s,
    scrollTop: o + i
  });
}, e2 = (e) => function* (t) {
  const {
    settings: { zoomLevel: n }
  } = t, o = Ia(n + e), { movementX: r, movementY: s } = Yp(t, o);
  yield Fr({ value: e }), yield jr({
    movementX: r,
    movementY: s
  });
}, t2 = {
  changeZoomLevelAction$: Xk,
  streamZoomLevelAction$: e2
}, RR = Object.freeze({
  ...RA,
  ...jk,
  ...zA,
  ...Hk,
  ...rN,
  ...Qk,
  ...bN,
  ...O$,
  ...LN,
  ...Jk,
  ...pM,
  ...t2,
  ...WM,
  ...$$,
  ...c$,
  ...P$
}), Kp = [
  // table
  "table.add",
  "table.move",
  "table.moveTo",
  "table.remove",
  "table.changeName",
  "table.changeComment",
  "table.changeColor",
  "table.sort",
  // column
  "column.add",
  "column.remove",
  "column.changeName",
  "column.changeComment",
  "column.changeDataType",
  "column.changeDefault",
  "column.changeAutoIncrement",
  "column.changePrimaryKey",
  "column.changeUnique",
  "column.changeNotNull",
  "column.move",
  // relationship
  "relationship.add",
  "relationship.remove",
  "relationship.changeType",
  // index
  "index.add",
  "index.remove",
  "index.changeName",
  "index.changeUnique",
  // indexColumn
  "indexColumn.add",
  "indexColumn.remove",
  "indexColumn.move",
  "indexColumn.changeOrderType",
  // memo
  "memo.add",
  "memo.move",
  "memo.moveTo",
  "memo.remove",
  "memo.changeValue",
  "memo.changeColor",
  "memo.resize",
  // settings
  "settings.changeDatabaseName",
  "settings.resize",
  "settings.changeZoomLevel",
  "settings.streamZoomLevel",
  "settings.scrollTo",
  "settings.streamScrollTo",
  "settings.changeShow",
  "settings.changeDatabase",
  "settings.changeCanvasType",
  "settings.changeLanguage",
  "settings.changeTableNameCase",
  "settings.changeColumnNameCase",
  "settings.changeBracketType",
  "settings.changeRelationshipDataTypeSync",
  "settings.changeRelationshipOptimization",
  "settings.changeColumnOrder",
  "settings.changeMaxWidthComment",
  "settings.changeIgnoreSaveSettings",
  // editor
  "editor.loadJson",
  "editor.clear"
], n2 = B([
  "settings.changeZoomLevel",
  "settings.streamZoomLevel",
  "settings.scrollTo",
  "settings.streamScrollTo",
  "settings.changeDatabase",
  "settings.changeCanvasType",
  "settings.changeLanguage",
  "settings.changeTableNameCase",
  "settings.changeColumnNameCase",
  "settings.changeBracketType"
]), _R = [
  ...Kp.filter((e) => !n2(e))
], au = [
  "editor.sharedMouseTracker"
], PR = [
  ...Kp,
  ...au,
  "editor.getLWW",
  "editor.mergeLWW"
], BR = [
  "settings.changeZoomLevel",
  "settings.streamZoomLevel",
  "settings.scrollTo",
  "settings.streamScrollTo",
  "settings.changeCanvasType"
], o2 = [
  "table.move",
  "memo.move"
], r2 = [
  "table.changeColor",
  "memo.changeColor"
], s2 = [
  "settings.streamZoomLevel",
  "settings.streamScrollTo"
], lu = [
  ...Object.keys(ts)
], WR = [
  ...Object.keys(Ap),
  ...lu
];
var os;
class i2 {
  constructor() {
    wu(this, os, 0);
    Ns(this, "getVersion", () => Tu(this, os));
    Ns(this, "getNextVersion", () => this.getVersion() + 1);
    Ns(this, "merge", (t) => Cm(t) ? (this.getVersion() < t && Cu(this, os, t), this) : this);
  }
}
os = new WeakMap();
function UR(e) {
  return {
    ...e,
    clock: new i2()
  };
}
const Qp = GE(
  (e) => !!e.length
), VR = (e) => {
  const t = B(e);
  return (n) => new nt(
    (o) => n.subscribe({
      next: (r) => o.next(r.filter((s) => t(s.type))),
      error: (r) => o.error(r),
      complete: () => o.complete()
    })
  ).pipe(Qp);
}, Jp = "@@none-stream", a2 = (e, t) => (n) => {
  const o = t.find(([, r]) => r(n));
  return o ? o[0] : e(n) ? n : Jp;
}, jd = (e, t = [], n = KE(200)) => {
  const o = B(e), r = t.map(([i, a]) => [
    i,
    B(a)
  ]), s = a2(o, r);
  return (i) => new nt(
    (a) => i.subscribe({
      next: (l) => {
        const c = l.reduce(
          (u, d) => {
            const m = s(d.type);
            return u[m] || (u[m] = []), u[m].push(d), u;
          },
          {}
        );
        Object.values(c).forEach((u) => a.next(u));
      },
      error: (l) => a.error(l),
      complete: () => a.complete()
    })
  ).pipe(
    Qp,
    QE((a) => s(a[0].type)),
    qh(
      (a) => a.key === Jp ? a : a.pipe(
        YE(a.pipe(n)),
        Vi((l) => l.flat())
      )
    )
  );
}, l2 = B(lu), c2 = B(au), FR = (e) => e.pipe(
  jd(au, [], XE(100)),
  Vi(
    (t) => {
      var n;
      return c2((n = t[0]) == null ? void 0 : n.type) ? [Po(t)] : t;
    }
  ),
  jd(lu, [
    ["@@move", o2],
    ["@@scroll", s2],
    ["@@color", r2]
  ]),
  Vi((t) => {
    var o;
    if (!l2((o = t[0]) == null ? void 0 : o.type))
      return t;
    const n = [];
    for (const r of Object.keys(ts))
      ts[r]([], n, t);
    return n.length ? n : t;
  })
);
function jR(e, t) {
  return iE({
    context: e,
    state: {
      ...Un({}),
      editor: Rx(),
      lww: {}
    },
    reducers: {
      ...LA,
      ...BM,
      ...l$,
      ...vN,
      ...DN,
      ...hM,
      ...HA,
      ...oN
    },
    enableObservable: t ?? !0
  });
}
var Xp = (e) => {
  throw TypeError(e);
}, cu = (e, t, n) => t.has(e) || Xp("Cannot " + n), Y = (e, t, n) => (cu(e, t, "read from private field"), n ? n.call(e) : t.get(e)), Cn = (e, t, n) => t.has(e) ? Xp("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), Zr = (e, t, n, o) => (cu(e, t, "write to private field"), t.set(e, n), n), kl = (e, t, n) => (cu(e, t, "access private method"), n);
/*!
 * @dineug/go
 * @version 0.1.8 | Thu Oct 15 2026
 * @author SeungHwan-Lee <dineug2@gmail.com>
 * @license MIT
 */
const u2 = {
  limit: -1,
  leading: !1,
  trailing: !1
};
var Ne, Tn, Dl, ey;
class d2 {
  constructor(t) {
    Cn(this, Dl), Cn(this, Ne, []), Cn(this, Tn), Zr(this, Tn, Object.assign({}, u2, {
      ...t
    }));
  }
  isEmpty() {
    return !Y(this, Ne).length;
  }
  put(t) {
    Y(this, Ne).push(t), kl(this, Dl, ey).call(this);
  }
  take() {
    return Y(this, Ne).shift();
  }
  flush() {
    const t = Y(this, Ne);
    return Zr(this, Ne, []), t;
  }
  drop(t) {
    const n = Y(this, Ne).findIndex(t);
    if (n === -1) return !1;
    const o = Y(this, Ne).slice();
    return o.splice(n, 1), Zr(this, Ne, o), !0;
  }
}
Ne = /* @__PURE__ */ new WeakMap(), Tn = /* @__PURE__ */ new WeakMap(), Dl = /* @__PURE__ */ new WeakSet(), ey = function() {
  Y(this, Tn).limit !== -1 && Y(this, Tn).limit < Y(this, Ne).length && (Y(this, Tn).trailing ? Y(this, Ne).pop() : Y(this, Tn).leading ? Y(this, Ne).shift() : Y(this, Ne).pop());
};
const f2 = (e) => new d2(e), qd = {
  limitBuffer: f2
}, Qa = Symbol.for("https://github.com/dineug/go.git#closed");
var Sn, On, In, xi, Ll;
class m2 {
  constructor(t = qd.limitBuffer()) {
    Cn(this, xi), Cn(this, Sn), Cn(this, On, qd.limitBuffer()), Cn(this, In, !1), Zr(this, Sn, t);
  }
  get closed() {
    return Y(this, In);
  }
  put(t) {
    Y(this, In) || (Y(this, Sn).put(t), kl(this, xi, Ll).call(this));
  }
  take(t, n) {
    return Y(this, In) ? (n == null || n(Qa), () => !1) : (Y(this, On).put([t, n]), kl(this, xi, Ll).call(this), () => Y(this, On).drop(([o]) => o === t));
  }
  flush(t, n) {
    if (Y(this, In)) {
      n == null || n(Qa);
      return;
    }
    t(Y(this, Sn).flush());
  }
  close() {
    Zr(this, In, !0), Y(this, On).flush().forEach(([t, n]) => n == null ? void 0 : n(Qa));
  }
}
Sn = /* @__PURE__ */ new WeakMap(), On = /* @__PURE__ */ new WeakMap(), In = /* @__PURE__ */ new WeakMap(), xi = /* @__PURE__ */ new WeakSet(), Ll = function() {
  if (Y(this, On).isEmpty() || Y(this, Sn).isEmpty())
    return;
  const [e] = Y(this, On).take(), t = Y(this, Sn).take();
  e == null || e(t);
};
const h2 = (e) => new m2(e), ty = (e) => (t) => typeof t === e, p2 = ty("object"), So = ty("function"), y2 = (e) => e === null, { isArray: Qi } = Array, Ma = (e) => p2(e) && !y2(e) && !Qi(e), ny = (e) => Ma(e) && So(e.then), oy = (e) => Ma(e) && So(e.next), g2 = (e) => Ma(e) && So(e.next) && So(e.throw) && So(e.return), uu = Symbol.for("https://github.com/dineug/go.git#cancel"), ry = Symbol.for(
  "https://github.com/dineug/go.git#attachCancel"
), sy = (e, t) => (Reflect.set(e, ry, t), e), v2 = (e) => e === uu, iy = (e) => {
  if (Ma(e)) {
    const t = Reflect.get(e, ry);
    t == null || t();
  }
  return Qe(() => new Promise((t, n) => n(uu)));
}, ay = (e) => Qe(function* () {
  let t = () => !1;
  const n = new Promise((o, r) => {
    t = e.take(o, r);
  });
  return sy(n, () => {
    t();
  }), yield n;
}), qR = (e) => Qe(() => new Promise((t) => setTimeout(t, e))), b2 = Symbol.for("https://github.com/dineug/go.git#kill"), I2 = (e) => e === b2, T2 = (e, t) => {
  e.put(t);
}, $a = (e, t) => Qe(function* () {
  for (; ; ) {
    const n = yield ay(e);
    Qe(t, n);
  }
}), w2 = {
  leading: !0,
  trailing: !1
}, ka = (e, t, n, o) => Qe(function* () {
  const r = Object.assign({}, w2, {
    ...o
  });
  let s = -1, i, a;
  for (; ; ) {
    const l = yield ay(e);
    a = l, s === -1 && (r.leading && (i = l, Qe(t, l)), s = setTimeout(() => {
      r.trailing && (!r.leading || i !== a) && Qe(t, a), s = -1;
    }, n));
  }
});
function Qe(e, ...t) {
  let n = !1, o = null;
  const r = new Promise(async (s, i) => {
    let a = null;
    o = () => {
      i(uu), a == null || a.forEach(iy), a = null;
    };
    try {
      const l = e(...t);
      if (ny(l))
        return a = [l], s(await l);
      if (!oy(l))
        return s(l);
      let c = await l.next(), u;
      for (; !n && !c.done; ) {
        try {
          const d = C2(c.value);
          a = Qi(d) ? d : [d], u = await (Qi(d) ? Promise.all(d) : d), c = await l.next(u);
        } catch (d) {
          if (I2(d))
            throw d;
          g2(l) && (c = await l.throw(d));
        }
        u = void 0, a = null;
      }
      s(c.value);
    } catch (l) {
      v2(l) && (n = !0), i(l);
    }
  });
  return r.catch(() => {
  }), sy(r, () => {
    n = !0, o == null || o();
  }), r;
}
function C2(e) {
  return ny(e) ? e : oy(e) ? Qe(() => e) : So(e) ? Qe(e) : Qi(e) ? e.map((t) => Qe(() => t)) : Promise.resolve();
}
const oe = {
  left: "left",
  right: "right",
  top: "top",
  bottom: "bottom"
}, Rl = Object.values(oe);
B([
  oe.top,
  oe.bottom,
  oe.left,
  oe.right
]);
const S2 = 30, ZR = S2 + 20, HR = 35, zR = 10, GR = 16, YR = 26;
function O2(e, t) {
  const n = Qc(t, e).width, o = Gi(t), { x: r, y: s } = t.ui;
  return {
    width: n,
    height: o,
    top: {
      x: r + n / 2,
      y: s
    },
    bottom: {
      x: r + n / 2,
      y: s + o
    },
    left: {
      x: r,
      y: s + o / 2
    },
    right: {
      x: r + n,
      y: s + o / 2
    },
    lt: {
      x: r,
      y: s
    },
    rt: {
      x: r + n,
      y: s
    },
    lb: {
      x: r,
      y: s + o
    },
    rb: {
      x: r + n,
      y: s + o
    }
  };
}
function Zd(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
const Hd = {
  [oe.top]: Tt.top,
  [oe.bottom]: Tt.bottom,
  [oe.left]: Tt.left,
  [oe.right]: Tt.right
};
function ly(e) {
  const {
    doc: { tableIds: t, relationshipIds: n },
    collections: o
  } = e, r = B(t), s = y(o).collection("tableEntities"), i = y(o).collection("relationshipEntities").selectByIds(n).filter(
    ({ start: c, end: u }) => r(c.tableId) && r(u.tableId)
  ), a = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map();
  for (const c of i) {
    const u = E2(c), { start: d, end: m } = u, f = s.selectById(d.tableId), p = s.selectById(m.tableId);
    if (!(!f || !p))
      if (l.set(c, u), d.tableId === m.tableId) {
        d.direction = Tt.top, m.direction = Tt.right;
        const v = Ja(e, a, f);
        d.x = v.objectPoint.rt.x - 20, d.y = v.objectPoint.rt.y, m.x = v.objectPoint.rt.x, m.y = v.objectPoint.rt.y + 20, v.top.set(u.id, u), v.right.set(u.id, u);
      } else {
        const v = Ja(e, a, f), I = Ja(e, a, p), [g, b] = x2(
          v.objectPoint,
          I.objectPoint,
          u
        );
        v[g].set(u.id, u), I[b].set(u.id, u);
      }
  }
  for (const c of a.values())
    for (const u of Rl) {
      const d = u;
      c[d].size < 2 || A2(d, c);
    }
  for (const [c, u] of l.entries())
    c.start.direction = u.start.direction, c.start.x = u.start.x, c.start.y = u.start.y, c.end.direction = u.end.direction, c.end.x = u.end.x, c.end.y = u.end.y;
}
function Ja(e, t, n) {
  let o = t.get(n.id);
  return o || (o = {
    tableId: n.id,
    objectPoint: O2(e, n),
    top: /* @__PURE__ */ new Map(),
    bottom: /* @__PURE__ */ new Map(),
    left: /* @__PURE__ */ new Map(),
    right: /* @__PURE__ */ new Map()
  }, t.set(n.id, o)), o;
}
function E2(e) {
  return {
    id: e.id,
    start: {
      tableId: e.start.tableId,
      x: e.start.x,
      y: e.start.y,
      direction: e.start.direction
    },
    end: {
      tableId: e.end.tableId,
      x: e.end.x,
      y: e.end.y,
      direction: e.end.direction
    }
  };
}
function x2(e, t, n) {
  const o = [
    oe.bottom,
    oe.bottom
  ];
  let r = Zd(e.bottom, t.bottom);
  n.start.x = e.bottom.x, n.start.y = e.bottom.y, n.end.x = t.bottom.x, n.end.y = t.bottom.y, n.start.direction = Tt.bottom, n.end.direction = Tt.bottom;
  for (const s of Rl)
    for (const i of Rl) {
      const a = s, l = i, c = Zd(e[a], t[l]);
      r <= c || (r = c, o[0] = a, o[1] = l, n.start.x = e[a].x, n.start.y = e[a].y, n.start.direction = Hd[a], n.end.x = t[l].x, n.end.y = t[l].y, n.end.direction = Hd[l]);
    }
  return o;
}
function A2(e, t) {
  const n = N2(e, t), o = M2(e, t);
  e === oe.left || e === oe.right ? n.yArray.forEach((r, s) => {
    o[s].start.y = r;
  }) : (e === oe.top || e === oe.bottom) && n.xArray.forEach((r, s) => {
    o[s].start.x = r;
  });
}
function N2(e, t) {
  const n = t[e].size, o = {
    x: t.objectPoint.width / n,
    y: t.objectPoint.height / n
  }, r = {
    x: o.x / 2,
    y: o.y / 2
  }, s = [], i = [];
  if (e === oe.left || e === oe.right) {
    let a = t.objectPoint.lt.y - r.y;
    for (let l = 0; l < n; l++)
      a += o.y, i.push(a);
  } else if (e === oe.top || e === oe.bottom) {
    let a = t.objectPoint.lt.x - r.x;
    for (let l = 0; l < n; l++)
      a += o.x, s.push(a);
  }
  return {
    xArray: s,
    yArray: i
  };
}
function M2(e, t) {
  const n = [], o = [], r = [], s = e === oe.top || e === oe.bottom;
  for (const i of t[e].values()) {
    const { start: a, end: l } = i;
    a.tableId === l.tableId ? e === oe.top ? (n.push(i.start), o.push(i.end)) : e === oe.right && (n.push(i.end), o.push(i.start)) : i.start.tableId === t.tableId ? (n.push(i.start), o.push(i.end)) : (n.push(i.end), o.push(i.start));
  }
  return o.forEach((i, a) => {
    r.push({
      start: n[a],
      end: o[a],
      distance: s ? i.x : i.y
    });
  }), r.sort((i, a) => i.distance - a.distance);
}
const $2 = function* (e, t) {
  yield ka(
    e,
    function* () {
      const { doc: n, collections: o } = t(), s = y(o).collection("relationshipEntities").selectByIds(n.relationshipIds);
      for (const i of s) {
        const { end: a, identification: l } = i, c = y(o).collection("tableEntities").selectById(a.tableId);
        if (!c) continue;
        const u = B(c.columnIds), d = y(o).collection("tableColumnEntities").selectByIds(a.columnIds).filter((f) => u(f.id));
        if (!d.length) continue;
        const m = d.every(
          (f) => $(f.options, V.primaryKey)
        );
        m !== l && (i.identification = m);
      }
    },
    10,
    { leading: !1, trailing: !0 }
  );
}, k2 = function* (e, t) {
  yield ka(
    e,
    function* () {
      const { doc: n, collections: o } = t(), s = y(o).collection("relationshipEntities").selectByIds(n.relationshipIds);
      for (const i of s) {
        const { end: a, startRelationshipType: l } = i, c = y(o).collection("tableEntities").selectById(a.tableId);
        if (!c) continue;
        const u = B(c.columnIds), d = y(o).collection("tableColumnEntities").selectByIds(a.columnIds).filter((f) => u(f.id));
        if (!d.length) continue;
        const m = d.every(
          (f) => $(f.options, V.notNull)
        ) ? xl.dash : xl.ring;
        m !== l && (i.startRelationshipType = m);
      }
    },
    10,
    { leading: !1, trailing: !0 }
  );
}, D2 = function* (e, t) {
  yield ka(
    e,
    function* () {
      ly(t());
    },
    5,
    { leading: !1, trailing: !0 }
  );
}, L2 = [
  [
    [
      Co,
      zn,
      on,
      $o
    ],
    $2
  ],
  [
    [
      Co,
      Pt,
      on,
      $o
    ],
    k2
  ],
  [
    [
      Kc,
      Ep,
      Ts,
      To,
      wo,
      Xc,
      eu,
      tu,
      Ot,
      Co,
      Dt,
      Lt,
      Rt,
      _t,
      nu
    ],
    D2
  ]
], R2 = function* (e, t, n) {
  yield ka(
    e,
    function* () {
      const o = t();
      AM(o, n), ly(o);
    },
    5,
    { leading: !1, trailing: !0 }
  );
}, _2 = [
  [[on, $o], R2]
], P2 = function* (e, t) {
  yield $a(
    e,
    function* ({
      payload: { id: n }
    }) {
      const { collections: o } = t(), s = y(o).collection("tableColumnEntities").selectById(n);
      !s || !$(s.options, V.primaryKey) || $(s.options, V.notNull) || (s.options = s.options | V.notNull);
    }
  );
}, B2 = function* (e, t) {
  yield $a(
    e,
    function* ({
      payload: { id: n, end: o }
    }) {
      const {
        doc: { relationshipIds: r },
        collections: s
      } = t();
      if (!r.includes(n)) return;
      const i = y(s).collection("tableColumnEntities").selectByIds(o.columnIds);
      for (const a of i)
        a.ui.keys = a.ui.keys | bt.foreignKey;
    }
  );
}, W2 = function* (e, t) {
  yield $a(
    e,
    function* ({
      payload: { id: n }
    }) {
      const {
        doc: { relationshipIds: o },
        collections: r
      } = t();
      if (o.includes(n)) return;
      const s = y(r).collection("relationshipEntities").selectById(n);
      if (!s) return;
      const i = y(r).collection("tableColumnEntities").selectByIds(s.end.columnIds);
      for (const a of i)
        a.ui.keys = a.ui.keys & -3;
    }
  );
}, U2 = function* (e, t) {
  yield $a(e, function* () {
    const { doc: n, collections: o } = t(), r = y(o).collection("relationshipEntities").selectByIds(n.relationshipIds), s = y(o).collection("tableEntities").selectByIds(n.tableIds), i = /* @__PURE__ */ new Set(), a = y(o).collection(
      "tableColumnEntities"
    );
    for (const { end: l } of r) {
      const c = a.selectByIds(l.columnIds);
      for (const u of c)
        u.ui.keys = u.ui.keys | bt.foreignKey, i.add(u.id);
    }
    for (const l of s) {
      const c = a.selectByIds(l.columnIds);
      for (const u of c)
        $(u.ui.keys, bt.foreignKey) && !i.has(u.id) && (u.ui.keys = u.ui.keys & -3);
    }
  });
}, V2 = [
  [[zn], P2],
  [[Ts], B2],
  [[ko], W2],
  [[on, $o], U2]
], F2 = [..._2, ...V2, ...L2];
function KR(e) {
  const t = () => e.state, n = F2.map(([s, i]) => {
    const a = h2();
    return {
      pattern: B(s.map(String)),
      channel: a,
      proc: Qe(i, a, t, e.context)
    };
  }), o = e.subscribe((s) => {
    for (const i of s)
      for (const a of n)
        a.pattern(i.type) && T2(a.channel, i);
  });
  return { destroy: () => {
    n.forEach(({ proc: s }) => iy(s)), n.splice(0, n.length), o();
  } };
}
class Yn extends Error {
}
class j2 extends Yn {
  constructor(t) {
    super(`Invalid DateTime: ${t.toMessage()}`);
  }
}
class q2 extends Yn {
  constructor(t) {
    super(`Invalid Interval: ${t.toMessage()}`);
  }
}
class Z2 extends Yn {
  constructor(t) {
    super(`Invalid Duration: ${t.toMessage()}`);
  }
}
class ho extends Yn {
}
class cy extends Yn {
  constructor(t) {
    super(`Invalid unit ${t}`);
  }
}
class Me extends Yn {
}
class zt extends Yn {
  constructor() {
    super("Zone is an abstract class");
  }
}
const E = "numeric", mt = "short", Pe = "long", Ji = {
  year: E,
  month: E,
  day: E
}, uy = {
  year: E,
  month: mt,
  day: E
}, H2 = {
  year: E,
  month: mt,
  day: E,
  weekday: mt
}, dy = {
  year: E,
  month: Pe,
  day: E
}, fy = {
  year: E,
  month: Pe,
  day: E,
  weekday: Pe
}, my = {
  hour: E,
  minute: E
}, hy = {
  hour: E,
  minute: E,
  second: E
}, py = {
  hour: E,
  minute: E,
  second: E,
  timeZoneName: mt
}, yy = {
  hour: E,
  minute: E,
  second: E,
  timeZoneName: Pe
}, gy = {
  hour: E,
  minute: E,
  hourCycle: "h23"
}, vy = {
  hour: E,
  minute: E,
  second: E,
  hourCycle: "h23"
}, by = {
  hour: E,
  minute: E,
  second: E,
  hourCycle: "h23",
  timeZoneName: mt
}, Iy = {
  hour: E,
  minute: E,
  second: E,
  hourCycle: "h23",
  timeZoneName: Pe
}, Ty = {
  year: E,
  month: E,
  day: E,
  hour: E,
  minute: E
}, wy = {
  year: E,
  month: E,
  day: E,
  hour: E,
  minute: E,
  second: E
}, Cy = {
  year: E,
  month: mt,
  day: E,
  hour: E,
  minute: E
}, Sy = {
  year: E,
  month: mt,
  day: E,
  hour: E,
  minute: E,
  second: E
}, z2 = {
  year: E,
  month: mt,
  day: E,
  weekday: mt,
  hour: E,
  minute: E
}, Oy = {
  year: E,
  month: Pe,
  day: E,
  hour: E,
  minute: E,
  timeZoneName: mt
}, Ey = {
  year: E,
  month: Pe,
  day: E,
  hour: E,
  minute: E,
  second: E,
  timeZoneName: mt
}, xy = {
  year: E,
  month: Pe,
  day: E,
  weekday: Pe,
  hour: E,
  minute: E,
  timeZoneName: Pe
}, Ay = {
  year: E,
  month: Pe,
  day: E,
  weekday: Pe,
  hour: E,
  minute: E,
  second: E,
  timeZoneName: Pe
};
class Os {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new zt();
  }
  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new zt();
  }
  get ianaName() {
    return this.name;
  }
  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new zt();
  }
  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(t, n) {
    throw new zt();
  }
  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(t, n) {
    throw new zt();
  }
  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(t) {
    throw new zt();
  }
  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(t) {
    throw new zt();
  }
  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new zt();
  }
}
let Xa = null;
class Da extends Os {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    return Xa === null && (Xa = new Da()), Xa;
  }
  /** @override **/
  get type() {
    return "system";
  }
  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: o }) {
    return Py(t, n, o);
  }
  /** @override **/
  formatOffset(t, n) {
    return Hr(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    return -new Date(t).getTimezoneOffset();
  }
  /** @override **/
  equals(t) {
    return t.type === "system";
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
let Ai = {};
function G2(e) {
  return Ai[e] || (Ai[e] = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    timeZone: e,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    era: "short"
  })), Ai[e];
}
const Y2 = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function K2(e, t) {
  const n = e.format(t).replace(/\u200E/g, ""), o = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(n), [, r, s, i, a, l, c, u] = o;
  return [i, r, s, a, l, c, u];
}
function Q2(e, t) {
  const n = e.formatToParts(t), o = [];
  for (let r = 0; r < n.length; r++) {
    const { type: s, value: i } = n[r], a = Y2[s];
    s === "era" ? o[a] = i : k(a) || (o[a] = parseInt(i, 10));
  }
  return o;
}
let Us = {};
class Ut extends Os {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(t) {
    return Us[t] || (Us[t] = new Ut(t)), Us[t];
  }
  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    Us = {}, Ai = {};
  }
  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */
  static isValidSpecifier(t) {
    return this.isValidZone(t);
  }
  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(t) {
    if (!t)
      return !1;
    try {
      return new Intl.DateTimeFormat("en-US", { timeZone: t }).format(), !0;
    } catch {
      return !1;
    }
  }
  constructor(t) {
    super(), this.zoneName = t, this.valid = Ut.isValidZone(t);
  }
  /** @override **/
  get type() {
    return "iana";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName(t, { format: n, locale: o }) {
    return Py(t, n, o, this.name);
  }
  /** @override **/
  formatOffset(t, n) {
    return Hr(this.offset(t), n);
  }
  /** @override **/
  offset(t) {
    const n = new Date(t);
    if (isNaN(n)) return NaN;
    const o = G2(this.name);
    let [r, s, i, a, l, c, u] = o.formatToParts ? Q2(o, n) : K2(o, n);
    a === "BC" && (r = -Math.abs(r) + 1);
    const m = Ra({
      year: r,
      month: s,
      day: i,
      hour: l === 24 ? 0 : l,
      minute: c,
      second: u,
      millisecond: 0
    });
    let f = +n;
    const p = f % 1e3;
    return f -= p >= 0 ? p : 1e3 + p, (m - f) / (60 * 1e3);
  }
  /** @override **/
  equals(t) {
    return t.type === "iana" && t.name === this.name;
  }
  /** @override **/
  get isValid() {
    return this.valid;
  }
}
let zd = {};
function J2(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let o = zd[n];
  return o || (o = new Intl.ListFormat(e, t), zd[n] = o), o;
}
let _l = {};
function Pl(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let o = _l[n];
  return o || (o = new Intl.DateTimeFormat(e, t), _l[n] = o), o;
}
let Bl = {};
function X2(e, t = {}) {
  const n = JSON.stringify([e, t]);
  let o = Bl[n];
  return o || (o = new Intl.NumberFormat(e, t), Bl[n] = o), o;
}
let Wl = {};
function eD(e, t = {}) {
  const { base: n, ...o } = t, r = JSON.stringify([e, o]);
  let s = Wl[r];
  return s || (s = new Intl.RelativeTimeFormat(e, t), Wl[r] = s), s;
}
let Pr = null;
function tD() {
  return Pr || (Pr = new Intl.DateTimeFormat().resolvedOptions().locale, Pr);
}
let Gd = {};
function nD(e) {
  let t = Gd[e];
  if (!t) {
    const n = new Intl.Locale(e);
    t = "getWeekInfo" in n ? n.getWeekInfo() : n.weekInfo, Gd[e] = t;
  }
  return t;
}
function oD(e) {
  const t = e.indexOf("-x-");
  t !== -1 && (e = e.substring(0, t));
  const n = e.indexOf("-u-");
  if (n === -1)
    return [e];
  {
    let o, r;
    try {
      o = Pl(e).resolvedOptions(), r = e;
    } catch {
      const l = e.substring(0, n);
      o = Pl(l).resolvedOptions(), r = l;
    }
    const { numberingSystem: s, calendar: i } = o;
    return [r, s, i];
  }
}
function rD(e, t, n) {
  return (n || t) && (e.includes("-u-") || (e += "-u"), n && (e += `-ca-${n}`), t && (e += `-nu-${t}`)), e;
}
function sD(e) {
  const t = [];
  for (let n = 1; n <= 12; n++) {
    const o = D.utc(2009, n, 1);
    t.push(e(o));
  }
  return t;
}
function iD(e) {
  const t = [];
  for (let n = 1; n <= 7; n++) {
    const o = D.utc(2016, 11, 13 + n);
    t.push(e(o));
  }
  return t;
}
function Vs(e, t, n, o) {
  const r = e.listingMode();
  return r === "error" ? null : r === "en" ? n(t) : o(t);
}
function aD(e) {
  return e.numberingSystem && e.numberingSystem !== "latn" ? !1 : e.numberingSystem === "latn" || !e.locale || e.locale.startsWith("en") || new Intl.DateTimeFormat(e.intl).resolvedOptions().numberingSystem === "latn";
}
class lD {
  constructor(t, n, o) {
    this.padTo = o.padTo || 0, this.floor = o.floor || !1;
    const { padTo: r, floor: s, ...i } = o;
    if (!n || Object.keys(i).length > 0) {
      const a = { useGrouping: !1, ...o };
      o.padTo > 0 && (a.minimumIntegerDigits = o.padTo), this.inf = X2(t, a);
    }
  }
  format(t) {
    if (this.inf) {
      const n = this.floor ? Math.floor(t) : t;
      return this.inf.format(n);
    } else {
      const n = this.floor ? Math.floor(t) : hu(t, 3);
      return fe(n, this.padTo);
    }
  }
}
class cD {
  constructor(t, n, o) {
    this.opts = o, this.originalZone = void 0;
    let r;
    if (this.opts.timeZone)
      this.dt = t;
    else if (t.zone.type === "fixed") {
      const i = -1 * (t.offset / 60), a = i >= 0 ? `Etc/GMT+${i}` : `Etc/GMT${i}`;
      t.offset !== 0 && Ut.create(a).valid ? (r = a, this.dt = t) : (r = "UTC", this.dt = t.offset === 0 ? t : t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    } else t.zone.type === "system" ? this.dt = t : t.zone.type === "iana" ? (this.dt = t, r = t.zone.name) : (r = "UTC", this.dt = t.setZone("UTC").plus({ minutes: t.offset }), this.originalZone = t.zone);
    const s = { ...this.opts };
    s.timeZone = s.timeZone || r, this.dtf = Pl(n, s);
  }
  format() {
    return this.originalZone ? this.formatToParts().map(({ value: t }) => t).join("") : this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const t = this.dtf.formatToParts(this.dt.toJSDate());
    return this.originalZone ? t.map((n) => {
      if (n.type === "timeZoneName") {
        const o = this.originalZone.offsetName(this.dt.ts, {
          locale: this.dt.locale,
          format: this.opts.timeZoneName
        });
        return {
          ...n,
          value: o
        };
      } else
        return n;
    }) : t;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}
class uD {
  constructor(t, n, o) {
    this.opts = { style: "long", ...o }, !n && Ry() && (this.rtf = eD(t, o));
  }
  format(t, n) {
    return this.rtf ? this.rtf.format(t, n) : MD(n, t, this.opts.numeric, this.opts.style !== "long");
  }
  formatToParts(t, n) {
    return this.rtf ? this.rtf.formatToParts(t, n) : [];
  }
}
const dD = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};
class G {
  static fromOpts(t) {
    return G.create(
      t.locale,
      t.numberingSystem,
      t.outputCalendar,
      t.weekSettings,
      t.defaultToEN
    );
  }
  static create(t, n, o, r, s = !1) {
    const i = t || ce.defaultLocale, a = i || (s ? "en-US" : tD()), l = n || ce.defaultNumberingSystem, c = o || ce.defaultOutputCalendar, u = Ul(r) || ce.defaultWeekSettings;
    return new G(a, l, c, u, i);
  }
  static resetCache() {
    Pr = null, _l = {}, Bl = {}, Wl = {};
  }
  static fromObject({ locale: t, numberingSystem: n, outputCalendar: o, weekSettings: r } = {}) {
    return G.create(t, n, o, r);
  }
  constructor(t, n, o, r, s) {
    const [i, a, l] = oD(t);
    this.locale = i, this.numberingSystem = n || a || null, this.outputCalendar = o || l || null, this.weekSettings = r, this.intl = rD(this.locale, this.numberingSystem, this.outputCalendar), this.weekdaysCache = { format: {}, standalone: {} }, this.monthsCache = { format: {}, standalone: {} }, this.meridiemCache = null, this.eraCache = {}, this.specifiedLocale = s, this.fastNumbersCached = null;
  }
  get fastNumbers() {
    return this.fastNumbersCached == null && (this.fastNumbersCached = aD(this)), this.fastNumbersCached;
  }
  listingMode() {
    const t = this.isEnglish(), n = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return t && n ? "en" : "intl";
  }
  clone(t) {
    return !t || Object.getOwnPropertyNames(t).length === 0 ? this : G.create(
      t.locale || this.specifiedLocale,
      t.numberingSystem || this.numberingSystem,
      t.outputCalendar || this.outputCalendar,
      Ul(t.weekSettings) || this.weekSettings,
      t.defaultToEN || !1
    );
  }
  redefaultToEN(t = {}) {
    return this.clone({ ...t, defaultToEN: !0 });
  }
  redefaultToSystem(t = {}) {
    return this.clone({ ...t, defaultToEN: !1 });
  }
  months(t, n = !1) {
    return Vs(this, t, Uy, () => {
      const o = n ? { month: t, day: "numeric" } : { month: t }, r = n ? "format" : "standalone";
      return this.monthsCache[r][t] || (this.monthsCache[r][t] = sD((s) => this.extract(s, o, "month"))), this.monthsCache[r][t];
    });
  }
  weekdays(t, n = !1) {
    return Vs(this, t, jy, () => {
      const o = n ? { weekday: t, year: "numeric", month: "long", day: "numeric" } : { weekday: t }, r = n ? "format" : "standalone";
      return this.weekdaysCache[r][t] || (this.weekdaysCache[r][t] = iD(
        (s) => this.extract(s, o, "weekday")
      )), this.weekdaysCache[r][t];
    });
  }
  meridiems() {
    return Vs(
      this,
      void 0,
      () => qy,
      () => {
        if (!this.meridiemCache) {
          const t = { hour: "numeric", hourCycle: "h12" };
          this.meridiemCache = [D.utc(2016, 11, 13, 9), D.utc(2016, 11, 13, 19)].map(
            (n) => this.extract(n, t, "dayperiod")
          );
        }
        return this.meridiemCache;
      }
    );
  }
  eras(t) {
    return Vs(this, t, Zy, () => {
      const n = { era: t };
      return this.eraCache[t] || (this.eraCache[t] = [D.utc(-40, 1, 1), D.utc(2017, 1, 1)].map(
        (o) => this.extract(o, n, "era")
      )), this.eraCache[t];
    });
  }
  extract(t, n, o) {
    const r = this.dtFormatter(t, n), s = r.formatToParts(), i = s.find((a) => a.type.toLowerCase() === o);
    return i ? i.value : null;
  }
  numberFormatter(t = {}) {
    return new lD(this.intl, t.forceSimple || this.fastNumbers, t);
  }
  dtFormatter(t, n = {}) {
    return new cD(t, this.intl, n);
  }
  relFormatter(t = {}) {
    return new uD(this.intl, this.isEnglish(), t);
  }
  listFormatter(t = {}) {
    return J2(this.intl, t);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    return this.weekSettings ? this.weekSettings : _y() ? nD(this.locale) : dD;
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(t) {
    return this.locale === t.locale && this.numberingSystem === t.numberingSystem && this.outputCalendar === t.outputCalendar;
  }
}
let el = null;
class Oe extends Os {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    return el === null && (el = new Oe(0)), el;
  }
  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(t) {
    return t === 0 ? Oe.utcInstance : new Oe(t);
  }
  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(t) {
    if (t) {
      const n = t.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (n)
        return new Oe(_a(n[1], n[2]));
    }
    return null;
  }
  constructor(t) {
    super(), this.fixed = t;
  }
  /** @override **/
  get type() {
    return "fixed";
  }
  /** @override **/
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${Hr(this.fixed, "narrow")}`;
  }
  get ianaName() {
    return this.fixed === 0 ? "Etc/UTC" : `Etc/GMT${Hr(-this.fixed, "narrow")}`;
  }
  /** @override **/
  offsetName() {
    return this.name;
  }
  /** @override **/
  formatOffset(t, n) {
    return Hr(this.fixed, n);
  }
  /** @override **/
  get isUniversal() {
    return !0;
  }
  /** @override **/
  offset() {
    return this.fixed;
  }
  /** @override **/
  equals(t) {
    return t.type === "fixed" && t.fixed === this.fixed;
  }
  /** @override **/
  get isValid() {
    return !0;
  }
}
class fD extends Os {
  constructor(t) {
    super(), this.zoneName = t;
  }
  /** @override **/
  get type() {
    return "invalid";
  }
  /** @override **/
  get name() {
    return this.zoneName;
  }
  /** @override **/
  get isUniversal() {
    return !1;
  }
  /** @override **/
  offsetName() {
    return null;
  }
  /** @override **/
  formatOffset() {
    return "";
  }
  /** @override **/
  offset() {
    return NaN;
  }
  /** @override **/
  equals() {
    return !1;
  }
  /** @override **/
  get isValid() {
    return !1;
  }
}
function en(e, t) {
  if (k(e) || e === null)
    return t;
  if (e instanceof Os)
    return e;
  if (pD(e)) {
    const n = e.toLowerCase();
    return n === "default" ? t : n === "local" || n === "system" ? Da.instance : n === "utc" || n === "gmt" ? Oe.utcInstance : Oe.parseSpecifier(n) || Ut.create(e);
  } else return kn(e) ? Oe.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new fD(e);
}
let Yd = () => Date.now(), Kd = "system", Qd = null, Jd = null, Xd = null, ef = 60, tf, nf = null;
class ce {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return Yd;
  }
  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(t) {
    Yd = t;
  }
  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(t) {
    Kd = t;
  }
  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return en(Kd, Da.instance);
  }
  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return Qd;
  }
  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(t) {
    Qd = t;
  }
  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return Jd;
  }
  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(t) {
    Jd = t;
  }
  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return Xd;
  }
  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(t) {
    Xd = t;
  }
  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */
  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return nf;
  }
  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(t) {
    nf = Ul(t);
  }
  /**
   * Get the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return ef;
  }
  /**
   * Set the cutoff year after which a string encoding a year as two digits is interpreted to occur in the current century.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // cut-off year is 0, so all 'yy' are interpreted as current century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 1949; '50' -> 2050
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(t) {
    ef = t % 100;
  }
  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return tf;
  }
  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    tf = t;
  }
  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    G.resetCache(), Ut.resetCache();
  }
}
class ct {
  constructor(t, n) {
    this.reason = t, this.explanation = n;
  }
  toMessage() {
    return this.explanation ? `${this.reason}: ${this.explanation}` : this.reason;
  }
}
const Ny = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], My = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function Ye(e, t) {
  return new ct(
    "unit out of range",
    `you specified ${t} (of type ${typeof t}) as a ${e}, which is invalid`
  );
}
function du(e, t, n) {
  const o = new Date(Date.UTC(e, t - 1, n));
  e < 100 && e >= 0 && o.setUTCFullYear(o.getUTCFullYear() - 1900);
  const r = o.getUTCDay();
  return r === 0 ? 7 : r;
}
function $y(e, t, n) {
  return n + (Es(e) ? My : Ny)[t - 1];
}
function ky(e, t) {
  const n = Es(e) ? My : Ny, o = n.findIndex((s) => s < t), r = t - n[o];
  return { month: o + 1, day: r };
}
function fu(e, t) {
  return (e - t + 7) % 7 + 1;
}
function Xi(e, t = 4, n = 1) {
  const { year: o, month: r, day: s } = e, i = $y(o, r, s), a = fu(du(o, r, s), n);
  let l = Math.floor((i - a + 14 - t) / 7), c;
  return l < 1 ? (c = o - 1, l = ns(c, t, n)) : l > ns(o, t, n) ? (c = o + 1, l = 1) : c = o, { weekYear: c, weekNumber: l, weekday: a, ...Pa(e) };
}
function of(e, t = 4, n = 1) {
  const { weekYear: o, weekNumber: r, weekday: s } = e, i = fu(du(o, 1, t), n), a = Oo(o);
  let l = r * 7 + s - i - 7 + t, c;
  l < 1 ? (c = o - 1, l += Oo(c)) : l > a ? (c = o + 1, l -= Oo(o)) : c = o;
  const { month: u, day: d } = ky(c, l);
  return { year: c, month: u, day: d, ...Pa(e) };
}
function tl(e) {
  const { year: t, month: n, day: o } = e, r = $y(t, n, o);
  return { year: t, ordinal: r, ...Pa(e) };
}
function rf(e) {
  const { year: t, ordinal: n } = e, { month: o, day: r } = ky(t, n);
  return { year: t, month: o, day: r, ...Pa(e) };
}
function sf(e, t) {
  if (!k(e.localWeekday) || !k(e.localWeekNumber) || !k(e.localWeekYear)) {
    if (!k(e.weekday) || !k(e.weekNumber) || !k(e.weekYear))
      throw new ho(
        "Cannot mix locale-based week fields with ISO-based week fields"
      );
    return k(e.localWeekday) || (e.weekday = e.localWeekday), k(e.localWeekNumber) || (e.weekNumber = e.localWeekNumber), k(e.localWeekYear) || (e.weekYear = e.localWeekYear), delete e.localWeekday, delete e.localWeekNumber, delete e.localWeekYear, {
      minDaysInFirstWeek: t.getMinDaysInFirstWeek(),
      startOfWeek: t.getStartOfWeek()
    };
  } else
    return { minDaysInFirstWeek: 4, startOfWeek: 1 };
}
function mD(e, t = 4, n = 1) {
  const o = La(e.weekYear), r = Ke(
    e.weekNumber,
    1,
    ns(e.weekYear, t, n)
  ), s = Ke(e.weekday, 1, 7);
  return o ? r ? s ? !1 : Ye("weekday", e.weekday) : Ye("week", e.weekNumber) : Ye("weekYear", e.weekYear);
}
function hD(e) {
  const t = La(e.year), n = Ke(e.ordinal, 1, Oo(e.year));
  return t ? n ? !1 : Ye("ordinal", e.ordinal) : Ye("year", e.year);
}
function Dy(e) {
  const t = La(e.year), n = Ke(e.month, 1, 12), o = Ke(e.day, 1, ea(e.year, e.month));
  return t ? n ? o ? !1 : Ye("day", e.day) : Ye("month", e.month) : Ye("year", e.year);
}
function Ly(e) {
  const { hour: t, minute: n, second: o, millisecond: r } = e, s = Ke(t, 0, 23) || t === 24 && n === 0 && o === 0 && r === 0, i = Ke(n, 0, 59), a = Ke(o, 0, 59), l = Ke(r, 0, 999);
  return s ? i ? a ? l ? !1 : Ye("millisecond", r) : Ye("second", o) : Ye("minute", n) : Ye("hour", t);
}
function k(e) {
  return typeof e > "u";
}
function kn(e) {
  return typeof e == "number";
}
function La(e) {
  return typeof e == "number" && e % 1 === 0;
}
function pD(e) {
  return typeof e == "string";
}
function yD(e) {
  return Object.prototype.toString.call(e) === "[object Date]";
}
function Ry() {
  try {
    return typeof Intl < "u" && !!Intl.RelativeTimeFormat;
  } catch {
    return !1;
  }
}
function _y() {
  try {
    return typeof Intl < "u" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch {
    return !1;
  }
}
function gD(e) {
  return Array.isArray(e) ? e : [e];
}
function af(e, t, n) {
  if (e.length !== 0)
    return e.reduce((o, r) => {
      const s = [t(r), r];
      return o && n(o[0], s[0]) === o[0] ? o : s;
    }, null)[1];
}
function vD(e, t) {
  return t.reduce((n, o) => (n[o] = e[o], n), {});
}
function Do(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Ul(e) {
  if (e == null)
    return null;
  if (typeof e != "object")
    throw new Me("Week settings must be an object");
  if (!Ke(e.firstDay, 1, 7) || !Ke(e.minimalDays, 1, 7) || !Array.isArray(e.weekend) || e.weekend.some((t) => !Ke(t, 1, 7)))
    throw new Me("Invalid week settings");
  return {
    firstDay: e.firstDay,
    minimalDays: e.minimalDays,
    weekend: Array.from(e.weekend)
  };
}
function Ke(e, t, n) {
  return La(e) && e >= t && e <= n;
}
function bD(e, t) {
  return e - t * Math.floor(e / t);
}
function fe(e, t = 2) {
  const n = e < 0;
  let o;
  return n ? o = "-" + ("" + -e).padStart(t, "0") : o = ("" + e).padStart(t, "0"), o;
}
function Xt(e) {
  if (!(k(e) || e === null || e === ""))
    return parseInt(e, 10);
}
function mn(e) {
  if (!(k(e) || e === null || e === ""))
    return parseFloat(e);
}
function mu(e) {
  if (!(k(e) || e === null || e === "")) {
    const t = parseFloat("0." + e) * 1e3;
    return Math.floor(t);
  }
}
function hu(e, t, n = !1) {
  const o = 10 ** t;
  return (n ? Math.trunc : Math.round)(e * o) / o;
}
function Es(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Oo(e) {
  return Es(e) ? 366 : 365;
}
function ea(e, t) {
  const n = bD(t - 1, 12) + 1, o = e + (t - n) / 12;
  return n === 2 ? Es(o) ? 29 : 28 : [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][n - 1];
}
function Ra(e) {
  let t = Date.UTC(
    e.year,
    e.month - 1,
    e.day,
    e.hour,
    e.minute,
    e.second,
    e.millisecond
  );
  return e.year < 100 && e.year >= 0 && (t = new Date(t), t.setUTCFullYear(e.year, e.month - 1, e.day)), +t;
}
function lf(e, t, n) {
  return -fu(du(e, 1, t), n) + t - 1;
}
function ns(e, t = 4, n = 1) {
  const o = lf(e, t, n), r = lf(e + 1, t, n);
  return (Oo(e) - o + r) / 7;
}
function Vl(e) {
  return e > 99 ? e : e > ce.twoDigitCutoffYear ? 1900 + e : 2e3 + e;
}
function Py(e, t, n, o = null) {
  const r = new Date(e), s = {
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };
  o && (s.timeZone = o);
  const i = { timeZoneName: t, ...s }, a = new Intl.DateTimeFormat(n, i).formatToParts(r).find((l) => l.type.toLowerCase() === "timezonename");
  return a ? a.value : null;
}
function _a(e, t) {
  let n = parseInt(e, 10);
  Number.isNaN(n) && (n = 0);
  const o = parseInt(t, 10) || 0, r = n < 0 || Object.is(n, -0) ? -o : o;
  return n * 60 + r;
}
function By(e) {
  const t = Number(e);
  if (typeof e == "boolean" || e === "" || Number.isNaN(t))
    throw new Me(`Invalid unit value ${e}`);
  return t;
}
function ta(e, t) {
  const n = {};
  for (const o in e)
    if (Do(e, o)) {
      const r = e[o];
      if (r == null) continue;
      n[t(o)] = By(r);
    }
  return n;
}
function Hr(e, t) {
  const n = Math.trunc(Math.abs(e / 60)), o = Math.trunc(Math.abs(e % 60)), r = e >= 0 ? "+" : "-";
  switch (t) {
    case "short":
      return `${r}${fe(n, 2)}:${fe(o, 2)}`;
    case "narrow":
      return `${r}${n}${o > 0 ? `:${o}` : ""}`;
    case "techie":
      return `${r}${fe(n, 2)}${fe(o, 2)}`;
    default:
      throw new RangeError(`Value format ${t} is out of range for property format`);
  }
}
function Pa(e) {
  return vD(e, ["hour", "minute", "second", "millisecond"]);
}
const ID = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
], Wy = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
], TD = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function Uy(e) {
  switch (e) {
    case "narrow":
      return [...TD];
    case "short":
      return [...Wy];
    case "long":
      return [...ID];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const Vy = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], Fy = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"], wD = ["M", "T", "W", "T", "F", "S", "S"];
function jy(e) {
  switch (e) {
    case "narrow":
      return [...wD];
    case "short":
      return [...Fy];
    case "long":
      return [...Vy];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const qy = ["AM", "PM"], CD = ["Before Christ", "Anno Domini"], SD = ["BC", "AD"], OD = ["B", "A"];
function Zy(e) {
  switch (e) {
    case "narrow":
      return [...OD];
    case "short":
      return [...SD];
    case "long":
      return [...CD];
    default:
      return null;
  }
}
function ED(e) {
  return qy[e.hour < 12 ? 0 : 1];
}
function xD(e, t) {
  return jy(t)[e.weekday - 1];
}
function AD(e, t) {
  return Uy(t)[e.month - 1];
}
function ND(e, t) {
  return Zy(t)[e.year < 0 ? 0 : 1];
}
function MD(e, t, n = "always", o = !1) {
  const r = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  }, s = ["hours", "minutes", "seconds"].indexOf(e) === -1;
  if (n === "auto" && s) {
    const d = e === "days";
    switch (t) {
      case 1:
        return d ? "tomorrow" : `next ${r[e][0]}`;
      case -1:
        return d ? "yesterday" : `last ${r[e][0]}`;
      case 0:
        return d ? "today" : `this ${r[e][0]}`;
    }
  }
  const i = Object.is(t, -0) || t < 0, a = Math.abs(t), l = a === 1, c = r[e], u = o ? l ? c[1] : c[2] || c[1] : l ? r[e][0] : e;
  return i ? `${a} ${u} ago` : `in ${a} ${u}`;
}
function cf(e, t) {
  let n = "";
  for (const o of e)
    o.literal ? n += o.val : n += t(o.val);
  return n;
}
const $D = {
  D: Ji,
  DD: uy,
  DDD: dy,
  DDDD: fy,
  t: my,
  tt: hy,
  ttt: py,
  tttt: yy,
  T: gy,
  TT: vy,
  TTT: by,
  TTTT: Iy,
  f: Ty,
  ff: Cy,
  fff: Oy,
  ffff: xy,
  F: wy,
  FF: Sy,
  FFF: Ey,
  FFFF: Ay
};
class we {
  static create(t, n = {}) {
    return new we(t, n);
  }
  static parseFormat(t) {
    let n = null, o = "", r = !1;
    const s = [];
    for (let i = 0; i < t.length; i++) {
      const a = t.charAt(i);
      a === "'" ? (o.length > 0 && s.push({ literal: r || /^\s+$/.test(o), val: o }), n = null, o = "", r = !r) : r || a === n ? o += a : (o.length > 0 && s.push({ literal: /^\s+$/.test(o), val: o }), o = a, n = a);
    }
    return o.length > 0 && s.push({ literal: r || /^\s+$/.test(o), val: o }), s;
  }
  static macroTokenToFormatOpts(t) {
    return $D[t];
  }
  constructor(t, n) {
    this.opts = n, this.loc = t, this.systemLoc = null;
  }
  formatWithSystemDefault(t, n) {
    return this.systemLoc === null && (this.systemLoc = this.loc.redefaultToSystem()), this.systemLoc.dtFormatter(t, { ...this.opts, ...n }).format();
  }
  dtFormatter(t, n = {}) {
    return this.loc.dtFormatter(t, { ...this.opts, ...n });
  }
  formatDateTime(t, n) {
    return this.dtFormatter(t, n).format();
  }
  formatDateTimeParts(t, n) {
    return this.dtFormatter(t, n).formatToParts();
  }
  formatInterval(t, n) {
    return this.dtFormatter(t.start, n).dtf.formatRange(t.start.toJSDate(), t.end.toJSDate());
  }
  resolvedOptions(t, n) {
    return this.dtFormatter(t, n).resolvedOptions();
  }
  num(t, n = 0) {
    if (this.opts.forceSimple)
      return fe(t, n);
    const o = { ...this.opts };
    return n > 0 && (o.padTo = n), this.loc.numberFormatter(o).format(t);
  }
  formatDateTimeFromString(t, n) {
    const o = this.loc.listingMode() === "en", r = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", s = (f, p) => this.loc.extract(t, f, p), i = (f) => t.isOffsetFixed && t.offset === 0 && f.allowZ ? "Z" : t.isValid ? t.zone.formatOffset(t.ts, f.format) : "", a = () => o ? ED(t) : s({ hour: "numeric", hourCycle: "h12" }, "dayperiod"), l = (f, p) => o ? AD(t, f) : s(p ? { month: f } : { month: f, day: "numeric" }, "month"), c = (f, p) => o ? xD(t, f) : s(
      p ? { weekday: f } : { weekday: f, month: "long", day: "numeric" },
      "weekday"
    ), u = (f) => {
      const p = we.macroTokenToFormatOpts(f);
      return p ? this.formatWithSystemDefault(t, p) : f;
    }, d = (f) => o ? ND(t, f) : s({ era: f }, "era"), m = (f) => {
      switch (f) {
        // ms
        case "S":
          return this.num(t.millisecond);
        case "u":
        // falls through
        case "SSS":
          return this.num(t.millisecond, 3);
        // seconds
        case "s":
          return this.num(t.second);
        case "ss":
          return this.num(t.second, 2);
        // fractional seconds
        case "uu":
          return this.num(Math.floor(t.millisecond / 10), 2);
        case "uuu":
          return this.num(Math.floor(t.millisecond / 100));
        // minutes
        case "m":
          return this.num(t.minute);
        case "mm":
          return this.num(t.minute, 2);
        // hours
        case "h":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12);
        case "hh":
          return this.num(t.hour % 12 === 0 ? 12 : t.hour % 12, 2);
        case "H":
          return this.num(t.hour);
        case "HH":
          return this.num(t.hour, 2);
        // offset
        case "Z":
          return i({ format: "narrow", allowZ: this.opts.allowZ });
        case "ZZ":
          return i({ format: "short", allowZ: this.opts.allowZ });
        case "ZZZ":
          return i({ format: "techie", allowZ: this.opts.allowZ });
        case "ZZZZ":
          return t.zone.offsetName(t.ts, { format: "short", locale: this.loc.locale });
        case "ZZZZZ":
          return t.zone.offsetName(t.ts, { format: "long", locale: this.loc.locale });
        // zone
        case "z":
          return t.zoneName;
        // meridiems
        case "a":
          return a();
        // dates
        case "d":
          return r ? s({ day: "numeric" }, "day") : this.num(t.day);
        case "dd":
          return r ? s({ day: "2-digit" }, "day") : this.num(t.day, 2);
        // weekdays - standalone
        case "c":
          return this.num(t.weekday);
        case "ccc":
          return c("short", !0);
        case "cccc":
          return c("long", !0);
        case "ccccc":
          return c("narrow", !0);
        // weekdays - format
        case "E":
          return this.num(t.weekday);
        case "EEE":
          return c("short", !1);
        case "EEEE":
          return c("long", !1);
        case "EEEEE":
          return c("narrow", !1);
        // months - standalone
        case "L":
          return r ? s({ month: "numeric", day: "numeric" }, "month") : this.num(t.month);
        case "LL":
          return r ? s({ month: "2-digit", day: "numeric" }, "month") : this.num(t.month, 2);
        case "LLL":
          return l("short", !0);
        case "LLLL":
          return l("long", !0);
        case "LLLLL":
          return l("narrow", !0);
        // months - format
        case "M":
          return r ? s({ month: "numeric" }, "month") : this.num(t.month);
        case "MM":
          return r ? s({ month: "2-digit" }, "month") : this.num(t.month, 2);
        case "MMM":
          return l("short", !1);
        case "MMMM":
          return l("long", !1);
        case "MMMMM":
          return l("narrow", !1);
        // years
        case "y":
          return r ? s({ year: "numeric" }, "year") : this.num(t.year);
        case "yy":
          return r ? s({ year: "2-digit" }, "year") : this.num(t.year.toString().slice(-2), 2);
        case "yyyy":
          return r ? s({ year: "numeric" }, "year") : this.num(t.year, 4);
        case "yyyyyy":
          return r ? s({ year: "numeric" }, "year") : this.num(t.year, 6);
        // eras
        case "G":
          return d("short");
        case "GG":
          return d("long");
        case "GGGGG":
          return d("narrow");
        case "kk":
          return this.num(t.weekYear.toString().slice(-2), 2);
        case "kkkk":
          return this.num(t.weekYear, 4);
        case "W":
          return this.num(t.weekNumber);
        case "WW":
          return this.num(t.weekNumber, 2);
        case "n":
          return this.num(t.localWeekNumber);
        case "nn":
          return this.num(t.localWeekNumber, 2);
        case "ii":
          return this.num(t.localWeekYear.toString().slice(-2), 2);
        case "iiii":
          return this.num(t.localWeekYear, 4);
        case "o":
          return this.num(t.ordinal);
        case "ooo":
          return this.num(t.ordinal, 3);
        case "q":
          return this.num(t.quarter);
        case "qq":
          return this.num(t.quarter, 2);
        case "X":
          return this.num(Math.floor(t.ts / 1e3));
        case "x":
          return this.num(t.ts);
        default:
          return u(f);
      }
    };
    return cf(we.parseFormat(n), m);
  }
  formatDurationFromString(t, n) {
    const o = (l) => {
      switch (l[0]) {
        case "S":
          return "millisecond";
        case "s":
          return "second";
        case "m":
          return "minute";
        case "h":
          return "hour";
        case "d":
          return "day";
        case "w":
          return "week";
        case "M":
          return "month";
        case "y":
          return "year";
        default:
          return null;
      }
    }, r = (l) => (c) => {
      const u = o(c);
      return u ? this.num(l.get(u), c.length) : c;
    }, s = we.parseFormat(n), i = s.reduce(
      (l, { literal: c, val: u }) => c ? l : l.concat(u),
      []
    ), a = t.shiftTo(...i.map(o).filter((l) => l));
    return cf(s, r(a));
  }
}
const Hy = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function er(...e) {
  const t = e.reduce((n, o) => n + o.source, "");
  return RegExp(`^${t}$`);
}
function tr(...e) {
  return (t) => e.reduce(
    ([n, o, r], s) => {
      const [i, a, l] = s(t, r);
      return [{ ...n, ...i }, a || o, l];
    },
    [{}, null, 1]
  ).slice(0, 2);
}
function nr(e, ...t) {
  if (e == null)
    return [null, null];
  for (const [n, o] of t) {
    const r = n.exec(e);
    if (r)
      return o(r);
  }
  return [null, null];
}
function zy(...e) {
  return (t, n) => {
    const o = {};
    let r;
    for (r = 0; r < e.length; r++)
      o[e[r]] = Xt(t[n + r]);
    return [o, null, n + r];
  };
}
const Gy = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, kD = `(?:${Gy.source}?(?:\\[(${Hy.source})\\])?)?`, pu = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, Yy = RegExp(`${pu.source}${kD}`), yu = RegExp(`(?:T${Yy.source})?`), DD = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, LD = /(\d{4})-?W(\d\d)(?:-?(\d))?/, RD = /(\d{4})-?(\d{3})/, _D = zy("weekYear", "weekNumber", "weekDay"), PD = zy("year", "ordinal"), BD = /(\d{4})-(\d\d)-(\d\d)/, Ky = RegExp(
  `${pu.source} ?(?:${Gy.source}|(${Hy.source}))?`
), WD = RegExp(`(?: ${Ky.source})?`);
function Eo(e, t, n) {
  const o = e[t];
  return k(o) ? n : Xt(o);
}
function UD(e, t) {
  return [{
    year: Eo(e, t),
    month: Eo(e, t + 1, 1),
    day: Eo(e, t + 2, 1)
  }, null, t + 3];
}
function or(e, t) {
  return [{
    hours: Eo(e, t, 0),
    minutes: Eo(e, t + 1, 0),
    seconds: Eo(e, t + 2, 0),
    milliseconds: mu(e[t + 3])
  }, null, t + 4];
}
function xs(e, t) {
  const n = !e[t] && !e[t + 1], o = _a(e[t + 1], e[t + 2]), r = n ? null : Oe.instance(o);
  return [{}, r, t + 3];
}
function As(e, t) {
  const n = e[t] ? Ut.create(e[t]) : null;
  return [{}, n, t + 1];
}
const VD = RegExp(`^T?${pu.source}$`), FD = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function jD(e) {
  const [t, n, o, r, s, i, a, l, c] = e, u = t[0] === "-", d = l && l[0] === "-", m = (f, p = !1) => f !== void 0 && (p || f && u) ? -f : f;
  return [
    {
      years: m(mn(n)),
      months: m(mn(o)),
      weeks: m(mn(r)),
      days: m(mn(s)),
      hours: m(mn(i)),
      minutes: m(mn(a)),
      seconds: m(mn(l), l === "-0"),
      milliseconds: m(mu(c), d)
    }
  ];
}
const qD = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function gu(e, t, n, o, r, s, i) {
  const a = {
    year: t.length === 2 ? Vl(Xt(t)) : Xt(t),
    month: Wy.indexOf(n) + 1,
    day: Xt(o),
    hour: Xt(r),
    minute: Xt(s)
  };
  return i && (a.second = Xt(i)), e && (a.weekday = e.length > 3 ? Vy.indexOf(e) + 1 : Fy.indexOf(e) + 1), a;
}
const ZD = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function HD(e) {
  const [
    ,
    t,
    n,
    o,
    r,
    s,
    i,
    a,
    l,
    c,
    u,
    d
  ] = e, m = gu(t, r, o, n, s, i, a);
  let f;
  return l ? f = qD[l] : c ? f = 0 : f = _a(u, d), [m, new Oe(f)];
}
function zD(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
const GD = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, YD = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, KD = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function uf(e) {
  const [, t, n, o, r, s, i, a] = e;
  return [gu(t, r, o, n, s, i, a), Oe.utcInstance];
}
function QD(e) {
  const [, t, n, o, r, s, i, a] = e;
  return [gu(t, a, n, o, r, s, i), Oe.utcInstance];
}
const JD = er(DD, yu), XD = er(LD, yu), eL = er(RD, yu), tL = er(Yy), Qy = tr(
  UD,
  or,
  xs,
  As
), nL = tr(
  _D,
  or,
  xs,
  As
), oL = tr(
  PD,
  or,
  xs,
  As
), rL = tr(
  or,
  xs,
  As
);
function sL(e) {
  return nr(
    e,
    [JD, Qy],
    [XD, nL],
    [eL, oL],
    [tL, rL]
  );
}
function iL(e) {
  return nr(zD(e), [ZD, HD]);
}
function aL(e) {
  return nr(
    e,
    [GD, uf],
    [YD, uf],
    [KD, QD]
  );
}
function lL(e) {
  return nr(e, [FD, jD]);
}
const cL = tr(or);
function uL(e) {
  return nr(e, [VD, cL]);
}
const dL = er(BD, WD), fL = er(Ky), mL = tr(
  or,
  xs,
  As
);
function hL(e) {
  return nr(
    e,
    [dL, Qy],
    [fL, mL]
  );
}
const df = "Invalid Duration", Jy = {
  weeks: {
    days: 7,
    hours: 7 * 24,
    minutes: 7 * 24 * 60,
    seconds: 7 * 24 * 60 * 60,
    milliseconds: 7 * 24 * 60 * 60 * 1e3
  },
  days: {
    hours: 24,
    minutes: 24 * 60,
    seconds: 24 * 60 * 60,
    milliseconds: 24 * 60 * 60 * 1e3
  },
  hours: { minutes: 60, seconds: 60 * 60, milliseconds: 60 * 60 * 1e3 },
  minutes: { seconds: 60, milliseconds: 60 * 1e3 },
  seconds: { milliseconds: 1e3 }
}, pL = {
  years: {
    quarters: 4,
    months: 12,
    weeks: 52,
    days: 365,
    hours: 365 * 24,
    minutes: 365 * 24 * 60,
    seconds: 365 * 24 * 60 * 60,
    milliseconds: 365 * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: 13,
    days: 91,
    hours: 91 * 24,
    minutes: 91 * 24 * 60,
    seconds: 91 * 24 * 60 * 60,
    milliseconds: 91 * 24 * 60 * 60 * 1e3
  },
  months: {
    weeks: 4,
    days: 30,
    hours: 30 * 24,
    minutes: 30 * 24 * 60,
    seconds: 30 * 24 * 60 * 60,
    milliseconds: 30 * 24 * 60 * 60 * 1e3
  },
  ...Jy
}, We = 146097 / 400, Qn = 146097 / 4800, yL = {
  years: {
    quarters: 4,
    months: 12,
    weeks: We / 7,
    days: We,
    hours: We * 24,
    minutes: We * 24 * 60,
    seconds: We * 24 * 60 * 60,
    milliseconds: We * 24 * 60 * 60 * 1e3
  },
  quarters: {
    months: 3,
    weeks: We / 28,
    days: We / 4,
    hours: We * 24 / 4,
    minutes: We * 24 * 60 / 4,
    seconds: We * 24 * 60 * 60 / 4,
    milliseconds: We * 24 * 60 * 60 * 1e3 / 4
  },
  months: {
    weeks: Qn / 7,
    days: Qn,
    hours: Qn * 24,
    minutes: Qn * 24 * 60,
    seconds: Qn * 24 * 60 * 60,
    milliseconds: Qn * 24 * 60 * 60 * 1e3
  },
  ...Jy
}, En = [
  "years",
  "quarters",
  "months",
  "weeks",
  "days",
  "hours",
  "minutes",
  "seconds",
  "milliseconds"
], gL = En.slice(0).reverse();
function Gt(e, t, n = !1) {
  const o = {
    values: n ? t.values : { ...e.values, ...t.values || {} },
    loc: e.loc.clone(t.loc),
    conversionAccuracy: t.conversionAccuracy || e.conversionAccuracy,
    matrix: t.matrix || e.matrix
  };
  return new F(o);
}
function Xy(e, t) {
  let n = t.milliseconds ?? 0;
  for (const o of gL.slice(1))
    t[o] && (n += t[o] * e[o].milliseconds);
  return n;
}
function ff(e, t) {
  const n = Xy(e, t) < 0 ? -1 : 1;
  En.reduceRight((o, r) => {
    if (k(t[r]))
      return o;
    if (o) {
      const s = t[o] * n, i = e[r][o], a = Math.floor(s / i);
      t[r] += a * n, t[o] -= a * i * n;
    }
    return r;
  }, null), En.reduce((o, r) => {
    if (k(t[r]))
      return o;
    if (o) {
      const s = t[o] % 1;
      t[o] -= s, t[r] += s * e[o][r];
    }
    return r;
  }, null);
}
function vL(e) {
  const t = {};
  for (const [n, o] of Object.entries(e))
    o !== 0 && (t[n] = o);
  return t;
}
class F {
  /**
   * @private
   */
  constructor(t) {
    const n = t.conversionAccuracy === "longterm" || !1;
    let o = n ? yL : pL;
    t.matrix && (o = t.matrix), this.values = t.values, this.loc = t.loc || G.create(), this.conversionAccuracy = n ? "longterm" : "casual", this.invalid = t.invalid || null, this.matrix = o, this.isLuxonDuration = !0;
  }
  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(t, n) {
    return F.fromObject({ milliseconds: t }, n);
  }
  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(t, n = {}) {
    if (t == null || typeof t != "object")
      throw new Me(
        `Duration.fromObject: argument expected to be an object, got ${t === null ? "null" : typeof t}`
      );
    return new F({
      values: ta(t, F.normalizeUnit),
      loc: G.fromObject(n),
      conversionAccuracy: n.conversionAccuracy,
      matrix: n.matrix
    });
  }
  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(t) {
    if (kn(t))
      return F.fromMillis(t);
    if (F.isDuration(t))
      return t;
    if (typeof t == "object")
      return F.fromObject(t);
    throw new Me(
      `Unknown duration argument ${t} of type ${typeof t}`
    );
  }
  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(t, n) {
    const [o] = lL(t);
    return o ? F.fromObject(o, n) : F.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(t, n) {
    const [o] = uL(t);
    return o ? F.fromObject(o, n) : F.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Me("need to specify a reason the Duration is invalid");
    const o = t instanceof ct ? t : new ct(t, n);
    if (ce.throwOnInvalid)
      throw new Z2(o);
    return new F({ invalid: o });
  }
  /**
   * @private
   */
  static normalizeUnit(t) {
    const n = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[t && t.toLowerCase()];
    if (!n) throw new cy(t);
    return n;
  }
  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(t) {
    return t && t.isLuxonDuration || !1;
  }
  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(t, n = {}) {
    const o = {
      ...n,
      floor: n.round !== !1 && n.floor !== !1
    };
    return this.isValid ? we.create(this.loc, o).formatDurationFromString(this, t) : df;
  }
  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(t = {}) {
    if (!this.isValid) return df;
    const n = En.map((o) => {
      const r = this.values[o];
      return k(r) ? null : this.loc.numberFormatter({ style: "unit", unitDisplay: "long", ...t, unit: o.slice(0, -1) }).format(r);
    }).filter((o) => o);
    return this.loc.listFormatter({ type: "conjunction", style: t.listStyle || "narrow", ...t }).format(n);
  }
  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    return this.isValid ? { ...this.values } : {};
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    if (!this.isValid) return null;
    let t = "P";
    return this.years !== 0 && (t += this.years + "Y"), (this.months !== 0 || this.quarters !== 0) && (t += this.months + this.quarters * 3 + "M"), this.weeks !== 0 && (t += this.weeks + "W"), this.days !== 0 && (t += this.days + "D"), (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) && (t += "T"), this.hours !== 0 && (t += this.hours + "H"), this.minutes !== 0 && (t += this.minutes + "M"), (this.seconds !== 0 || this.milliseconds !== 0) && (t += hu(this.seconds + this.milliseconds / 1e3, 3) + "S"), t === "P" && (t += "T0S"), t;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(t = {}) {
    if (!this.isValid) return null;
    const n = this.toMillis();
    return n < 0 || n >= 864e5 ? null : (t = {
      suppressMilliseconds: !1,
      suppressSeconds: !1,
      includePrefix: !1,
      format: "extended",
      ...t,
      includeOffset: !1
    }, D.fromMillis(n, { zone: "UTC" }).toISOTime(t));
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }
  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Duration { values: ${JSON.stringify(this.values)} }` : `Duration { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? Xy(this.matrix, this.values) : NaN;
  }
  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(t) {
    if (!this.isValid) return this;
    const n = F.fromDurationLike(t), o = {};
    for (const r of En)
      (Do(n.values, r) || Do(this.values, r)) && (o[r] = n.get(r) + this.get(r));
    return Gt(this, { values: o }, !0);
  }
  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(t) {
    if (!this.isValid) return this;
    const n = F.fromDurationLike(t);
    return this.plus(n.negate());
  }
  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(t) {
    if (!this.isValid) return this;
    const n = {};
    for (const o of Object.keys(this.values))
      n[o] = By(t(this.values[o], o));
    return Gt(this, { values: n }, !0);
  }
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(t) {
    return this[F.normalizeUnit(t)];
  }
  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(t) {
    if (!this.isValid) return this;
    const n = { ...this.values, ...ta(t, F.normalizeUnit) };
    return Gt(this, { values: n });
  }
  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({ locale: t, numberingSystem: n, conversionAccuracy: o, matrix: r } = {}) {
    const i = { loc: this.loc.clone({ locale: t, numberingSystem: n }), matrix: r, conversionAccuracy: o };
    return Gt(this, i);
  }
  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(t) {
    return this.isValid ? this.shiftTo(t).get(t) : NaN;
  }
  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const t = this.toObject();
    return ff(this.matrix, t), Gt(this, { values: t }, !0);
  }
  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const t = vL(this.normalize().shiftToAll().toObject());
    return Gt(this, { values: t }, !0);
  }
  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...t) {
    if (!this.isValid) return this;
    if (t.length === 0)
      return this;
    t = t.map((i) => F.normalizeUnit(i));
    const n = {}, o = {}, r = this.toObject();
    let s;
    for (const i of En)
      if (t.indexOf(i) >= 0) {
        s = i;
        let a = 0;
        for (const c in o)
          a += this.matrix[c][i] * o[c], o[c] = 0;
        kn(r[i]) && (a += r[i]);
        const l = Math.trunc(a);
        n[i] = l, o[i] = (a * 1e3 - l * 1e3) / 1e3;
      } else kn(r[i]) && (o[i] = r[i]);
    for (const i in o)
      o[i] !== 0 && (n[s] += i === s ? o[i] : o[i] / this.matrix[s][i]);
    return ff(this.matrix, n), Gt(this, { values: n }, !0);
  }
  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    return this.isValid ? this.shiftTo(
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    ) : this;
  }
  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const t = {};
    for (const n of Object.keys(this.values))
      t[n] = this.values[n] === 0 ? 0 : -this.values[n];
    return Gt(this, { values: t }, !0);
  }
  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }
  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }
  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }
  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }
  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }
  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }
  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }
  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }
  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }
  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(t) {
    if (!this.isValid || !t.isValid || !this.loc.equals(t.loc))
      return !1;
    function n(o, r) {
      return o === void 0 || o === 0 ? r === void 0 || r === 0 : o === r;
    }
    for (const o of En)
      if (!n(this.values[o], t.values[o]))
        return !1;
    return !0;
  }
}
const Jn = "Invalid Interval";
function bL(e, t) {
  return !e || !e.isValid ? se.invalid("missing or invalid start") : !t || !t.isValid ? se.invalid("missing or invalid end") : t < e ? se.invalid(
    "end before start",
    `The end of an interval must be after its start, but you had start=${e.toISO()} and end=${t.toISO()}`
  ) : null;
}
class se {
  /**
   * @private
   */
  constructor(t) {
    this.s = t.start, this.e = t.end, this.invalid = t.invalid || null, this.isLuxonInterval = !0;
  }
  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Me("need to specify a reason the Interval is invalid");
    const o = t instanceof ct ? t : new ct(t, n);
    if (ce.throwOnInvalid)
      throw new q2(o);
    return new se({ invalid: o });
  }
  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(t, n) {
    const o = hr(t), r = hr(n), s = bL(o, r);
    return s ?? new se({
      start: o,
      end: r
    });
  }
  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(t, n) {
    const o = F.fromDurationLike(n), r = hr(t);
    return se.fromDateTimes(r, r.plus(o));
  }
  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(t, n) {
    const o = F.fromDurationLike(n), r = hr(t);
    return se.fromDateTimes(r.minus(o), r);
  }
  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(t, n) {
    const [o, r] = (t || "").split("/", 2);
    if (o && r) {
      let s, i;
      try {
        s = D.fromISO(o, n), i = s.isValid;
      } catch {
        i = !1;
      }
      let a, l;
      try {
        a = D.fromISO(r, n), l = a.isValid;
      } catch {
        l = !1;
      }
      if (i && l)
        return se.fromDateTimes(s, a);
      if (i) {
        const c = F.fromISO(r, n);
        if (c.isValid)
          return se.after(s, c);
      } else if (l) {
        const c = F.fromISO(o, n);
        if (c.isValid)
          return se.before(a, c);
      }
    }
    return se.invalid("unparsable", `the input "${t}" can't be parsed as ISO 8601`);
  }
  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(t) {
    return t && t.isLuxonInterval || !1;
  }
  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }
  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }
  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }
  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(t = "milliseconds") {
    return this.isValid ? this.toDuration(t).get(t) : NaN;
  }
  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(t = "milliseconds", n) {
    if (!this.isValid) return NaN;
    const o = this.start.startOf(t, n);
    let r;
    return n != null && n.useLocaleWeeks ? r = this.end.reconfigure({ locale: o.locale }) : r = this.end, r = r.startOf(t, n), Math.floor(r.diff(o, t).get(t)) + (r.valueOf() !== this.end.valueOf());
  }
  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(t) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, t) : !1;
  }
  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }
  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(t) {
    return this.isValid ? this.s > t : !1;
  }
  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(t) {
    return this.isValid ? this.e <= t : !1;
  }
  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(t) {
    return this.isValid ? this.s <= t && this.e > t : !1;
  }
  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({ start: t, end: n } = {}) {
    return this.isValid ? se.fromDateTimes(t || this.s, n || this.e) : this;
  }
  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...t) {
    if (!this.isValid) return [];
    const n = t.map(hr).filter((i) => this.contains(i)).sort((i, a) => i.toMillis() - a.toMillis()), o = [];
    let { s: r } = this, s = 0;
    for (; r < this.e; ) {
      const i = n[s] || this.e, a = +i > +this.e ? this.e : i;
      o.push(se.fromDateTimes(r, a)), r = a, s += 1;
    }
    return o;
  }
  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(t) {
    const n = F.fromDurationLike(t);
    if (!this.isValid || !n.isValid || n.as("milliseconds") === 0)
      return [];
    let { s: o } = this, r = 1, s;
    const i = [];
    for (; o < this.e; ) {
      const a = this.start.plus(n.mapUnits((l) => l * r));
      s = +a > +this.e ? this.e : a, i.push(se.fromDateTimes(o, s)), o = s, r += 1;
    }
    return i;
  }
  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(t) {
    return this.isValid ? this.splitBy(this.length() / t).slice(0, t) : [];
  }
  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(t) {
    return this.e > t.s && this.s < t.e;
  }
  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(t) {
    return this.isValid ? +this.e == +t.s : !1;
  }
  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(t) {
    return this.isValid ? +t.e == +this.s : !1;
  }
  /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(t) {
    return this.isValid ? this.s <= t.s && this.e >= t.e : !1;
  }
  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(t) {
    return !this.isValid || !t.isValid ? !1 : this.s.equals(t.s) && this.e.equals(t.e);
  }
  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(t) {
    if (!this.isValid) return this;
    const n = this.s > t.s ? this.s : t.s, o = this.e < t.e ? this.e : t.e;
    return n >= o ? null : se.fromDateTimes(n, o);
  }
  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(t) {
    if (!this.isValid) return this;
    const n = this.s < t.s ? this.s : t.s, o = this.e > t.e ? this.e : t.e;
    return se.fromDateTimes(n, o);
  }
  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(t) {
    const [n, o] = t.sort((r, s) => r.s - s.s).reduce(
      ([r, s], i) => s ? s.overlaps(i) || s.abutsStart(i) ? [r, s.union(i)] : [r.concat([s]), i] : [r, i],
      [[], null]
    );
    return o && n.push(o), n;
  }
  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(t) {
    let n = null, o = 0;
    const r = [], s = t.map((l) => [
      { time: l.s, type: "s" },
      { time: l.e, type: "e" }
    ]), i = Array.prototype.concat(...s), a = i.sort((l, c) => l.time - c.time);
    for (const l of a)
      o += l.type === "s" ? 1 : -1, o === 1 ? n = l.time : (n && +n != +l.time && r.push(se.fromDateTimes(n, l.time)), n = null);
    return se.merge(r);
  }
  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...t) {
    return se.xor([this].concat(t)).map((n) => this.intersection(n)).filter((n) => n && !n.isEmpty());
  }
  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    return this.isValid ? `[${this.s.toISO()} – ${this.e.toISO()})` : Jn;
  }
  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }` : `Interval { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(t = Ji, n = {}) {
    return this.isValid ? we.create(this.s.loc.clone(n), t).formatInterval(this) : Jn;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(t) {
    return this.isValid ? `${this.s.toISO(t)}/${this.e.toISO(t)}` : Jn;
  }
  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    return this.isValid ? `${this.s.toISODate()}/${this.e.toISODate()}` : Jn;
  }
  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(t) {
    return this.isValid ? `${this.s.toISOTime(t)}/${this.e.toISOTime(t)}` : Jn;
  }
  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(t, { separator: n = " – " } = {}) {
    return this.isValid ? `${this.s.toFormat(t)}${n}${this.e.toFormat(t)}` : Jn;
  }
  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(t, n) {
    return this.isValid ? this.e.diff(this.s, t, n) : F.invalid(this.invalidReason);
  }
  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(t) {
    return se.fromDateTimes(t(this.s), t(this.e));
  }
}
class Fs {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(t = ce.defaultZone) {
    const n = D.now().setZone(t).set({ month: 12 });
    return !t.isUniversal && n.offset !== n.set({ month: 6 }).offset;
  }
  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(t) {
    return Ut.isValidZone(t);
  }
  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(t) {
    return en(t, ce.defaultZone);
  }
  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || G.create(t)).getStartOfWeek();
  }
  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({ locale: t = null, locObj: n = null } = {}) {
    return (n || G.create(t)).getMinDaysInFirstWeek();
  }
  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({ locale: t = null, locObj: n = null } = {}) {
    return (n || G.create(t)).getWeekendDays().slice();
  }
  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(t = "long", { locale: n = null, numberingSystem: o = null, locObj: r = null, outputCalendar: s = "gregory" } = {}) {
    return (r || G.create(n, o, s)).months(t);
  }
  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(t = "long", { locale: n = null, numberingSystem: o = null, locObj: r = null, outputCalendar: s = "gregory" } = {}) {
    return (r || G.create(n, o, s)).months(t, !0);
  }
  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(t = "long", { locale: n = null, numberingSystem: o = null, locObj: r = null } = {}) {
    return (r || G.create(n, o, null)).weekdays(t);
  }
  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(t = "long", { locale: n = null, numberingSystem: o = null, locObj: r = null } = {}) {
    return (r || G.create(n, o, null)).weekdays(t, !0);
  }
  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({ locale: t = null } = {}) {
    return G.create(t).meridiems();
  }
  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(t = "short", { locale: n = null } = {}) {
    return G.create(n, null, "gregory").eras(t);
  }
  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return { relative: Ry(), localeWeek: _y() };
  }
}
function mf(e, t) {
  const n = (r) => r.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), o = n(t) - n(e);
  return Math.floor(F.fromMillis(o).as("days"));
}
function IL(e, t, n) {
  const o = [
    ["years", (l, c) => c.year - l.year],
    ["quarters", (l, c) => c.quarter - l.quarter + (c.year - l.year) * 4],
    ["months", (l, c) => c.month - l.month + (c.year - l.year) * 12],
    [
      "weeks",
      (l, c) => {
        const u = mf(l, c);
        return (u - u % 7) / 7;
      }
    ],
    ["days", mf]
  ], r = {}, s = e;
  let i, a;
  for (const [l, c] of o)
    n.indexOf(l) >= 0 && (i = l, r[l] = c(e, t), a = s.plus(r), a > t ? (r[l]--, e = s.plus(r), e > t && (a = e, r[l]--, e = s.plus(r))) : e = a);
  return [e, r, a, i];
}
function TL(e, t, n, o) {
  let [r, s, i, a] = IL(e, t, n);
  const l = t - r, c = n.filter(
    (d) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(d) >= 0
  );
  c.length === 0 && (i < t && (i = r.plus({ [a]: 1 })), i !== r && (s[a] = (s[a] || 0) + l / (i - r)));
  const u = F.fromObject(s, o);
  return c.length > 0 ? F.fromMillis(l, o).shiftTo(...c).plus(u) : u;
}
const vu = {
  arab: "[٠-٩]",
  arabext: "[۰-۹]",
  bali: "[᭐-᭙]",
  beng: "[০-৯]",
  deva: "[०-९]",
  fullwide: "[０-９]",
  gujr: "[૦-૯]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[០-៩]",
  knda: "[೦-೯]",
  laoo: "[໐-໙]",
  limb: "[᥆-᥏]",
  mlym: "[൦-൯]",
  mong: "[᠐-᠙]",
  mymr: "[၀-၉]",
  orya: "[୦-୯]",
  tamldec: "[௦-௯]",
  telu: "[౦-౯]",
  thai: "[๐-๙]",
  tibt: "[༠-༩]",
  latn: "\\d"
}, hf = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
}, wL = vu.hanidec.replace(/[\[|\]]/g, "").split("");
function CL(e) {
  let t = parseInt(e, 10);
  if (isNaN(t)) {
    t = "";
    for (let n = 0; n < e.length; n++) {
      const o = e.charCodeAt(n);
      if (e[n].search(vu.hanidec) !== -1)
        t += wL.indexOf(e[n]);
      else
        for (const r in hf) {
          const [s, i] = hf[r];
          o >= s && o <= i && (t += o - s);
        }
    }
    return parseInt(t, 10);
  } else
    return t;
}
function st({ numberingSystem: e }, t = "") {
  return new RegExp(`${vu[e || "latn"]}${t}`);
}
const SL = "missing Intl.DateTimeFormat.formatToParts support";
function Z(e, t = (n) => n) {
  return { regex: e, deser: ([n]) => t(CL(n)) };
}
const OL = " ", eg = `[ ${OL}]`, tg = new RegExp(eg, "g");
function EL(e) {
  return e.replace(/\./g, "\\.?").replace(tg, eg);
}
function pf(e) {
  return e.replace(/\./g, "").replace(tg, " ").toLowerCase();
}
function it(e, t) {
  return e === null ? null : {
    regex: RegExp(e.map(EL).join("|")),
    deser: ([n]) => e.findIndex((o) => pf(n) === pf(o)) + t
  };
}
function yf(e, t) {
  return { regex: e, deser: ([, n, o]) => _a(n, o), groups: t };
}
function js(e) {
  return { regex: e, deser: ([t]) => t };
}
function xL(e) {
  return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function AL(e, t) {
  const n = st(t), o = st(t, "{2}"), r = st(t, "{3}"), s = st(t, "{4}"), i = st(t, "{6}"), a = st(t, "{1,2}"), l = st(t, "{1,3}"), c = st(t, "{1,6}"), u = st(t, "{1,9}"), d = st(t, "{2,4}"), m = st(t, "{4,6}"), f = (I) => ({ regex: RegExp(xL(I.val)), deser: ([g]) => g, literal: !0 }), v = ((I) => {
    if (e.literal)
      return f(I);
    switch (I.val) {
      // era
      case "G":
        return it(t.eras("short"), 0);
      case "GG":
        return it(t.eras("long"), 0);
      // years
      case "y":
        return Z(c);
      case "yy":
        return Z(d, Vl);
      case "yyyy":
        return Z(s);
      case "yyyyy":
        return Z(m);
      case "yyyyyy":
        return Z(i);
      // months
      case "M":
        return Z(a);
      case "MM":
        return Z(o);
      case "MMM":
        return it(t.months("short", !0), 1);
      case "MMMM":
        return it(t.months("long", !0), 1);
      case "L":
        return Z(a);
      case "LL":
        return Z(o);
      case "LLL":
        return it(t.months("short", !1), 1);
      case "LLLL":
        return it(t.months("long", !1), 1);
      // dates
      case "d":
        return Z(a);
      case "dd":
        return Z(o);
      // ordinals
      case "o":
        return Z(l);
      case "ooo":
        return Z(r);
      // time
      case "HH":
        return Z(o);
      case "H":
        return Z(a);
      case "hh":
        return Z(o);
      case "h":
        return Z(a);
      case "mm":
        return Z(o);
      case "m":
        return Z(a);
      case "q":
        return Z(a);
      case "qq":
        return Z(o);
      case "s":
        return Z(a);
      case "ss":
        return Z(o);
      case "S":
        return Z(l);
      case "SSS":
        return Z(r);
      case "u":
        return js(u);
      case "uu":
        return js(a);
      case "uuu":
        return Z(n);
      // meridiem
      case "a":
        return it(t.meridiems(), 0);
      // weekYear (k)
      case "kkkk":
        return Z(s);
      case "kk":
        return Z(d, Vl);
      // weekNumber (W)
      case "W":
        return Z(a);
      case "WW":
        return Z(o);
      // weekdays
      case "E":
      case "c":
        return Z(n);
      case "EEE":
        return it(t.weekdays("short", !1), 1);
      case "EEEE":
        return it(t.weekdays("long", !1), 1);
      case "ccc":
        return it(t.weekdays("short", !0), 1);
      case "cccc":
        return it(t.weekdays("long", !0), 1);
      // offset/zone
      case "Z":
      case "ZZ":
        return yf(new RegExp(`([+-]${a.source})(?::(${o.source}))?`), 2);
      case "ZZZ":
        return yf(new RegExp(`([+-]${a.source})(${o.source})?`), 2);
      // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
      // because we don't have any way to figure out what they are
      case "z":
        return js(/[a-z_+-/]{1,256}?/i);
      // this special-case "token" represents a place where a macro-token expanded into a white-space literal
      // in this case we accept any non-newline white-space
      case " ":
        return js(/[^\S\n\r]/);
      default:
        return f(I);
    }
  })(e) || {
    invalidReason: SL
  };
  return v.token = e, v;
}
const NL = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function ML(e, t, n) {
  const { type: o, value: r } = e;
  if (o === "literal") {
    const l = /^\s+$/.test(r);
    return {
      literal: !l,
      val: l ? " " : r
    };
  }
  const s = t[o];
  let i = o;
  o === "hour" && (t.hour12 != null ? i = t.hour12 ? "hour12" : "hour24" : t.hourCycle != null ? t.hourCycle === "h11" || t.hourCycle === "h12" ? i = "hour12" : i = "hour24" : i = n.hour12 ? "hour12" : "hour24");
  let a = NL[i];
  if (typeof a == "object" && (a = a[s]), a)
    return {
      literal: !1,
      val: a
    };
}
function $L(e) {
  return [`^${e.map((n) => n.regex).reduce((n, o) => `${n}(${o.source})`, "")}$`, e];
}
function kL(e, t, n) {
  const o = e.match(t);
  if (o) {
    const r = {};
    let s = 1;
    for (const i in n)
      if (Do(n, i)) {
        const a = n[i], l = a.groups ? a.groups + 1 : 1;
        !a.literal && a.token && (r[a.token.val[0]] = a.deser(o.slice(s, s + l))), s += l;
      }
    return [o, r];
  } else
    return [o, {}];
}
function DL(e) {
  const t = (s) => {
    switch (s) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let n = null, o;
  return k(e.z) || (n = Ut.create(e.z)), k(e.Z) || (n || (n = new Oe(e.Z)), o = e.Z), k(e.q) || (e.M = (e.q - 1) * 3 + 1), k(e.h) || (e.h < 12 && e.a === 1 ? e.h += 12 : e.h === 12 && e.a === 0 && (e.h = 0)), e.G === 0 && e.y && (e.y = -e.y), k(e.u) || (e.S = mu(e.u)), [Object.keys(e).reduce((s, i) => {
    const a = t(i);
    return a && (s[a] = e[i]), s;
  }, {}), n, o];
}
let nl = null;
function LL() {
  return nl || (nl = D.fromMillis(1555555555555)), nl;
}
function RL(e, t) {
  if (e.literal)
    return e;
  const n = we.macroTokenToFormatOpts(e.val), o = rg(n, t);
  return o == null || o.includes(void 0) ? e : o;
}
function ng(e, t) {
  return Array.prototype.concat(...e.map((n) => RL(n, t)));
}
function og(e, t, n) {
  const o = ng(we.parseFormat(n), e), r = o.map((i) => AL(i, e)), s = r.find((i) => i.invalidReason);
  if (s)
    return { input: t, tokens: o, invalidReason: s.invalidReason };
  {
    const [i, a] = $L(r), l = RegExp(i, "i"), [c, u] = kL(t, l, a), [d, m, f] = u ? DL(u) : [null, null, void 0];
    if (Do(u, "a") && Do(u, "H"))
      throw new ho(
        "Can't include meridiem when specifying 24-hour format"
      );
    return { input: t, tokens: o, regex: l, rawMatches: c, matches: u, result: d, zone: m, specificOffset: f };
  }
}
function _L(e, t, n) {
  const { result: o, zone: r, specificOffset: s, invalidReason: i } = og(e, t, n);
  return [o, r, s, i];
}
function rg(e, t) {
  if (!e)
    return null;
  const o = we.create(t, e).dtFormatter(LL()), r = o.formatToParts(), s = o.resolvedOptions();
  return r.map((i) => ML(i, e, s));
}
const ol = "Invalid DateTime", PL = 864e13;
function qs(e) {
  return new ct("unsupported zone", `the zone "${e.name}" is not supported`);
}
function rl(e) {
  return e.weekData === null && (e.weekData = Xi(e.c)), e.weekData;
}
function sl(e) {
  return e.localWeekData === null && (e.localWeekData = Xi(
    e.c,
    e.loc.getMinDaysInFirstWeek(),
    e.loc.getStartOfWeek()
  )), e.localWeekData;
}
function hn(e, t) {
  const n = {
    ts: e.ts,
    zone: e.zone,
    c: e.c,
    o: e.o,
    loc: e.loc,
    invalid: e.invalid
  };
  return new D({ ...n, ...t, old: n });
}
function sg(e, t, n) {
  let o = e - t * 60 * 1e3;
  const r = n.offset(o);
  if (t === r)
    return [o, t];
  o -= (r - t) * 60 * 1e3;
  const s = n.offset(o);
  return r === s ? [o, r] : [e - Math.min(r, s) * 60 * 1e3, Math.max(r, s)];
}
function Zs(e, t) {
  e += t * 60 * 1e3;
  const n = new Date(e);
  return {
    year: n.getUTCFullYear(),
    month: n.getUTCMonth() + 1,
    day: n.getUTCDate(),
    hour: n.getUTCHours(),
    minute: n.getUTCMinutes(),
    second: n.getUTCSeconds(),
    millisecond: n.getUTCMilliseconds()
  };
}
function Ni(e, t, n) {
  return sg(Ra(e), t, n);
}
function gf(e, t) {
  const n = e.o, o = e.c.year + Math.trunc(t.years), r = e.c.month + Math.trunc(t.months) + Math.trunc(t.quarters) * 3, s = {
    ...e.c,
    year: o,
    month: r,
    day: Math.min(e.c.day, ea(o, r)) + Math.trunc(t.days) + Math.trunc(t.weeks) * 7
  }, i = F.fromObject({
    years: t.years - Math.trunc(t.years),
    quarters: t.quarters - Math.trunc(t.quarters),
    months: t.months - Math.trunc(t.months),
    weeks: t.weeks - Math.trunc(t.weeks),
    days: t.days - Math.trunc(t.days),
    hours: t.hours,
    minutes: t.minutes,
    seconds: t.seconds,
    milliseconds: t.milliseconds
  }).as("milliseconds"), a = Ra(s);
  let [l, c] = sg(a, n, e.zone);
  return i !== 0 && (l += i, c = e.zone.offset(l)), { ts: l, o: c };
}
function mr(e, t, n, o, r, s) {
  const { setZone: i, zone: a } = n;
  if (e && Object.keys(e).length !== 0 || t) {
    const l = t || a, c = D.fromObject(e, {
      ...n,
      zone: l,
      specificOffset: s
    });
    return i ? c : c.setZone(a);
  } else
    return D.invalid(
      new ct("unparsable", `the input "${r}" can't be parsed as ${o}`)
    );
}
function Hs(e, t, n = !0) {
  return e.isValid ? we.create(G.create("en-US"), {
    allowZ: n,
    forceSimple: !0
  }).formatDateTimeFromString(e, t) : null;
}
function il(e, t) {
  const n = e.c.year > 9999 || e.c.year < 0;
  let o = "";
  return n && e.c.year >= 0 && (o += "+"), o += fe(e.c.year, n ? 6 : 4), t ? (o += "-", o += fe(e.c.month), o += "-", o += fe(e.c.day)) : (o += fe(e.c.month), o += fe(e.c.day)), o;
}
function vf(e, t, n, o, r, s) {
  let i = fe(e.c.hour);
  return t ? (i += ":", i += fe(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (i += ":")) : i += fe(e.c.minute), (e.c.millisecond !== 0 || e.c.second !== 0 || !n) && (i += fe(e.c.second), (e.c.millisecond !== 0 || !o) && (i += ".", i += fe(e.c.millisecond, 3))), r && (e.isOffsetFixed && e.offset === 0 && !s ? i += "Z" : e.o < 0 ? (i += "-", i += fe(Math.trunc(-e.o / 60)), i += ":", i += fe(Math.trunc(-e.o % 60))) : (i += "+", i += fe(Math.trunc(e.o / 60)), i += ":", i += fe(Math.trunc(e.o % 60)))), s && (i += "[" + e.zone.ianaName + "]"), i;
}
const ig = {
  month: 1,
  day: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, BL = {
  weekNumber: 1,
  weekday: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, WL = {
  ordinal: 1,
  hour: 0,
  minute: 0,
  second: 0,
  millisecond: 0
}, ag = ["year", "month", "day", "hour", "minute", "second", "millisecond"], UL = [
  "weekYear",
  "weekNumber",
  "weekday",
  "hour",
  "minute",
  "second",
  "millisecond"
], VL = ["year", "ordinal", "hour", "minute", "second", "millisecond"];
function FL(e) {
  const t = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[e.toLowerCase()];
  if (!t) throw new cy(e);
  return t;
}
function bf(e) {
  switch (e.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return FL(e);
  }
}
function If(e, t) {
  const n = en(t.zone, ce.defaultZone), o = G.fromObject(t), r = ce.now();
  let s, i;
  if (k(e.year))
    s = r;
  else {
    for (const c of ag)
      k(e[c]) && (e[c] = ig[c]);
    const a = Dy(e) || Ly(e);
    if (a)
      return D.invalid(a);
    const l = n.offset(r);
    [s, i] = Ni(e, l, n);
  }
  return new D({ ts: s, zone: n, loc: o, o: i });
}
function Tf(e, t, n) {
  const o = k(n.round) ? !0 : n.round, r = (i, a) => (i = hu(i, o || n.calendary ? 0 : 2, !0), t.loc.clone(n).relFormatter(n).format(i, a)), s = (i) => n.calendary ? t.hasSame(e, i) ? 0 : t.startOf(i).diff(e.startOf(i), i).get(i) : t.diff(e, i).get(i);
  if (n.unit)
    return r(s(n.unit), n.unit);
  for (const i of n.units) {
    const a = s(i);
    if (Math.abs(a) >= 1)
      return r(a, i);
  }
  return r(e > t ? -0 : 0, n.units[n.units.length - 1]);
}
function wf(e) {
  let t = {}, n;
  return e.length > 0 && typeof e[e.length - 1] == "object" ? (t = e[e.length - 1], n = Array.from(e).slice(0, e.length - 1)) : n = Array.from(e), [t, n];
}
class D {
  /**
   * @access private
   */
  constructor(t) {
    const n = t.zone || ce.defaultZone;
    let o = t.invalid || (Number.isNaN(t.ts) ? new ct("invalid input") : null) || (n.isValid ? null : qs(n));
    this.ts = k(t.ts) ? ce.now() : t.ts;
    let r = null, s = null;
    if (!o)
      if (t.old && t.old.ts === this.ts && t.old.zone.equals(n))
        [r, s] = [t.old.c, t.old.o];
      else {
        const a = n.offset(this.ts);
        r = Zs(this.ts, a), o = Number.isNaN(r.year) ? new ct("invalid input") : null, r = o ? null : r, s = o ? null : a;
      }
    this._zone = n, this.loc = t.loc || G.create(), this.invalid = o, this.weekData = null, this.localWeekData = null, this.c = r, this.o = s, this.isLuxonDateTime = !0;
  }
  // CONSTRUCT
  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new D({});
  }
  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [t, n] = wf(arguments), [o, r, s, i, a, l, c] = n;
    return If({ year: o, month: r, day: s, hour: i, minute: a, second: l, millisecond: c }, t);
  }
  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [t, n] = wf(arguments), [o, r, s, i, a, l, c] = n;
    return t.zone = Oe.utcInstance, If({ year: o, month: r, day: s, hour: i, minute: a, second: l, millisecond: c }, t);
  }
  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(t, n = {}) {
    const o = yD(t) ? t.valueOf() : NaN;
    if (Number.isNaN(o))
      return D.invalid("invalid input");
    const r = en(n.zone, ce.defaultZone);
    return r.isValid ? new D({
      ts: o,
      zone: r,
      loc: G.fromObject(n)
    }) : D.invalid(qs(r));
  }
  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(t, n = {}) {
    if (kn(t))
      return t < -864e13 || t > PL ? D.invalid("Timestamp out of range") : new D({
        ts: t,
        zone: en(n.zone, ce.defaultZone),
        loc: G.fromObject(n)
      });
    throw new Me(
      `fromMillis requires a numerical input, but received a ${typeof t} with value ${t}`
    );
  }
  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(t, n = {}) {
    if (kn(t))
      return new D({
        ts: t * 1e3,
        zone: en(n.zone, ce.defaultZone),
        loc: G.fromObject(n)
      });
    throw new Me("fromSeconds requires a numerical input");
  }
  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(t, n = {}) {
    t = t || {};
    const o = en(n.zone, ce.defaultZone);
    if (!o.isValid)
      return D.invalid(qs(o));
    const r = G.fromObject(n), s = ta(t, bf), { minDaysInFirstWeek: i, startOfWeek: a } = sf(s, r), l = ce.now(), c = k(n.specificOffset) ? o.offset(l) : n.specificOffset, u = !k(s.ordinal), d = !k(s.year), m = !k(s.month) || !k(s.day), f = d || m, p = s.weekYear || s.weekNumber;
    if ((f || u) && p)
      throw new ho(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (m && u)
      throw new ho("Can't mix ordinal dates with month/day");
    const v = p || s.weekday && !f;
    let I, g, b = Zs(l, c);
    v ? (I = UL, g = BL, b = Xi(b, i, a)) : u ? (I = VL, g = WL, b = tl(b)) : (I = ag, g = ig);
    let S = !1;
    for (const gt of I) {
      const le = s[gt];
      k(le) ? S ? s[gt] = g[gt] : s[gt] = b[gt] : S = !0;
    }
    const M = v ? mD(s, i, a) : u ? hD(s) : Dy(s), U = M || Ly(s);
    if (U)
      return D.invalid(U);
    const Ee = v ? of(s, i, a) : u ? rf(s) : s, [yt, At] = Ni(Ee, c, o), Nt = new D({
      ts: yt,
      zone: o,
      o: At,
      loc: r
    });
    return s.weekday && f && t.weekday !== Nt.weekday ? D.invalid(
      "mismatched weekday",
      `you can't specify both a weekday of ${s.weekday} and a date of ${Nt.toISO()}`
    ) : Nt;
  }
  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(t, n = {}) {
    const [o, r] = sL(t);
    return mr(o, r, n, "ISO 8601", t);
  }
  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(t, n = {}) {
    const [o, r] = iL(t);
    return mr(o, r, n, "RFC 2822", t);
  }
  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(t, n = {}) {
    const [o, r] = aL(t);
    return mr(o, r, n, "HTTP", n);
  }
  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(t, n, o = {}) {
    if (k(t) || k(n))
      throw new Me("fromFormat requires an input string and a format");
    const { locale: r = null, numberingSystem: s = null } = o, i = G.fromOpts({
      locale: r,
      numberingSystem: s,
      defaultToEN: !0
    }), [a, l, c, u] = _L(i, t, n);
    return u ? D.invalid(u) : mr(a, l, o, `format ${n}`, t, c);
  }
  /**
   * @deprecated use fromFormat instead
   */
  static fromString(t, n, o = {}) {
    return D.fromFormat(t, n, o);
  }
  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(t, n = {}) {
    const [o, r] = hL(t);
    return mr(o, r, n, "SQL", t);
  }
  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(t, n = null) {
    if (!t)
      throw new Me("need to specify a reason the DateTime is invalid");
    const o = t instanceof ct ? t : new ct(t, n);
    if (ce.throwOnInvalid)
      throw new j2(o);
    return new D({ invalid: o });
  }
  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(t) {
    return t && t.isLuxonDateTime || !1;
  }
  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(t, n = {}) {
    const o = rg(t, G.fromObject(n));
    return o ? o.map((r) => r ? r.val : null).join("") : null;
  }
  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(t, n = {}) {
    return ng(we.parseFormat(t), G.fromObject(n)).map((r) => r.val).join("");
  }
  // INFO
  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(t) {
    return this[t];
  }
  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }
  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }
  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }
  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }
  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }
  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }
  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }
  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }
  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }
  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }
  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }
  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }
  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }
  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }
  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }
  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }
  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? rl(this).weekYear : NaN;
  }
  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? rl(this).weekNumber : NaN;
  }
  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? rl(this).weekday : NaN;
  }
  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }
  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? sl(this).weekday : NaN;
  }
  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? sl(this).weekNumber : NaN;
  }
  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? sl(this).weekYear : NaN;
  }
  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? tl(this.c).ordinal : NaN;
  }
  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Fs.months("short", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Fs.months("long", { locObj: this.loc })[this.month - 1] : null;
  }
  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Fs.weekdays("short", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Fs.weekdays("long", { locObj: this.loc })[this.weekday - 1] : null;
  }
  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }
  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "short",
      locale: this.locale
    }) : null;
  }
  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    return this.isValid ? this.zone.offsetName(this.ts, {
      format: "long",
      locale: this.locale
    }) : null;
  }
  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }
  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    return this.isOffsetFixed ? !1 : this.offset > this.set({ month: 1, day: 1 }).offset || this.offset > this.set({ month: 5 }).offset;
  }
  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed)
      return [this];
    const t = 864e5, n = 6e4, o = Ra(this.c), r = this.zone.offset(o - t), s = this.zone.offset(o + t), i = this.zone.offset(o - r * n), a = this.zone.offset(o - s * n);
    if (i === a)
      return [this];
    const l = o - i * n, c = o - a * n, u = Zs(l, i), d = Zs(c, a);
    return u.hour === d.hour && u.minute === d.minute && u.second === d.second && u.millisecond === d.millisecond ? [hn(this, { ts: l }), hn(this, { ts: c })] : [this];
  }
  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return Es(this.year);
  }
  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return ea(this.year, this.month);
  }
  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? Oo(this.year) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? ns(this.weekYear) : NaN;
  }
  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? ns(
      this.localWeekYear,
      this.loc.getMinDaysInFirstWeek(),
      this.loc.getStartOfWeek()
    ) : NaN;
  }
  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(t = {}) {
    const { locale: n, numberingSystem: o, calendar: r } = we.create(
      this.loc.clone(t),
      t
    ).resolvedOptions(this);
    return { locale: n, numberingSystem: o, outputCalendar: r };
  }
  // TRANSFORM
  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(t = 0, n = {}) {
    return this.setZone(Oe.instance(t), n);
  }
  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(ce.defaultZone);
  }
  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(t, { keepLocalTime: n = !1, keepCalendarTime: o = !1 } = {}) {
    if (t = en(t, ce.defaultZone), t.equals(this.zone))
      return this;
    if (t.isValid) {
      let r = this.ts;
      if (n || o) {
        const s = t.offset(this.ts), i = this.toObject();
        [r] = Ni(i, s, t);
      }
      return hn(this, { ts: r, zone: t });
    } else
      return D.invalid(qs(t));
  }
  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({ locale: t, numberingSystem: n, outputCalendar: o } = {}) {
    const r = this.loc.clone({ locale: t, numberingSystem: n, outputCalendar: o });
    return hn(this, { loc: r });
  }
  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(t) {
    return this.reconfigure({ locale: t });
  }
  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(t) {
    if (!this.isValid) return this;
    const n = ta(t, bf), { minDaysInFirstWeek: o, startOfWeek: r } = sf(n, this.loc), s = !k(n.weekYear) || !k(n.weekNumber) || !k(n.weekday), i = !k(n.ordinal), a = !k(n.year), l = !k(n.month) || !k(n.day), c = a || l, u = n.weekYear || n.weekNumber;
    if ((c || i) && u)
      throw new ho(
        "Can't mix weekYear/weekNumber units with year/month/day or ordinals"
      );
    if (l && i)
      throw new ho("Can't mix ordinal dates with month/day");
    let d;
    s ? d = of(
      { ...Xi(this.c, o, r), ...n },
      o,
      r
    ) : k(n.ordinal) ? (d = { ...this.toObject(), ...n }, k(n.day) && (d.day = Math.min(ea(d.year, d.month), d.day))) : d = rf({ ...tl(this.c), ...n });
    const [m, f] = Ni(d, this.o, this.zone);
    return hn(this, { ts: m, o: f });
  }
  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(t) {
    if (!this.isValid) return this;
    const n = F.fromDurationLike(t);
    return hn(this, gf(this, n));
  }
  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(t) {
    if (!this.isValid) return this;
    const n = F.fromDurationLike(t).negate();
    return hn(this, gf(this, n));
  }
  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(t, { useLocaleWeeks: n = !1 } = {}) {
    if (!this.isValid) return this;
    const o = {}, r = F.normalizeUnit(t);
    switch (r) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
    }
    if (r === "weeks")
      if (n) {
        const s = this.loc.getStartOfWeek(), { weekday: i } = this;
        i < s && (o.weekNumber = this.weekNumber - 1), o.weekday = s;
      } else
        o.weekday = 1;
    if (r === "quarters") {
      const s = Math.ceil(this.month / 3);
      o.month = (s - 1) * 3 + 1;
    }
    return this.set(o);
  }
  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(t, n) {
    return this.isValid ? this.plus({ [t]: 1 }).startOf(t, n).minus(1) : this;
  }
  // OUTPUT
  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(t, n = {}) {
    return this.isValid ? we.create(this.loc.redefaultToEN(n)).formatDateTimeFromString(this, t) : ol;
  }
  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(t = Ji, n = {}) {
    return this.isValid ? we.create(this.loc.clone(n), t).formatDateTime(this) : ol;
  }
  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(t = {}) {
    return this.isValid ? we.create(this.loc.clone(t), t).formatDateTimeParts(this) : [];
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format: t = "extended",
    suppressSeconds: n = !1,
    suppressMilliseconds: o = !1,
    includeOffset: r = !0,
    extendedZone: s = !1
  } = {}) {
    if (!this.isValid)
      return null;
    const i = t === "extended";
    let a = il(this, i);
    return a += "T", a += vf(this, i, n, o, r, s), a;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({ format: t = "extended" } = {}) {
    return this.isValid ? il(this, t === "extended") : null;
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return Hs(this, "kkkk-'W'WW-c");
  }
  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds: t = !1,
    suppressSeconds: n = !1,
    includeOffset: o = !0,
    includePrefix: r = !1,
    extendedZone: s = !1,
    format: i = "extended"
  } = {}) {
    return this.isValid ? (r ? "T" : "") + vf(
      this,
      i === "extended",
      n,
      t,
      o,
      s
    ) : null;
  }
  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return Hs(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", !1);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return Hs(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    return this.isValid ? il(this, !0) : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({ includeOffset: t = !0, includeZone: n = !1, includeOffsetSpace: o = !0 } = {}) {
    let r = "HH:mm:ss.SSS";
    return (n || t) && (o && (r += " "), n ? r += "z" : t && (r += "ZZ")), Hs(this, r, !0);
  }
  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(t = {}) {
    return this.isValid ? `${this.toSQLDate()} ${this.toSQLTime(t)}` : null;
  }
  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : ol;
  }
  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    return this.isValid ? `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }` : `DateTime { Invalid, reason: ${this.invalidReason} }`;
  }
  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }
  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }
  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1e3 : NaN;
  }
  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1e3) : NaN;
  }
  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }
  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }
  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(t = {}) {
    if (!this.isValid) return {};
    const n = { ...this.c };
    return t.includeConfig && (n.outputCalendar = this.outputCalendar, n.numberingSystem = this.loc.numberingSystem, n.locale = this.loc.locale), n;
  }
  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }
  // COMPARE
  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(t, n = "milliseconds", o = {}) {
    if (!this.isValid || !t.isValid)
      return F.invalid("created by diffing an invalid DateTime");
    const r = { locale: this.locale, numberingSystem: this.numberingSystem, ...o }, s = gD(n).map(F.normalizeUnit), i = t.valueOf() > this.valueOf(), a = i ? this : t, l = i ? t : this, c = TL(a, l, s, r);
    return i ? c.negate() : c;
  }
  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(t = "milliseconds", n = {}) {
    return this.diff(D.now(), t, n);
  }
  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(t) {
    return this.isValid ? se.fromDateTimes(this, t) : this;
  }
  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(t, n, o) {
    if (!this.isValid) return !1;
    const r = t.valueOf(), s = this.setZone(t.zone, { keepLocalTime: !0 });
    return s.startOf(n, o) <= r && r <= s.endOf(n, o);
  }
  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(t) {
    return this.isValid && t.isValid && this.valueOf() === t.valueOf() && this.zone.equals(t.zone) && this.loc.equals(t.loc);
  }
  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(t = {}) {
    if (!this.isValid) return null;
    const n = t.base || D.fromObject({}, { zone: this.zone }), o = t.padding ? this < n ? -t.padding : t.padding : 0;
    let r = ["years", "months", "days", "hours", "minutes", "seconds"], s = t.unit;
    return Array.isArray(t.unit) && (r = t.unit, s = void 0), Tf(n, this.plus(o), {
      ...t,
      numeric: "always",
      units: r,
      unit: s
    });
  }
  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(t = {}) {
    return this.isValid ? Tf(t.base || D.fromObject({}, { zone: this.zone }), this, {
      ...t,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: !0
    }) : null;
  }
  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...t) {
    if (!t.every(D.isDateTime))
      throw new Me("min requires all arguments be DateTimes");
    return af(t, (n) => n.valueOf(), Math.min);
  }
  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...t) {
    if (!t.every(D.isDateTime))
      throw new Me("max requires all arguments be DateTimes");
    return af(t, (n) => n.valueOf(), Math.max);
  }
  // MISC
  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(t, n, o = {}) {
    const { locale: r = null, numberingSystem: s = null } = o, i = G.fromOpts({
      locale: r,
      numberingSystem: s,
      defaultToEN: !0
    });
    return og(i, t, n);
  }
  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(t, n, o = {}) {
    return D.fromFormatExplain(t, n, o);
  }
  // FORMAT PRESETS
  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return Ji;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return uy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return H2;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return dy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return fy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return my;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return hy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return py;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return yy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return gy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return vy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return by;
  }
  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return Iy;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return Ty;
  }
  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return wy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return Cy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return Sy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return z2;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return Oy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return Ey;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return xy;
  }
  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return Ay;
  }
}
function hr(e) {
  if (D.isDateTime(e))
    return e;
  if (e && e.valueOf && kn(e.valueOf()))
    return D.fromJSDate(e);
  if (e && typeof e == "object")
    return D.fromObject(e);
  throw new Me(
    `Unknown datetime argument: ${e}, of type ${typeof e}`
  );
}
function jL({ collections: e }, {
  tableIds: t,
  tableColumnIds: n,
  relationshipIds: o,
  indexIds: r,
  indexColumnIds: s,
  memoIds: i
}) {
  y(e).collection("tableEntities").removeMany(t), y(e).collection("tableColumnEntities").removeMany(n), y(e).collection("relationshipEntities").removeMany(o), y(e).collection("indexEntities").removeMany(r), y(e).collection("indexColumnEntities").removeMany(s), y(e).collection("memoEntities").removeMany(i);
}
const qL = 3;
class QR {
  async run(t) {
    const n = JSON.parse(t), o = Un(n), {
      doc: { tableIds: r, memoIds: s, indexIds: i, relationshipIds: a },
      collections: l
    } = o, c = B(r), u = B(s), d = B(i), m = B(a), f = ZL(D.now()), p = y(l).collection("tableEntities"), v = y(l).collection(
      "tableColumnEntities"
    ), I = y(l).collection("indexEntities"), g = y(l).collection(
      "indexColumnEntities"
    ), b = y(l).collection(
      "relationshipEntities"
    ), S = y(l).collection("memoEntities"), M = new Set(
      p.selectAll().filter(f(c)).map(({ id: x }) => x)
    ), U = /* @__PURE__ */ new Set(), Ee = new Set(
      b.selectAll().filter(f(m)).map(({ id: x }) => x)
    ), yt = new Set(
      I.selectAll().filter(f(d)).map(({ id: x }) => x)
    ), At = /* @__PURE__ */ new Set(), Nt = new Set(
      S.selectAll().filter(f(u)).map(({ id: x }) => x)
    );
    v.selectAll().filter(({ tableId: x }) => M.has(x)).forEach(({ id: x }) => U.add(x)), b.selectAll().filter(
      ({ id: x, start: q, end: Te }) => !Ee.has(x) && (M.has(q.tableId) || M.has(Te.tableId))
    ).forEach(({ id: x }) => Ee.add(x)), I.selectAll().filter(
      ({ id: x, tableId: q }) => !yt.has(x) && M.has(q)
    ).forEach(({ id: x }) => yt.add(x)), g.selectAll().filter(({ indexId: x }) => yt.has(x)).forEach(({ id: x }) => At.add(x)), jL(o, {
      tableIds: [...M],
      tableColumnIds: [...U],
      relationshipIds: [...Ee],
      indexIds: [...yt],
      indexColumnIds: [...At],
      memoIds: [...Nt]
    });
    const gt = B(
      p.selectAll().map(({ id: x }) => x)
    ), le = B(
      I.selectAll().map(({ id: x }) => x)
    );
    return v.selectAll().filter(
      ({ tableId: x, id: q, meta: Te }) => !gt(x) && f(() => !1)({ id: q, meta: Te })
    ).forEach(({ id: x }) => U.add(x)), g.selectAll().filter(
      ({ indexId: x, id: q, meta: Te }) => !le(x) && f(() => !1)({ id: q, meta: Te })
    ).forEach(({ id: x }) => At.add(x)), {
      tableIds: [...M],
      tableColumnIds: [...U],
      relationshipIds: [...Ee],
      indexIds: [...yt],
      indexColumnIds: [...At],
      memoIds: [...Nt]
    };
  }
}
const ZL = (e) => (t) => ({ id: n, meta: o }) => {
  if (t(n)) return !1;
  const r = Math.floor(
    e.diff(D.fromMillis(o.updateAt), "days").toObject().days ?? 0
  );
  return qL < r;
};
export {
  us as $,
  $ as A,
  B,
  _R as C,
  jR as D,
  KR as E,
  VR as F,
  jd as G,
  WR as H,
  Kp as I,
  KE as J,
  DR as K,
  Hx as L,
  o2 as M,
  s2 as N,
  nt as O,
  r2 as P,
  lu as Q,
  ve as R,
  gs as S,
  qn as T,
  GL as U,
  zL as V,
  Rh as W,
  C as X,
  lC as Y,
  UR as Z,
  Wi as _,
  Bi as a,
  Vk as a$,
  rR as a0,
  RR as a1,
  nR as a2,
  QL as a3,
  mp as a4,
  Tt as a5,
  GR as a6,
  zR as a7,
  YR as a8,
  ZR as a9,
  Qc as aA,
  Gi as aB,
  Tm as aC,
  XO as aD,
  Tp as aE,
  Ex as aF,
  xx as aG,
  Zi as aH,
  bx as aI,
  B$ as aJ,
  W$ as aK,
  S$ as aL,
  Np as aM,
  Ip as aN,
  tR as aO,
  P as aP,
  J1 as aQ,
  sR as aR,
  iR as aS,
  Kn as aT,
  Yh as aU,
  Lp as aV,
  bt as aW,
  Xh as aX,
  V as aY,
  Ox as aZ,
  Sx as a_,
  HR as aa,
  Hh as ab,
  uR as ac,
  xl as ad,
  Bc as ae,
  fR as af,
  y as ag,
  cR as ah,
  X1 as ai,
  oe as aj,
  O2 as ak,
  Zd as al,
  Rl as am,
  JL as an,
  gA as ao,
  ji as ap,
  Kh as aq,
  Tx as ar,
  IR as as,
  wx as at,
  Ix as au,
  An as av,
  op as aw,
  GE as ax,
  N$ as ay,
  kk as az,
  Qw as b,
  Xc as b$,
  Fk as b0,
  Dp as b1,
  R as b2,
  K as b3,
  tp as b4,
  ep as b5,
  rn as b6,
  L$ as b7,
  lA as b8,
  k$ as b9,
  TA as bA,
  cx as bB,
  Na as bC,
  e2 as bD,
  gR as bE,
  Io as bF,
  SR as bG,
  mx as bH,
  px as bI,
  hx as bJ,
  zh as bK,
  Lk as bL,
  P1 as bM,
  me as bN,
  H as bO,
  zp as bP,
  Bk as bQ,
  zN as bR,
  _k as bS,
  D as bT,
  Sp as bU,
  Kc as bV,
  _$ as bW,
  ko as bX,
  A$ as bY,
  C$ as bZ,
  kd as b_,
  uA as ba,
  R$ as bb,
  XE as bc,
  eR as bd,
  kp as be,
  Mp as bf,
  Sa as bg,
  tu as bh,
  eu as bi,
  Wk as bj,
  SA as bk,
  Uk as bl,
  aR as bm,
  MR as bn,
  jr as bo,
  TR as bp,
  wR as bq,
  Yc as br,
  ly as bs,
  oR as bt,
  Jx as bu,
  $k as bv,
  hc as bw,
  Gc as bx,
  dt as by,
  Xe as bz,
  rT as c,
  FR as c$,
  bp as c0,
  bR as c1,
  Zk as c2,
  gp as c3,
  es as c4,
  zk as c5,
  Gk as c6,
  Yk as c7,
  Kk as c8,
  qk as c9,
  M$ as cA,
  EA as cB,
  Pk as cC,
  YN as cD,
  ER as cE,
  yR as cF,
  vR as cG,
  sM as cH,
  fM as cI,
  Ep as cJ,
  He as cK,
  rp as cL,
  AM as cM,
  cM as cN,
  Rb as cO,
  Fl as cP,
  XL as cQ,
  CR as cR,
  xR as cS,
  WN as cT,
  Nl as cU,
  Op as cV,
  Ia as cW,
  Xk as cX,
  QR as cY,
  BR as cZ,
  PR as c_,
  pR as ca,
  tM as cb,
  hR as cc,
  QN as cd,
  XN as ce,
  lR as cf,
  kR as cg,
  sT as ch,
  qR as ci,
  Ws as cj,
  oM as ck,
  WA as cl,
  x$ as cm,
  E$ as cn,
  Et as co,
  LR as cp,
  Zh as cq,
  lt as cr,
  $R as cs,
  hp as ct,
  Rk as cu,
  Gx as cv,
  Dk as cw,
  Le as cx,
  fA as cy,
  Pc as cz,
  St as d,
  dx as d0,
  ux as d1,
  MA as d2,
  kA as d3,
  Ce as d4,
  ua as d5,
  Rc as d6,
  NR as d7,
  AR as d8,
  OR as d9,
  dR as da,
  jL as db,
  AA as dc,
  Kw as dd,
  mR as e,
  vs as f,
  ge as g,
  RE as h,
  AE as i,
  $E as j,
  NE as k,
  ME as l,
  kE as m,
  _E as n,
  jn as o,
  BE as p,
  DE as q,
  PE as r,
  Vi as s,
  qh as t,
  gE as u,
  El as v,
  Fh as w,
  Ol as x,
  YE as y,
  Qp as z
};
